
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref7f2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref7f2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Qwp0", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $2129928c0bdc1efe$export$ffb0004e005737fa; }, function (v) { return $2129928c0bdc1efe$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $2129928c0bdc1efe$export$34b9dba7ce09269b; }, function (v) { return $2129928c0bdc1efe$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $2129928c0bdc1efe$export$25062201e9e25d76; }, function (v) { return $2129928c0bdc1efe$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2129928c0bdc1efe$export$ffb0004e005737fa;
var $2129928c0bdc1efe$export$34b9dba7ce09269b;
var $2129928c0bdc1efe$export$25062201e9e25d76;
'use strict';

var $gIfym = parcelRequire("gIfym");
var $2129928c0bdc1efe$var$k = Symbol.for("react.element"), $2129928c0bdc1efe$var$l = Symbol.for("react.fragment"), $2129928c0bdc1efe$var$m = Object.prototype.hasOwnProperty, $2129928c0bdc1efe$var$n = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2129928c0bdc1efe$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2129928c0bdc1efe$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$2129928c0bdc1efe$var$m.call(a, b) && !$2129928c0bdc1efe$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $2129928c0bdc1efe$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $2129928c0bdc1efe$var$n.current
    };
}
$2129928c0bdc1efe$export$ffb0004e005737fa = $2129928c0bdc1efe$var$l;
$2129928c0bdc1efe$export$34b9dba7ce09269b = $2129928c0bdc1efe$var$q;
$2129928c0bdc1efe$export$25062201e9e25d76 = $2129928c0bdc1efe$var$q;

});
parcelRegister("gIfym", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ga9lV"));

});
parcelRegister("ga9lV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $bc44d5c582efa5c9$export$dca3b0875bd9a954; }, function (v) { return $bc44d5c582efa5c9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bc44d5c582efa5c9$export$16fa2f45be04daa8; }, function (v) { return $bc44d5c582efa5c9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bc44d5c582efa5c9$export$ffb0004e005737fa; }, function (v) { return $bc44d5c582efa5c9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bc44d5c582efa5c9$export$e2c29f18771995cb; }, function (v) { return $bc44d5c582efa5c9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd; }, function (v) { return $bc44d5c582efa5c9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bc44d5c582efa5c9$export$5f8d39834fd61797; }, function (v) { return $bc44d5c582efa5c9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5; }, function (v) { return $bc44d5c582efa5c9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc44d5c582efa5c9$export$ae55be85d98224ed; }, function (v) { return $bc44d5c582efa5c9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $bc44d5c582efa5c9$export$3ba232387fd5d6dd; }, function (v) { return $bc44d5c582efa5c9$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bc44d5c582efa5c9$export$e530037191fcd5d7; }, function (v) { return $bc44d5c582efa5c9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109; }, function (v) { return $bc44d5c582efa5c9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d; }, function (v) { return $bc44d5c582efa5c9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9; }, function (v) { return $bc44d5c582efa5c9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43; }, function (v) { return $bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bc44d5c582efa5c9$export$257a8862b851cb5b; }, function (v) { return $bc44d5c582efa5c9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bc44d5c582efa5c9$export$a8257692ac88316c; }, function (v) { return $bc44d5c582efa5c9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bc44d5c582efa5c9$export$488013bae63b21da; }, function (v) { return $bc44d5c582efa5c9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bc44d5c582efa5c9$export$7c73462e0d25e514; }, function (v) { return $bc44d5c582efa5c9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $bc44d5c582efa5c9$export$7568632d0d33d16d; }, function (v) { return $bc44d5c582efa5c9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $bc44d5c582efa5c9$export$88948ce120ea2619; }, function (v) { return $bc44d5c582efa5c9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bc44d5c582efa5c9$export$35808ee640e87ca7; }, function (v) { return $bc44d5c582efa5c9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bc44d5c582efa5c9$export$fae74005e78b1a27; }, function (v) { return $bc44d5c582efa5c9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e; }, function (v) { return $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bc44d5c582efa5c9$export$6a7bc4e911dc01cf; }, function (v) { return $bc44d5c582efa5c9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $bc44d5c582efa5c9$export$6d9c69b0de29b591; }, function (v) { return $bc44d5c582efa5c9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $bc44d5c582efa5c9$export$f680877a34711e37; }, function (v) { return $bc44d5c582efa5c9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bc44d5c582efa5c9$export$d5a552a76deda3c2; }, function (v) { return $bc44d5c582efa5c9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bc44d5c582efa5c9$export$aaabe4eda9ed9969; }, function (v) { return $bc44d5c582efa5c9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c; }, function (v) { return $bc44d5c582efa5c9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bc44d5c582efa5c9$export$1538c33de8887b59; }, function (v) { return $bc44d5c582efa5c9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $bc44d5c582efa5c9$export$13e3392192263954; }, function (v) { return $bc44d5c582efa5c9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca; }, function (v) { return $bc44d5c582efa5c9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bc44d5c582efa5c9$export$60241385465d0a34; }, function (v) { return $bc44d5c582efa5c9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $bc44d5c582efa5c9$export$306c0aa65ff9ec16; }, function (v) { return $bc44d5c582efa5c9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $bc44d5c582efa5c9$export$7b286972b8d8ccbf; }, function (v) { return $bc44d5c582efa5c9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $bc44d5c582efa5c9$export$83d89fbfd8236492; }, function (v) { return $bc44d5c582efa5c9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc44d5c582efa5c9$export$dca3b0875bd9a954;
var $bc44d5c582efa5c9$export$16fa2f45be04daa8;
var $bc44d5c582efa5c9$export$ffb0004e005737fa;
var $bc44d5c582efa5c9$export$e2c29f18771995cb;
var $bc44d5c582efa5c9$export$221d75b3f55bb0bd;
var $bc44d5c582efa5c9$export$5f8d39834fd61797;
var $bc44d5c582efa5c9$export$74bf444e3cd11ea5;
var $bc44d5c582efa5c9$export$ae55be85d98224ed;
var $bc44d5c582efa5c9$export$3ba232387fd5d6dd;
var $bc44d5c582efa5c9$export$e530037191fcd5d7;
var $bc44d5c582efa5c9$export$fd42f52fd3ae1109;
var $bc44d5c582efa5c9$export$c8a8987d4410bf2d;
var $bc44d5c582efa5c9$export$d38cd72104c1f0e9;
var $bc44d5c582efa5c9$export$7d1e3a5e95ceca43;
var $bc44d5c582efa5c9$export$257a8862b851cb5b;
var $bc44d5c582efa5c9$export$a8257692ac88316c;
var $bc44d5c582efa5c9$export$488013bae63b21da;
var $bc44d5c582efa5c9$export$7c73462e0d25e514;
var $bc44d5c582efa5c9$export$7568632d0d33d16d;
var $bc44d5c582efa5c9$export$88948ce120ea2619;
var $bc44d5c582efa5c9$export$35808ee640e87ca7;
var $bc44d5c582efa5c9$export$fae74005e78b1a27;
var $bc44d5c582efa5c9$export$dc8fbce3eb94dc1e;
var $bc44d5c582efa5c9$export$6a7bc4e911dc01cf;
var $bc44d5c582efa5c9$export$6d9c69b0de29b591;
var $bc44d5c582efa5c9$export$f680877a34711e37;
var $bc44d5c582efa5c9$export$d5a552a76deda3c2;
var $bc44d5c582efa5c9$export$aaabe4eda9ed9969;
var $bc44d5c582efa5c9$export$e5c5a5f917a5871c;
var $bc44d5c582efa5c9$export$1538c33de8887b59;
var $bc44d5c582efa5c9$export$13e3392192263954;
var $bc44d5c582efa5c9$export$b8f5890fc79d6aca;
var $bc44d5c582efa5c9$export$60241385465d0a34;
var $bc44d5c582efa5c9$export$306c0aa65ff9ec16;
var $bc44d5c582efa5c9$export$7b286972b8d8ccbf;
var $bc44d5c582efa5c9$export$83d89fbfd8236492;
'use strict';
var $bc44d5c582efa5c9$var$l = Symbol.for("react.element"), $bc44d5c582efa5c9$var$n = Symbol.for("react.portal"), $bc44d5c582efa5c9$var$p = Symbol.for("react.fragment"), $bc44d5c582efa5c9$var$q = Symbol.for("react.strict_mode"), $bc44d5c582efa5c9$var$r = Symbol.for("react.profiler"), $bc44d5c582efa5c9$var$t = Symbol.for("react.provider"), $bc44d5c582efa5c9$var$u = Symbol.for("react.context"), $bc44d5c582efa5c9$var$v = Symbol.for("react.forward_ref"), $bc44d5c582efa5c9$var$w = Symbol.for("react.suspense"), $bc44d5c582efa5c9$var$x = Symbol.for("react.memo"), $bc44d5c582efa5c9$var$y = Symbol.for("react.lazy"), $bc44d5c582efa5c9$var$z = Symbol.iterator;
function $bc44d5c582efa5c9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bc44d5c582efa5c9$var$z && a[$bc44d5c582efa5c9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bc44d5c582efa5c9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bc44d5c582efa5c9$var$C = Object.assign, $bc44d5c582efa5c9$var$D = {};
function $bc44d5c582efa5c9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$D;
    this.updater = e || $bc44d5c582efa5c9$var$B;
}
$bc44d5c582efa5c9$var$E.prototype.isReactComponent = {};
$bc44d5c582efa5c9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$bc44d5c582efa5c9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $bc44d5c582efa5c9$var$F() {}
$bc44d5c582efa5c9$var$F.prototype = $bc44d5c582efa5c9$var$E.prototype;
function $bc44d5c582efa5c9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $bc44d5c582efa5c9$var$D;
    this.updater = e || $bc44d5c582efa5c9$var$B;
}
var $bc44d5c582efa5c9$var$H = $bc44d5c582efa5c9$var$G.prototype = new $bc44d5c582efa5c9$var$F;
$bc44d5c582efa5c9$var$H.constructor = $bc44d5c582efa5c9$var$G;
$bc44d5c582efa5c9$var$C($bc44d5c582efa5c9$var$H, $bc44d5c582efa5c9$var$E.prototype);
$bc44d5c582efa5c9$var$H.isPureReactComponent = !0;
var $bc44d5c582efa5c9$var$I = Array.isArray, $bc44d5c582efa5c9$var$J = Object.prototype.hasOwnProperty, $bc44d5c582efa5c9$var$K = {
    current: null
}, $bc44d5c582efa5c9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bc44d5c582efa5c9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$bc44d5c582efa5c9$var$J.call(b, d) && !$bc44d5c582efa5c9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $bc44d5c582efa5c9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $bc44d5c582efa5c9$var$K.current
    };
}
function $bc44d5c582efa5c9$var$N(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $bc44d5c582efa5c9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bc44d5c582efa5c9$var$l;
}
function $bc44d5c582efa5c9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $bc44d5c582efa5c9$var$P = /\/+/g;
function $bc44d5c582efa5c9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $bc44d5c582efa5c9$var$escape("" + a.key) : b.toString(36);
}
function $bc44d5c582efa5c9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $bc44d5c582efa5c9$var$l:
                case $bc44d5c582efa5c9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $bc44d5c582efa5c9$var$Q(h, 0) : d, $bc44d5c582efa5c9$var$I(c) ? (e = "", null != a && (e = a.replace($bc44d5c582efa5c9$var$P, "$&/") + "/"), $bc44d5c582efa5c9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($bc44d5c582efa5c9$var$O(c) && (c = $bc44d5c582efa5c9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($bc44d5c582efa5c9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($bc44d5c582efa5c9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $bc44d5c582efa5c9$var$Q(k, g);
        h += $bc44d5c582efa5c9$var$R(k, b, e, f, c);
    }
    else if (f = $bc44d5c582efa5c9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $bc44d5c582efa5c9$var$Q(k, g++), h += $bc44d5c582efa5c9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $bc44d5c582efa5c9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $bc44d5c582efa5c9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $bc44d5c582efa5c9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $bc44d5c582efa5c9$var$U = {
    current: null
}, $bc44d5c582efa5c9$var$V = {
    transition: null
}, $bc44d5c582efa5c9$var$W = {
    ReactCurrentDispatcher: $bc44d5c582efa5c9$var$U,
    ReactCurrentBatchConfig: $bc44d5c582efa5c9$var$V,
    ReactCurrentOwner: $bc44d5c582efa5c9$var$K
};
function $bc44d5c582efa5c9$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$bc44d5c582efa5c9$export$dca3b0875bd9a954 = {
    map: $bc44d5c582efa5c9$var$S,
    forEach: function(a, b, e) {
        $bc44d5c582efa5c9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $bc44d5c582efa5c9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $bc44d5c582efa5c9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$bc44d5c582efa5c9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$bc44d5c582efa5c9$export$16fa2f45be04daa8 = $bc44d5c582efa5c9$var$E;
$bc44d5c582efa5c9$export$ffb0004e005737fa = $bc44d5c582efa5c9$var$p;
$bc44d5c582efa5c9$export$e2c29f18771995cb = $bc44d5c582efa5c9$var$r;
$bc44d5c582efa5c9$export$221d75b3f55bb0bd = $bc44d5c582efa5c9$var$G;
$bc44d5c582efa5c9$export$5f8d39834fd61797 = $bc44d5c582efa5c9$var$q;
$bc44d5c582efa5c9$export$74bf444e3cd11ea5 = $bc44d5c582efa5c9$var$w;
$bc44d5c582efa5c9$export$ae55be85d98224ed = $bc44d5c582efa5c9$var$W;
$bc44d5c582efa5c9$export$3ba232387fd5d6dd = $bc44d5c582efa5c9$var$X;
$bc44d5c582efa5c9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $bc44d5c582efa5c9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $bc44d5c582efa5c9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$bc44d5c582efa5c9$var$J.call(b, f) && !$bc44d5c582efa5c9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $bc44d5c582efa5c9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$bc44d5c582efa5c9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $bc44d5c582efa5c9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $bc44d5c582efa5c9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$bc44d5c582efa5c9$export$c8a8987d4410bf2d = $bc44d5c582efa5c9$var$M;
$bc44d5c582efa5c9$export$d38cd72104c1f0e9 = function(a) {
    var b = $bc44d5c582efa5c9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$bc44d5c582efa5c9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bc44d5c582efa5c9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$v,
        render: a
    };
};
$bc44d5c582efa5c9$export$a8257692ac88316c = $bc44d5c582efa5c9$var$O;
$bc44d5c582efa5c9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $bc44d5c582efa5c9$var$T
    };
};
$bc44d5c582efa5c9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $bc44d5c582efa5c9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$bc44d5c582efa5c9$export$7568632d0d33d16d = function(a) {
    var b = $bc44d5c582efa5c9$var$V.transition;
    $bc44d5c582efa5c9$var$V.transition = {};
    try {
        a();
    } finally{
        $bc44d5c582efa5c9$var$V.transition = b;
    }
};
$bc44d5c582efa5c9$export$88948ce120ea2619 = $bc44d5c582efa5c9$var$X;
$bc44d5c582efa5c9$export$35808ee640e87ca7 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useCallback(a, b);
};
$bc44d5c582efa5c9$export$fae74005e78b1a27 = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useContext(a);
};
$bc44d5c582efa5c9$export$dc8fbce3eb94dc1e = function() {};
$bc44d5c582efa5c9$export$6a7bc4e911dc01cf = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useDeferredValue(a);
};
$bc44d5c582efa5c9$export$6d9c69b0de29b591 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useEffect(a, b);
};
$bc44d5c582efa5c9$export$f680877a34711e37 = function() {
    return $bc44d5c582efa5c9$var$U.current.useId();
};
$bc44d5c582efa5c9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $bc44d5c582efa5c9$var$U.current.useImperativeHandle(a, b, e);
};
$bc44d5c582efa5c9$export$aaabe4eda9ed9969 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useInsertionEffect(a, b);
};
$bc44d5c582efa5c9$export$e5c5a5f917a5871c = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useLayoutEffect(a, b);
};
$bc44d5c582efa5c9$export$1538c33de8887b59 = function(a, b) {
    return $bc44d5c582efa5c9$var$U.current.useMemo(a, b);
};
$bc44d5c582efa5c9$export$13e3392192263954 = function(a, b, e) {
    return $bc44d5c582efa5c9$var$U.current.useReducer(a, b, e);
};
$bc44d5c582efa5c9$export$b8f5890fc79d6aca = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useRef(a);
};
$bc44d5c582efa5c9$export$60241385465d0a34 = function(a) {
    return $bc44d5c582efa5c9$var$U.current.useState(a);
};
$bc44d5c582efa5c9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $bc44d5c582efa5c9$var$U.current.useSyncExternalStore(a, b, e);
};
$bc44d5c582efa5c9$export$7b286972b8d8ccbf = function() {
    return $bc44d5c582efa5c9$var$U.current.useTransition();
};
$bc44d5c582efa5c9$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("eN6q3", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ac4a9effa24fe7be$export$ae55be85d98224ed; }, function (v) { return $ac4a9effa24fe7be$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $ac4a9effa24fe7be$export$d39a5bbd09211389; }, function (v) { return $ac4a9effa24fe7be$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $ac4a9effa24fe7be$export$882461b6382ed46c; }, function (v) { return $ac4a9effa24fe7be$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $ac4a9effa24fe7be$export$466bfc07425424d5; }, function (v) { return $ac4a9effa24fe7be$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $ac4a9effa24fe7be$export$cd75ccfd720a3cd4; }, function (v) { return $ac4a9effa24fe7be$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $ac4a9effa24fe7be$export$fa8d919ba61d84db; }, function (v) { return $ac4a9effa24fe7be$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ac4a9effa24fe7be$export$757ceba2d55c277e; }, function (v) { return $ac4a9effa24fe7be$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $ac4a9effa24fe7be$export$b3890eb0ae9dca99; }, function (v) { return $ac4a9effa24fe7be$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $ac4a9effa24fe7be$export$502457920280e6be; }, function (v) { return $ac4a9effa24fe7be$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $ac4a9effa24fe7be$export$c78a37762a8d58e1; }, function (v) { return $ac4a9effa24fe7be$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $ac4a9effa24fe7be$export$dc54d992c10e8a18; }, function (v) { return $ac4a9effa24fe7be$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $ac4a9effa24fe7be$export$83d89fbfd8236492; }, function (v) { return $ac4a9effa24fe7be$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $ac4a9effa24fe7be$export$ae55be85d98224ed;
var $ac4a9effa24fe7be$export$d39a5bbd09211389;
var $ac4a9effa24fe7be$export$882461b6382ed46c;
var $ac4a9effa24fe7be$export$466bfc07425424d5;
var $ac4a9effa24fe7be$export$cd75ccfd720a3cd4;
var $ac4a9effa24fe7be$export$fa8d919ba61d84db;
var $ac4a9effa24fe7be$export$757ceba2d55c277e;
var $ac4a9effa24fe7be$export$b3890eb0ae9dca99;
var $ac4a9effa24fe7be$export$502457920280e6be;
var $ac4a9effa24fe7be$export$c78a37762a8d58e1;
var $ac4a9effa24fe7be$export$dc54d992c10e8a18;
var $ac4a9effa24fe7be$export$83d89fbfd8236492;
'use strict';

var $gIfym = parcelRequire("gIfym");

var $Qw0kg = parcelRequire("Qw0kg");
function $ac4a9effa24fe7be$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $ac4a9effa24fe7be$var$da = new Set, $ac4a9effa24fe7be$var$ea = {};
function $ac4a9effa24fe7be$var$fa(a, b) {
    $ac4a9effa24fe7be$var$ha(a, b);
    $ac4a9effa24fe7be$var$ha(a + "Capture", b);
}
function $ac4a9effa24fe7be$var$ha(a, b) {
    $ac4a9effa24fe7be$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$ac4a9effa24fe7be$var$da.add(b[a]);
}
var $ac4a9effa24fe7be$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $ac4a9effa24fe7be$var$ja = Object.prototype.hasOwnProperty, $ac4a9effa24fe7be$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $ac4a9effa24fe7be$var$la = {}, $ac4a9effa24fe7be$var$ma = {};
function $ac4a9effa24fe7be$var$oa(a) {
    if ($ac4a9effa24fe7be$var$ja.call($ac4a9effa24fe7be$var$ma, a)) return !0;
    if ($ac4a9effa24fe7be$var$ja.call($ac4a9effa24fe7be$var$la, a)) return !1;
    if ($ac4a9effa24fe7be$var$ka.test(a)) return $ac4a9effa24fe7be$var$ma[a] = !0;
    $ac4a9effa24fe7be$var$la[a] = !0;
    return !1;
}
function $ac4a9effa24fe7be$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $ac4a9effa24fe7be$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $ac4a9effa24fe7be$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $ac4a9effa24fe7be$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $ac4a9effa24fe7be$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $ac4a9effa24fe7be$var$ra = /[\-:]([a-z])/g;
function $ac4a9effa24fe7be$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($ac4a9effa24fe7be$var$ra, $ac4a9effa24fe7be$var$sa);
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($ac4a9effa24fe7be$var$ra, $ac4a9effa24fe7be$var$sa);
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($ac4a9effa24fe7be$var$ra, $ac4a9effa24fe7be$var$sa);
    $ac4a9effa24fe7be$var$z[b] = new $ac4a9effa24fe7be$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$ac4a9effa24fe7be$var$z.xlinkHref = new $ac4a9effa24fe7be$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $ac4a9effa24fe7be$var$z[a] = new $ac4a9effa24fe7be$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $ac4a9effa24fe7be$var$ta(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$z.hasOwnProperty(b) ? $ac4a9effa24fe7be$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $ac4a9effa24fe7be$var$qa(b, c, e, d) && (c = null), d || null === e ? $ac4a9effa24fe7be$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $ac4a9effa24fe7be$var$ua = $gIfym.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $ac4a9effa24fe7be$var$va = Symbol.for("react.element"), $ac4a9effa24fe7be$var$wa = Symbol.for("react.portal"), $ac4a9effa24fe7be$var$ya = Symbol.for("react.fragment"), $ac4a9effa24fe7be$var$za = Symbol.for("react.strict_mode"), $ac4a9effa24fe7be$var$Aa = Symbol.for("react.profiler"), $ac4a9effa24fe7be$var$Ba = Symbol.for("react.provider"), $ac4a9effa24fe7be$var$Ca = Symbol.for("react.context"), $ac4a9effa24fe7be$var$Da = Symbol.for("react.forward_ref"), $ac4a9effa24fe7be$var$Ea = Symbol.for("react.suspense"), $ac4a9effa24fe7be$var$Fa = Symbol.for("react.suspense_list"), $ac4a9effa24fe7be$var$Ga = Symbol.for("react.memo"), $ac4a9effa24fe7be$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $ac4a9effa24fe7be$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $ac4a9effa24fe7be$var$Ja = Symbol.iterator;
function $ac4a9effa24fe7be$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ac4a9effa24fe7be$var$Ja && a[$ac4a9effa24fe7be$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ac4a9effa24fe7be$var$A = Object.assign, $ac4a9effa24fe7be$var$La;
function $ac4a9effa24fe7be$var$Ma(a) {
    if (void 0 === $ac4a9effa24fe7be$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $ac4a9effa24fe7be$var$La = b && b[1] || "";
    }
    return "\n" + $ac4a9effa24fe7be$var$La + a;
}
var $ac4a9effa24fe7be$var$Na = !1;
function $ac4a9effa24fe7be$var$Oa(a, b) {
    if (!a || $ac4a9effa24fe7be$var$Na) return "";
    $ac4a9effa24fe7be$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $ac4a9effa24fe7be$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $ac4a9effa24fe7be$var$Ma(a) : "";
}
function $ac4a9effa24fe7be$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $ac4a9effa24fe7be$var$Ma(a.type);
        case 16:
            return $ac4a9effa24fe7be$var$Ma("Lazy");
        case 13:
            return $ac4a9effa24fe7be$var$Ma("Suspense");
        case 19:
            return $ac4a9effa24fe7be$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $ac4a9effa24fe7be$var$Oa(a.type, !1), a;
        case 11:
            return a = $ac4a9effa24fe7be$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $ac4a9effa24fe7be$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $ac4a9effa24fe7be$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $ac4a9effa24fe7be$var$ya:
            return "Fragment";
        case $ac4a9effa24fe7be$var$wa:
            return "Portal";
        case $ac4a9effa24fe7be$var$Aa:
            return "Profiler";
        case $ac4a9effa24fe7be$var$za:
            return "StrictMode";
        case $ac4a9effa24fe7be$var$Ea:
            return "Suspense";
        case $ac4a9effa24fe7be$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $ac4a9effa24fe7be$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $ac4a9effa24fe7be$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $ac4a9effa24fe7be$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $ac4a9effa24fe7be$var$Ga:
            return b = a.displayName || null, null !== b ? b : $ac4a9effa24fe7be$var$Qa(a.type) || "Memo";
        case $ac4a9effa24fe7be$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $ac4a9effa24fe7be$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $ac4a9effa24fe7be$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $ac4a9effa24fe7be$var$Qa(b);
        case 8:
            return b === $ac4a9effa24fe7be$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $ac4a9effa24fe7be$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $ac4a9effa24fe7be$var$Ua(a) {
    var b = $ac4a9effa24fe7be$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $ac4a9effa24fe7be$var$Va(a) {
    a._valueTracker || (a._valueTracker = $ac4a9effa24fe7be$var$Ua(a));
}
function $ac4a9effa24fe7be$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $ac4a9effa24fe7be$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $ac4a9effa24fe7be$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $ac4a9effa24fe7be$var$Ya(a, b) {
    var c = b.checked;
    return $ac4a9effa24fe7be$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $ac4a9effa24fe7be$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $ac4a9effa24fe7be$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $ac4a9effa24fe7be$var$ab(a, b) {
    b = b.checked;
    null != b && $ac4a9effa24fe7be$var$ta(a, "checked", b, !1);
}
function $ac4a9effa24fe7be$var$bb(a, b) {
    $ac4a9effa24fe7be$var$ab(a, b);
    var c = $ac4a9effa24fe7be$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $ac4a9effa24fe7be$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $ac4a9effa24fe7be$var$cb(a, b.type, $ac4a9effa24fe7be$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $ac4a9effa24fe7be$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $ac4a9effa24fe7be$var$cb(a, b, c) {
    if ("number" !== b || $ac4a9effa24fe7be$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $ac4a9effa24fe7be$var$eb = Array.isArray;
function $ac4a9effa24fe7be$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $ac4a9effa24fe7be$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $ac4a9effa24fe7be$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($ac4a9effa24fe7be$var$p(91));
    return $ac4a9effa24fe7be$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $ac4a9effa24fe7be$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($ac4a9effa24fe7be$var$p(92));
            if ($ac4a9effa24fe7be$var$eb(c)) {
                if (1 < c.length) throw Error($ac4a9effa24fe7be$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $ac4a9effa24fe7be$var$Sa(c)
    };
}
function $ac4a9effa24fe7be$var$ib(a, b) {
    var c = $ac4a9effa24fe7be$var$Sa(b.value), d = $ac4a9effa24fe7be$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $ac4a9effa24fe7be$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $ac4a9effa24fe7be$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $ac4a9effa24fe7be$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $ac4a9effa24fe7be$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $ac4a9effa24fe7be$var$mb, $ac4a9effa24fe7be$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $ac4a9effa24fe7be$var$mb = $ac4a9effa24fe7be$var$mb || document.createElement("div");
        $ac4a9effa24fe7be$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $ac4a9effa24fe7be$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $ac4a9effa24fe7be$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $ac4a9effa24fe7be$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $ac4a9effa24fe7be$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($ac4a9effa24fe7be$var$pb).forEach(function(a) {
    $ac4a9effa24fe7be$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $ac4a9effa24fe7be$var$pb[b] = $ac4a9effa24fe7be$var$pb[a];
    });
});
function $ac4a9effa24fe7be$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $ac4a9effa24fe7be$var$pb.hasOwnProperty(a) && $ac4a9effa24fe7be$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $ac4a9effa24fe7be$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $ac4a9effa24fe7be$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $ac4a9effa24fe7be$var$tb = $ac4a9effa24fe7be$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $ac4a9effa24fe7be$var$ub(a, b) {
    if (b) {
        if ($ac4a9effa24fe7be$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($ac4a9effa24fe7be$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($ac4a9effa24fe7be$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($ac4a9effa24fe7be$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($ac4a9effa24fe7be$var$p(62));
    }
}
function $ac4a9effa24fe7be$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $ac4a9effa24fe7be$var$wb = null;
function $ac4a9effa24fe7be$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $ac4a9effa24fe7be$var$yb = null, $ac4a9effa24fe7be$var$zb = null, $ac4a9effa24fe7be$var$Ab = null;
function $ac4a9effa24fe7be$var$Bb(a) {
    if (a = $ac4a9effa24fe7be$var$Cb(a)) {
        if ("function" !== typeof $ac4a9effa24fe7be$var$yb) throw Error($ac4a9effa24fe7be$var$p(280));
        var b = a.stateNode;
        b && (b = $ac4a9effa24fe7be$var$Db(b), $ac4a9effa24fe7be$var$yb(a.stateNode, a.type, b));
    }
}
function $ac4a9effa24fe7be$var$Eb(a) {
    $ac4a9effa24fe7be$var$zb ? $ac4a9effa24fe7be$var$Ab ? $ac4a9effa24fe7be$var$Ab.push(a) : $ac4a9effa24fe7be$var$Ab = [
        a
    ] : $ac4a9effa24fe7be$var$zb = a;
}
function $ac4a9effa24fe7be$var$Fb() {
    if ($ac4a9effa24fe7be$var$zb) {
        var a = $ac4a9effa24fe7be$var$zb, b = $ac4a9effa24fe7be$var$Ab;
        $ac4a9effa24fe7be$var$Ab = $ac4a9effa24fe7be$var$zb = null;
        $ac4a9effa24fe7be$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$ac4a9effa24fe7be$var$Bb(b[a]);
    }
}
function $ac4a9effa24fe7be$var$Gb(a, b) {
    return a(b);
}
function $ac4a9effa24fe7be$var$Hb() {}
var $ac4a9effa24fe7be$var$Ib = !1;
function $ac4a9effa24fe7be$var$Jb(a, b, c) {
    if ($ac4a9effa24fe7be$var$Ib) return a(b, c);
    $ac4a9effa24fe7be$var$Ib = !0;
    try {
        return $ac4a9effa24fe7be$var$Gb(a, b, c);
    } finally{
        if ($ac4a9effa24fe7be$var$Ib = !1, null !== $ac4a9effa24fe7be$var$zb || null !== $ac4a9effa24fe7be$var$Ab) $ac4a9effa24fe7be$var$Hb(), $ac4a9effa24fe7be$var$Fb();
    }
}
function $ac4a9effa24fe7be$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $ac4a9effa24fe7be$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($ac4a9effa24fe7be$var$p(231, b, typeof c));
    return c;
}
var $ac4a9effa24fe7be$var$Lb = !1;
if ($ac4a9effa24fe7be$var$ia) try {
    var $ac4a9effa24fe7be$var$Mb = {};
    Object.defineProperty($ac4a9effa24fe7be$var$Mb, "passive", {
        get: function() {
            $ac4a9effa24fe7be$var$Lb = !0;
        }
    });
    window.addEventListener("test", $ac4a9effa24fe7be$var$Mb, $ac4a9effa24fe7be$var$Mb);
    window.removeEventListener("test", $ac4a9effa24fe7be$var$Mb, $ac4a9effa24fe7be$var$Mb);
} catch (a) {
    $ac4a9effa24fe7be$var$Lb = !1;
}
function $ac4a9effa24fe7be$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $ac4a9effa24fe7be$var$Ob = !1, $ac4a9effa24fe7be$var$Pb = null, $ac4a9effa24fe7be$var$Qb = !1, $ac4a9effa24fe7be$var$Rb = null, $ac4a9effa24fe7be$var$Sb = {
    onError: function(a) {
        $ac4a9effa24fe7be$var$Ob = !0;
        $ac4a9effa24fe7be$var$Pb = a;
    }
};
function $ac4a9effa24fe7be$var$Tb(a, b, c, d, e, f, g, h, k) {
    $ac4a9effa24fe7be$var$Ob = !1;
    $ac4a9effa24fe7be$var$Pb = null;
    $ac4a9effa24fe7be$var$Nb.apply($ac4a9effa24fe7be$var$Sb, arguments);
}
function $ac4a9effa24fe7be$var$Ub(a, b, c, d, e, f, g, h, k) {
    $ac4a9effa24fe7be$var$Tb.apply(this, arguments);
    if ($ac4a9effa24fe7be$var$Ob) {
        if ($ac4a9effa24fe7be$var$Ob) {
            var l = $ac4a9effa24fe7be$var$Pb;
            $ac4a9effa24fe7be$var$Ob = !1;
            $ac4a9effa24fe7be$var$Pb = null;
        } else throw Error($ac4a9effa24fe7be$var$p(198));
        $ac4a9effa24fe7be$var$Qb || ($ac4a9effa24fe7be$var$Qb = !0, $ac4a9effa24fe7be$var$Rb = l);
    }
}
function $ac4a9effa24fe7be$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $ac4a9effa24fe7be$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Xb(a) {
    if ($ac4a9effa24fe7be$var$Vb(a) !== a) throw Error($ac4a9effa24fe7be$var$p(188));
}
function $ac4a9effa24fe7be$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $ac4a9effa24fe7be$var$Vb(a);
        if (null === b) throw Error($ac4a9effa24fe7be$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $ac4a9effa24fe7be$var$Xb(e), a;
                if (f === d) return $ac4a9effa24fe7be$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($ac4a9effa24fe7be$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($ac4a9effa24fe7be$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($ac4a9effa24fe7be$var$p(190));
    }
    if (3 !== c.tag) throw Error($ac4a9effa24fe7be$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $ac4a9effa24fe7be$var$Zb(a) {
    a = $ac4a9effa24fe7be$var$Yb(a);
    return null !== a ? $ac4a9effa24fe7be$var$$b(a) : null;
}
function $ac4a9effa24fe7be$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $ac4a9effa24fe7be$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $ac4a9effa24fe7be$var$ac = $Qw0kg.unstable_scheduleCallback, $ac4a9effa24fe7be$var$bc = $Qw0kg.unstable_cancelCallback, $ac4a9effa24fe7be$var$cc = $Qw0kg.unstable_shouldYield, $ac4a9effa24fe7be$var$dc = $Qw0kg.unstable_requestPaint, $ac4a9effa24fe7be$var$B = $Qw0kg.unstable_now, $ac4a9effa24fe7be$var$ec = $Qw0kg.unstable_getCurrentPriorityLevel, $ac4a9effa24fe7be$var$fc = $Qw0kg.unstable_ImmediatePriority, $ac4a9effa24fe7be$var$gc = $Qw0kg.unstable_UserBlockingPriority, $ac4a9effa24fe7be$var$hc = $Qw0kg.unstable_NormalPriority, $ac4a9effa24fe7be$var$ic = $Qw0kg.unstable_LowPriority, $ac4a9effa24fe7be$var$jc = $Qw0kg.unstable_IdlePriority, $ac4a9effa24fe7be$var$kc = null, $ac4a9effa24fe7be$var$lc = null;
function $ac4a9effa24fe7be$var$mc(a) {
    if ($ac4a9effa24fe7be$var$lc && "function" === typeof $ac4a9effa24fe7be$var$lc.onCommitFiberRoot) try {
        $ac4a9effa24fe7be$var$lc.onCommitFiberRoot($ac4a9effa24fe7be$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $ac4a9effa24fe7be$var$oc = Math.clz32 ? Math.clz32 : $ac4a9effa24fe7be$var$nc, $ac4a9effa24fe7be$var$pc = Math.log, $ac4a9effa24fe7be$var$qc = Math.LN2;
function $ac4a9effa24fe7be$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($ac4a9effa24fe7be$var$pc(a) / $ac4a9effa24fe7be$var$qc | 0) | 0;
}
var $ac4a9effa24fe7be$var$rc = 64, $ac4a9effa24fe7be$var$sc = 4194304;
function $ac4a9effa24fe7be$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $ac4a9effa24fe7be$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $ac4a9effa24fe7be$var$tc(h) : (f &= g, 0 !== f && (d = $ac4a9effa24fe7be$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $ac4a9effa24fe7be$var$tc(g) : 0 !== f && (d = $ac4a9effa24fe7be$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $ac4a9effa24fe7be$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $ac4a9effa24fe7be$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $ac4a9effa24fe7be$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $ac4a9effa24fe7be$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $ac4a9effa24fe7be$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $ac4a9effa24fe7be$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $ac4a9effa24fe7be$var$yc() {
    var a = $ac4a9effa24fe7be$var$rc;
    $ac4a9effa24fe7be$var$rc <<= 1;
    0 === ($ac4a9effa24fe7be$var$rc & 4194240) && ($ac4a9effa24fe7be$var$rc = 64);
    return a;
}
function $ac4a9effa24fe7be$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $ac4a9effa24fe7be$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $ac4a9effa24fe7be$var$oc(b);
    a[b] = c;
}
function $ac4a9effa24fe7be$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $ac4a9effa24fe7be$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $ac4a9effa24fe7be$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $ac4a9effa24fe7be$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $ac4a9effa24fe7be$var$C = 0;
function $ac4a9effa24fe7be$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $ac4a9effa24fe7be$var$Ec, $ac4a9effa24fe7be$var$Fc, $ac4a9effa24fe7be$var$Gc, $ac4a9effa24fe7be$var$Hc, $ac4a9effa24fe7be$var$Ic, $ac4a9effa24fe7be$var$Jc = !1, $ac4a9effa24fe7be$var$Kc = [], $ac4a9effa24fe7be$var$Lc = null, $ac4a9effa24fe7be$var$Mc = null, $ac4a9effa24fe7be$var$Nc = null, $ac4a9effa24fe7be$var$Oc = new Map, $ac4a9effa24fe7be$var$Pc = new Map, $ac4a9effa24fe7be$var$Qc = [], $ac4a9effa24fe7be$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $ac4a9effa24fe7be$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $ac4a9effa24fe7be$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $ac4a9effa24fe7be$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $ac4a9effa24fe7be$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $ac4a9effa24fe7be$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $ac4a9effa24fe7be$var$Pc.delete(b.pointerId);
    }
}
function $ac4a9effa24fe7be$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $ac4a9effa24fe7be$var$Cb(b), null !== b && $ac4a9effa24fe7be$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $ac4a9effa24fe7be$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $ac4a9effa24fe7be$var$Lc = $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $ac4a9effa24fe7be$var$Mc = $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $ac4a9effa24fe7be$var$Nc = $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $ac4a9effa24fe7be$var$Oc.set(f, $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $ac4a9effa24fe7be$var$Pc.set(f, $ac4a9effa24fe7be$var$Tc($ac4a9effa24fe7be$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $ac4a9effa24fe7be$var$Vc(a) {
    var b = $ac4a9effa24fe7be$var$Wc(a.target);
    if (null !== b) {
        var c = $ac4a9effa24fe7be$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $ac4a9effa24fe7be$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $ac4a9effa24fe7be$var$Ic(a.priority, function() {
                        $ac4a9effa24fe7be$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $ac4a9effa24fe7be$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $ac4a9effa24fe7be$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $ac4a9effa24fe7be$var$wb = d;
            c.target.dispatchEvent(d);
            $ac4a9effa24fe7be$var$wb = null;
        } else return b = $ac4a9effa24fe7be$var$Cb(c), null !== b && $ac4a9effa24fe7be$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $ac4a9effa24fe7be$var$Zc(a, b, c) {
    $ac4a9effa24fe7be$var$Xc(a) && c.delete(b);
}
function $ac4a9effa24fe7be$var$$c() {
    $ac4a9effa24fe7be$var$Jc = !1;
    null !== $ac4a9effa24fe7be$var$Lc && $ac4a9effa24fe7be$var$Xc($ac4a9effa24fe7be$var$Lc) && ($ac4a9effa24fe7be$var$Lc = null);
    null !== $ac4a9effa24fe7be$var$Mc && $ac4a9effa24fe7be$var$Xc($ac4a9effa24fe7be$var$Mc) && ($ac4a9effa24fe7be$var$Mc = null);
    null !== $ac4a9effa24fe7be$var$Nc && $ac4a9effa24fe7be$var$Xc($ac4a9effa24fe7be$var$Nc) && ($ac4a9effa24fe7be$var$Nc = null);
    $ac4a9effa24fe7be$var$Oc.forEach($ac4a9effa24fe7be$var$Zc);
    $ac4a9effa24fe7be$var$Pc.forEach($ac4a9effa24fe7be$var$Zc);
}
function $ac4a9effa24fe7be$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $ac4a9effa24fe7be$var$Jc || ($ac4a9effa24fe7be$var$Jc = !0, $Qw0kg.unstable_scheduleCallback($Qw0kg.unstable_NormalPriority, $ac4a9effa24fe7be$var$$c)));
}
function $ac4a9effa24fe7be$var$bd(a) {
    function b(b) {
        return $ac4a9effa24fe7be$var$ad(b, a);
    }
    if (0 < $ac4a9effa24fe7be$var$Kc.length) {
        $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Kc[0], a);
        for(var c = 1; c < $ac4a9effa24fe7be$var$Kc.length; c++){
            var d = $ac4a9effa24fe7be$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $ac4a9effa24fe7be$var$Lc && $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Lc, a);
    null !== $ac4a9effa24fe7be$var$Mc && $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Mc, a);
    null !== $ac4a9effa24fe7be$var$Nc && $ac4a9effa24fe7be$var$ad($ac4a9effa24fe7be$var$Nc, a);
    $ac4a9effa24fe7be$var$Oc.forEach(b);
    $ac4a9effa24fe7be$var$Pc.forEach(b);
    for(c = 0; c < $ac4a9effa24fe7be$var$Qc.length; c++)d = $ac4a9effa24fe7be$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $ac4a9effa24fe7be$var$Qc.length && (c = $ac4a9effa24fe7be$var$Qc[0], null === c.blockedOn);)$ac4a9effa24fe7be$var$Vc(c), null === c.blockedOn && $ac4a9effa24fe7be$var$Qc.shift();
}
var $ac4a9effa24fe7be$var$cd = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig, $ac4a9effa24fe7be$var$dd = !0;
function $ac4a9effa24fe7be$var$ed(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$C, f = $ac4a9effa24fe7be$var$cd.transition;
    $ac4a9effa24fe7be$var$cd.transition = null;
    try {
        $ac4a9effa24fe7be$var$C = 1, $ac4a9effa24fe7be$var$fd(a, b, c, d);
    } finally{
        $ac4a9effa24fe7be$var$C = e, $ac4a9effa24fe7be$var$cd.transition = f;
    }
}
function $ac4a9effa24fe7be$var$gd(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$C, f = $ac4a9effa24fe7be$var$cd.transition;
    $ac4a9effa24fe7be$var$cd.transition = null;
    try {
        $ac4a9effa24fe7be$var$C = 4, $ac4a9effa24fe7be$var$fd(a, b, c, d);
    } finally{
        $ac4a9effa24fe7be$var$C = e, $ac4a9effa24fe7be$var$cd.transition = f;
    }
}
function $ac4a9effa24fe7be$var$fd(a, b, c, d) {
    if ($ac4a9effa24fe7be$var$dd) {
        var e = $ac4a9effa24fe7be$var$Yc(a, b, c, d);
        if (null === e) $ac4a9effa24fe7be$var$hd(a, b, d, $ac4a9effa24fe7be$var$id, c), $ac4a9effa24fe7be$var$Sc(a, d);
        else if ($ac4a9effa24fe7be$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($ac4a9effa24fe7be$var$Sc(a, d), b & 4 && -1 < $ac4a9effa24fe7be$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $ac4a9effa24fe7be$var$Cb(e);
                null !== f && $ac4a9effa24fe7be$var$Ec(f);
                f = $ac4a9effa24fe7be$var$Yc(a, b, c, d);
                null === f && $ac4a9effa24fe7be$var$hd(a, b, d, $ac4a9effa24fe7be$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $ac4a9effa24fe7be$var$hd(a, b, d, null, c);
    }
}
var $ac4a9effa24fe7be$var$id = null;
function $ac4a9effa24fe7be$var$Yc(a, b, c, d) {
    $ac4a9effa24fe7be$var$id = null;
    a = $ac4a9effa24fe7be$var$xb(d);
    a = $ac4a9effa24fe7be$var$Wc(a);
    if (null !== a) {
        if (b = $ac4a9effa24fe7be$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $ac4a9effa24fe7be$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $ac4a9effa24fe7be$var$id = a;
    return null;
}
function $ac4a9effa24fe7be$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($ac4a9effa24fe7be$var$ec()){
                case $ac4a9effa24fe7be$var$fc:
                    return 1;
                case $ac4a9effa24fe7be$var$gc:
                    return 4;
                case $ac4a9effa24fe7be$var$hc:
                case $ac4a9effa24fe7be$var$ic:
                    return 16;
                case $ac4a9effa24fe7be$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $ac4a9effa24fe7be$var$kd = null, $ac4a9effa24fe7be$var$ld = null, $ac4a9effa24fe7be$var$md = null;
function $ac4a9effa24fe7be$var$nd() {
    if ($ac4a9effa24fe7be$var$md) return $ac4a9effa24fe7be$var$md;
    var a, b = $ac4a9effa24fe7be$var$ld, c = b.length, d, e = "value" in $ac4a9effa24fe7be$var$kd ? $ac4a9effa24fe7be$var$kd.value : $ac4a9effa24fe7be$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $ac4a9effa24fe7be$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $ac4a9effa24fe7be$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $ac4a9effa24fe7be$var$pd() {
    return !0;
}
function $ac4a9effa24fe7be$var$qd() {
    return !1;
}
function $ac4a9effa24fe7be$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $ac4a9effa24fe7be$var$pd : $ac4a9effa24fe7be$var$qd;
        this.isPropagationStopped = $ac4a9effa24fe7be$var$qd;
        return this;
    }
    $ac4a9effa24fe7be$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $ac4a9effa24fe7be$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $ac4a9effa24fe7be$var$pd);
        },
        persist: function() {},
        isPersistent: $ac4a9effa24fe7be$var$pd
    });
    return b;
}
var $ac4a9effa24fe7be$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $ac4a9effa24fe7be$var$td = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$sd), $ac4a9effa24fe7be$var$ud = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    view: 0,
    detail: 0
}), $ac4a9effa24fe7be$var$vd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$ud), $ac4a9effa24fe7be$var$wd, $ac4a9effa24fe7be$var$xd, $ac4a9effa24fe7be$var$yd, $ac4a9effa24fe7be$var$Ad = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $ac4a9effa24fe7be$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $ac4a9effa24fe7be$var$yd && ($ac4a9effa24fe7be$var$yd && "mousemove" === a.type ? ($ac4a9effa24fe7be$var$wd = a.screenX - $ac4a9effa24fe7be$var$yd.screenX, $ac4a9effa24fe7be$var$xd = a.screenY - $ac4a9effa24fe7be$var$yd.screenY) : $ac4a9effa24fe7be$var$xd = $ac4a9effa24fe7be$var$wd = 0, $ac4a9effa24fe7be$var$yd = a);
        return $ac4a9effa24fe7be$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $ac4a9effa24fe7be$var$xd;
    }
}), $ac4a9effa24fe7be$var$Bd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Ad), $ac4a9effa24fe7be$var$Cd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$Ad, {
    dataTransfer: 0
}), $ac4a9effa24fe7be$var$Dd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Cd), $ac4a9effa24fe7be$var$Ed = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    relatedTarget: 0
}), $ac4a9effa24fe7be$var$Fd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Ed), $ac4a9effa24fe7be$var$Gd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ac4a9effa24fe7be$var$Hd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Gd), $ac4a9effa24fe7be$var$Id = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $ac4a9effa24fe7be$var$Jd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Id), $ac4a9effa24fe7be$var$Kd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    data: 0
}), $ac4a9effa24fe7be$var$Ld = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Kd), $ac4a9effa24fe7be$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $ac4a9effa24fe7be$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $ac4a9effa24fe7be$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $ac4a9effa24fe7be$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $ac4a9effa24fe7be$var$Od[a]) ? !!b[a] : !1;
}
function $ac4a9effa24fe7be$var$zd() {
    return $ac4a9effa24fe7be$var$Pd;
}
var $ac4a9effa24fe7be$var$Qd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $ac4a9effa24fe7be$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $ac4a9effa24fe7be$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $ac4a9effa24fe7be$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $ac4a9effa24fe7be$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $ac4a9effa24fe7be$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $ac4a9effa24fe7be$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $ac4a9effa24fe7be$var$Rd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Qd), $ac4a9effa24fe7be$var$Sd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $ac4a9effa24fe7be$var$Td = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Sd), $ac4a9effa24fe7be$var$Ud = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $ac4a9effa24fe7be$var$zd
}), $ac4a9effa24fe7be$var$Vd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Ud), $ac4a9effa24fe7be$var$Wd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ac4a9effa24fe7be$var$Xd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Wd), $ac4a9effa24fe7be$var$Yd = $ac4a9effa24fe7be$var$A({}, $ac4a9effa24fe7be$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $ac4a9effa24fe7be$var$Zd = $ac4a9effa24fe7be$var$rd($ac4a9effa24fe7be$var$Yd), $ac4a9effa24fe7be$var$$d = [
    9,
    13,
    27,
    32
], $ac4a9effa24fe7be$var$ae = $ac4a9effa24fe7be$var$ia && "CompositionEvent" in window, $ac4a9effa24fe7be$var$be = null;
$ac4a9effa24fe7be$var$ia && "documentMode" in document && ($ac4a9effa24fe7be$var$be = document.documentMode);
var $ac4a9effa24fe7be$var$ce = $ac4a9effa24fe7be$var$ia && "TextEvent" in window && !$ac4a9effa24fe7be$var$be, $ac4a9effa24fe7be$var$de = $ac4a9effa24fe7be$var$ia && (!$ac4a9effa24fe7be$var$ae || $ac4a9effa24fe7be$var$be && 8 < $ac4a9effa24fe7be$var$be && 11 >= $ac4a9effa24fe7be$var$be), $ac4a9effa24fe7be$var$ee = String.fromCharCode(32), $ac4a9effa24fe7be$var$fe = !1;
function $ac4a9effa24fe7be$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $ac4a9effa24fe7be$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $ac4a9effa24fe7be$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $ac4a9effa24fe7be$var$ie = !1;
function $ac4a9effa24fe7be$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $ac4a9effa24fe7be$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $ac4a9effa24fe7be$var$fe = !0;
            return $ac4a9effa24fe7be$var$ee;
        case "textInput":
            return a = b.data, a === $ac4a9effa24fe7be$var$ee && $ac4a9effa24fe7be$var$fe ? null : a;
        default:
            return null;
    }
}
function $ac4a9effa24fe7be$var$ke(a, b) {
    if ($ac4a9effa24fe7be$var$ie) return "compositionend" === a || !$ac4a9effa24fe7be$var$ae && $ac4a9effa24fe7be$var$ge(a, b) ? (a = $ac4a9effa24fe7be$var$nd(), $ac4a9effa24fe7be$var$md = $ac4a9effa24fe7be$var$ld = $ac4a9effa24fe7be$var$kd = null, $ac4a9effa24fe7be$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $ac4a9effa24fe7be$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $ac4a9effa24fe7be$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $ac4a9effa24fe7be$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$ac4a9effa24fe7be$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $ac4a9effa24fe7be$var$ne(a, b, c, d) {
    $ac4a9effa24fe7be$var$Eb(d);
    b = $ac4a9effa24fe7be$var$oe(b, "onChange");
    0 < b.length && (c = new $ac4a9effa24fe7be$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $ac4a9effa24fe7be$var$pe = null, $ac4a9effa24fe7be$var$qe = null;
function $ac4a9effa24fe7be$var$re(a) {
    $ac4a9effa24fe7be$var$se(a, 0);
}
function $ac4a9effa24fe7be$var$te(a) {
    var b = $ac4a9effa24fe7be$var$ue(a);
    if ($ac4a9effa24fe7be$var$Wa(b)) return a;
}
function $ac4a9effa24fe7be$var$ve(a, b) {
    if ("change" === a) return b;
}
var $ac4a9effa24fe7be$var$we = !1;
if ($ac4a9effa24fe7be$var$ia) {
    var $ac4a9effa24fe7be$var$xe;
    if ($ac4a9effa24fe7be$var$ia) {
        var $ac4a9effa24fe7be$var$ye = "oninput" in document;
        if (!$ac4a9effa24fe7be$var$ye) {
            var $ac4a9effa24fe7be$var$ze = document.createElement("div");
            $ac4a9effa24fe7be$var$ze.setAttribute("oninput", "return;");
            $ac4a9effa24fe7be$var$ye = "function" === typeof $ac4a9effa24fe7be$var$ze.oninput;
        }
        $ac4a9effa24fe7be$var$xe = $ac4a9effa24fe7be$var$ye;
    } else $ac4a9effa24fe7be$var$xe = !1;
    $ac4a9effa24fe7be$var$we = $ac4a9effa24fe7be$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $ac4a9effa24fe7be$var$Ae() {
    $ac4a9effa24fe7be$var$pe && ($ac4a9effa24fe7be$var$pe.detachEvent("onpropertychange", $ac4a9effa24fe7be$var$Be), $ac4a9effa24fe7be$var$qe = $ac4a9effa24fe7be$var$pe = null);
}
function $ac4a9effa24fe7be$var$Be(a) {
    if ("value" === a.propertyName && $ac4a9effa24fe7be$var$te($ac4a9effa24fe7be$var$qe)) {
        var b = [];
        $ac4a9effa24fe7be$var$ne(b, $ac4a9effa24fe7be$var$qe, a, $ac4a9effa24fe7be$var$xb(a));
        $ac4a9effa24fe7be$var$Jb($ac4a9effa24fe7be$var$re, b);
    }
}
function $ac4a9effa24fe7be$var$Ce(a, b, c) {
    "focusin" === a ? ($ac4a9effa24fe7be$var$Ae(), $ac4a9effa24fe7be$var$pe = b, $ac4a9effa24fe7be$var$qe = c, $ac4a9effa24fe7be$var$pe.attachEvent("onpropertychange", $ac4a9effa24fe7be$var$Be)) : "focusout" === a && $ac4a9effa24fe7be$var$Ae();
}
function $ac4a9effa24fe7be$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $ac4a9effa24fe7be$var$te($ac4a9effa24fe7be$var$qe);
}
function $ac4a9effa24fe7be$var$Ee(a, b) {
    if ("click" === a) return $ac4a9effa24fe7be$var$te(b);
}
function $ac4a9effa24fe7be$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $ac4a9effa24fe7be$var$te(b);
}
function $ac4a9effa24fe7be$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ac4a9effa24fe7be$var$He = "function" === typeof Object.is ? Object.is : $ac4a9effa24fe7be$var$Ge;
function $ac4a9effa24fe7be$var$Ie(a, b) {
    if ($ac4a9effa24fe7be$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$ac4a9effa24fe7be$var$ja.call(b, e) || !$ac4a9effa24fe7be$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $ac4a9effa24fe7be$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $ac4a9effa24fe7be$var$Ke(a, b) {
    var c = $ac4a9effa24fe7be$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $ac4a9effa24fe7be$var$Je(c);
    }
}
function $ac4a9effa24fe7be$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $ac4a9effa24fe7be$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $ac4a9effa24fe7be$var$Me() {
    for(var a = window, b = $ac4a9effa24fe7be$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $ac4a9effa24fe7be$var$Xa(a.document);
    }
    return b;
}
function $ac4a9effa24fe7be$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $ac4a9effa24fe7be$var$Oe(a) {
    var b = $ac4a9effa24fe7be$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $ac4a9effa24fe7be$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $ac4a9effa24fe7be$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $ac4a9effa24fe7be$var$Ke(c, f);
                var g = $ac4a9effa24fe7be$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $ac4a9effa24fe7be$var$Pe = $ac4a9effa24fe7be$var$ia && "documentMode" in document && 11 >= document.documentMode, $ac4a9effa24fe7be$var$Qe = null, $ac4a9effa24fe7be$var$Re = null, $ac4a9effa24fe7be$var$Se = null, $ac4a9effa24fe7be$var$Te = !1;
function $ac4a9effa24fe7be$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $ac4a9effa24fe7be$var$Te || null == $ac4a9effa24fe7be$var$Qe || $ac4a9effa24fe7be$var$Qe !== $ac4a9effa24fe7be$var$Xa(d) || (d = $ac4a9effa24fe7be$var$Qe, "selectionStart" in d && $ac4a9effa24fe7be$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $ac4a9effa24fe7be$var$Se && $ac4a9effa24fe7be$var$Ie($ac4a9effa24fe7be$var$Se, d) || ($ac4a9effa24fe7be$var$Se = d, d = $ac4a9effa24fe7be$var$oe($ac4a9effa24fe7be$var$Re, "onSelect"), 0 < d.length && (b = new $ac4a9effa24fe7be$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $ac4a9effa24fe7be$var$Qe)));
}
function $ac4a9effa24fe7be$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $ac4a9effa24fe7be$var$We = {
    animationend: $ac4a9effa24fe7be$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $ac4a9effa24fe7be$var$Ve("Animation", "AnimationIteration"),
    animationstart: $ac4a9effa24fe7be$var$Ve("Animation", "AnimationStart"),
    transitionend: $ac4a9effa24fe7be$var$Ve("Transition", "TransitionEnd")
}, $ac4a9effa24fe7be$var$Xe = {}, $ac4a9effa24fe7be$var$Ye = {};
$ac4a9effa24fe7be$var$ia && ($ac4a9effa24fe7be$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $ac4a9effa24fe7be$var$We.animationend.animation, delete $ac4a9effa24fe7be$var$We.animationiteration.animation, delete $ac4a9effa24fe7be$var$We.animationstart.animation), "TransitionEvent" in window || delete $ac4a9effa24fe7be$var$We.transitionend.transition);
function $ac4a9effa24fe7be$var$Ze(a) {
    if ($ac4a9effa24fe7be$var$Xe[a]) return $ac4a9effa24fe7be$var$Xe[a];
    if (!$ac4a9effa24fe7be$var$We[a]) return a;
    var b = $ac4a9effa24fe7be$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $ac4a9effa24fe7be$var$Ye) return $ac4a9effa24fe7be$var$Xe[a] = b[c];
    return a;
}
var $ac4a9effa24fe7be$var$$e = $ac4a9effa24fe7be$var$Ze("animationend"), $ac4a9effa24fe7be$var$af = $ac4a9effa24fe7be$var$Ze("animationiteration"), $ac4a9effa24fe7be$var$bf = $ac4a9effa24fe7be$var$Ze("animationstart"), $ac4a9effa24fe7be$var$cf = $ac4a9effa24fe7be$var$Ze("transitionend"), $ac4a9effa24fe7be$var$df = new Map, $ac4a9effa24fe7be$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $ac4a9effa24fe7be$var$ff(a, b) {
    $ac4a9effa24fe7be$var$df.set(a, b);
    $ac4a9effa24fe7be$var$fa(b, [
        a
    ]);
}
for(var $ac4a9effa24fe7be$var$gf = 0; $ac4a9effa24fe7be$var$gf < $ac4a9effa24fe7be$var$ef.length; $ac4a9effa24fe7be$var$gf++){
    var $ac4a9effa24fe7be$var$hf = $ac4a9effa24fe7be$var$ef[$ac4a9effa24fe7be$var$gf], $ac4a9effa24fe7be$var$jf = $ac4a9effa24fe7be$var$hf.toLowerCase(), $ac4a9effa24fe7be$var$kf = $ac4a9effa24fe7be$var$hf[0].toUpperCase() + $ac4a9effa24fe7be$var$hf.slice(1);
    $ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$jf, "on" + $ac4a9effa24fe7be$var$kf);
}
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$$e, "onAnimationEnd");
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$af, "onAnimationIteration");
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$bf, "onAnimationStart");
$ac4a9effa24fe7be$var$ff("dblclick", "onDoubleClick");
$ac4a9effa24fe7be$var$ff("focusin", "onFocus");
$ac4a9effa24fe7be$var$ff("focusout", "onBlur");
$ac4a9effa24fe7be$var$ff($ac4a9effa24fe7be$var$cf, "onTransitionEnd");
$ac4a9effa24fe7be$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$ac4a9effa24fe7be$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$ac4a9effa24fe7be$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$ac4a9effa24fe7be$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$ac4a9effa24fe7be$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$ac4a9effa24fe7be$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$ac4a9effa24fe7be$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$ac4a9effa24fe7be$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$ac4a9effa24fe7be$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$ac4a9effa24fe7be$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $ac4a9effa24fe7be$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $ac4a9effa24fe7be$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($ac4a9effa24fe7be$var$lf));
function $ac4a9effa24fe7be$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $ac4a9effa24fe7be$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $ac4a9effa24fe7be$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $ac4a9effa24fe7be$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $ac4a9effa24fe7be$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($ac4a9effa24fe7be$var$Qb) throw a = $ac4a9effa24fe7be$var$Rb, $ac4a9effa24fe7be$var$Qb = !1, $ac4a9effa24fe7be$var$Rb = null, a;
}
function $ac4a9effa24fe7be$var$D(a, b) {
    var c = b[$ac4a9effa24fe7be$var$of];
    void 0 === c && (c = b[$ac4a9effa24fe7be$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($ac4a9effa24fe7be$var$pf(b, a, 2, !1), c.add(d));
}
function $ac4a9effa24fe7be$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $ac4a9effa24fe7be$var$pf(c, a, d, b);
}
var $ac4a9effa24fe7be$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $ac4a9effa24fe7be$var$sf(a) {
    if (!a[$ac4a9effa24fe7be$var$rf]) {
        a[$ac4a9effa24fe7be$var$rf] = !0;
        $ac4a9effa24fe7be$var$da.forEach(function(b) {
            "selectionchange" !== b && ($ac4a9effa24fe7be$var$mf.has(b) || $ac4a9effa24fe7be$var$qf(b, !1, a), $ac4a9effa24fe7be$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$ac4a9effa24fe7be$var$rf] || (b[$ac4a9effa24fe7be$var$rf] = !0, $ac4a9effa24fe7be$var$qf("selectionchange", !1, b));
    }
}
function $ac4a9effa24fe7be$var$pf(a, b, c, d) {
    switch($ac4a9effa24fe7be$var$jd(b)){
        case 1:
            var e = $ac4a9effa24fe7be$var$ed;
            break;
        case 4:
            e = $ac4a9effa24fe7be$var$gd;
            break;
        default:
            e = $ac4a9effa24fe7be$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$ac4a9effa24fe7be$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $ac4a9effa24fe7be$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $ac4a9effa24fe7be$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $ac4a9effa24fe7be$var$Jb(function() {
        var d = f, e = $ac4a9effa24fe7be$var$xb(c), g = [];
        a: {
            var h = $ac4a9effa24fe7be$var$df.get(a);
            if (void 0 !== h) {
                var k = $ac4a9effa24fe7be$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $ac4a9effa24fe7be$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $ac4a9effa24fe7be$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $ac4a9effa24fe7be$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $ac4a9effa24fe7be$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $ac4a9effa24fe7be$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $ac4a9effa24fe7be$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $ac4a9effa24fe7be$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $ac4a9effa24fe7be$var$Vd;
                        break;
                    case $ac4a9effa24fe7be$var$$e:
                    case $ac4a9effa24fe7be$var$af:
                    case $ac4a9effa24fe7be$var$bf:
                        k = $ac4a9effa24fe7be$var$Hd;
                        break;
                    case $ac4a9effa24fe7be$var$cf:
                        k = $ac4a9effa24fe7be$var$Xd;
                        break;
                    case "scroll":
                        k = $ac4a9effa24fe7be$var$vd;
                        break;
                    case "wheel":
                        k = $ac4a9effa24fe7be$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $ac4a9effa24fe7be$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $ac4a9effa24fe7be$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $ac4a9effa24fe7be$var$Kb(w, x), null != F && t.push($ac4a9effa24fe7be$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $ac4a9effa24fe7be$var$wb && (n = c.relatedTarget || c.fromElement) && ($ac4a9effa24fe7be$var$Wc(n) || n[$ac4a9effa24fe7be$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $ac4a9effa24fe7be$var$Wc(n) : null, null !== n && (J = $ac4a9effa24fe7be$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $ac4a9effa24fe7be$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $ac4a9effa24fe7be$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $ac4a9effa24fe7be$var$ue(k);
                        u = null == n ? h : $ac4a9effa24fe7be$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $ac4a9effa24fe7be$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $ac4a9effa24fe7be$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $ac4a9effa24fe7be$var$vf(F))u++;
                            for(; 0 < w - u;)t = $ac4a9effa24fe7be$var$vf(t), w--;
                            for(; 0 < u - w;)x = $ac4a9effa24fe7be$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $ac4a9effa24fe7be$var$vf(t);
                                x = $ac4a9effa24fe7be$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $ac4a9effa24fe7be$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $ac4a9effa24fe7be$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $ac4a9effa24fe7be$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $ac4a9effa24fe7be$var$ve;
                else if ($ac4a9effa24fe7be$var$me(h)) {
                    if ($ac4a9effa24fe7be$var$we) na = $ac4a9effa24fe7be$var$Fe;
                    else {
                        na = $ac4a9effa24fe7be$var$De;
                        var xa = $ac4a9effa24fe7be$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $ac4a9effa24fe7be$var$Ee);
                if (na && (na = na(a, d))) {
                    $ac4a9effa24fe7be$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $ac4a9effa24fe7be$var$cb(h, "number", h.value);
            }
            xa = d ? $ac4a9effa24fe7be$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($ac4a9effa24fe7be$var$me(xa) || "true" === xa.contentEditable) $ac4a9effa24fe7be$var$Qe = xa, $ac4a9effa24fe7be$var$Re = d, $ac4a9effa24fe7be$var$Se = null;
                    break;
                case "focusout":
                    $ac4a9effa24fe7be$var$Se = $ac4a9effa24fe7be$var$Re = $ac4a9effa24fe7be$var$Qe = null;
                    break;
                case "mousedown":
                    $ac4a9effa24fe7be$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $ac4a9effa24fe7be$var$Te = !1;
                    $ac4a9effa24fe7be$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($ac4a9effa24fe7be$var$Pe) break;
                case "keydown":
                case "keyup":
                    $ac4a9effa24fe7be$var$Ue(g, c, e);
            }
            var $a;
            if ($ac4a9effa24fe7be$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $ac4a9effa24fe7be$var$ie ? $ac4a9effa24fe7be$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($ac4a9effa24fe7be$var$de && "ko" !== c.locale && ($ac4a9effa24fe7be$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $ac4a9effa24fe7be$var$ie && ($a = $ac4a9effa24fe7be$var$nd()) : ($ac4a9effa24fe7be$var$kd = e, $ac4a9effa24fe7be$var$ld = "value" in $ac4a9effa24fe7be$var$kd ? $ac4a9effa24fe7be$var$kd.value : $ac4a9effa24fe7be$var$kd.textContent, $ac4a9effa24fe7be$var$ie = !0)), xa = $ac4a9effa24fe7be$var$oe(d, ba), 0 < xa.length && (ba = new $ac4a9effa24fe7be$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $ac4a9effa24fe7be$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $ac4a9effa24fe7be$var$ce ? $ac4a9effa24fe7be$var$je(a, c) : $ac4a9effa24fe7be$var$ke(a, c)) d = $ac4a9effa24fe7be$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $ac4a9effa24fe7be$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $ac4a9effa24fe7be$var$se(g, b);
    });
}
function $ac4a9effa24fe7be$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $ac4a9effa24fe7be$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $ac4a9effa24fe7be$var$Kb(a, c), null != f && d.unshift($ac4a9effa24fe7be$var$tf(a, f, e)), f = $ac4a9effa24fe7be$var$Kb(a, b), null != f && d.push($ac4a9effa24fe7be$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $ac4a9effa24fe7be$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $ac4a9effa24fe7be$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $ac4a9effa24fe7be$var$Kb(c, f), null != k && g.unshift($ac4a9effa24fe7be$var$tf(c, k, h))) : e || (k = $ac4a9effa24fe7be$var$Kb(c, f), null != k && g.push($ac4a9effa24fe7be$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $ac4a9effa24fe7be$var$xf = /\r\n?/g, $ac4a9effa24fe7be$var$yf = /\u0000|\uFFFD/g;
function $ac4a9effa24fe7be$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($ac4a9effa24fe7be$var$xf, "\n").replace($ac4a9effa24fe7be$var$yf, "");
}
function $ac4a9effa24fe7be$var$Af(a, b, c) {
    b = $ac4a9effa24fe7be$var$zf(b);
    if ($ac4a9effa24fe7be$var$zf(a) !== b && c) throw Error($ac4a9effa24fe7be$var$p(425));
}
function $ac4a9effa24fe7be$var$Bf() {}
var $ac4a9effa24fe7be$var$Cf = null, $ac4a9effa24fe7be$var$Df = null;
function $ac4a9effa24fe7be$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $ac4a9effa24fe7be$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $ac4a9effa24fe7be$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $ac4a9effa24fe7be$var$Hf = "function" === typeof Promise ? Promise : void 0, $ac4a9effa24fe7be$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $ac4a9effa24fe7be$var$Hf ? function(a) {
    return $ac4a9effa24fe7be$var$Hf.resolve(null).then(a).catch($ac4a9effa24fe7be$var$If);
} : $ac4a9effa24fe7be$var$Ff;
function $ac4a9effa24fe7be$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $ac4a9effa24fe7be$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $ac4a9effa24fe7be$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $ac4a9effa24fe7be$var$bd(b);
}
function $ac4a9effa24fe7be$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $ac4a9effa24fe7be$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $ac4a9effa24fe7be$var$Nf = Math.random().toString(36).slice(2), $ac4a9effa24fe7be$var$Of = "__reactFiber$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$Pf = "__reactProps$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$uf = "__reactContainer$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$of = "__reactEvents$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$Qf = "__reactListeners$" + $ac4a9effa24fe7be$var$Nf, $ac4a9effa24fe7be$var$Rf = "__reactHandles$" + $ac4a9effa24fe7be$var$Nf;
function $ac4a9effa24fe7be$var$Wc(a) {
    var b = a[$ac4a9effa24fe7be$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$ac4a9effa24fe7be$var$uf] || c[$ac4a9effa24fe7be$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $ac4a9effa24fe7be$var$Mf(a); null !== a;){
                if (c = a[$ac4a9effa24fe7be$var$Of]) return c;
                a = $ac4a9effa24fe7be$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Cb(a) {
    a = a[$ac4a9effa24fe7be$var$Of] || a[$ac4a9effa24fe7be$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $ac4a9effa24fe7be$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($ac4a9effa24fe7be$var$p(33));
}
function $ac4a9effa24fe7be$var$Db(a) {
    return a[$ac4a9effa24fe7be$var$Pf] || null;
}
var $ac4a9effa24fe7be$var$Sf = [], $ac4a9effa24fe7be$var$Tf = -1;
function $ac4a9effa24fe7be$var$Uf(a) {
    return {
        current: a
    };
}
function $ac4a9effa24fe7be$var$E(a) {
    0 > $ac4a9effa24fe7be$var$Tf || (a.current = $ac4a9effa24fe7be$var$Sf[$ac4a9effa24fe7be$var$Tf], $ac4a9effa24fe7be$var$Sf[$ac4a9effa24fe7be$var$Tf] = null, $ac4a9effa24fe7be$var$Tf--);
}
function $ac4a9effa24fe7be$var$G(a, b) {
    $ac4a9effa24fe7be$var$Tf++;
    $ac4a9effa24fe7be$var$Sf[$ac4a9effa24fe7be$var$Tf] = a.current;
    a.current = b;
}
var $ac4a9effa24fe7be$var$Vf = {}, $ac4a9effa24fe7be$var$H = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$Vf), $ac4a9effa24fe7be$var$Wf = $ac4a9effa24fe7be$var$Uf(!1), $ac4a9effa24fe7be$var$Xf = $ac4a9effa24fe7be$var$Vf;
function $ac4a9effa24fe7be$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $ac4a9effa24fe7be$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $ac4a9effa24fe7be$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $ac4a9effa24fe7be$var$$f() {
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H);
}
function $ac4a9effa24fe7be$var$ag(a, b, c) {
    if ($ac4a9effa24fe7be$var$H.current !== $ac4a9effa24fe7be$var$Vf) throw Error($ac4a9effa24fe7be$var$p(168));
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$H, b);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wf, c);
}
function $ac4a9effa24fe7be$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($ac4a9effa24fe7be$var$p(108, $ac4a9effa24fe7be$var$Ra(a) || "Unknown", e));
    return $ac4a9effa24fe7be$var$A({}, c, d);
}
function $ac4a9effa24fe7be$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $ac4a9effa24fe7be$var$Vf;
    $ac4a9effa24fe7be$var$Xf = $ac4a9effa24fe7be$var$H.current;
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$H, a);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wf, $ac4a9effa24fe7be$var$Wf.current);
    return !0;
}
function $ac4a9effa24fe7be$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($ac4a9effa24fe7be$var$p(169));
    c ? (a = $ac4a9effa24fe7be$var$bg(a, b, $ac4a9effa24fe7be$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H), $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$H, a)) : $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wf, c);
}
var $ac4a9effa24fe7be$var$eg = null, $ac4a9effa24fe7be$var$fg = !1, $ac4a9effa24fe7be$var$gg = !1;
function $ac4a9effa24fe7be$var$hg(a) {
    null === $ac4a9effa24fe7be$var$eg ? $ac4a9effa24fe7be$var$eg = [
        a
    ] : $ac4a9effa24fe7be$var$eg.push(a);
}
function $ac4a9effa24fe7be$var$ig(a) {
    $ac4a9effa24fe7be$var$fg = !0;
    $ac4a9effa24fe7be$var$hg(a);
}
function $ac4a9effa24fe7be$var$jg() {
    if (!$ac4a9effa24fe7be$var$gg && null !== $ac4a9effa24fe7be$var$eg) {
        $ac4a9effa24fe7be$var$gg = !0;
        var a = 0, b = $ac4a9effa24fe7be$var$C;
        try {
            var c = $ac4a9effa24fe7be$var$eg;
            for($ac4a9effa24fe7be$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $ac4a9effa24fe7be$var$eg = null;
            $ac4a9effa24fe7be$var$fg = !1;
        } catch (e) {
            throw null !== $ac4a9effa24fe7be$var$eg && ($ac4a9effa24fe7be$var$eg = $ac4a9effa24fe7be$var$eg.slice(a + 1)), $ac4a9effa24fe7be$var$ac($ac4a9effa24fe7be$var$fc, $ac4a9effa24fe7be$var$jg), e;
        } finally{
            $ac4a9effa24fe7be$var$C = b, $ac4a9effa24fe7be$var$gg = !1;
        }
    }
    return null;
}
var $ac4a9effa24fe7be$var$kg = [], $ac4a9effa24fe7be$var$lg = 0, $ac4a9effa24fe7be$var$mg = null, $ac4a9effa24fe7be$var$ng = 0, $ac4a9effa24fe7be$var$og = [], $ac4a9effa24fe7be$var$pg = 0, $ac4a9effa24fe7be$var$qg = null, $ac4a9effa24fe7be$var$rg = 1, $ac4a9effa24fe7be$var$sg = "";
function $ac4a9effa24fe7be$var$tg(a, b) {
    $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg++] = $ac4a9effa24fe7be$var$ng;
    $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg++] = $ac4a9effa24fe7be$var$mg;
    $ac4a9effa24fe7be$var$mg = a;
    $ac4a9effa24fe7be$var$ng = b;
}
function $ac4a9effa24fe7be$var$ug(a, b, c) {
    $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$rg;
    $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$sg;
    $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$qg;
    $ac4a9effa24fe7be$var$qg = a;
    var d = $ac4a9effa24fe7be$var$rg;
    a = $ac4a9effa24fe7be$var$sg;
    var e = 32 - $ac4a9effa24fe7be$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $ac4a9effa24fe7be$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $ac4a9effa24fe7be$var$rg = 1 << 32 - $ac4a9effa24fe7be$var$oc(b) + e | c << e | d;
        $ac4a9effa24fe7be$var$sg = f + a;
    } else $ac4a9effa24fe7be$var$rg = 1 << f | c << e | d, $ac4a9effa24fe7be$var$sg = a;
}
function $ac4a9effa24fe7be$var$vg(a) {
    null !== a.return && ($ac4a9effa24fe7be$var$tg(a, 1), $ac4a9effa24fe7be$var$ug(a, 1, 0));
}
function $ac4a9effa24fe7be$var$wg(a) {
    for(; a === $ac4a9effa24fe7be$var$mg;)$ac4a9effa24fe7be$var$mg = $ac4a9effa24fe7be$var$kg[--$ac4a9effa24fe7be$var$lg], $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg] = null, $ac4a9effa24fe7be$var$ng = $ac4a9effa24fe7be$var$kg[--$ac4a9effa24fe7be$var$lg], $ac4a9effa24fe7be$var$kg[$ac4a9effa24fe7be$var$lg] = null;
    for(; a === $ac4a9effa24fe7be$var$qg;)$ac4a9effa24fe7be$var$qg = $ac4a9effa24fe7be$var$og[--$ac4a9effa24fe7be$var$pg], $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg] = null, $ac4a9effa24fe7be$var$sg = $ac4a9effa24fe7be$var$og[--$ac4a9effa24fe7be$var$pg], $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg] = null, $ac4a9effa24fe7be$var$rg = $ac4a9effa24fe7be$var$og[--$ac4a9effa24fe7be$var$pg], $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg] = null;
}
var $ac4a9effa24fe7be$var$xg = null, $ac4a9effa24fe7be$var$yg = null, $ac4a9effa24fe7be$var$I = !1, $ac4a9effa24fe7be$var$zg = null;
function $ac4a9effa24fe7be$var$Ag(a, b) {
    var c = $ac4a9effa24fe7be$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $ac4a9effa24fe7be$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $ac4a9effa24fe7be$var$xg = a, $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $ac4a9effa24fe7be$var$xg = a, $ac4a9effa24fe7be$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $ac4a9effa24fe7be$var$qg ? {
                id: $ac4a9effa24fe7be$var$rg,
                overflow: $ac4a9effa24fe7be$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $ac4a9effa24fe7be$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $ac4a9effa24fe7be$var$xg = a, $ac4a9effa24fe7be$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $ac4a9effa24fe7be$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $ac4a9effa24fe7be$var$Eg(a) {
    if ($ac4a9effa24fe7be$var$I) {
        var b = $ac4a9effa24fe7be$var$yg;
        if (b) {
            var c = b;
            if (!$ac4a9effa24fe7be$var$Cg(a, b)) {
                if ($ac4a9effa24fe7be$var$Dg(a)) throw Error($ac4a9effa24fe7be$var$p(418));
                b = $ac4a9effa24fe7be$var$Lf(c.nextSibling);
                var d = $ac4a9effa24fe7be$var$xg;
                b && $ac4a9effa24fe7be$var$Cg(a, b) ? $ac4a9effa24fe7be$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $ac4a9effa24fe7be$var$I = !1, $ac4a9effa24fe7be$var$xg = a);
            }
        } else {
            if ($ac4a9effa24fe7be$var$Dg(a)) throw Error($ac4a9effa24fe7be$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $ac4a9effa24fe7be$var$I = !1;
            $ac4a9effa24fe7be$var$xg = a;
        }
    }
}
function $ac4a9effa24fe7be$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $ac4a9effa24fe7be$var$xg = a;
}
function $ac4a9effa24fe7be$var$Gg(a) {
    if (a !== $ac4a9effa24fe7be$var$xg) return !1;
    if (!$ac4a9effa24fe7be$var$I) return $ac4a9effa24fe7be$var$Fg(a), $ac4a9effa24fe7be$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$ac4a9effa24fe7be$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $ac4a9effa24fe7be$var$yg)) {
        if ($ac4a9effa24fe7be$var$Dg(a)) throw $ac4a9effa24fe7be$var$Hg(), Error($ac4a9effa24fe7be$var$p(418));
        for(; b;)$ac4a9effa24fe7be$var$Ag(a, b), b = $ac4a9effa24fe7be$var$Lf(b.nextSibling);
    }
    $ac4a9effa24fe7be$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($ac4a9effa24fe7be$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $ac4a9effa24fe7be$var$yg = null;
        }
    } else $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$xg ? $ac4a9effa24fe7be$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $ac4a9effa24fe7be$var$Hg() {
    for(var a = $ac4a9effa24fe7be$var$yg; a;)a = $ac4a9effa24fe7be$var$Lf(a.nextSibling);
}
function $ac4a9effa24fe7be$var$Ig() {
    $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$xg = null;
    $ac4a9effa24fe7be$var$I = !1;
}
function $ac4a9effa24fe7be$var$Jg(a) {
    null === $ac4a9effa24fe7be$var$zg ? $ac4a9effa24fe7be$var$zg = [
        a
    ] : $ac4a9effa24fe7be$var$zg.push(a);
}
var $ac4a9effa24fe7be$var$Kg = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig;
function $ac4a9effa24fe7be$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($ac4a9effa24fe7be$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($ac4a9effa24fe7be$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($ac4a9effa24fe7be$var$p(284));
        if (!c._owner) throw Error($ac4a9effa24fe7be$var$p(290, a));
    }
    return a;
}
function $ac4a9effa24fe7be$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($ac4a9effa24fe7be$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $ac4a9effa24fe7be$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $ac4a9effa24fe7be$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $ac4a9effa24fe7be$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $ac4a9effa24fe7be$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $ac4a9effa24fe7be$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $ac4a9effa24fe7be$var$Ha && $ac4a9effa24fe7be$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $ac4a9effa24fe7be$var$Lg(a, b, c), d.return = a, d;
        d = $ac4a9effa24fe7be$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $ac4a9effa24fe7be$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $ac4a9effa24fe7be$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $ac4a9effa24fe7be$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $ac4a9effa24fe7be$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    return c = $ac4a9effa24fe7be$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $ac4a9effa24fe7be$var$Lg(a, null, b), c.return = a, c;
                case $ac4a9effa24fe7be$var$wa:
                    return b = $ac4a9effa24fe7be$var$Sg(b, a.mode, c), b.return = a, b;
                case $ac4a9effa24fe7be$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($ac4a9effa24fe7be$var$eb(b) || $ac4a9effa24fe7be$var$Ka(b)) return b = $ac4a9effa24fe7be$var$Tg(b, a.mode, c, null), b.return = a, b;
            $ac4a9effa24fe7be$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $ac4a9effa24fe7be$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $ac4a9effa24fe7be$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($ac4a9effa24fe7be$var$eb(c) || $ac4a9effa24fe7be$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $ac4a9effa24fe7be$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $ac4a9effa24fe7be$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $ac4a9effa24fe7be$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($ac4a9effa24fe7be$var$eb(d) || $ac4a9effa24fe7be$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $ac4a9effa24fe7be$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $ac4a9effa24fe7be$var$Ka(h);
        if ("function" !== typeof l) throw Error($ac4a9effa24fe7be$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($ac4a9effa24fe7be$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $ac4a9effa24fe7be$var$I && $ac4a9effa24fe7be$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $ac4a9effa24fe7be$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $ac4a9effa24fe7be$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $ac4a9effa24fe7be$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $ac4a9effa24fe7be$var$Ha && $ac4a9effa24fe7be$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $ac4a9effa24fe7be$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $ac4a9effa24fe7be$var$ya ? (d = $ac4a9effa24fe7be$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $ac4a9effa24fe7be$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $ac4a9effa24fe7be$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $ac4a9effa24fe7be$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $ac4a9effa24fe7be$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $ac4a9effa24fe7be$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($ac4a9effa24fe7be$var$eb(f)) return n(a, d, f, h);
            if ($ac4a9effa24fe7be$var$Ka(f)) return t(a, d, f, h);
            $ac4a9effa24fe7be$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $ac4a9effa24fe7be$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $ac4a9effa24fe7be$var$Ug = $ac4a9effa24fe7be$var$Og(!0), $ac4a9effa24fe7be$var$Vg = $ac4a9effa24fe7be$var$Og(!1), $ac4a9effa24fe7be$var$Wg = $ac4a9effa24fe7be$var$Uf(null), $ac4a9effa24fe7be$var$Xg = null, $ac4a9effa24fe7be$var$Yg = null, $ac4a9effa24fe7be$var$Zg = null;
function $ac4a9effa24fe7be$var$$g() {
    $ac4a9effa24fe7be$var$Zg = $ac4a9effa24fe7be$var$Yg = $ac4a9effa24fe7be$var$Xg = null;
}
function $ac4a9effa24fe7be$var$ah(a) {
    var b = $ac4a9effa24fe7be$var$Wg.current;
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wg);
    a._currentValue = b;
}
function $ac4a9effa24fe7be$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $ac4a9effa24fe7be$var$ch(a, b) {
    $ac4a9effa24fe7be$var$Xg = a;
    $ac4a9effa24fe7be$var$Zg = $ac4a9effa24fe7be$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($ac4a9effa24fe7be$var$dh = !0), a.firstContext = null);
}
function $ac4a9effa24fe7be$var$eh(a) {
    var b = a._currentValue;
    if ($ac4a9effa24fe7be$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $ac4a9effa24fe7be$var$Yg) {
            if (null === $ac4a9effa24fe7be$var$Xg) throw Error($ac4a9effa24fe7be$var$p(308));
            $ac4a9effa24fe7be$var$Yg = a;
            $ac4a9effa24fe7be$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $ac4a9effa24fe7be$var$Yg = $ac4a9effa24fe7be$var$Yg.next = a;
    }
    return b;
}
var $ac4a9effa24fe7be$var$fh = null;
function $ac4a9effa24fe7be$var$gh(a) {
    null === $ac4a9effa24fe7be$var$fh ? $ac4a9effa24fe7be$var$fh = [
        a
    ] : $ac4a9effa24fe7be$var$fh.push(a);
}
function $ac4a9effa24fe7be$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $ac4a9effa24fe7be$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $ac4a9effa24fe7be$var$ih(a, d);
}
function $ac4a9effa24fe7be$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $ac4a9effa24fe7be$var$jh = !1;
function $ac4a9effa24fe7be$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $ac4a9effa24fe7be$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $ac4a9effa24fe7be$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $ac4a9effa24fe7be$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($ac4a9effa24fe7be$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $ac4a9effa24fe7be$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $ac4a9effa24fe7be$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $ac4a9effa24fe7be$var$ih(a, c);
}
function $ac4a9effa24fe7be$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $ac4a9effa24fe7be$var$Cc(a, c);
    }
}
function $ac4a9effa24fe7be$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $ac4a9effa24fe7be$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $ac4a9effa24fe7be$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $ac4a9effa24fe7be$var$A({}, q, r);
                            break a;
                        case 2:
                            $ac4a9effa24fe7be$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $ac4a9effa24fe7be$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $ac4a9effa24fe7be$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($ac4a9effa24fe7be$var$p(191, e));
            e.call(d);
        }
    }
}
var $ac4a9effa24fe7be$var$th = {}, $ac4a9effa24fe7be$var$uh = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$th), $ac4a9effa24fe7be$var$vh = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$th), $ac4a9effa24fe7be$var$wh = $ac4a9effa24fe7be$var$Uf($ac4a9effa24fe7be$var$th);
function $ac4a9effa24fe7be$var$xh(a) {
    if (a === $ac4a9effa24fe7be$var$th) throw Error($ac4a9effa24fe7be$var$p(174));
    return a;
}
function $ac4a9effa24fe7be$var$yh(a, b) {
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$wh, b);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$vh, a);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$uh, $ac4a9effa24fe7be$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $ac4a9effa24fe7be$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $ac4a9effa24fe7be$var$lb(b, a);
    }
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$uh);
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$uh, b);
}
function $ac4a9effa24fe7be$var$zh() {
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$uh);
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$vh);
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$wh);
}
function $ac4a9effa24fe7be$var$Ah(a) {
    $ac4a9effa24fe7be$var$xh($ac4a9effa24fe7be$var$wh.current);
    var b = $ac4a9effa24fe7be$var$xh($ac4a9effa24fe7be$var$uh.current);
    var c = $ac4a9effa24fe7be$var$lb(b, a.type);
    b !== c && ($ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$vh, a), $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$uh, c));
}
function $ac4a9effa24fe7be$var$Bh(a) {
    $ac4a9effa24fe7be$var$vh.current === a && ($ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$uh), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$vh));
}
var $ac4a9effa24fe7be$var$L = $ac4a9effa24fe7be$var$Uf(0);
function $ac4a9effa24fe7be$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $ac4a9effa24fe7be$var$Dh = [];
function $ac4a9effa24fe7be$var$Eh() {
    for(var a = 0; a < $ac4a9effa24fe7be$var$Dh.length; a++)$ac4a9effa24fe7be$var$Dh[a]._workInProgressVersionPrimary = null;
    $ac4a9effa24fe7be$var$Dh.length = 0;
}
var $ac4a9effa24fe7be$var$Fh = $ac4a9effa24fe7be$var$ua.ReactCurrentDispatcher, $ac4a9effa24fe7be$var$Gh = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig, $ac4a9effa24fe7be$var$Hh = 0, $ac4a9effa24fe7be$var$M = null, $ac4a9effa24fe7be$var$N = null, $ac4a9effa24fe7be$var$O = null, $ac4a9effa24fe7be$var$Ih = !1, $ac4a9effa24fe7be$var$Jh = !1, $ac4a9effa24fe7be$var$Kh = 0, $ac4a9effa24fe7be$var$Lh = 0;
function $ac4a9effa24fe7be$var$P() {
    throw Error($ac4a9effa24fe7be$var$p(321));
}
function $ac4a9effa24fe7be$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$ac4a9effa24fe7be$var$He(a[c], b[c])) return !1;
    return !0;
}
function $ac4a9effa24fe7be$var$Nh(a, b, c, d, e, f) {
    $ac4a9effa24fe7be$var$Hh = f;
    $ac4a9effa24fe7be$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $ac4a9effa24fe7be$var$Fh.current = null === a || null === a.memoizedState ? $ac4a9effa24fe7be$var$Oh : $ac4a9effa24fe7be$var$Ph;
    a = c(d, e);
    if ($ac4a9effa24fe7be$var$Jh) {
        f = 0;
        do {
            $ac4a9effa24fe7be$var$Jh = !1;
            $ac4a9effa24fe7be$var$Kh = 0;
            if (25 <= f) throw Error($ac4a9effa24fe7be$var$p(301));
            f += 1;
            $ac4a9effa24fe7be$var$O = $ac4a9effa24fe7be$var$N = null;
            b.updateQueue = null;
            $ac4a9effa24fe7be$var$Fh.current = $ac4a9effa24fe7be$var$Qh;
            a = c(d, e);
        }while ($ac4a9effa24fe7be$var$Jh);
    }
    $ac4a9effa24fe7be$var$Fh.current = $ac4a9effa24fe7be$var$Rh;
    b = null !== $ac4a9effa24fe7be$var$N && null !== $ac4a9effa24fe7be$var$N.next;
    $ac4a9effa24fe7be$var$Hh = 0;
    $ac4a9effa24fe7be$var$O = $ac4a9effa24fe7be$var$N = $ac4a9effa24fe7be$var$M = null;
    $ac4a9effa24fe7be$var$Ih = !1;
    if (b) throw Error($ac4a9effa24fe7be$var$p(300));
    return a;
}
function $ac4a9effa24fe7be$var$Sh() {
    var a = 0 !== $ac4a9effa24fe7be$var$Kh;
    $ac4a9effa24fe7be$var$Kh = 0;
    return a;
}
function $ac4a9effa24fe7be$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $ac4a9effa24fe7be$var$O ? $ac4a9effa24fe7be$var$M.memoizedState = $ac4a9effa24fe7be$var$O = a : $ac4a9effa24fe7be$var$O = $ac4a9effa24fe7be$var$O.next = a;
    return $ac4a9effa24fe7be$var$O;
}
function $ac4a9effa24fe7be$var$Uh() {
    if (null === $ac4a9effa24fe7be$var$N) {
        var a = $ac4a9effa24fe7be$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $ac4a9effa24fe7be$var$N.next;
    var b = null === $ac4a9effa24fe7be$var$O ? $ac4a9effa24fe7be$var$M.memoizedState : $ac4a9effa24fe7be$var$O.next;
    if (null !== b) $ac4a9effa24fe7be$var$O = b, $ac4a9effa24fe7be$var$N = a;
    else {
        if (null === a) throw Error($ac4a9effa24fe7be$var$p(310));
        $ac4a9effa24fe7be$var$N = a;
        a = {
            memoizedState: $ac4a9effa24fe7be$var$N.memoizedState,
            baseState: $ac4a9effa24fe7be$var$N.baseState,
            baseQueue: $ac4a9effa24fe7be$var$N.baseQueue,
            queue: $ac4a9effa24fe7be$var$N.queue,
            next: null
        };
        null === $ac4a9effa24fe7be$var$O ? $ac4a9effa24fe7be$var$M.memoizedState = $ac4a9effa24fe7be$var$O = a : $ac4a9effa24fe7be$var$O = $ac4a9effa24fe7be$var$O.next = a;
    }
    return $ac4a9effa24fe7be$var$O;
}
function $ac4a9effa24fe7be$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $ac4a9effa24fe7be$var$Wh(a) {
    var b = $ac4a9effa24fe7be$var$Uh(), c = b.queue;
    if (null === c) throw Error($ac4a9effa24fe7be$var$p(311));
    c.lastRenderedReducer = a;
    var d = $ac4a9effa24fe7be$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($ac4a9effa24fe7be$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $ac4a9effa24fe7be$var$M.lanes |= m;
                $ac4a9effa24fe7be$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $ac4a9effa24fe7be$var$He(d, b.memoizedState) || ($ac4a9effa24fe7be$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $ac4a9effa24fe7be$var$M.lanes |= f, $ac4a9effa24fe7be$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $ac4a9effa24fe7be$var$Xh(a) {
    var b = $ac4a9effa24fe7be$var$Uh(), c = b.queue;
    if (null === c) throw Error($ac4a9effa24fe7be$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $ac4a9effa24fe7be$var$He(f, b.memoizedState) || ($ac4a9effa24fe7be$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $ac4a9effa24fe7be$var$Yh() {}
function $ac4a9effa24fe7be$var$Zh(a, b) {
    var c = $ac4a9effa24fe7be$var$M, d = $ac4a9effa24fe7be$var$Uh(), e = b(), f = !$ac4a9effa24fe7be$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $ac4a9effa24fe7be$var$dh = !0);
    d = d.queue;
    $ac4a9effa24fe7be$var$$h($ac4a9effa24fe7be$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $ac4a9effa24fe7be$var$O && $ac4a9effa24fe7be$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $ac4a9effa24fe7be$var$bi(9, $ac4a9effa24fe7be$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $ac4a9effa24fe7be$var$Q) throw Error($ac4a9effa24fe7be$var$p(349));
        0 !== ($ac4a9effa24fe7be$var$Hh & 30) || $ac4a9effa24fe7be$var$di(c, b, e);
    }
    return e;
}
function $ac4a9effa24fe7be$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $ac4a9effa24fe7be$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $ac4a9effa24fe7be$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $ac4a9effa24fe7be$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $ac4a9effa24fe7be$var$ei(b) && $ac4a9effa24fe7be$var$fi(a);
}
function $ac4a9effa24fe7be$var$ai(a, b, c) {
    return c(function() {
        $ac4a9effa24fe7be$var$ei(b) && $ac4a9effa24fe7be$var$fi(a);
    });
}
function $ac4a9effa24fe7be$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$ac4a9effa24fe7be$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $ac4a9effa24fe7be$var$fi(a) {
    var b = $ac4a9effa24fe7be$var$ih(a, 1);
    null !== b && $ac4a9effa24fe7be$var$gi(b, a, 1, -1);
}
function $ac4a9effa24fe7be$var$hi(a) {
    var b = $ac4a9effa24fe7be$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $ac4a9effa24fe7be$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $ac4a9effa24fe7be$var$ii.bind(null, $ac4a9effa24fe7be$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $ac4a9effa24fe7be$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $ac4a9effa24fe7be$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $ac4a9effa24fe7be$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $ac4a9effa24fe7be$var$ji() {
    return $ac4a9effa24fe7be$var$Uh().memoizedState;
}
function $ac4a9effa24fe7be$var$ki(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$Th();
    $ac4a9effa24fe7be$var$M.flags |= a;
    e.memoizedState = $ac4a9effa24fe7be$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $ac4a9effa24fe7be$var$li(a, b, c, d) {
    var e = $ac4a9effa24fe7be$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $ac4a9effa24fe7be$var$N) {
        var g = $ac4a9effa24fe7be$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $ac4a9effa24fe7be$var$Mh(d, g.deps)) {
            e.memoizedState = $ac4a9effa24fe7be$var$bi(b, c, f, d);
            return;
        }
    }
    $ac4a9effa24fe7be$var$M.flags |= a;
    e.memoizedState = $ac4a9effa24fe7be$var$bi(1 | b, c, f, d);
}
function $ac4a9effa24fe7be$var$mi(a, b) {
    return $ac4a9effa24fe7be$var$ki(8390656, 8, a, b);
}
function $ac4a9effa24fe7be$var$$h(a, b) {
    return $ac4a9effa24fe7be$var$li(2048, 8, a, b);
}
function $ac4a9effa24fe7be$var$ni(a, b) {
    return $ac4a9effa24fe7be$var$li(4, 2, a, b);
}
function $ac4a9effa24fe7be$var$oi(a, b) {
    return $ac4a9effa24fe7be$var$li(4, 4, a, b);
}
function $ac4a9effa24fe7be$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $ac4a9effa24fe7be$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $ac4a9effa24fe7be$var$li(4, 4, $ac4a9effa24fe7be$var$pi.bind(null, b, a), c);
}
function $ac4a9effa24fe7be$var$ri() {}
function $ac4a9effa24fe7be$var$si(a, b) {
    var c = $ac4a9effa24fe7be$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ac4a9effa24fe7be$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ac4a9effa24fe7be$var$ti(a, b) {
    var c = $ac4a9effa24fe7be$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ac4a9effa24fe7be$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ac4a9effa24fe7be$var$ui(a, b, c) {
    if (0 === ($ac4a9effa24fe7be$var$Hh & 21)) return a.baseState && (a.baseState = !1, $ac4a9effa24fe7be$var$dh = !0), a.memoizedState = c;
    $ac4a9effa24fe7be$var$He(c, b) || (c = $ac4a9effa24fe7be$var$yc(), $ac4a9effa24fe7be$var$M.lanes |= c, $ac4a9effa24fe7be$var$rh |= c, a.baseState = !0);
    return b;
}
function $ac4a9effa24fe7be$var$vi(a, b) {
    var c = $ac4a9effa24fe7be$var$C;
    $ac4a9effa24fe7be$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $ac4a9effa24fe7be$var$Gh.transition;
    $ac4a9effa24fe7be$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $ac4a9effa24fe7be$var$C = c, $ac4a9effa24fe7be$var$Gh.transition = d;
    }
}
function $ac4a9effa24fe7be$var$wi() {
    return $ac4a9effa24fe7be$var$Uh().memoizedState;
}
function $ac4a9effa24fe7be$var$xi(a, b, c) {
    var d = $ac4a9effa24fe7be$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ac4a9effa24fe7be$var$zi(a)) $ac4a9effa24fe7be$var$Ai(b, c);
    else if (c = $ac4a9effa24fe7be$var$hh(a, b, c, d), null !== c) {
        var e = $ac4a9effa24fe7be$var$R();
        $ac4a9effa24fe7be$var$gi(c, a, d, e);
        $ac4a9effa24fe7be$var$Bi(c, b, d);
    }
}
function $ac4a9effa24fe7be$var$ii(a, b, c) {
    var d = $ac4a9effa24fe7be$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ac4a9effa24fe7be$var$zi(a)) $ac4a9effa24fe7be$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($ac4a9effa24fe7be$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $ac4a9effa24fe7be$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $ac4a9effa24fe7be$var$hh(a, b, e, d);
        null !== c && (e = $ac4a9effa24fe7be$var$R(), $ac4a9effa24fe7be$var$gi(c, a, d, e), $ac4a9effa24fe7be$var$Bi(c, b, d));
    }
}
function $ac4a9effa24fe7be$var$zi(a) {
    var b = a.alternate;
    return a === $ac4a9effa24fe7be$var$M || null !== b && b === $ac4a9effa24fe7be$var$M;
}
function $ac4a9effa24fe7be$var$Ai(a, b) {
    $ac4a9effa24fe7be$var$Jh = $ac4a9effa24fe7be$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $ac4a9effa24fe7be$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $ac4a9effa24fe7be$var$Cc(a, c);
    }
}
var $ac4a9effa24fe7be$var$Rh = {
    readContext: $ac4a9effa24fe7be$var$eh,
    useCallback: $ac4a9effa24fe7be$var$P,
    useContext: $ac4a9effa24fe7be$var$P,
    useEffect: $ac4a9effa24fe7be$var$P,
    useImperativeHandle: $ac4a9effa24fe7be$var$P,
    useInsertionEffect: $ac4a9effa24fe7be$var$P,
    useLayoutEffect: $ac4a9effa24fe7be$var$P,
    useMemo: $ac4a9effa24fe7be$var$P,
    useReducer: $ac4a9effa24fe7be$var$P,
    useRef: $ac4a9effa24fe7be$var$P,
    useState: $ac4a9effa24fe7be$var$P,
    useDebugValue: $ac4a9effa24fe7be$var$P,
    useDeferredValue: $ac4a9effa24fe7be$var$P,
    useTransition: $ac4a9effa24fe7be$var$P,
    useMutableSource: $ac4a9effa24fe7be$var$P,
    useSyncExternalStore: $ac4a9effa24fe7be$var$P,
    useId: $ac4a9effa24fe7be$var$P,
    unstable_isNewReconciler: !1
}, $ac4a9effa24fe7be$var$Oh = {
    readContext: $ac4a9effa24fe7be$var$eh,
    useCallback: function(a, b) {
        $ac4a9effa24fe7be$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $ac4a9effa24fe7be$var$eh,
    useEffect: $ac4a9effa24fe7be$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $ac4a9effa24fe7be$var$ki(4194308, 4, $ac4a9effa24fe7be$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $ac4a9effa24fe7be$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $ac4a9effa24fe7be$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $ac4a9effa24fe7be$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $ac4a9effa24fe7be$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $ac4a9effa24fe7be$var$xi.bind(null, $ac4a9effa24fe7be$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $ac4a9effa24fe7be$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $ac4a9effa24fe7be$var$hi,
    useDebugValue: $ac4a9effa24fe7be$var$ri,
    useDeferredValue: function(a) {
        return $ac4a9effa24fe7be$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $ac4a9effa24fe7be$var$hi(!1), b = a[0];
        a = $ac4a9effa24fe7be$var$vi.bind(null, a[1]);
        $ac4a9effa24fe7be$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $ac4a9effa24fe7be$var$M, e = $ac4a9effa24fe7be$var$Th();
        if ($ac4a9effa24fe7be$var$I) {
            if (void 0 === c) throw Error($ac4a9effa24fe7be$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $ac4a9effa24fe7be$var$Q) throw Error($ac4a9effa24fe7be$var$p(349));
            0 !== ($ac4a9effa24fe7be$var$Hh & 30) || $ac4a9effa24fe7be$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $ac4a9effa24fe7be$var$mi($ac4a9effa24fe7be$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $ac4a9effa24fe7be$var$bi(9, $ac4a9effa24fe7be$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $ac4a9effa24fe7be$var$Th(), b = $ac4a9effa24fe7be$var$Q.identifierPrefix;
        if ($ac4a9effa24fe7be$var$I) {
            var c = $ac4a9effa24fe7be$var$sg;
            var d = $ac4a9effa24fe7be$var$rg;
            c = (d & ~(1 << 32 - $ac4a9effa24fe7be$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $ac4a9effa24fe7be$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $ac4a9effa24fe7be$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $ac4a9effa24fe7be$var$Ph = {
    readContext: $ac4a9effa24fe7be$var$eh,
    useCallback: $ac4a9effa24fe7be$var$si,
    useContext: $ac4a9effa24fe7be$var$eh,
    useEffect: $ac4a9effa24fe7be$var$$h,
    useImperativeHandle: $ac4a9effa24fe7be$var$qi,
    useInsertionEffect: $ac4a9effa24fe7be$var$ni,
    useLayoutEffect: $ac4a9effa24fe7be$var$oi,
    useMemo: $ac4a9effa24fe7be$var$ti,
    useReducer: $ac4a9effa24fe7be$var$Wh,
    useRef: $ac4a9effa24fe7be$var$ji,
    useState: function() {
        return $ac4a9effa24fe7be$var$Wh($ac4a9effa24fe7be$var$Vh);
    },
    useDebugValue: $ac4a9effa24fe7be$var$ri,
    useDeferredValue: function(a) {
        var b = $ac4a9effa24fe7be$var$Uh();
        return $ac4a9effa24fe7be$var$ui(b, $ac4a9effa24fe7be$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $ac4a9effa24fe7be$var$Wh($ac4a9effa24fe7be$var$Vh)[0], b = $ac4a9effa24fe7be$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $ac4a9effa24fe7be$var$Yh,
    useSyncExternalStore: $ac4a9effa24fe7be$var$Zh,
    useId: $ac4a9effa24fe7be$var$wi,
    unstable_isNewReconciler: !1
}, $ac4a9effa24fe7be$var$Qh = {
    readContext: $ac4a9effa24fe7be$var$eh,
    useCallback: $ac4a9effa24fe7be$var$si,
    useContext: $ac4a9effa24fe7be$var$eh,
    useEffect: $ac4a9effa24fe7be$var$$h,
    useImperativeHandle: $ac4a9effa24fe7be$var$qi,
    useInsertionEffect: $ac4a9effa24fe7be$var$ni,
    useLayoutEffect: $ac4a9effa24fe7be$var$oi,
    useMemo: $ac4a9effa24fe7be$var$ti,
    useReducer: $ac4a9effa24fe7be$var$Xh,
    useRef: $ac4a9effa24fe7be$var$ji,
    useState: function() {
        return $ac4a9effa24fe7be$var$Xh($ac4a9effa24fe7be$var$Vh);
    },
    useDebugValue: $ac4a9effa24fe7be$var$ri,
    useDeferredValue: function(a) {
        var b = $ac4a9effa24fe7be$var$Uh();
        return null === $ac4a9effa24fe7be$var$N ? b.memoizedState = a : $ac4a9effa24fe7be$var$ui(b, $ac4a9effa24fe7be$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $ac4a9effa24fe7be$var$Xh($ac4a9effa24fe7be$var$Vh)[0], b = $ac4a9effa24fe7be$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $ac4a9effa24fe7be$var$Yh,
    useSyncExternalStore: $ac4a9effa24fe7be$var$Zh,
    useId: $ac4a9effa24fe7be$var$wi,
    unstable_isNewReconciler: !1
};
function $ac4a9effa24fe7be$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $ac4a9effa24fe7be$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $ac4a9effa24fe7be$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $ac4a9effa24fe7be$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $ac4a9effa24fe7be$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $ac4a9effa24fe7be$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $ac4a9effa24fe7be$var$R(), e = $ac4a9effa24fe7be$var$yi(a), f = $ac4a9effa24fe7be$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $ac4a9effa24fe7be$var$nh(a, f, e);
        null !== b && ($ac4a9effa24fe7be$var$gi(b, a, e, d), $ac4a9effa24fe7be$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $ac4a9effa24fe7be$var$R(), e = $ac4a9effa24fe7be$var$yi(a), f = $ac4a9effa24fe7be$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $ac4a9effa24fe7be$var$nh(a, f, e);
        null !== b && ($ac4a9effa24fe7be$var$gi(b, a, e, d), $ac4a9effa24fe7be$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $ac4a9effa24fe7be$var$R(), d = $ac4a9effa24fe7be$var$yi(a), e = $ac4a9effa24fe7be$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $ac4a9effa24fe7be$var$nh(a, e, d);
        null !== b && ($ac4a9effa24fe7be$var$gi(b, a, d, c), $ac4a9effa24fe7be$var$oh(b, a, d));
    }
};
function $ac4a9effa24fe7be$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$ac4a9effa24fe7be$var$Ie(c, d) || !$ac4a9effa24fe7be$var$Ie(e, f) : !0;
}
function $ac4a9effa24fe7be$var$Gi(a, b, c) {
    var d = !1, e = $ac4a9effa24fe7be$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $ac4a9effa24fe7be$var$eh(f) : (e = $ac4a9effa24fe7be$var$Zf(b) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $ac4a9effa24fe7be$var$Yf(a, e) : $ac4a9effa24fe7be$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $ac4a9effa24fe7be$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $ac4a9effa24fe7be$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $ac4a9effa24fe7be$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $ac4a9effa24fe7be$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $ac4a9effa24fe7be$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $ac4a9effa24fe7be$var$eh(f) : (f = $ac4a9effa24fe7be$var$Zf(b) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, e.context = $ac4a9effa24fe7be$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($ac4a9effa24fe7be$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $ac4a9effa24fe7be$var$Ei.enqueueReplaceState(e, e.state, null), $ac4a9effa24fe7be$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $ac4a9effa24fe7be$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $ac4a9effa24fe7be$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $ac4a9effa24fe7be$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $ac4a9effa24fe7be$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $ac4a9effa24fe7be$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $ac4a9effa24fe7be$var$Ni(a, b, c) {
    c = $ac4a9effa24fe7be$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $ac4a9effa24fe7be$var$Oi || ($ac4a9effa24fe7be$var$Oi = !0, $ac4a9effa24fe7be$var$Pi = d);
        $ac4a9effa24fe7be$var$Li(a, b);
    };
    return c;
}
function $ac4a9effa24fe7be$var$Qi(a, b, c) {
    c = $ac4a9effa24fe7be$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $ac4a9effa24fe7be$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $ac4a9effa24fe7be$var$Li(a, b);
        "function" !== typeof d && (null === $ac4a9effa24fe7be$var$Ri ? $ac4a9effa24fe7be$var$Ri = new Set([
            this
        ]) : $ac4a9effa24fe7be$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $ac4a9effa24fe7be$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $ac4a9effa24fe7be$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $ac4a9effa24fe7be$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $ac4a9effa24fe7be$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $ac4a9effa24fe7be$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $ac4a9effa24fe7be$var$mh(-1, 1), b.tag = 2, $ac4a9effa24fe7be$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $ac4a9effa24fe7be$var$Wi = $ac4a9effa24fe7be$var$ua.ReactCurrentOwner, $ac4a9effa24fe7be$var$dh = !1;
function $ac4a9effa24fe7be$var$Xi(a, b, c, d) {
    b.child = null === a ? $ac4a9effa24fe7be$var$Vg(b, null, c, d) : $ac4a9effa24fe7be$var$Ug(b, a.child, c, d);
}
function $ac4a9effa24fe7be$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $ac4a9effa24fe7be$var$ch(b, e);
    d = $ac4a9effa24fe7be$var$Nh(a, b, c, d, f, e);
    c = $ac4a9effa24fe7be$var$Sh();
    if (null !== a && !$ac4a9effa24fe7be$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $ac4a9effa24fe7be$var$Zi(a, b, e);
    $ac4a9effa24fe7be$var$I && c && $ac4a9effa24fe7be$var$vg(b);
    b.flags |= 1;
    $ac4a9effa24fe7be$var$Xi(a, b, d, e);
    return b.child;
}
function $ac4a9effa24fe7be$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$ac4a9effa24fe7be$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $ac4a9effa24fe7be$var$bj(a, b, f, d, e);
        a = $ac4a9effa24fe7be$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $ac4a9effa24fe7be$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $ac4a9effa24fe7be$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $ac4a9effa24fe7be$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $ac4a9effa24fe7be$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($ac4a9effa24fe7be$var$Ie(f, d) && a.ref === b.ref) {
            if ($ac4a9effa24fe7be$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($ac4a9effa24fe7be$var$dh = !0);
            else return b.lanes = a.lanes, $ac4a9effa24fe7be$var$Zi(a, b, e);
        }
    }
    return $ac4a9effa24fe7be$var$cj(a, b, c, d, e);
}
function $ac4a9effa24fe7be$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$ej, $ac4a9effa24fe7be$var$fj), $ac4a9effa24fe7be$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$ej, $ac4a9effa24fe7be$var$fj), $ac4a9effa24fe7be$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$ej, $ac4a9effa24fe7be$var$fj);
            $ac4a9effa24fe7be$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$ej, $ac4a9effa24fe7be$var$fj), $ac4a9effa24fe7be$var$fj |= d;
    $ac4a9effa24fe7be$var$Xi(a, b, e, c);
    return b.child;
}
function $ac4a9effa24fe7be$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $ac4a9effa24fe7be$var$cj(a, b, c, d, e) {
    var f = $ac4a9effa24fe7be$var$Zf(c) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current;
    f = $ac4a9effa24fe7be$var$Yf(b, f);
    $ac4a9effa24fe7be$var$ch(b, e);
    c = $ac4a9effa24fe7be$var$Nh(a, b, c, d, f, e);
    d = $ac4a9effa24fe7be$var$Sh();
    if (null !== a && !$ac4a9effa24fe7be$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $ac4a9effa24fe7be$var$Zi(a, b, e);
    $ac4a9effa24fe7be$var$I && d && $ac4a9effa24fe7be$var$vg(b);
    b.flags |= 1;
    $ac4a9effa24fe7be$var$Xi(a, b, c, e);
    return b.child;
}
function $ac4a9effa24fe7be$var$hj(a, b, c, d, e) {
    if ($ac4a9effa24fe7be$var$Zf(c)) {
        var f = !0;
        $ac4a9effa24fe7be$var$cg(b);
    } else f = !1;
    $ac4a9effa24fe7be$var$ch(b, e);
    if (null === b.stateNode) $ac4a9effa24fe7be$var$ij(a, b), $ac4a9effa24fe7be$var$Gi(b, c, d), $ac4a9effa24fe7be$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $ac4a9effa24fe7be$var$eh(l) : (l = $ac4a9effa24fe7be$var$Zf(c) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, l = $ac4a9effa24fe7be$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $ac4a9effa24fe7be$var$Hi(b, g, d, l);
        $ac4a9effa24fe7be$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $ac4a9effa24fe7be$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $ac4a9effa24fe7be$var$Wf.current || $ac4a9effa24fe7be$var$jh ? ("function" === typeof m && ($ac4a9effa24fe7be$var$Di(b, c, m, d), k = b.memoizedState), (h = $ac4a9effa24fe7be$var$jh || $ac4a9effa24fe7be$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $ac4a9effa24fe7be$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $ac4a9effa24fe7be$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $ac4a9effa24fe7be$var$eh(k) : (k = $ac4a9effa24fe7be$var$Zf(c) ? $ac4a9effa24fe7be$var$Xf : $ac4a9effa24fe7be$var$H.current, k = $ac4a9effa24fe7be$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $ac4a9effa24fe7be$var$Hi(b, g, d, k);
        $ac4a9effa24fe7be$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $ac4a9effa24fe7be$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $ac4a9effa24fe7be$var$Wf.current || $ac4a9effa24fe7be$var$jh ? ("function" === typeof y && ($ac4a9effa24fe7be$var$Di(b, c, y, d), n = b.memoizedState), (l = $ac4a9effa24fe7be$var$jh || $ac4a9effa24fe7be$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $ac4a9effa24fe7be$var$jj(a, b, c, d, f, e);
}
function $ac4a9effa24fe7be$var$jj(a, b, c, d, e, f) {
    $ac4a9effa24fe7be$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $ac4a9effa24fe7be$var$dg(b, c, !1), $ac4a9effa24fe7be$var$Zi(a, b, f);
    d = b.stateNode;
    $ac4a9effa24fe7be$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $ac4a9effa24fe7be$var$Ug(b, a.child, null, f), b.child = $ac4a9effa24fe7be$var$Ug(b, null, h, f)) : $ac4a9effa24fe7be$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $ac4a9effa24fe7be$var$dg(b, c, !0);
    return b.child;
}
function $ac4a9effa24fe7be$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $ac4a9effa24fe7be$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $ac4a9effa24fe7be$var$ag(a, b.context, !1);
    $ac4a9effa24fe7be$var$yh(a, b.containerInfo);
}
function $ac4a9effa24fe7be$var$lj(a, b, c, d, e) {
    $ac4a9effa24fe7be$var$Ig();
    $ac4a9effa24fe7be$var$Jg(e);
    b.flags |= 256;
    $ac4a9effa24fe7be$var$Xi(a, b, c, d);
    return b.child;
}
var $ac4a9effa24fe7be$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $ac4a9effa24fe7be$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $ac4a9effa24fe7be$var$oj(a, b, c) {
    var d = b.pendingProps, e = $ac4a9effa24fe7be$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, e & 1);
    if (null === a) {
        $ac4a9effa24fe7be$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $ac4a9effa24fe7be$var$pj(g, d, 0, null), a = $ac4a9effa24fe7be$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $ac4a9effa24fe7be$var$nj(c), b.memoizedState = $ac4a9effa24fe7be$var$mj, a) : $ac4a9effa24fe7be$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $ac4a9effa24fe7be$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $ac4a9effa24fe7be$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $ac4a9effa24fe7be$var$Pg(h, f) : (f = $ac4a9effa24fe7be$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $ac4a9effa24fe7be$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $ac4a9effa24fe7be$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $ac4a9effa24fe7be$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $ac4a9effa24fe7be$var$qj(a, b) {
    b = $ac4a9effa24fe7be$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $ac4a9effa24fe7be$var$sj(a, b, c, d) {
    null !== d && $ac4a9effa24fe7be$var$Jg(d);
    $ac4a9effa24fe7be$var$Ug(b, a.child, null, c);
    a = $ac4a9effa24fe7be$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $ac4a9effa24fe7be$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $ac4a9effa24fe7be$var$Ki(Error($ac4a9effa24fe7be$var$p(422))), $ac4a9effa24fe7be$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $ac4a9effa24fe7be$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $ac4a9effa24fe7be$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $ac4a9effa24fe7be$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $ac4a9effa24fe7be$var$nj(g);
        b.memoizedState = $ac4a9effa24fe7be$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $ac4a9effa24fe7be$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($ac4a9effa24fe7be$var$p(419));
        d = $ac4a9effa24fe7be$var$Ki(f, d, void 0);
        return $ac4a9effa24fe7be$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($ac4a9effa24fe7be$var$dh || h) {
        d = $ac4a9effa24fe7be$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $ac4a9effa24fe7be$var$ih(a, e), $ac4a9effa24fe7be$var$gi(d, a, e, -1));
        }
        $ac4a9effa24fe7be$var$tj();
        d = $ac4a9effa24fe7be$var$Ki(Error($ac4a9effa24fe7be$var$p(421)));
        return $ac4a9effa24fe7be$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $ac4a9effa24fe7be$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(e.nextSibling);
    $ac4a9effa24fe7be$var$xg = b;
    $ac4a9effa24fe7be$var$I = !0;
    $ac4a9effa24fe7be$var$zg = null;
    null !== a && ($ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$rg, $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$sg, $ac4a9effa24fe7be$var$og[$ac4a9effa24fe7be$var$pg++] = $ac4a9effa24fe7be$var$qg, $ac4a9effa24fe7be$var$rg = a.id, $ac4a9effa24fe7be$var$sg = a.overflow, $ac4a9effa24fe7be$var$qg = b);
    b = $ac4a9effa24fe7be$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $ac4a9effa24fe7be$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $ac4a9effa24fe7be$var$bh(a.return, b, c);
}
function $ac4a9effa24fe7be$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $ac4a9effa24fe7be$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $ac4a9effa24fe7be$var$Xi(a, b, d.children, c);
    d = $ac4a9effa24fe7be$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $ac4a9effa24fe7be$var$vj(a, c, b);
            else if (19 === a.tag) $ac4a9effa24fe7be$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $ac4a9effa24fe7be$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $ac4a9effa24fe7be$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $ac4a9effa24fe7be$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $ac4a9effa24fe7be$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $ac4a9effa24fe7be$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $ac4a9effa24fe7be$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $ac4a9effa24fe7be$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $ac4a9effa24fe7be$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($ac4a9effa24fe7be$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $ac4a9effa24fe7be$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $ac4a9effa24fe7be$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $ac4a9effa24fe7be$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $ac4a9effa24fe7be$var$kj(b);
            $ac4a9effa24fe7be$var$Ig();
            break;
        case 5:
            $ac4a9effa24fe7be$var$Ah(b);
            break;
        case 1:
            $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$cg(b);
            break;
        case 4:
            $ac4a9effa24fe7be$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, $ac4a9effa24fe7be$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $ac4a9effa24fe7be$var$oj(a, b, c);
                $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, $ac4a9effa24fe7be$var$L.current & 1);
                a = $ac4a9effa24fe7be$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, $ac4a9effa24fe7be$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $ac4a9effa24fe7be$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, $ac4a9effa24fe7be$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $ac4a9effa24fe7be$var$dj(a, b, c);
    }
    return $ac4a9effa24fe7be$var$Zi(a, b, c);
}
var $ac4a9effa24fe7be$var$zj, $ac4a9effa24fe7be$var$Aj, $ac4a9effa24fe7be$var$Bj, $ac4a9effa24fe7be$var$Cj;
$ac4a9effa24fe7be$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$ac4a9effa24fe7be$var$Aj = function() {};
$ac4a9effa24fe7be$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $ac4a9effa24fe7be$var$xh($ac4a9effa24fe7be$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $ac4a9effa24fe7be$var$Ya(a, e);
                d = $ac4a9effa24fe7be$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $ac4a9effa24fe7be$var$A({}, e, {
                    value: void 0
                });
                d = $ac4a9effa24fe7be$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $ac4a9effa24fe7be$var$gb(a, e);
                d = $ac4a9effa24fe7be$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $ac4a9effa24fe7be$var$Bf);
        }
        $ac4a9effa24fe7be$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($ac4a9effa24fe7be$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($ac4a9effa24fe7be$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $ac4a9effa24fe7be$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$ac4a9effa24fe7be$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $ac4a9effa24fe7be$var$Dj(a, b) {
    if (!$ac4a9effa24fe7be$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $ac4a9effa24fe7be$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $ac4a9effa24fe7be$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $ac4a9effa24fe7be$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $ac4a9effa24fe7be$var$S(b), null;
        case 1:
            return $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$$f(), $ac4a9effa24fe7be$var$S(b), null;
        case 3:
            d = b.stateNode;
            $ac4a9effa24fe7be$var$zh();
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H);
            $ac4a9effa24fe7be$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $ac4a9effa24fe7be$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $ac4a9effa24fe7be$var$zg && ($ac4a9effa24fe7be$var$Fj($ac4a9effa24fe7be$var$zg), $ac4a9effa24fe7be$var$zg = null));
            $ac4a9effa24fe7be$var$Aj(a, b);
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 5:
            $ac4a9effa24fe7be$var$Bh(b);
            var e = $ac4a9effa24fe7be$var$xh($ac4a9effa24fe7be$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $ac4a9effa24fe7be$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($ac4a9effa24fe7be$var$p(166));
                    $ac4a9effa24fe7be$var$S(b);
                    return null;
                }
                a = $ac4a9effa24fe7be$var$xh($ac4a9effa24fe7be$var$uh.current);
                if ($ac4a9effa24fe7be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$ac4a9effa24fe7be$var$Of] = b;
                    d[$ac4a9effa24fe7be$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $ac4a9effa24fe7be$var$D("cancel", d);
                            $ac4a9effa24fe7be$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $ac4a9effa24fe7be$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $ac4a9effa24fe7be$var$lf.length; e++)$ac4a9effa24fe7be$var$D($ac4a9effa24fe7be$var$lf[e], d);
                            break;
                        case "source":
                            $ac4a9effa24fe7be$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $ac4a9effa24fe7be$var$D("error", d);
                            $ac4a9effa24fe7be$var$D("load", d);
                            break;
                        case "details":
                            $ac4a9effa24fe7be$var$D("toggle", d);
                            break;
                        case "input":
                            $ac4a9effa24fe7be$var$Za(d, f);
                            $ac4a9effa24fe7be$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $ac4a9effa24fe7be$var$D("invalid", d);
                            break;
                        case "textarea":
                            $ac4a9effa24fe7be$var$hb(d, f), $ac4a9effa24fe7be$var$D("invalid", d);
                    }
                    $ac4a9effa24fe7be$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $ac4a9effa24fe7be$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $ac4a9effa24fe7be$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $ac4a9effa24fe7be$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $ac4a9effa24fe7be$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $ac4a9effa24fe7be$var$Va(d);
                            $ac4a9effa24fe7be$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $ac4a9effa24fe7be$var$Va(d);
                            $ac4a9effa24fe7be$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $ac4a9effa24fe7be$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $ac4a9effa24fe7be$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$ac4a9effa24fe7be$var$Of] = b;
                    a[$ac4a9effa24fe7be$var$Pf] = d;
                    $ac4a9effa24fe7be$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $ac4a9effa24fe7be$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $ac4a9effa24fe7be$var$D("cancel", a);
                                $ac4a9effa24fe7be$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $ac4a9effa24fe7be$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $ac4a9effa24fe7be$var$lf.length; e++)$ac4a9effa24fe7be$var$D($ac4a9effa24fe7be$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $ac4a9effa24fe7be$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $ac4a9effa24fe7be$var$D("error", a);
                                $ac4a9effa24fe7be$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $ac4a9effa24fe7be$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $ac4a9effa24fe7be$var$Za(a, d);
                                e = $ac4a9effa24fe7be$var$Ya(a, d);
                                $ac4a9effa24fe7be$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $ac4a9effa24fe7be$var$A({}, d, {
                                    value: void 0
                                });
                                $ac4a9effa24fe7be$var$D("invalid", a);
                                break;
                            case "textarea":
                                $ac4a9effa24fe7be$var$hb(a, d);
                                e = $ac4a9effa24fe7be$var$gb(a, d);
                                $ac4a9effa24fe7be$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $ac4a9effa24fe7be$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $ac4a9effa24fe7be$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $ac4a9effa24fe7be$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $ac4a9effa24fe7be$var$ob(a, k) : "number" === typeof k && $ac4a9effa24fe7be$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($ac4a9effa24fe7be$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $ac4a9effa24fe7be$var$D("scroll", a) : null != k && $ac4a9effa24fe7be$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $ac4a9effa24fe7be$var$Va(a);
                                $ac4a9effa24fe7be$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $ac4a9effa24fe7be$var$Va(a);
                                $ac4a9effa24fe7be$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $ac4a9effa24fe7be$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $ac4a9effa24fe7be$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $ac4a9effa24fe7be$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $ac4a9effa24fe7be$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $ac4a9effa24fe7be$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($ac4a9effa24fe7be$var$p(166));
                c = $ac4a9effa24fe7be$var$xh($ac4a9effa24fe7be$var$wh.current);
                $ac4a9effa24fe7be$var$xh($ac4a9effa24fe7be$var$uh.current);
                if ($ac4a9effa24fe7be$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$ac4a9effa24fe7be$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $ac4a9effa24fe7be$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $ac4a9effa24fe7be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $ac4a9effa24fe7be$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$ac4a9effa24fe7be$var$Of] = b, b.stateNode = d;
            }
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 13:
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($ac4a9effa24fe7be$var$I && null !== $ac4a9effa24fe7be$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $ac4a9effa24fe7be$var$Hg(), $ac4a9effa24fe7be$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $ac4a9effa24fe7be$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($ac4a9effa24fe7be$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($ac4a9effa24fe7be$var$p(317));
                        f[$ac4a9effa24fe7be$var$Of] = b;
                    } else $ac4a9effa24fe7be$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $ac4a9effa24fe7be$var$S(b);
                    f = !1;
                } else null !== $ac4a9effa24fe7be$var$zg && ($ac4a9effa24fe7be$var$Fj($ac4a9effa24fe7be$var$zg), $ac4a9effa24fe7be$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($ac4a9effa24fe7be$var$L.current & 1) ? 0 === $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$T = 3) : $ac4a9effa24fe7be$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 4:
            return $ac4a9effa24fe7be$var$zh(), $ac4a9effa24fe7be$var$Aj(a, b), null === a && $ac4a9effa24fe7be$var$sf(b.stateNode.containerInfo), $ac4a9effa24fe7be$var$S(b), null;
        case 10:
            return $ac4a9effa24fe7be$var$ah(b.type._context), $ac4a9effa24fe7be$var$S(b), null;
        case 17:
            return $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$$f(), $ac4a9effa24fe7be$var$S(b), null;
        case 19:
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$L);
            f = b.memoizedState;
            if (null === f) return $ac4a9effa24fe7be$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $ac4a9effa24fe7be$var$Dj(f, !1);
                else {
                    if (0 !== $ac4a9effa24fe7be$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $ac4a9effa24fe7be$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $ac4a9effa24fe7be$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, $ac4a9effa24fe7be$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $ac4a9effa24fe7be$var$B() > $ac4a9effa24fe7be$var$Gj && (b.flags |= 128, d = !0, $ac4a9effa24fe7be$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $ac4a9effa24fe7be$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $ac4a9effa24fe7be$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$ac4a9effa24fe7be$var$I) return $ac4a9effa24fe7be$var$S(b), null;
                    } else 2 * $ac4a9effa24fe7be$var$B() - f.renderingStartTime > $ac4a9effa24fe7be$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $ac4a9effa24fe7be$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $ac4a9effa24fe7be$var$B(), b.sibling = null, c = $ac4a9effa24fe7be$var$L.current, $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$L, d ? c & 1 | 2 : c & 1), b;
            $ac4a9effa24fe7be$var$S(b);
            return null;
        case 22:
        case 23:
            return $ac4a9effa24fe7be$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($ac4a9effa24fe7be$var$fj & 1073741824) && ($ac4a9effa24fe7be$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $ac4a9effa24fe7be$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($ac4a9effa24fe7be$var$p(156, b.tag));
}
function $ac4a9effa24fe7be$var$Ij(a, b) {
    $ac4a9effa24fe7be$var$wg(b);
    switch(b.tag){
        case 1:
            return $ac4a9effa24fe7be$var$Zf(b.type) && $ac4a9effa24fe7be$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $ac4a9effa24fe7be$var$zh(), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf), $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H), $ac4a9effa24fe7be$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $ac4a9effa24fe7be$var$Bh(b), null;
        case 13:
            $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($ac4a9effa24fe7be$var$p(340));
                $ac4a9effa24fe7be$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$L), null;
        case 4:
            return $ac4a9effa24fe7be$var$zh(), null;
        case 10:
            return $ac4a9effa24fe7be$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $ac4a9effa24fe7be$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $ac4a9effa24fe7be$var$Jj = !1, $ac4a9effa24fe7be$var$U = !1, $ac4a9effa24fe7be$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $ac4a9effa24fe7be$var$V = null;
function $ac4a9effa24fe7be$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $ac4a9effa24fe7be$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $ac4a9effa24fe7be$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $ac4a9effa24fe7be$var$W(a, b, d);
    }
}
var $ac4a9effa24fe7be$var$Nj = !1;
function $ac4a9effa24fe7be$var$Oj(a, b) {
    $ac4a9effa24fe7be$var$Cf = $ac4a9effa24fe7be$var$dd;
    a = $ac4a9effa24fe7be$var$Me();
    if ($ac4a9effa24fe7be$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $ac4a9effa24fe7be$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $ac4a9effa24fe7be$var$dd = !1;
    for($ac4a9effa24fe7be$var$V = b; null !== $ac4a9effa24fe7be$var$V;)if (b = $ac4a9effa24fe7be$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $ac4a9effa24fe7be$var$V = a;
    else for(; null !== $ac4a9effa24fe7be$var$V;){
        b = $ac4a9effa24fe7be$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $ac4a9effa24fe7be$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($ac4a9effa24fe7be$var$p(163));
            }
        } catch (F) {
            $ac4a9effa24fe7be$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $ac4a9effa24fe7be$var$V = a;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
    n = $ac4a9effa24fe7be$var$Nj;
    $ac4a9effa24fe7be$var$Nj = !1;
    return n;
}
function $ac4a9effa24fe7be$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $ac4a9effa24fe7be$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $ac4a9effa24fe7be$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $ac4a9effa24fe7be$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $ac4a9effa24fe7be$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $ac4a9effa24fe7be$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$ac4a9effa24fe7be$var$Of], delete b[$ac4a9effa24fe7be$var$Pf], delete b[$ac4a9effa24fe7be$var$of], delete b[$ac4a9effa24fe7be$var$Qf], delete b[$ac4a9effa24fe7be$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $ac4a9effa24fe7be$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $ac4a9effa24fe7be$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $ac4a9effa24fe7be$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $ac4a9effa24fe7be$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $ac4a9effa24fe7be$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($ac4a9effa24fe7be$var$Vj(a, b, c), a = a.sibling; null !== a;)$ac4a9effa24fe7be$var$Vj(a, b, c), a = a.sibling;
}
function $ac4a9effa24fe7be$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($ac4a9effa24fe7be$var$Wj(a, b, c), a = a.sibling; null !== a;)$ac4a9effa24fe7be$var$Wj(a, b, c), a = a.sibling;
}
var $ac4a9effa24fe7be$var$X = null, $ac4a9effa24fe7be$var$Xj = !1;
function $ac4a9effa24fe7be$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$ac4a9effa24fe7be$var$Zj(a, b, c), c = c.sibling;
}
function $ac4a9effa24fe7be$var$Zj(a, b, c) {
    if ($ac4a9effa24fe7be$var$lc && "function" === typeof $ac4a9effa24fe7be$var$lc.onCommitFiberUnmount) try {
        $ac4a9effa24fe7be$var$lc.onCommitFiberUnmount($ac4a9effa24fe7be$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $ac4a9effa24fe7be$var$U || $ac4a9effa24fe7be$var$Lj(c, b);
        case 6:
            var d = $ac4a9effa24fe7be$var$X, e = $ac4a9effa24fe7be$var$Xj;
            $ac4a9effa24fe7be$var$X = null;
            $ac4a9effa24fe7be$var$Yj(a, b, c);
            $ac4a9effa24fe7be$var$X = d;
            $ac4a9effa24fe7be$var$Xj = e;
            null !== $ac4a9effa24fe7be$var$X && ($ac4a9effa24fe7be$var$Xj ? (a = $ac4a9effa24fe7be$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $ac4a9effa24fe7be$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $ac4a9effa24fe7be$var$X && ($ac4a9effa24fe7be$var$Xj ? (a = $ac4a9effa24fe7be$var$X, c = c.stateNode, 8 === a.nodeType ? $ac4a9effa24fe7be$var$Kf(a.parentNode, c) : 1 === a.nodeType && $ac4a9effa24fe7be$var$Kf(a, c), $ac4a9effa24fe7be$var$bd(a)) : $ac4a9effa24fe7be$var$Kf($ac4a9effa24fe7be$var$X, c.stateNode));
            break;
        case 4:
            d = $ac4a9effa24fe7be$var$X;
            e = $ac4a9effa24fe7be$var$Xj;
            $ac4a9effa24fe7be$var$X = c.stateNode.containerInfo;
            $ac4a9effa24fe7be$var$Xj = !0;
            $ac4a9effa24fe7be$var$Yj(a, b, c);
            $ac4a9effa24fe7be$var$X = d;
            $ac4a9effa24fe7be$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$ac4a9effa24fe7be$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $ac4a9effa24fe7be$var$Mj(c, b, g) : 0 !== (f & 4) && $ac4a9effa24fe7be$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $ac4a9effa24fe7be$var$Yj(a, b, c);
            break;
        case 1:
            if (!$ac4a9effa24fe7be$var$U && ($ac4a9effa24fe7be$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $ac4a9effa24fe7be$var$W(c, b, h);
            }
            $ac4a9effa24fe7be$var$Yj(a, b, c);
            break;
        case 21:
            $ac4a9effa24fe7be$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($ac4a9effa24fe7be$var$U = (d = $ac4a9effa24fe7be$var$U) || null !== c.memoizedState, $ac4a9effa24fe7be$var$Yj(a, b, c), $ac4a9effa24fe7be$var$U = d) : $ac4a9effa24fe7be$var$Yj(a, b, c);
            break;
        default:
            $ac4a9effa24fe7be$var$Yj(a, b, c);
    }
}
function $ac4a9effa24fe7be$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $ac4a9effa24fe7be$var$Kj);
        b.forEach(function(b) {
            var d = $ac4a9effa24fe7be$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $ac4a9effa24fe7be$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $ac4a9effa24fe7be$var$X = h.stateNode;
                        $ac4a9effa24fe7be$var$Xj = !1;
                        break a;
                    case 3:
                        $ac4a9effa24fe7be$var$X = h.stateNode.containerInfo;
                        $ac4a9effa24fe7be$var$Xj = !0;
                        break a;
                    case 4:
                        $ac4a9effa24fe7be$var$X = h.stateNode.containerInfo;
                        $ac4a9effa24fe7be$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $ac4a9effa24fe7be$var$X) throw Error($ac4a9effa24fe7be$var$p(160));
            $ac4a9effa24fe7be$var$Zj(f, g, e);
            $ac4a9effa24fe7be$var$X = null;
            $ac4a9effa24fe7be$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $ac4a9effa24fe7be$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$ac4a9effa24fe7be$var$dk(b, a), b = b.sibling;
}
function $ac4a9effa24fe7be$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            if (d & 4) {
                try {
                    $ac4a9effa24fe7be$var$Pj(3, a, a.return), $ac4a9effa24fe7be$var$Qj(3, a);
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
                try {
                    $ac4a9effa24fe7be$var$Pj(5, a, a.return);
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            d & 512 && null !== c && $ac4a9effa24fe7be$var$Lj(c, c.return);
            break;
        case 5:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            d & 512 && null !== c && $ac4a9effa24fe7be$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $ac4a9effa24fe7be$var$ob(e, "");
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $ac4a9effa24fe7be$var$ab(e, f);
                    $ac4a9effa24fe7be$var$vb(h, g);
                    var l = $ac4a9effa24fe7be$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $ac4a9effa24fe7be$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $ac4a9effa24fe7be$var$nb(e, q) : "children" === m ? $ac4a9effa24fe7be$var$ob(e, q) : $ac4a9effa24fe7be$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $ac4a9effa24fe7be$var$bb(e, f);
                            break;
                        case "textarea":
                            $ac4a9effa24fe7be$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $ac4a9effa24fe7be$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $ac4a9effa24fe7be$var$fb(e, !!f.multiple, f.defaultValue, !0) : $ac4a9effa24fe7be$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$ac4a9effa24fe7be$var$Pf] = f;
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($ac4a9effa24fe7be$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $ac4a9effa24fe7be$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $ac4a9effa24fe7be$var$bd(b.containerInfo);
            } catch (t) {
                $ac4a9effa24fe7be$var$W(a, a.return, t);
            }
            break;
        case 4:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            break;
        case 13:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($ac4a9effa24fe7be$var$fk = $ac4a9effa24fe7be$var$B()));
            d & 4 && $ac4a9effa24fe7be$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($ac4a9effa24fe7be$var$U = (l = $ac4a9effa24fe7be$var$U) || m, $ac4a9effa24fe7be$var$ck(b, a), $ac4a9effa24fe7be$var$U = l) : $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($ac4a9effa24fe7be$var$V = a, m = a.child; null !== m;){
                    for(q = $ac4a9effa24fe7be$var$V = m; null !== $ac4a9effa24fe7be$var$V;){
                        r = $ac4a9effa24fe7be$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $ac4a9effa24fe7be$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $ac4a9effa24fe7be$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $ac4a9effa24fe7be$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $ac4a9effa24fe7be$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $ac4a9effa24fe7be$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $ac4a9effa24fe7be$var$V = y) : $ac4a9effa24fe7be$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $ac4a9effa24fe7be$var$rb("display", g));
                            } catch (t) {
                                $ac4a9effa24fe7be$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $ac4a9effa24fe7be$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $ac4a9effa24fe7be$var$ck(b, a);
            $ac4a9effa24fe7be$var$ek(a);
            d & 4 && $ac4a9effa24fe7be$var$ak(a);
            break;
        case 21:
            break;
        default:
            $ac4a9effa24fe7be$var$ck(b, a), $ac4a9effa24fe7be$var$ek(a);
    }
}
function $ac4a9effa24fe7be$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($ac4a9effa24fe7be$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($ac4a9effa24fe7be$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($ac4a9effa24fe7be$var$ob(e, ""), d.flags &= -33);
                    var f = $ac4a9effa24fe7be$var$Uj(a);
                    $ac4a9effa24fe7be$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $ac4a9effa24fe7be$var$Uj(a);
                    $ac4a9effa24fe7be$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($ac4a9effa24fe7be$var$p(161));
            }
        } catch (k) {
            $ac4a9effa24fe7be$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $ac4a9effa24fe7be$var$hk(a, b, c) {
    $ac4a9effa24fe7be$var$V = a;
    $ac4a9effa24fe7be$var$ik(a, b, c);
}
function $ac4a9effa24fe7be$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $ac4a9effa24fe7be$var$V;){
        var e = $ac4a9effa24fe7be$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $ac4a9effa24fe7be$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $ac4a9effa24fe7be$var$U;
                h = $ac4a9effa24fe7be$var$Jj;
                var l = $ac4a9effa24fe7be$var$U;
                $ac4a9effa24fe7be$var$Jj = g;
                if (($ac4a9effa24fe7be$var$U = k) && !l) for($ac4a9effa24fe7be$var$V = e; null !== $ac4a9effa24fe7be$var$V;)g = $ac4a9effa24fe7be$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $ac4a9effa24fe7be$var$jk(e) : null !== k ? (k.return = g, $ac4a9effa24fe7be$var$V = k) : $ac4a9effa24fe7be$var$jk(e);
                for(; null !== f;)$ac4a9effa24fe7be$var$V = f, $ac4a9effa24fe7be$var$ik(f, b, c), f = f.sibling;
                $ac4a9effa24fe7be$var$V = e;
                $ac4a9effa24fe7be$var$Jj = h;
                $ac4a9effa24fe7be$var$U = l;
            }
            $ac4a9effa24fe7be$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $ac4a9effa24fe7be$var$V = f) : $ac4a9effa24fe7be$var$kk(a, b, c);
    }
}
function $ac4a9effa24fe7be$var$kk(a) {
    for(; null !== $ac4a9effa24fe7be$var$V;){
        var b = $ac4a9effa24fe7be$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $ac4a9effa24fe7be$var$U || $ac4a9effa24fe7be$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$ac4a9effa24fe7be$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $ac4a9effa24fe7be$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $ac4a9effa24fe7be$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $ac4a9effa24fe7be$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $ac4a9effa24fe7be$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($ac4a9effa24fe7be$var$p(163));
                }
                $ac4a9effa24fe7be$var$U || b.flags & 512 && $ac4a9effa24fe7be$var$Rj(b);
            } catch (r) {
                $ac4a9effa24fe7be$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $ac4a9effa24fe7be$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $ac4a9effa24fe7be$var$V = c;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
}
function $ac4a9effa24fe7be$var$gk(a) {
    for(; null !== $ac4a9effa24fe7be$var$V;){
        var b = $ac4a9effa24fe7be$var$V;
        if (b === a) {
            $ac4a9effa24fe7be$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $ac4a9effa24fe7be$var$V = c;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
}
function $ac4a9effa24fe7be$var$jk(a) {
    for(; null !== $ac4a9effa24fe7be$var$V;){
        var b = $ac4a9effa24fe7be$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $ac4a9effa24fe7be$var$Qj(4, b);
                    } catch (k) {
                        $ac4a9effa24fe7be$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $ac4a9effa24fe7be$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $ac4a9effa24fe7be$var$Rj(b);
                    } catch (k) {
                        $ac4a9effa24fe7be$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $ac4a9effa24fe7be$var$Rj(b);
                    } catch (k) {
                        $ac4a9effa24fe7be$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $ac4a9effa24fe7be$var$W(b, b.return, k);
        }
        if (b === a) {
            $ac4a9effa24fe7be$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $ac4a9effa24fe7be$var$V = h;
            break;
        }
        $ac4a9effa24fe7be$var$V = b.return;
    }
}
var $ac4a9effa24fe7be$var$lk = Math.ceil, $ac4a9effa24fe7be$var$mk = $ac4a9effa24fe7be$var$ua.ReactCurrentDispatcher, $ac4a9effa24fe7be$var$nk = $ac4a9effa24fe7be$var$ua.ReactCurrentOwner, $ac4a9effa24fe7be$var$ok = $ac4a9effa24fe7be$var$ua.ReactCurrentBatchConfig, $ac4a9effa24fe7be$var$K = 0, $ac4a9effa24fe7be$var$Q = null, $ac4a9effa24fe7be$var$Y = null, $ac4a9effa24fe7be$var$Z = 0, $ac4a9effa24fe7be$var$fj = 0, $ac4a9effa24fe7be$var$ej = $ac4a9effa24fe7be$var$Uf(0), $ac4a9effa24fe7be$var$T = 0, $ac4a9effa24fe7be$var$pk = null, $ac4a9effa24fe7be$var$rh = 0, $ac4a9effa24fe7be$var$qk = 0, $ac4a9effa24fe7be$var$rk = 0, $ac4a9effa24fe7be$var$sk = null, $ac4a9effa24fe7be$var$tk = null, $ac4a9effa24fe7be$var$fk = 0, $ac4a9effa24fe7be$var$Gj = Infinity, $ac4a9effa24fe7be$var$uk = null, $ac4a9effa24fe7be$var$Oi = !1, $ac4a9effa24fe7be$var$Pi = null, $ac4a9effa24fe7be$var$Ri = null, $ac4a9effa24fe7be$var$vk = !1, $ac4a9effa24fe7be$var$wk = null, $ac4a9effa24fe7be$var$xk = 0, $ac4a9effa24fe7be$var$yk = 0, $ac4a9effa24fe7be$var$zk = null, $ac4a9effa24fe7be$var$Ak = -1, $ac4a9effa24fe7be$var$Bk = 0;
function $ac4a9effa24fe7be$var$R() {
    return 0 !== ($ac4a9effa24fe7be$var$K & 6) ? $ac4a9effa24fe7be$var$B() : -1 !== $ac4a9effa24fe7be$var$Ak ? $ac4a9effa24fe7be$var$Ak : $ac4a9effa24fe7be$var$Ak = $ac4a9effa24fe7be$var$B();
}
function $ac4a9effa24fe7be$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($ac4a9effa24fe7be$var$K & 2) && 0 !== $ac4a9effa24fe7be$var$Z) return $ac4a9effa24fe7be$var$Z & -$ac4a9effa24fe7be$var$Z;
    if (null !== $ac4a9effa24fe7be$var$Kg.transition) return 0 === $ac4a9effa24fe7be$var$Bk && ($ac4a9effa24fe7be$var$Bk = $ac4a9effa24fe7be$var$yc()), $ac4a9effa24fe7be$var$Bk;
    a = $ac4a9effa24fe7be$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $ac4a9effa24fe7be$var$jd(a.type);
    return a;
}
function $ac4a9effa24fe7be$var$gi(a, b, c, d) {
    if (50 < $ac4a9effa24fe7be$var$yk) throw $ac4a9effa24fe7be$var$yk = 0, $ac4a9effa24fe7be$var$zk = null, Error($ac4a9effa24fe7be$var$p(185));
    $ac4a9effa24fe7be$var$Ac(a, c, d);
    if (0 === ($ac4a9effa24fe7be$var$K & 2) || a !== $ac4a9effa24fe7be$var$Q) a === $ac4a9effa24fe7be$var$Q && (0 === ($ac4a9effa24fe7be$var$K & 2) && ($ac4a9effa24fe7be$var$qk |= c), 4 === $ac4a9effa24fe7be$var$T && $ac4a9effa24fe7be$var$Ck(a, $ac4a9effa24fe7be$var$Z)), $ac4a9effa24fe7be$var$Dk(a, d), 1 === c && 0 === $ac4a9effa24fe7be$var$K && 0 === (b.mode & 1) && ($ac4a9effa24fe7be$var$Gj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$fg && $ac4a9effa24fe7be$var$jg());
}
function $ac4a9effa24fe7be$var$Dk(a, b) {
    var c = a.callbackNode;
    $ac4a9effa24fe7be$var$wc(a, b);
    var d = $ac4a9effa24fe7be$var$uc(a, a === $ac4a9effa24fe7be$var$Q ? $ac4a9effa24fe7be$var$Z : 0);
    if (0 === d) null !== c && $ac4a9effa24fe7be$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $ac4a9effa24fe7be$var$bc(c);
        if (1 === b) 0 === a.tag ? $ac4a9effa24fe7be$var$ig($ac4a9effa24fe7be$var$Ek.bind(null, a)) : $ac4a9effa24fe7be$var$hg($ac4a9effa24fe7be$var$Ek.bind(null, a)), $ac4a9effa24fe7be$var$Jf(function() {
            0 === ($ac4a9effa24fe7be$var$K & 6) && $ac4a9effa24fe7be$var$jg();
        }), c = null;
        else {
            switch($ac4a9effa24fe7be$var$Dc(d)){
                case 1:
                    c = $ac4a9effa24fe7be$var$fc;
                    break;
                case 4:
                    c = $ac4a9effa24fe7be$var$gc;
                    break;
                case 16:
                    c = $ac4a9effa24fe7be$var$hc;
                    break;
                case 536870912:
                    c = $ac4a9effa24fe7be$var$jc;
                    break;
                default:
                    c = $ac4a9effa24fe7be$var$hc;
            }
            c = $ac4a9effa24fe7be$var$Fk(c, $ac4a9effa24fe7be$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $ac4a9effa24fe7be$var$Gk(a, b) {
    $ac4a9effa24fe7be$var$Ak = -1;
    $ac4a9effa24fe7be$var$Bk = 0;
    if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(327));
    var c = a.callbackNode;
    if ($ac4a9effa24fe7be$var$Hk() && a.callbackNode !== c) return null;
    var d = $ac4a9effa24fe7be$var$uc(a, a === $ac4a9effa24fe7be$var$Q ? $ac4a9effa24fe7be$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $ac4a9effa24fe7be$var$Ik(a, d);
    else {
        b = d;
        var e = $ac4a9effa24fe7be$var$K;
        $ac4a9effa24fe7be$var$K |= 2;
        var f = $ac4a9effa24fe7be$var$Jk();
        if ($ac4a9effa24fe7be$var$Q !== a || $ac4a9effa24fe7be$var$Z !== b) $ac4a9effa24fe7be$var$uk = null, $ac4a9effa24fe7be$var$Gj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$Kk(a, b);
        for(;;)try {
            $ac4a9effa24fe7be$var$Lk();
            break;
        } catch (h) {
            $ac4a9effa24fe7be$var$Mk(a, h);
        }
        $ac4a9effa24fe7be$var$$g();
        $ac4a9effa24fe7be$var$mk.current = f;
        $ac4a9effa24fe7be$var$K = e;
        null !== $ac4a9effa24fe7be$var$Y ? b = 0 : ($ac4a9effa24fe7be$var$Q = null, $ac4a9effa24fe7be$var$Z = 0, b = $ac4a9effa24fe7be$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $ac4a9effa24fe7be$var$xc(a), 0 !== e && (d = e, b = $ac4a9effa24fe7be$var$Nk(a, e)));
        if (1 === b) throw c = $ac4a9effa24fe7be$var$pk, $ac4a9effa24fe7be$var$Kk(a, 0), $ac4a9effa24fe7be$var$Ck(a, d), $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$B()), c;
        if (6 === b) $ac4a9effa24fe7be$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$ac4a9effa24fe7be$var$Ok(e) && (b = $ac4a9effa24fe7be$var$Ik(a, d), 2 === b && (f = $ac4a9effa24fe7be$var$xc(a), 0 !== f && (d = f, b = $ac4a9effa24fe7be$var$Nk(a, f))), 1 === b)) throw c = $ac4a9effa24fe7be$var$pk, $ac4a9effa24fe7be$var$Kk(a, 0), $ac4a9effa24fe7be$var$Ck(a, d), $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($ac4a9effa24fe7be$var$p(345));
                case 2:
                    $ac4a9effa24fe7be$var$Pk(a, $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$uk);
                    break;
                case 3:
                    $ac4a9effa24fe7be$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $ac4a9effa24fe7be$var$fk + 500 - $ac4a9effa24fe7be$var$B(), 10 < b)) {
                        if (0 !== $ac4a9effa24fe7be$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $ac4a9effa24fe7be$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $ac4a9effa24fe7be$var$Ff($ac4a9effa24fe7be$var$Pk.bind(null, a, $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$uk), b);
                        break;
                    }
                    $ac4a9effa24fe7be$var$Pk(a, $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$uk);
                    break;
                case 4:
                    $ac4a9effa24fe7be$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $ac4a9effa24fe7be$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $ac4a9effa24fe7be$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $ac4a9effa24fe7be$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $ac4a9effa24fe7be$var$Ff($ac4a9effa24fe7be$var$Pk.bind(null, a, $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$uk), d);
                        break;
                    }
                    $ac4a9effa24fe7be$var$Pk(a, $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$uk);
                    break;
                case 5:
                    $ac4a9effa24fe7be$var$Pk(a, $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$uk);
                    break;
                default:
                    throw Error($ac4a9effa24fe7be$var$p(329));
            }
        }
    }
    $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$B());
    return a.callbackNode === c ? $ac4a9effa24fe7be$var$Gk.bind(null, a) : null;
}
function $ac4a9effa24fe7be$var$Nk(a, b) {
    var c = $ac4a9effa24fe7be$var$sk;
    a.current.memoizedState.isDehydrated && ($ac4a9effa24fe7be$var$Kk(a, b).flags |= 256);
    a = $ac4a9effa24fe7be$var$Ik(a, b);
    2 !== a && (b = $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$tk = c, null !== b && $ac4a9effa24fe7be$var$Fj(b));
    return a;
}
function $ac4a9effa24fe7be$var$Fj(a) {
    null === $ac4a9effa24fe7be$var$tk ? $ac4a9effa24fe7be$var$tk = a : $ac4a9effa24fe7be$var$tk.push.apply($ac4a9effa24fe7be$var$tk, a);
}
function $ac4a9effa24fe7be$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$ac4a9effa24fe7be$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $ac4a9effa24fe7be$var$Ck(a, b) {
    b &= ~$ac4a9effa24fe7be$var$rk;
    b &= ~$ac4a9effa24fe7be$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $ac4a9effa24fe7be$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $ac4a9effa24fe7be$var$Ek(a) {
    if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(327));
    $ac4a9effa24fe7be$var$Hk();
    var b = $ac4a9effa24fe7be$var$uc(a, 0);
    if (0 === (b & 1)) return $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$B()), null;
    var c = $ac4a9effa24fe7be$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $ac4a9effa24fe7be$var$xc(a);
        0 !== d && (b = d, c = $ac4a9effa24fe7be$var$Nk(a, d));
    }
    if (1 === c) throw c = $ac4a9effa24fe7be$var$pk, $ac4a9effa24fe7be$var$Kk(a, 0), $ac4a9effa24fe7be$var$Ck(a, b), $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$B()), c;
    if (6 === c) throw Error($ac4a9effa24fe7be$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $ac4a9effa24fe7be$var$Pk(a, $ac4a9effa24fe7be$var$tk, $ac4a9effa24fe7be$var$uk);
    $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$B());
    return null;
}
function $ac4a9effa24fe7be$var$Qk(a, b) {
    var c = $ac4a9effa24fe7be$var$K;
    $ac4a9effa24fe7be$var$K |= 1;
    try {
        return a(b);
    } finally{
        $ac4a9effa24fe7be$var$K = c, 0 === $ac4a9effa24fe7be$var$K && ($ac4a9effa24fe7be$var$Gj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$fg && $ac4a9effa24fe7be$var$jg());
    }
}
function $ac4a9effa24fe7be$var$Rk(a) {
    null !== $ac4a9effa24fe7be$var$wk && 0 === $ac4a9effa24fe7be$var$wk.tag && 0 === ($ac4a9effa24fe7be$var$K & 6) && $ac4a9effa24fe7be$var$Hk();
    var b = $ac4a9effa24fe7be$var$K;
    $ac4a9effa24fe7be$var$K |= 1;
    var c = $ac4a9effa24fe7be$var$ok.transition, d = $ac4a9effa24fe7be$var$C;
    try {
        if ($ac4a9effa24fe7be$var$ok.transition = null, $ac4a9effa24fe7be$var$C = 1, a) return a();
    } finally{
        $ac4a9effa24fe7be$var$C = d, $ac4a9effa24fe7be$var$ok.transition = c, $ac4a9effa24fe7be$var$K = b, 0 === ($ac4a9effa24fe7be$var$K & 6) && $ac4a9effa24fe7be$var$jg();
    }
}
function $ac4a9effa24fe7be$var$Hj() {
    $ac4a9effa24fe7be$var$fj = $ac4a9effa24fe7be$var$ej.current;
    $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$ej);
}
function $ac4a9effa24fe7be$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $ac4a9effa24fe7be$var$Gf(c));
    if (null !== $ac4a9effa24fe7be$var$Y) for(c = $ac4a9effa24fe7be$var$Y.return; null !== c;){
        var d = c;
        $ac4a9effa24fe7be$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $ac4a9effa24fe7be$var$$f();
                break;
            case 3:
                $ac4a9effa24fe7be$var$zh();
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$Wf);
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$H);
                $ac4a9effa24fe7be$var$Eh();
                break;
            case 5:
                $ac4a9effa24fe7be$var$Bh(d);
                break;
            case 4:
                $ac4a9effa24fe7be$var$zh();
                break;
            case 13:
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$L);
                break;
            case 19:
                $ac4a9effa24fe7be$var$E($ac4a9effa24fe7be$var$L);
                break;
            case 10:
                $ac4a9effa24fe7be$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $ac4a9effa24fe7be$var$Hj();
        }
        c = c.return;
    }
    $ac4a9effa24fe7be$var$Q = a;
    $ac4a9effa24fe7be$var$Y = a = $ac4a9effa24fe7be$var$Pg(a.current, null);
    $ac4a9effa24fe7be$var$Z = $ac4a9effa24fe7be$var$fj = b;
    $ac4a9effa24fe7be$var$T = 0;
    $ac4a9effa24fe7be$var$pk = null;
    $ac4a9effa24fe7be$var$rk = $ac4a9effa24fe7be$var$qk = $ac4a9effa24fe7be$var$rh = 0;
    $ac4a9effa24fe7be$var$tk = $ac4a9effa24fe7be$var$sk = null;
    if (null !== $ac4a9effa24fe7be$var$fh) {
        for(b = 0; b < $ac4a9effa24fe7be$var$fh.length; b++)if (c = $ac4a9effa24fe7be$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $ac4a9effa24fe7be$var$fh = null;
    }
    return a;
}
function $ac4a9effa24fe7be$var$Mk(a, b) {
    do {
        var c = $ac4a9effa24fe7be$var$Y;
        try {
            $ac4a9effa24fe7be$var$$g();
            $ac4a9effa24fe7be$var$Fh.current = $ac4a9effa24fe7be$var$Rh;
            if ($ac4a9effa24fe7be$var$Ih) {
                for(var d = $ac4a9effa24fe7be$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $ac4a9effa24fe7be$var$Ih = !1;
            }
            $ac4a9effa24fe7be$var$Hh = 0;
            $ac4a9effa24fe7be$var$O = $ac4a9effa24fe7be$var$N = $ac4a9effa24fe7be$var$M = null;
            $ac4a9effa24fe7be$var$Jh = !1;
            $ac4a9effa24fe7be$var$Kh = 0;
            $ac4a9effa24fe7be$var$nk.current = null;
            if (null === c || null === c.return) {
                $ac4a9effa24fe7be$var$T = 1;
                $ac4a9effa24fe7be$var$pk = b;
                $ac4a9effa24fe7be$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $ac4a9effa24fe7be$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $ac4a9effa24fe7be$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $ac4a9effa24fe7be$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $ac4a9effa24fe7be$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $ac4a9effa24fe7be$var$Si(f, l, b);
                            $ac4a9effa24fe7be$var$tj();
                            break a;
                        }
                        k = Error($ac4a9effa24fe7be$var$p(426));
                    }
                } else if ($ac4a9effa24fe7be$var$I && h.mode & 1) {
                    var J = $ac4a9effa24fe7be$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $ac4a9effa24fe7be$var$Vi(J, g, h, f, b);
                        $ac4a9effa24fe7be$var$Jg($ac4a9effa24fe7be$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $ac4a9effa24fe7be$var$Ji(k, h);
                4 !== $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$T = 2);
                null === $ac4a9effa24fe7be$var$sk ? $ac4a9effa24fe7be$var$sk = [
                    f
                ] : $ac4a9effa24fe7be$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $ac4a9effa24fe7be$var$Ni(f, k, b);
                            $ac4a9effa24fe7be$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $ac4a9effa24fe7be$var$Ri || !$ac4a9effa24fe7be$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $ac4a9effa24fe7be$var$Qi(f, h, b);
                                $ac4a9effa24fe7be$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $ac4a9effa24fe7be$var$Sk(c);
        } catch (na) {
            b = na;
            $ac4a9effa24fe7be$var$Y === c && null !== c && ($ac4a9effa24fe7be$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $ac4a9effa24fe7be$var$Jk() {
    var a = $ac4a9effa24fe7be$var$mk.current;
    $ac4a9effa24fe7be$var$mk.current = $ac4a9effa24fe7be$var$Rh;
    return null === a ? $ac4a9effa24fe7be$var$Rh : a;
}
function $ac4a9effa24fe7be$var$tj() {
    if (0 === $ac4a9effa24fe7be$var$T || 3 === $ac4a9effa24fe7be$var$T || 2 === $ac4a9effa24fe7be$var$T) $ac4a9effa24fe7be$var$T = 4;
    null === $ac4a9effa24fe7be$var$Q || 0 === ($ac4a9effa24fe7be$var$rh & 268435455) && 0 === ($ac4a9effa24fe7be$var$qk & 268435455) || $ac4a9effa24fe7be$var$Ck($ac4a9effa24fe7be$var$Q, $ac4a9effa24fe7be$var$Z);
}
function $ac4a9effa24fe7be$var$Ik(a, b) {
    var c = $ac4a9effa24fe7be$var$K;
    $ac4a9effa24fe7be$var$K |= 2;
    var d = $ac4a9effa24fe7be$var$Jk();
    if ($ac4a9effa24fe7be$var$Q !== a || $ac4a9effa24fe7be$var$Z !== b) $ac4a9effa24fe7be$var$uk = null, $ac4a9effa24fe7be$var$Kk(a, b);
    for(;;)try {
        $ac4a9effa24fe7be$var$Tk();
        break;
    } catch (e) {
        $ac4a9effa24fe7be$var$Mk(a, e);
    }
    $ac4a9effa24fe7be$var$$g();
    $ac4a9effa24fe7be$var$K = c;
    $ac4a9effa24fe7be$var$mk.current = d;
    if (null !== $ac4a9effa24fe7be$var$Y) throw Error($ac4a9effa24fe7be$var$p(261));
    $ac4a9effa24fe7be$var$Q = null;
    $ac4a9effa24fe7be$var$Z = 0;
    return $ac4a9effa24fe7be$var$T;
}
function $ac4a9effa24fe7be$var$Tk() {
    for(; null !== $ac4a9effa24fe7be$var$Y;)$ac4a9effa24fe7be$var$Uk($ac4a9effa24fe7be$var$Y);
}
function $ac4a9effa24fe7be$var$Lk() {
    for(; null !== $ac4a9effa24fe7be$var$Y && !$ac4a9effa24fe7be$var$cc();)$ac4a9effa24fe7be$var$Uk($ac4a9effa24fe7be$var$Y);
}
function $ac4a9effa24fe7be$var$Uk(a) {
    var b = $ac4a9effa24fe7be$var$Vk(a.alternate, a, $ac4a9effa24fe7be$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $ac4a9effa24fe7be$var$Sk(a) : $ac4a9effa24fe7be$var$Y = b;
    $ac4a9effa24fe7be$var$nk.current = null;
}
function $ac4a9effa24fe7be$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $ac4a9effa24fe7be$var$Ej(c, b, $ac4a9effa24fe7be$var$fj), null !== c) {
                $ac4a9effa24fe7be$var$Y = c;
                return;
            }
        } else {
            c = $ac4a9effa24fe7be$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $ac4a9effa24fe7be$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $ac4a9effa24fe7be$var$T = 6;
                $ac4a9effa24fe7be$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $ac4a9effa24fe7be$var$Y = b;
            return;
        }
        $ac4a9effa24fe7be$var$Y = b = a;
    }while (null !== b);
    0 === $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$T = 5);
}
function $ac4a9effa24fe7be$var$Pk(a, b, c) {
    var d = $ac4a9effa24fe7be$var$C, e = $ac4a9effa24fe7be$var$ok.transition;
    try {
        $ac4a9effa24fe7be$var$ok.transition = null, $ac4a9effa24fe7be$var$C = 1, $ac4a9effa24fe7be$var$Wk(a, b, c, d);
    } finally{
        $ac4a9effa24fe7be$var$ok.transition = e, $ac4a9effa24fe7be$var$C = d;
    }
    return null;
}
function $ac4a9effa24fe7be$var$Wk(a, b, c, d) {
    do $ac4a9effa24fe7be$var$Hk();
    while (null !== $ac4a9effa24fe7be$var$wk);
    if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($ac4a9effa24fe7be$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $ac4a9effa24fe7be$var$Bc(a, f);
    a === $ac4a9effa24fe7be$var$Q && ($ac4a9effa24fe7be$var$Y = $ac4a9effa24fe7be$var$Q = null, $ac4a9effa24fe7be$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $ac4a9effa24fe7be$var$vk || ($ac4a9effa24fe7be$var$vk = !0, $ac4a9effa24fe7be$var$Fk($ac4a9effa24fe7be$var$hc, function() {
        $ac4a9effa24fe7be$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $ac4a9effa24fe7be$var$ok.transition;
        $ac4a9effa24fe7be$var$ok.transition = null;
        var g = $ac4a9effa24fe7be$var$C;
        $ac4a9effa24fe7be$var$C = 1;
        var h = $ac4a9effa24fe7be$var$K;
        $ac4a9effa24fe7be$var$K |= 4;
        $ac4a9effa24fe7be$var$nk.current = null;
        $ac4a9effa24fe7be$var$Oj(a, c);
        $ac4a9effa24fe7be$var$dk(c, a);
        $ac4a9effa24fe7be$var$Oe($ac4a9effa24fe7be$var$Df);
        $ac4a9effa24fe7be$var$dd = !!$ac4a9effa24fe7be$var$Cf;
        $ac4a9effa24fe7be$var$Df = $ac4a9effa24fe7be$var$Cf = null;
        a.current = c;
        $ac4a9effa24fe7be$var$hk(c, a, e);
        $ac4a9effa24fe7be$var$dc();
        $ac4a9effa24fe7be$var$K = h;
        $ac4a9effa24fe7be$var$C = g;
        $ac4a9effa24fe7be$var$ok.transition = f;
    } else a.current = c;
    $ac4a9effa24fe7be$var$vk && ($ac4a9effa24fe7be$var$vk = !1, $ac4a9effa24fe7be$var$wk = a, $ac4a9effa24fe7be$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($ac4a9effa24fe7be$var$Ri = null);
    $ac4a9effa24fe7be$var$mc(c.stateNode, d);
    $ac4a9effa24fe7be$var$Dk(a, $ac4a9effa24fe7be$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($ac4a9effa24fe7be$var$Oi) throw $ac4a9effa24fe7be$var$Oi = !1, a = $ac4a9effa24fe7be$var$Pi, $ac4a9effa24fe7be$var$Pi = null, a;
    0 !== ($ac4a9effa24fe7be$var$xk & 1) && 0 !== a.tag && $ac4a9effa24fe7be$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $ac4a9effa24fe7be$var$zk ? $ac4a9effa24fe7be$var$yk++ : ($ac4a9effa24fe7be$var$yk = 0, $ac4a9effa24fe7be$var$zk = a) : $ac4a9effa24fe7be$var$yk = 0;
    $ac4a9effa24fe7be$var$jg();
    return null;
}
function $ac4a9effa24fe7be$var$Hk() {
    if (null !== $ac4a9effa24fe7be$var$wk) {
        var a = $ac4a9effa24fe7be$var$Dc($ac4a9effa24fe7be$var$xk), b = $ac4a9effa24fe7be$var$ok.transition, c = $ac4a9effa24fe7be$var$C;
        try {
            $ac4a9effa24fe7be$var$ok.transition = null;
            $ac4a9effa24fe7be$var$C = 16 > a ? 16 : a;
            if (null === $ac4a9effa24fe7be$var$wk) var d = !1;
            else {
                a = $ac4a9effa24fe7be$var$wk;
                $ac4a9effa24fe7be$var$wk = null;
                $ac4a9effa24fe7be$var$xk = 0;
                if (0 !== ($ac4a9effa24fe7be$var$K & 6)) throw Error($ac4a9effa24fe7be$var$p(331));
                var e = $ac4a9effa24fe7be$var$K;
                $ac4a9effa24fe7be$var$K |= 4;
                for($ac4a9effa24fe7be$var$V = a.current; null !== $ac4a9effa24fe7be$var$V;){
                    var f = $ac4a9effa24fe7be$var$V, g = f.child;
                    if (0 !== ($ac4a9effa24fe7be$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($ac4a9effa24fe7be$var$V = l; null !== $ac4a9effa24fe7be$var$V;){
                                    var m = $ac4a9effa24fe7be$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $ac4a9effa24fe7be$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $ac4a9effa24fe7be$var$V = q;
                                    else for(; null !== $ac4a9effa24fe7be$var$V;){
                                        m = $ac4a9effa24fe7be$var$V;
                                        var r = m.sibling, y = m.return;
                                        $ac4a9effa24fe7be$var$Sj(m);
                                        if (m === l) {
                                            $ac4a9effa24fe7be$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $ac4a9effa24fe7be$var$V = r;
                                            break;
                                        }
                                        $ac4a9effa24fe7be$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $ac4a9effa24fe7be$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $ac4a9effa24fe7be$var$V = g;
                    else b: for(; null !== $ac4a9effa24fe7be$var$V;){
                        f = $ac4a9effa24fe7be$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $ac4a9effa24fe7be$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $ac4a9effa24fe7be$var$V = x;
                            break b;
                        }
                        $ac4a9effa24fe7be$var$V = f.return;
                    }
                }
                var w = a.current;
                for($ac4a9effa24fe7be$var$V = w; null !== $ac4a9effa24fe7be$var$V;){
                    g = $ac4a9effa24fe7be$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $ac4a9effa24fe7be$var$V = u;
                    else b: for(g = w; null !== $ac4a9effa24fe7be$var$V;){
                        h = $ac4a9effa24fe7be$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $ac4a9effa24fe7be$var$Qj(9, h);
                            }
                        } catch (na) {
                            $ac4a9effa24fe7be$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $ac4a9effa24fe7be$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $ac4a9effa24fe7be$var$V = F;
                            break b;
                        }
                        $ac4a9effa24fe7be$var$V = h.return;
                    }
                }
                $ac4a9effa24fe7be$var$K = e;
                $ac4a9effa24fe7be$var$jg();
                if ($ac4a9effa24fe7be$var$lc && "function" === typeof $ac4a9effa24fe7be$var$lc.onPostCommitFiberRoot) try {
                    $ac4a9effa24fe7be$var$lc.onPostCommitFiberRoot($ac4a9effa24fe7be$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $ac4a9effa24fe7be$var$C = c, $ac4a9effa24fe7be$var$ok.transition = b;
        }
    }
    return !1;
}
function $ac4a9effa24fe7be$var$Xk(a, b, c) {
    b = $ac4a9effa24fe7be$var$Ji(c, b);
    b = $ac4a9effa24fe7be$var$Ni(a, b, 1);
    a = $ac4a9effa24fe7be$var$nh(a, b, 1);
    b = $ac4a9effa24fe7be$var$R();
    null !== a && ($ac4a9effa24fe7be$var$Ac(a, 1, b), $ac4a9effa24fe7be$var$Dk(a, b));
}
function $ac4a9effa24fe7be$var$W(a, b, c) {
    if (3 === a.tag) $ac4a9effa24fe7be$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $ac4a9effa24fe7be$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $ac4a9effa24fe7be$var$Ri || !$ac4a9effa24fe7be$var$Ri.has(d))) {
                a = $ac4a9effa24fe7be$var$Ji(c, a);
                a = $ac4a9effa24fe7be$var$Qi(b, a, 1);
                b = $ac4a9effa24fe7be$var$nh(b, a, 1);
                a = $ac4a9effa24fe7be$var$R();
                null !== b && ($ac4a9effa24fe7be$var$Ac(b, 1, a), $ac4a9effa24fe7be$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $ac4a9effa24fe7be$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $ac4a9effa24fe7be$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $ac4a9effa24fe7be$var$Q === a && ($ac4a9effa24fe7be$var$Z & c) === c && (4 === $ac4a9effa24fe7be$var$T || 3 === $ac4a9effa24fe7be$var$T && ($ac4a9effa24fe7be$var$Z & 130023424) === $ac4a9effa24fe7be$var$Z && 500 > $ac4a9effa24fe7be$var$B() - $ac4a9effa24fe7be$var$fk ? $ac4a9effa24fe7be$var$Kk(a, 0) : $ac4a9effa24fe7be$var$rk |= c);
    $ac4a9effa24fe7be$var$Dk(a, b);
}
function $ac4a9effa24fe7be$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $ac4a9effa24fe7be$var$sc, $ac4a9effa24fe7be$var$sc <<= 1, 0 === ($ac4a9effa24fe7be$var$sc & 130023424) && ($ac4a9effa24fe7be$var$sc = 4194304)));
    var c = $ac4a9effa24fe7be$var$R();
    a = $ac4a9effa24fe7be$var$ih(a, b);
    null !== a && ($ac4a9effa24fe7be$var$Ac(a, b, c), $ac4a9effa24fe7be$var$Dk(a, c));
}
function $ac4a9effa24fe7be$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $ac4a9effa24fe7be$var$Yk(a, c);
}
function $ac4a9effa24fe7be$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($ac4a9effa24fe7be$var$p(314));
    }
    null !== d && d.delete(b);
    $ac4a9effa24fe7be$var$Yk(a, c);
}
var $ac4a9effa24fe7be$var$Vk;
$ac4a9effa24fe7be$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $ac4a9effa24fe7be$var$Wf.current) $ac4a9effa24fe7be$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $ac4a9effa24fe7be$var$dh = !1, $ac4a9effa24fe7be$var$yj(a, b, c);
            $ac4a9effa24fe7be$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $ac4a9effa24fe7be$var$dh = !1, $ac4a9effa24fe7be$var$I && 0 !== (b.flags & 1048576) && $ac4a9effa24fe7be$var$ug(b, $ac4a9effa24fe7be$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $ac4a9effa24fe7be$var$ij(a, b);
            a = b.pendingProps;
            var e = $ac4a9effa24fe7be$var$Yf(b, $ac4a9effa24fe7be$var$H.current);
            $ac4a9effa24fe7be$var$ch(b, c);
            e = $ac4a9effa24fe7be$var$Nh(null, b, d, a, e, c);
            var f = $ac4a9effa24fe7be$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $ac4a9effa24fe7be$var$Zf(d) ? (f = !0, $ac4a9effa24fe7be$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $ac4a9effa24fe7be$var$kh(b), e.updater = $ac4a9effa24fe7be$var$Ei, b.stateNode = e, e._reactInternals = b, $ac4a9effa24fe7be$var$Ii(b, d, a, c), b = $ac4a9effa24fe7be$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $ac4a9effa24fe7be$var$I && f && $ac4a9effa24fe7be$var$vg(b), $ac4a9effa24fe7be$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $ac4a9effa24fe7be$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $ac4a9effa24fe7be$var$Zk(d);
                a = $ac4a9effa24fe7be$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $ac4a9effa24fe7be$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $ac4a9effa24fe7be$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $ac4a9effa24fe7be$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $ac4a9effa24fe7be$var$$i(null, b, d, $ac4a9effa24fe7be$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($ac4a9effa24fe7be$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Ci(d, e), $ac4a9effa24fe7be$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Ci(d, e), $ac4a9effa24fe7be$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $ac4a9effa24fe7be$var$kj(b);
                if (null === a) throw Error($ac4a9effa24fe7be$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $ac4a9effa24fe7be$var$lh(a, b);
                $ac4a9effa24fe7be$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $ac4a9effa24fe7be$var$Ji(Error($ac4a9effa24fe7be$var$p(423)), b);
                        b = $ac4a9effa24fe7be$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $ac4a9effa24fe7be$var$Ji(Error($ac4a9effa24fe7be$var$p(424)), b);
                        b = $ac4a9effa24fe7be$var$lj(a, b, d, c, e);
                        break a;
                    } else for($ac4a9effa24fe7be$var$yg = $ac4a9effa24fe7be$var$Lf(b.stateNode.containerInfo.firstChild), $ac4a9effa24fe7be$var$xg = b, $ac4a9effa24fe7be$var$I = !0, $ac4a9effa24fe7be$var$zg = null, c = $ac4a9effa24fe7be$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $ac4a9effa24fe7be$var$Ig();
                    if (d === e) {
                        b = $ac4a9effa24fe7be$var$Zi(a, b, c);
                        break a;
                    }
                    $ac4a9effa24fe7be$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $ac4a9effa24fe7be$var$Ah(b), null === a && $ac4a9effa24fe7be$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $ac4a9effa24fe7be$var$Ef(d, e) ? g = null : null !== f && $ac4a9effa24fe7be$var$Ef(d, f) && (b.flags |= 32), $ac4a9effa24fe7be$var$gj(a, b), $ac4a9effa24fe7be$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $ac4a9effa24fe7be$var$Eg(b), null;
        case 13:
            return $ac4a9effa24fe7be$var$oj(a, b, c);
        case 4:
            return $ac4a9effa24fe7be$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $ac4a9effa24fe7be$var$Ug(b, null, d, c) : $ac4a9effa24fe7be$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Ci(d, e), $ac4a9effa24fe7be$var$Yi(a, b, d, e, c);
        case 7:
            return $ac4a9effa24fe7be$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $ac4a9effa24fe7be$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $ac4a9effa24fe7be$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $ac4a9effa24fe7be$var$G($ac4a9effa24fe7be$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($ac4a9effa24fe7be$var$He(f.value, g)) {
                        if (f.children === e.children && !$ac4a9effa24fe7be$var$Wf.current) {
                            b = $ac4a9effa24fe7be$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $ac4a9effa24fe7be$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $ac4a9effa24fe7be$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($ac4a9effa24fe7be$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $ac4a9effa24fe7be$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $ac4a9effa24fe7be$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $ac4a9effa24fe7be$var$ch(b, c), e = $ac4a9effa24fe7be$var$eh(e), d = d(e), b.flags |= 1, $ac4a9effa24fe7be$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $ac4a9effa24fe7be$var$Ci(d, b.pendingProps), e = $ac4a9effa24fe7be$var$Ci(d.type, e), $ac4a9effa24fe7be$var$$i(a, b, d, e, c);
        case 15:
            return $ac4a9effa24fe7be$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ac4a9effa24fe7be$var$Ci(d, e), $ac4a9effa24fe7be$var$ij(a, b), b.tag = 1, $ac4a9effa24fe7be$var$Zf(d) ? (a = !0, $ac4a9effa24fe7be$var$cg(b)) : a = !1, $ac4a9effa24fe7be$var$ch(b, c), $ac4a9effa24fe7be$var$Gi(b, d, e), $ac4a9effa24fe7be$var$Ii(b, d, e, c), $ac4a9effa24fe7be$var$jj(null, b, d, !0, a, c);
        case 19:
            return $ac4a9effa24fe7be$var$xj(a, b, c);
        case 22:
            return $ac4a9effa24fe7be$var$dj(a, b, c);
    }
    throw Error($ac4a9effa24fe7be$var$p(156, b.tag));
};
function $ac4a9effa24fe7be$var$Fk(a, b) {
    return $ac4a9effa24fe7be$var$ac(a, b);
}
function $ac4a9effa24fe7be$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $ac4a9effa24fe7be$var$Bg(a, b, c, d) {
    return new $ac4a9effa24fe7be$var$$k(a, b, c, d);
}
function $ac4a9effa24fe7be$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $ac4a9effa24fe7be$var$Zk(a) {
    if ("function" === typeof a) return $ac4a9effa24fe7be$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $ac4a9effa24fe7be$var$Da) return 11;
        if (a === $ac4a9effa24fe7be$var$Ga) return 14;
    }
    return 2;
}
function $ac4a9effa24fe7be$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $ac4a9effa24fe7be$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $ac4a9effa24fe7be$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $ac4a9effa24fe7be$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $ac4a9effa24fe7be$var$ya:
            return $ac4a9effa24fe7be$var$Tg(c.children, e, f, b);
        case $ac4a9effa24fe7be$var$za:
            g = 8;
            e |= 8;
            break;
        case $ac4a9effa24fe7be$var$Aa:
            return a = $ac4a9effa24fe7be$var$Bg(12, c, b, e | 2), a.elementType = $ac4a9effa24fe7be$var$Aa, a.lanes = f, a;
        case $ac4a9effa24fe7be$var$Ea:
            return a = $ac4a9effa24fe7be$var$Bg(13, c, b, e), a.elementType = $ac4a9effa24fe7be$var$Ea, a.lanes = f, a;
        case $ac4a9effa24fe7be$var$Fa:
            return a = $ac4a9effa24fe7be$var$Bg(19, c, b, e), a.elementType = $ac4a9effa24fe7be$var$Fa, a.lanes = f, a;
        case $ac4a9effa24fe7be$var$Ia:
            return $ac4a9effa24fe7be$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $ac4a9effa24fe7be$var$Ba:
                    g = 10;
                    break a;
                case $ac4a9effa24fe7be$var$Ca:
                    g = 9;
                    break a;
                case $ac4a9effa24fe7be$var$Da:
                    g = 11;
                    break a;
                case $ac4a9effa24fe7be$var$Ga:
                    g = 14;
                    break a;
                case $ac4a9effa24fe7be$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($ac4a9effa24fe7be$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $ac4a9effa24fe7be$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $ac4a9effa24fe7be$var$Tg(a, b, c, d) {
    a = $ac4a9effa24fe7be$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $ac4a9effa24fe7be$var$pj(a, b, c, d) {
    a = $ac4a9effa24fe7be$var$Bg(22, a, d, b);
    a.elementType = $ac4a9effa24fe7be$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $ac4a9effa24fe7be$var$Qg(a, b, c) {
    a = $ac4a9effa24fe7be$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $ac4a9effa24fe7be$var$Sg(a, b, c) {
    b = $ac4a9effa24fe7be$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $ac4a9effa24fe7be$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $ac4a9effa24fe7be$var$zc(0);
    this.expirationTimes = $ac4a9effa24fe7be$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $ac4a9effa24fe7be$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $ac4a9effa24fe7be$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $ac4a9effa24fe7be$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $ac4a9effa24fe7be$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $ac4a9effa24fe7be$var$kh(f);
    return a;
}
function $ac4a9effa24fe7be$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $ac4a9effa24fe7be$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $ac4a9effa24fe7be$var$dl(a) {
    if (!a) return $ac4a9effa24fe7be$var$Vf;
    a = a._reactInternals;
    a: {
        if ($ac4a9effa24fe7be$var$Vb(a) !== a || 1 !== a.tag) throw Error($ac4a9effa24fe7be$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($ac4a9effa24fe7be$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($ac4a9effa24fe7be$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($ac4a9effa24fe7be$var$Zf(c)) return $ac4a9effa24fe7be$var$bg(a, c, b);
    }
    return b;
}
function $ac4a9effa24fe7be$var$el(a, b, c, d, e, f, g, h, k) {
    a = $ac4a9effa24fe7be$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $ac4a9effa24fe7be$var$dl(null);
    c = a.current;
    d = $ac4a9effa24fe7be$var$R();
    e = $ac4a9effa24fe7be$var$yi(c);
    f = $ac4a9effa24fe7be$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $ac4a9effa24fe7be$var$nh(c, f, e);
    a.current.lanes = e;
    $ac4a9effa24fe7be$var$Ac(a, e, d);
    $ac4a9effa24fe7be$var$Dk(a, d);
    return a;
}
function $ac4a9effa24fe7be$var$fl(a, b, c, d) {
    var e = b.current, f = $ac4a9effa24fe7be$var$R(), g = $ac4a9effa24fe7be$var$yi(e);
    c = $ac4a9effa24fe7be$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $ac4a9effa24fe7be$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $ac4a9effa24fe7be$var$nh(e, b, g);
    null !== a && ($ac4a9effa24fe7be$var$gi(a, e, g, f), $ac4a9effa24fe7be$var$oh(a, e, g));
    return g;
}
function $ac4a9effa24fe7be$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $ac4a9effa24fe7be$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $ac4a9effa24fe7be$var$il(a, b) {
    $ac4a9effa24fe7be$var$hl(a, b);
    (a = a.alternate) && $ac4a9effa24fe7be$var$hl(a, b);
}
function $ac4a9effa24fe7be$var$jl() {
    return null;
}
var $ac4a9effa24fe7be$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $ac4a9effa24fe7be$var$ll(a) {
    this._internalRoot = a;
}
$ac4a9effa24fe7be$var$ml.prototype.render = $ac4a9effa24fe7be$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($ac4a9effa24fe7be$var$p(409));
    $ac4a9effa24fe7be$var$fl(a, b, null, null);
};
$ac4a9effa24fe7be$var$ml.prototype.unmount = $ac4a9effa24fe7be$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $ac4a9effa24fe7be$var$Rk(function() {
            $ac4a9effa24fe7be$var$fl(null, a, null, null);
        });
        b[$ac4a9effa24fe7be$var$uf] = null;
    }
};
function $ac4a9effa24fe7be$var$ml(a) {
    this._internalRoot = a;
}
$ac4a9effa24fe7be$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $ac4a9effa24fe7be$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $ac4a9effa24fe7be$var$Qc.length && 0 !== b && b < $ac4a9effa24fe7be$var$Qc[c].priority; c++);
        $ac4a9effa24fe7be$var$Qc.splice(c, 0, a);
        0 === c && $ac4a9effa24fe7be$var$Vc(a);
    }
};
function $ac4a9effa24fe7be$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $ac4a9effa24fe7be$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $ac4a9effa24fe7be$var$pl() {}
function $ac4a9effa24fe7be$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $ac4a9effa24fe7be$var$gl(g);
                f.call(a);
            };
        }
        var g = $ac4a9effa24fe7be$var$el(b, d, a, 0, null, !1, !1, "", $ac4a9effa24fe7be$var$pl);
        a._reactRootContainer = g;
        a[$ac4a9effa24fe7be$var$uf] = g.current;
        $ac4a9effa24fe7be$var$sf(8 === a.nodeType ? a.parentNode : a);
        $ac4a9effa24fe7be$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $ac4a9effa24fe7be$var$gl(k);
            h.call(a);
        };
    }
    var k = $ac4a9effa24fe7be$var$bl(a, 0, !1, null, null, !1, !1, "", $ac4a9effa24fe7be$var$pl);
    a._reactRootContainer = k;
    a[$ac4a9effa24fe7be$var$uf] = k.current;
    $ac4a9effa24fe7be$var$sf(8 === a.nodeType ? a.parentNode : a);
    $ac4a9effa24fe7be$var$Rk(function() {
        $ac4a9effa24fe7be$var$fl(b, k, c, d);
    });
    return k;
}
function $ac4a9effa24fe7be$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $ac4a9effa24fe7be$var$gl(g);
                h.call(a);
            };
        }
        $ac4a9effa24fe7be$var$fl(b, g, a, e);
    } else g = $ac4a9effa24fe7be$var$ql(c, b, a, e, d);
    return $ac4a9effa24fe7be$var$gl(g);
}
$ac4a9effa24fe7be$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $ac4a9effa24fe7be$var$tc(b.pendingLanes);
                0 !== c && ($ac4a9effa24fe7be$var$Cc(b, c | 1), $ac4a9effa24fe7be$var$Dk(b, $ac4a9effa24fe7be$var$B()), 0 === ($ac4a9effa24fe7be$var$K & 6) && ($ac4a9effa24fe7be$var$Gj = $ac4a9effa24fe7be$var$B() + 500, $ac4a9effa24fe7be$var$jg()));
            }
            break;
        case 13:
            $ac4a9effa24fe7be$var$Rk(function() {
                var b = $ac4a9effa24fe7be$var$ih(a, 1);
                if (null !== b) {
                    var c = $ac4a9effa24fe7be$var$R();
                    $ac4a9effa24fe7be$var$gi(b, a, 1, c);
                }
            }), $ac4a9effa24fe7be$var$il(a, 1);
    }
};
$ac4a9effa24fe7be$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $ac4a9effa24fe7be$var$ih(a, 134217728);
        if (null !== b) {
            var c = $ac4a9effa24fe7be$var$R();
            $ac4a9effa24fe7be$var$gi(b, a, 134217728, c);
        }
        $ac4a9effa24fe7be$var$il(a, 134217728);
    }
};
$ac4a9effa24fe7be$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $ac4a9effa24fe7be$var$yi(a), c = $ac4a9effa24fe7be$var$ih(a, b);
        if (null !== c) {
            var d = $ac4a9effa24fe7be$var$R();
            $ac4a9effa24fe7be$var$gi(c, a, b, d);
        }
        $ac4a9effa24fe7be$var$il(a, b);
    }
};
$ac4a9effa24fe7be$var$Hc = function() {
    return $ac4a9effa24fe7be$var$C;
};
$ac4a9effa24fe7be$var$Ic = function(a, b) {
    var c = $ac4a9effa24fe7be$var$C;
    try {
        return $ac4a9effa24fe7be$var$C = a, b();
    } finally{
        $ac4a9effa24fe7be$var$C = c;
    }
};
$ac4a9effa24fe7be$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $ac4a9effa24fe7be$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $ac4a9effa24fe7be$var$Db(d);
                        if (!e) throw Error($ac4a9effa24fe7be$var$p(90));
                        $ac4a9effa24fe7be$var$Wa(d);
                        $ac4a9effa24fe7be$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $ac4a9effa24fe7be$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $ac4a9effa24fe7be$var$fb(a, !!c.multiple, b, !1);
    }
};
$ac4a9effa24fe7be$var$Gb = $ac4a9effa24fe7be$var$Qk;
$ac4a9effa24fe7be$var$Hb = $ac4a9effa24fe7be$var$Rk;
var $ac4a9effa24fe7be$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $ac4a9effa24fe7be$var$Cb,
        $ac4a9effa24fe7be$var$ue,
        $ac4a9effa24fe7be$var$Db,
        $ac4a9effa24fe7be$var$Eb,
        $ac4a9effa24fe7be$var$Fb,
        $ac4a9effa24fe7be$var$Qk
    ]
}, $ac4a9effa24fe7be$var$tl = {
    findFiberByHostInstance: $ac4a9effa24fe7be$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $ac4a9effa24fe7be$var$ul = {
    bundleType: $ac4a9effa24fe7be$var$tl.bundleType,
    version: $ac4a9effa24fe7be$var$tl.version,
    rendererPackageName: $ac4a9effa24fe7be$var$tl.rendererPackageName,
    rendererConfig: $ac4a9effa24fe7be$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $ac4a9effa24fe7be$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $ac4a9effa24fe7be$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $ac4a9effa24fe7be$var$tl.findFiberByHostInstance || $ac4a9effa24fe7be$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $ac4a9effa24fe7be$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$ac4a9effa24fe7be$var$vl.isDisabled && $ac4a9effa24fe7be$var$vl.supportsFiber) try {
        $ac4a9effa24fe7be$var$kc = $ac4a9effa24fe7be$var$vl.inject($ac4a9effa24fe7be$var$ul), $ac4a9effa24fe7be$var$lc = $ac4a9effa24fe7be$var$vl;
    } catch (a) {}
}
$ac4a9effa24fe7be$export$ae55be85d98224ed = $ac4a9effa24fe7be$var$sl;
$ac4a9effa24fe7be$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$ac4a9effa24fe7be$var$nl(b)) throw Error($ac4a9effa24fe7be$var$p(200));
    return $ac4a9effa24fe7be$var$cl(a, b, null, c);
};
$ac4a9effa24fe7be$export$882461b6382ed46c = function(a, b) {
    if (!$ac4a9effa24fe7be$var$nl(a)) throw Error($ac4a9effa24fe7be$var$p(299));
    var c = !1, d = "", e = $ac4a9effa24fe7be$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $ac4a9effa24fe7be$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$ac4a9effa24fe7be$var$uf] = b.current;
    $ac4a9effa24fe7be$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $ac4a9effa24fe7be$var$ll(b);
};
$ac4a9effa24fe7be$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($ac4a9effa24fe7be$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($ac4a9effa24fe7be$var$p(268, a));
    }
    a = $ac4a9effa24fe7be$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$ac4a9effa24fe7be$export$cd75ccfd720a3cd4 = function(a) {
    return $ac4a9effa24fe7be$var$Rk(a);
};
$ac4a9effa24fe7be$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$ac4a9effa24fe7be$var$ol(b)) throw Error($ac4a9effa24fe7be$var$p(200));
    return $ac4a9effa24fe7be$var$rl(null, a, b, !0, c);
};
$ac4a9effa24fe7be$export$757ceba2d55c277e = function(a, b, c) {
    if (!$ac4a9effa24fe7be$var$nl(a)) throw Error($ac4a9effa24fe7be$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $ac4a9effa24fe7be$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $ac4a9effa24fe7be$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$ac4a9effa24fe7be$var$uf] = b.current;
    $ac4a9effa24fe7be$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $ac4a9effa24fe7be$var$ml(b);
};
$ac4a9effa24fe7be$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$ac4a9effa24fe7be$var$ol(b)) throw Error($ac4a9effa24fe7be$var$p(200));
    return $ac4a9effa24fe7be$var$rl(null, a, b, !1, c);
};
$ac4a9effa24fe7be$export$502457920280e6be = function(a) {
    if (!$ac4a9effa24fe7be$var$ol(a)) throw Error($ac4a9effa24fe7be$var$p(40));
    return a._reactRootContainer ? ($ac4a9effa24fe7be$var$Rk(function() {
        $ac4a9effa24fe7be$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$ac4a9effa24fe7be$var$uf] = null;
        });
    }), !0) : !1;
};
$ac4a9effa24fe7be$export$c78a37762a8d58e1 = $ac4a9effa24fe7be$var$Qk;
$ac4a9effa24fe7be$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$ac4a9effa24fe7be$var$ol(c)) throw Error($ac4a9effa24fe7be$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($ac4a9effa24fe7be$var$p(38));
    return $ac4a9effa24fe7be$var$rl(a, b, c, !1, d);
};
$ac4a9effa24fe7be$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("Qw0kg", function(module, exports) {
'use strict';

module.exports = (parcelRequire("29Llp"));

});
parcelRegister("29Llp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $192125a6b5623347$export$c4744153514ff05d; }, function (v) { return $192125a6b5623347$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $192125a6b5623347$export$3e506c1ccc9cc1a7; }, function (v) { return $192125a6b5623347$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $192125a6b5623347$export$e26fe2ed2fa76875; }, function (v) { return $192125a6b5623347$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $192125a6b5623347$export$502329bbf4b505b1; }, function (v) { return $192125a6b5623347$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $192125a6b5623347$export$6e3807111c4874c4; }, function (v) { return $192125a6b5623347$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $192125a6b5623347$export$c27134553091fb3a; }, function (v) { return $192125a6b5623347$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $192125a6b5623347$export$33ee1acdc04fd2a2; }, function (v) { return $192125a6b5623347$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $192125a6b5623347$export$b00a404bbd5edef2; }, function (v) { return $192125a6b5623347$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $192125a6b5623347$export$8352ce38b91d0c62; }, function (v) { return $192125a6b5623347$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $192125a6b5623347$export$d66a1c1c77bd778b; }, function (v) { return $192125a6b5623347$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $192125a6b5623347$export$d3dfb8e4810cb555; }, function (v) { return $192125a6b5623347$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $192125a6b5623347$export$839f9183b0465a69; }, function (v) { return $192125a6b5623347$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $192125a6b5623347$export$72fdf0e06517287b; }, function (v) { return $192125a6b5623347$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $192125a6b5623347$export$4b844e58a3e414b4; }, function (v) { return $192125a6b5623347$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $192125a6b5623347$export$816d2913ae6b83b1; }, function (v) { return $192125a6b5623347$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $192125a6b5623347$export$61bcfe829111a1d0; }, function (v) { return $192125a6b5623347$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $192125a6b5623347$export$7ee8c9beb337bc3f; }, function (v) { return $192125a6b5623347$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $192125a6b5623347$export$b5836b71941fa3ed; }, function (v) { return $192125a6b5623347$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $192125a6b5623347$export$cf845f2c119da08a; }, function (v) { return $192125a6b5623347$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $192125a6b5623347$export$c4744153514ff05d;
var $192125a6b5623347$export$3e506c1ccc9cc1a7;
var $192125a6b5623347$export$e26fe2ed2fa76875;
var $192125a6b5623347$export$502329bbf4b505b1;
var $192125a6b5623347$export$6e3807111c4874c4;
var $192125a6b5623347$export$c27134553091fb3a;
var $192125a6b5623347$export$33ee1acdc04fd2a2;
var $192125a6b5623347$export$b00a404bbd5edef2;
var $192125a6b5623347$export$8352ce38b91d0c62;
var $192125a6b5623347$export$d66a1c1c77bd778b;
var $192125a6b5623347$export$d3dfb8e4810cb555;
var $192125a6b5623347$export$839f9183b0465a69;
var $192125a6b5623347$export$72fdf0e06517287b;
var $192125a6b5623347$export$4b844e58a3e414b4;
var $192125a6b5623347$export$816d2913ae6b83b1;
var $192125a6b5623347$export$61bcfe829111a1d0;
var $192125a6b5623347$export$7ee8c9beb337bc3f;
var $192125a6b5623347$export$b5836b71941fa3ed;
var $192125a6b5623347$export$cf845f2c119da08a;
'use strict';
function $192125a6b5623347$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $192125a6b5623347$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $192125a6b5623347$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $192125a6b5623347$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $192125a6b5623347$var$g(C, c)) n < e && 0 > $192125a6b5623347$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $192125a6b5623347$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $192125a6b5623347$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $192125a6b5623347$var$l = performance;
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$l.now();
    };
} else {
    var $192125a6b5623347$var$p = Date, $192125a6b5623347$var$q = $192125a6b5623347$var$p.now();
    $192125a6b5623347$export$c4744153514ff05d = function() {
        return $192125a6b5623347$var$p.now() - $192125a6b5623347$var$q;
    };
}
var $192125a6b5623347$var$r = [], $192125a6b5623347$var$t = [], $192125a6b5623347$var$u = 1, $192125a6b5623347$var$v = null, $192125a6b5623347$var$y = 3, $192125a6b5623347$var$z = !1, $192125a6b5623347$var$A = !1, $192125a6b5623347$var$B = !1, $192125a6b5623347$var$D = "function" === typeof setTimeout ? setTimeout : null, $192125a6b5623347$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $192125a6b5623347$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $192125a6b5623347$var$G(a) {
    for(var b = $192125a6b5623347$var$h($192125a6b5623347$var$t); null !== b;){
        if (null === b.callback) $192125a6b5623347$var$k($192125a6b5623347$var$t);
        else if (b.startTime <= a) $192125a6b5623347$var$k($192125a6b5623347$var$t), b.sortIndex = b.expirationTime, $192125a6b5623347$var$f($192125a6b5623347$var$r, b);
        else break;
        b = $192125a6b5623347$var$h($192125a6b5623347$var$t);
    }
}
function $192125a6b5623347$var$H(a) {
    $192125a6b5623347$var$B = !1;
    $192125a6b5623347$var$G(a);
    if (!$192125a6b5623347$var$A) {
        if (null !== $192125a6b5623347$var$h($192125a6b5623347$var$r)) $192125a6b5623347$var$A = !0, $192125a6b5623347$var$I($192125a6b5623347$var$J);
        else {
            var b = $192125a6b5623347$var$h($192125a6b5623347$var$t);
            null !== b && $192125a6b5623347$var$K($192125a6b5623347$var$H, b.startTime - a);
        }
    }
}
function $192125a6b5623347$var$J(a, b) {
    $192125a6b5623347$var$A = !1;
    $192125a6b5623347$var$B && ($192125a6b5623347$var$B = !1, $192125a6b5623347$var$E($192125a6b5623347$var$L), $192125a6b5623347$var$L = -1);
    $192125a6b5623347$var$z = !0;
    var c = $192125a6b5623347$var$y;
    try {
        $192125a6b5623347$var$G(b);
        for($192125a6b5623347$var$v = $192125a6b5623347$var$h($192125a6b5623347$var$r); null !== $192125a6b5623347$var$v && (!($192125a6b5623347$var$v.expirationTime > b) || a && !$192125a6b5623347$var$M());){
            var d = $192125a6b5623347$var$v.callback;
            if ("function" === typeof d) {
                $192125a6b5623347$var$v.callback = null;
                $192125a6b5623347$var$y = $192125a6b5623347$var$v.priorityLevel;
                var e = d($192125a6b5623347$var$v.expirationTime <= b);
                b = $192125a6b5623347$export$c4744153514ff05d();
                "function" === typeof e ? $192125a6b5623347$var$v.callback = e : $192125a6b5623347$var$v === $192125a6b5623347$var$h($192125a6b5623347$var$r) && $192125a6b5623347$var$k($192125a6b5623347$var$r);
                $192125a6b5623347$var$G(b);
            } else $192125a6b5623347$var$k($192125a6b5623347$var$r);
            $192125a6b5623347$var$v = $192125a6b5623347$var$h($192125a6b5623347$var$r);
        }
        if (null !== $192125a6b5623347$var$v) var w = !0;
        else {
            var m = $192125a6b5623347$var$h($192125a6b5623347$var$t);
            null !== m && $192125a6b5623347$var$K($192125a6b5623347$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $192125a6b5623347$var$v = null, $192125a6b5623347$var$y = c, $192125a6b5623347$var$z = !1;
    }
}
var $192125a6b5623347$var$N = !1, $192125a6b5623347$var$O = null, $192125a6b5623347$var$L = -1, $192125a6b5623347$var$P = 5, $192125a6b5623347$var$Q = -1;
function $192125a6b5623347$var$M() {
    return $192125a6b5623347$export$c4744153514ff05d() - $192125a6b5623347$var$Q < $192125a6b5623347$var$P ? !1 : !0;
}
function $192125a6b5623347$var$R() {
    if (null !== $192125a6b5623347$var$O) {
        var a = $192125a6b5623347$export$c4744153514ff05d();
        $192125a6b5623347$var$Q = a;
        var b = !0;
        try {
            b = $192125a6b5623347$var$O(!0, a);
        } finally{
            b ? $192125a6b5623347$var$S() : ($192125a6b5623347$var$N = !1, $192125a6b5623347$var$O = null);
        }
    } else $192125a6b5623347$var$N = !1;
}
var $192125a6b5623347$var$S;
if ("function" === typeof $192125a6b5623347$var$F) $192125a6b5623347$var$S = function() {
    $192125a6b5623347$var$F($192125a6b5623347$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $192125a6b5623347$var$T = new MessageChannel, $192125a6b5623347$var$U = $192125a6b5623347$var$T.port2;
    $192125a6b5623347$var$T.port1.onmessage = $192125a6b5623347$var$R;
    $192125a6b5623347$var$S = function() {
        $192125a6b5623347$var$U.postMessage(null);
    };
} else $192125a6b5623347$var$S = function() {
    $192125a6b5623347$var$D($192125a6b5623347$var$R, 0);
};
function $192125a6b5623347$var$I(a) {
    $192125a6b5623347$var$O = a;
    $192125a6b5623347$var$N || ($192125a6b5623347$var$N = !0, $192125a6b5623347$var$S());
}
function $192125a6b5623347$var$K(a, b) {
    $192125a6b5623347$var$L = $192125a6b5623347$var$D(function() {
        a($192125a6b5623347$export$c4744153514ff05d());
    }, b);
}
$192125a6b5623347$export$3e506c1ccc9cc1a7 = 5;
$192125a6b5623347$export$e26fe2ed2fa76875 = 1;
$192125a6b5623347$export$502329bbf4b505b1 = 4;
$192125a6b5623347$export$6e3807111c4874c4 = 3;
$192125a6b5623347$export$c27134553091fb3a = null;
$192125a6b5623347$export$33ee1acdc04fd2a2 = 2;
$192125a6b5623347$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$192125a6b5623347$export$8352ce38b91d0c62 = function() {
    $192125a6b5623347$var$A || $192125a6b5623347$var$z || ($192125a6b5623347$var$A = !0, $192125a6b5623347$var$I($192125a6b5623347$var$J));
};
$192125a6b5623347$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $192125a6b5623347$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$192125a6b5623347$export$d3dfb8e4810cb555 = function() {
    return $192125a6b5623347$var$y;
};
$192125a6b5623347$export$839f9183b0465a69 = function() {
    return $192125a6b5623347$var$h($192125a6b5623347$var$r);
};
$192125a6b5623347$export$72fdf0e06517287b = function(a) {
    switch($192125a6b5623347$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $192125a6b5623347$var$y;
    }
    var c = $192125a6b5623347$var$y;
    $192125a6b5623347$var$y = b;
    try {
        return a();
    } finally{
        $192125a6b5623347$var$y = c;
    }
};
$192125a6b5623347$export$4b844e58a3e414b4 = function() {};
$192125a6b5623347$export$816d2913ae6b83b1 = function() {};
$192125a6b5623347$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $192125a6b5623347$var$y;
    $192125a6b5623347$var$y = a;
    try {
        return b();
    } finally{
        $192125a6b5623347$var$y = c;
    }
};
$192125a6b5623347$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $192125a6b5623347$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $192125a6b5623347$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $192125a6b5623347$var$f($192125a6b5623347$var$t, a), null === $192125a6b5623347$var$h($192125a6b5623347$var$r) && a === $192125a6b5623347$var$h($192125a6b5623347$var$t) && ($192125a6b5623347$var$B ? ($192125a6b5623347$var$E($192125a6b5623347$var$L), $192125a6b5623347$var$L = -1) : $192125a6b5623347$var$B = !0, $192125a6b5623347$var$K($192125a6b5623347$var$H, c - d))) : (a.sortIndex = e, $192125a6b5623347$var$f($192125a6b5623347$var$r, a), $192125a6b5623347$var$A || $192125a6b5623347$var$z || ($192125a6b5623347$var$A = !0, $192125a6b5623347$var$I($192125a6b5623347$var$J)));
    return a;
};
$192125a6b5623347$export$b5836b71941fa3ed = $192125a6b5623347$var$M;
$192125a6b5623347$export$cf845f2c119da08a = function(a) {
    var b = $192125a6b5623347$var$y;
    return function() {
        var c = $192125a6b5623347$var$y;
        $192125a6b5623347$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $192125a6b5623347$var$y = c;
        }
    };
};

});



parcelRegister("525q9", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

var $gIfym = parcelRequire("gIfym");
function $3aa1581c8b203a36$var$i() {
    return $3aa1581c8b203a36$var$i = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var s = arguments[i];
            for(var n in s)Object.prototype.hasOwnProperty.call(s, n) && (t[n] = s[n]);
        }
        return t;
    }, $3aa1581c8b203a36$var$i.apply(this, arguments);
}
var $3aa1581c8b203a36$var$s = $gIfym.createElement("svg", {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: {
        position: "absolute",
        top: 0
    }
}, $gIfym.createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
})), $3aa1581c8b203a36$var$n = $gIfym.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: {
        position: "absolute",
        top: 0
    }
}, $gIfym.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
}));
function $3aa1581c8b203a36$var$o(t) {
    if (7 === t.length) return t;
    for(var i = "#", s = 1; s < 4; s += 1)i += t[s] + t[s];
    return i;
}
function $3aa1581c8b203a36$var$h(t, i, s, n, h) {
    return function(t, i, s, n, o) {
        var h = (t - s) / (i - s);
        if (0 === h) return n;
        if (1 === h) return o;
        for(var e = "#", a = 1; a < 6; a += 2){
            var r = parseInt(n.substr(a, 2), 16), l = parseInt(o.substr(a, 2), 16), u = Math.round((1 - h) * r + h * l).toString(16);
            1 === u.length && (u = "0" + u), e += u;
        }
        return e;
    }(t, i, s, $3aa1581c8b203a36$var$o(n), $3aa1581c8b203a36$var$o(h));
}
var $3aa1581c8b203a36$var$e = function(s) {
    function n(t) {
        s.call(this, t);
        var i = t.height, n = t.width, o = t.checked;
        this.t = t.handleDiameter || i - 2, this.i = Math.max(n - i, n - (i + this.t) / 2), this.o = Math.max(0, (i - this.t) / 2), this.state = {
            h: o ? this.i : this.o
        }, this.l = 0, this.u = 0, this.p = this.p.bind(this), this.v = this.v.bind(this), this.k = this.k.bind(this), this.M = this.M.bind(this), this.m = this.m.bind(this), this.T = this.T.bind(this), this.$ = this.$.bind(this), this.C = this.C.bind(this), this.O = this.O.bind(this), this.D = this.D.bind(this), this.S = this.S.bind(this), this.W = this.W.bind(this);
    }
    return s && (n.__proto__ = s), (n.prototype = Object.create(s && s.prototype)).constructor = n, n.prototype.componentDidMount = function() {
        this.I = !0;
    }, n.prototype.componentDidUpdate = function(t) {
        t.checked !== this.props.checked && this.setState({
            h: this.props.checked ? this.i : this.o
        });
    }, n.prototype.componentWillUnmount = function() {
        this.I = !1;
    }, n.prototype.H = function(t) {
        this.j.focus(), this.setState({
            R: t,
            B: !0,
            L: Date.now()
        });
    }, n.prototype.N = function(t) {
        var i = this.state, s = i.R, n = i.h, o = (this.props.checked ? this.i : this.o) + t - s;
        i.U || t === s || this.setState({
            U: !0
        });
        var h = Math.min(this.i, Math.max(this.o, o));
        h !== n && this.setState({
            h: h
        });
    }, n.prototype.A = function(t) {
        var i = this.state, s = i.h, n = i.U, o = i.L, h = this.props.checked, e = (this.i + this.o) / 2;
        this.setState({
            h: this.props.checked ? this.i : this.o
        });
        var a = Date.now() - o;
        (!n || a < 250 || h && s <= e || !h && s >= e) && this.X(t), this.I && this.setState({
            U: !1,
            B: !1
        }), this.l = Date.now();
    }, n.prototype.p = function(t) {
        t.preventDefault(), "number" == typeof t.button && 0 !== t.button || (this.H(t.clientX), window.addEventListener("mousemove", this.v), window.addEventListener("mouseup", this.k));
    }, n.prototype.v = function(t) {
        t.preventDefault(), this.N(t.clientX);
    }, n.prototype.k = function(t) {
        this.A(t), window.removeEventListener("mousemove", this.v), window.removeEventListener("mouseup", this.k);
    }, n.prototype.M = function(t) {
        this._ = null, this.H(t.touches[0].clientX);
    }, n.prototype.m = function(t) {
        this.N(t.touches[0].clientX);
    }, n.prototype.T = function(t) {
        t.preventDefault(), this.A(t);
    }, n.prototype.C = function(t) {
        Date.now() - this.l > 50 && (this.X(t), Date.now() - this.u > 50 && this.I && this.setState({
            B: !1
        }));
    }, n.prototype.O = function() {
        this.u = Date.now();
    }, n.prototype.D = function() {
        this.setState({
            B: !0
        });
    }, n.prototype.S = function() {
        this.setState({
            B: !1
        });
    }, n.prototype.W = function(t) {
        this.j = t;
    }, n.prototype.$ = function(t) {
        t.preventDefault(), this.j.focus(), this.X(t), this.I && this.setState({
            B: !1
        });
    }, n.prototype.X = function(t) {
        var i = this.props;
        (0, i.onChange)(!i.checked, t, i.id);
    }, n.prototype.render = function() {
        var s = this.props, n = s.checked, o = s.disabled, e = s.className, a = s.offColor, r = s.onColor, l = s.offHandleColor, u = s.onHandleColor, c = s.checkedIcon, d = s.uncheckedIcon, f = s.checkedHandleIcon, p = s.uncheckedHandleIcon, b = s.boxShadow, v = s.activeBoxShadow, g = s.height, y = s.width, w = s.borderRadius, k = function(t, i) {
            var s = {};
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && -1 === i.indexOf(n) && (s[n] = t[n]);
            return s;
        }(s, [
            "checked",
            "disabled",
            "className",
            "offColor",
            "onColor",
            "offHandleColor",
            "onHandleColor",
            "checkedIcon",
            "uncheckedIcon",
            "checkedHandleIcon",
            "uncheckedHandleIcon",
            "boxShadow",
            "activeBoxShadow",
            "height",
            "width",
            "borderRadius",
            "handleDiameter"
        ]), M = this.state, m = M.h, T = M.U, x = M.B, $ = {
            position: "relative",
            display: "inline-block",
            textAlign: "left",
            opacity: o ? .5 : 1,
            direction: "ltr",
            borderRadius: g / 2,
            WebkitTransition: "opacity 0.25s",
            MozTransition: "opacity 0.25s",
            transition: "opacity 0.25s",
            touchAction: "none",
            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
            userSelect: "none"
        }, C = {
            height: g,
            width: y,
            margin: Math.max(0, (this.t - g) / 2),
            position: "relative",
            background: $3aa1581c8b203a36$var$h(m, this.i, this.o, a, r),
            borderRadius: "number" == typeof w ? w : g / 2,
            cursor: o ? "default" : "pointer",
            WebkitTransition: T ? null : "background 0.25s",
            MozTransition: T ? null : "background 0.25s",
            transition: T ? null : "background 0.25s"
        }, O = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "relative",
            opacity: (m - this.o) / (this.i - this.o),
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, D = {
            height: g,
            width: Math.min(1.5 * g, y - (this.t + g) / 2 + 1),
            position: "absolute",
            opacity: 1 - (m - this.o) / (this.i - this.o),
            right: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, S = {
            height: this.t,
            width: this.t,
            background: $3aa1581c8b203a36$var$h(m, this.i, this.o, l, u),
            display: "inline-block",
            cursor: o ? "default" : "pointer",
            borderRadius: "number" == typeof w ? w - 1 : "50%",
            position: "absolute",
            transform: "translateX(" + m + "px)",
            top: Math.max(0, (g - this.t) / 2),
            outline: 0,
            boxShadow: x ? v : b,
            border: 0,
            WebkitTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            MozTransition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
            transition: T ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
        }, W = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * (1 - (m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        }, z = {
            height: this.t,
            width: this.t,
            opacity: Math.max(2 * ((m - this.o) / (this.i - this.o) - .5), 0),
            position: "absolute",
            left: 0,
            top: 0,
            pointerEvents: "none",
            WebkitTransition: T ? null : "opacity 0.25s",
            MozTransition: T ? null : "opacity 0.25s",
            transition: T ? null : "opacity 0.25s"
        };
        return $gIfym.createElement("div", {
            className: e,
            style: $
        }, $gIfym.createElement("div", {
            className: "react-switch-bg",
            style: C,
            onClick: o ? null : this.$,
            onMouseDown: function(t) {
                return t.preventDefault();
            }
        }, c && $gIfym.createElement("div", {
            style: O
        }, c), d && $gIfym.createElement("div", {
            style: D
        }, d)), $gIfym.createElement("div", {
            className: "react-switch-handle",
            style: S,
            onClick: function(t) {
                return t.preventDefault();
            },
            onMouseDown: o ? null : this.p,
            onTouchStart: o ? null : this.M,
            onTouchMove: o ? null : this.m,
            onTouchEnd: o ? null : this.T,
            onTouchCancel: o ? null : this.S
        }, p && $gIfym.createElement("div", {
            style: W
        }, p), f && $gIfym.createElement("div", {
            style: z
        }, f)), $gIfym.createElement("input", $3aa1581c8b203a36$var$i({}, {
            type: "checkbox",
            role: "switch",
            "aria-checked": n,
            checked: n,
            disabled: o,
            style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: 1,
                margin: -1,
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: 1
            }
        }, k, {
            ref: this.W,
            onFocus: this.D,
            onBlur: this.S,
            onKeyUp: this.O,
            onChange: this.C
        })));
    }, n;
}($gIfym.Component);
$3aa1581c8b203a36$var$e.defaultProps = {
    disabled: !1,
    offColor: "#888",
    onColor: "#080",
    offHandleColor: "#fff",
    onHandleColor: "#fff",
    uncheckedIcon: $3aa1581c8b203a36$var$s,
    checkedIcon: $3aa1581c8b203a36$var$n,
    boxShadow: null,
    activeBoxShadow: "0 0 2px 3px #3bf",
    height: 28,
    width: 56
}, module.exports.default = $3aa1581c8b203a36$var$e;

});

var $14fc2f3a09df08ae$exports = {};
'use strict';

$14fc2f3a09df08ae$exports = (parcelRequire("2Qwp0"));



var $gIfym = parcelRequire("gIfym");
var $49079038e9e61aa0$export$882461b6382ed46c;
var $49079038e9e61aa0$export$757ceba2d55c277e;
'use strict';
var $c4a08725a78d51bf$exports = {};
'use strict';
function $c4a08725a78d51bf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c4a08725a78d51bf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c4a08725a78d51bf$var$checkDCE();

$c4a08725a78d51bf$exports = (parcelRequire("eN6q3"));


var $49079038e9e61aa0$var$i;
$49079038e9e61aa0$export$882461b6382ed46c = $c4a08725a78d51bf$exports.createRoot;
$49079038e9e61aa0$export$757ceba2d55c277e = $c4a08725a78d51bf$exports.hydrateRoot;





var $gIfym = parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");
// Базовые типы
const $9f05ce5269191f7e$export$2eca89e9ac669625 = (localId)=>{
    const now = new Date();
    return {
        id: localId,
        localId: localId,
        serverId: null,
        isSynced: false,
        syncVersion: 0,
        createdAt: now,
        updatedAt: now,
        deletedAt: null
    };
};


// Простая система сигналов для событий
class $9b26b9646341d616$export$95317eed80e19359 {
    static{
        this.debug = false;
    }
}
class $9b26b9646341d616$export$6039fc6176d96e35 {
    register(signal, handler) {
        this.handlers.push(signal.subscribe(handler));
    }
    registerDisposer(disposer) {
        this.handlers.push(disposer);
    }
    constructor(){
        this.handlers = [];
        /** Dispose all signal handlers.
	 *
	 */ this.dispose = ()=>{
            this.handlers.forEach((handler)=>handler ? handler() : null);
        };
    }
}
class $9b26b9646341d616$export$8210dfe1863c478 {
    constructor(name){
        this.listeners = [];
        this.lastValue = null;
        this.name = name;
    }
    subscribe(listener) {
        this.listeners.push(listener);
        // Немедленно вызываем с последним значением, если есть
        // if (this.lastValue !== null) {
        // 	listener(this.lastValue);
        // }
        // Функция отписки
        return ()=>{
            const index = this.listeners.indexOf(listener);
            if (index > -1) this.listeners.splice(index, 1);
        };
    }
    emit(value) {
        if ($9b26b9646341d616$export$95317eed80e19359.debug) console.log(`${Date.now()} Signal: ${this.name}`, value);
        this.lastValue = value;
        this.listeners.forEach((listener)=>listener(value));
    }
    getLastValue() {
        return this.lastValue;
    }
}


window.Signals = (0, $9b26b9646341d616$export$95317eed80e19359);
const $883133d1f570db27$export$bfc40ca370b68e03 = {
    boardUpdated: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/board/updated"),
    taskMoved: new (0, $9b26b9646341d616$export$8210dfe1863c478)("task/moved"),
    columnMoved: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/moved"),
    /** Сигнал принудительного раскрытия колонки */ expandColumn: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/expand"),
    appInvalidated: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/app/invalidated"),
    // Новые сигналы для редактирования задач
    taskEditEnded: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/edit/ended"),
    taskUpdated: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/updated"),
    taskDeleted: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/deleted"),
    taskEditStateChanged: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/edit/state/changed"),
    editorBackdropClicked: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/editor/backdrop/clicked"),
    viewModeChanged: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/viewmove/changed"),
    responsiveStateChanged: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/responsive/state/change"),
    // Добавление нового сигнала для сетевого статуса
    networkStatus: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/network_status_changed"),
    filtersToggled: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/filter/changed"),
    // Сигнал для активации добавления задачи в колонке
    activateTaskAdd: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/append"),
    cancelTaskAdd: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/append/cancel"),
    taskDragStarted: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/drag/started"),
    taskDragEnded: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/drag/ended"),
    // Сигнал для подсветки и скролла к задаче
    highlightAndScrollToTask: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/highlight_scroll"),
    columnDragOver: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/drag/over"),
    columnDragStarted: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/drag/started"),
    columnDragEnded: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/drag/ended"),
    columnDragLeave: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/drag/leave"),
    columnEditStart: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/edit/start"),
    columnEditFinish: new (0, $9b26b9646341d616$export$8210dfe1863c478)("/column/edit/finish")
};
window.signals = $883133d1f570db27$export$bfc40ca370b68e03;



class $19d6ae3d23827c9e$export$10417d07c8a86bc0 {
    constructor(getTaskById, updateTaskInStorage, deleteTaskInStorage){
        this.getTaskById = getTaskById;
        this.updateTaskInStorage = updateTaskInStorage;
        this.deleteTaskInStorage = deleteTaskInStorage;
        this._state = {
            taskId: null,
            isEditing: false,
            originalTask: null,
            hasChanges: false,
            isSaving: false
        };
        this.onEditStart = new (0, $9b26b9646341d616$export$8210dfe1863c478)("/edit/start");
        this.onEditEnd = new (0, $9b26b9646341d616$export$8210dfe1863c478)("/edit/end");
        this.onTaskUpdate = new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/update");
        this.onTaskDelete = new (0, $9b26b9646341d616$export$8210dfe1863c478)("/task/delete");
    }
    get state() {
        return {
            ...this._state
        };
    }
    async startEdit(taskId) {
        if (this._state.isEditing) await this.cancelEdit();
        const task = await this.getTaskById(taskId);
        if (!task) throw new Error(`Task ${taskId} not found`);
        this._state = {
            taskId: taskId,
            isEditing: true,
            originalTask: JSON.parse(JSON.stringify(task)),
            hasChanges: false,
            isSaving: false
        };
        this.onEditStart.emit(taskId);
    }
    async startInlineEdit(taskId, mode) {
        return this.startEdit(taskId); // Пока один режим
    }
    isChanged(updates) {
        if (!this._state.taskId || !this._state.originalTask) return true;
        for(const key in updates)if (Object.prototype.hasOwnProperty.call(updates, key)) {
            if (updates[key] !== this._state.originalTask[key]) return true;
        }
        return false;
    }
    async updateTask(updates) {
        if (!this._state.taskId || !this._state.originalTask) throw new Error('No task is being edited');
        this._state.isSaving = true;
        this._state.hasChanges = true;
        const updatedTask = {
            ...this._state.originalTask,
            ...updates,
            updatedAt: new Date(),
            isSynced: false
        };
        // Сохраняем в хранилище
        const savedTask = await this.updateTaskInStorage(this._state.taskId, {
            ...updates,
            updatedAt: new Date(),
            isSynced: false
        });
        // Обновляем состояние
        this._state.originalTask = savedTask;
        this._state.isSaving = false;
        this.onTaskUpdate.emit(savedTask);
    }
    cancelEdit() {
        if (!this._state.isEditing) return;
        this._state = {
            taskId: null,
            isEditing: false,
            originalTask: null,
            hasChanges: false,
            isSaving: false
        };
        this.onEditEnd.emit();
    }
    async deleteTask() {
        if (!this._state.taskId) throw new Error('No task is being edited');
        this._state.isSaving = true;
        try {
            // Мягкое удаление - устанавливаем deletedAt
            await this.updateTaskInStorage(this._state.taskId, {
                deletedAt: new Date(),
                updatedAt: new Date(),
                isSynced: false
            });
            this.onTaskDelete.emit(this._state.taskId);
            (0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated.emit();
            // Выходим из режима редактирования
            this.cancelEdit();
        } catch (error) {
            this._state.isSaving = false;
            throw error;
        }
    }
    getCurrentTask() {
        return this._state.originalTask;
    }
    getEditMode() {
        return 'inline'; // Пока только inline режим
    }
}


// Режимы отображения
var $33b90e3c48366ffe$export$65ea953c3c9014f8 = /*#__PURE__*/ function(ViewModeEnum) {
    ViewModeEnum["Columns"] = "columns";
    ViewModeEnum["List"] = "list";
    return ViewModeEnum;
}({});
const $33b90e3c48366ffe$export$fd4d112fcca8c71e = {
    'columns': {
        mode: "columns",
        name: "\u0414\u043E\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u0447",
        icon: "\uD83D\uDCBB",
        description: "\u041F\u043E\u043B\u043D\u043E\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C \u0441 \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u043A\u043E\u043B\u043E\u043D\u043A\u0430\u043C\u0438",
        breakpoint: 1024,
        features: {
            horizontalScroll: true,
            columnWidth: 'fixed',
            taskHeight: 'normal',
            dragAndDrop: 'full',
            gestures: [
                'drag'
            ]
        }
    },
    'list': {
        mode: "list",
        name: "\u0421\u043F\u0438\u0441\u043E\u043A",
        icon: "\uD83D\uDCCB",
        description: "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u0441\u0435\u0445 \u0437\u0430\u0434\u0430\u0447",
        breakpoint: 0,
        features: {
            horizontalScroll: false,
            columnWidth: 'full',
            taskHeight: 'expanded',
            dragAndDrop: 'disabled',
            gestures: [
                'tap',
                'long-press'
            ]
        }
    }
};


const $2862506a89f542be$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $2862506a89f542be$var$idbProxyableTypes;
let $2862506a89f542be$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $2862506a89f542be$var$getIdbProxyableTypes() {
    return $2862506a89f542be$var$idbProxyableTypes || ($2862506a89f542be$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $2862506a89f542be$var$getCursorAdvanceMethods() {
    return $2862506a89f542be$var$cursorAdvanceMethods || ($2862506a89f542be$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $2862506a89f542be$var$transactionDoneMap = new WeakMap();
const $2862506a89f542be$var$transformCache = new WeakMap();
const $2862506a89f542be$var$reverseTransformCache = new WeakMap();
function $2862506a89f542be$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($2862506a89f542be$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $2862506a89f542be$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $2862506a89f542be$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($2862506a89f542be$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $2862506a89f542be$var$transactionDoneMap.set(tx, done);
}
let $2862506a89f542be$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $2862506a89f542be$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $2862506a89f542be$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $2862506a89f542be$var$replaceTraps(callback) {
    $2862506a89f542be$var$idbProxyTraps = callback($2862506a89f542be$var$idbProxyTraps);
}
function $2862506a89f542be$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($2862506a89f542be$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($2862506a89f542be$export$debb760848ca95a(this), args);
        return $2862506a89f542be$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $2862506a89f542be$export$4997ffc0176396a6(func.apply($2862506a89f542be$export$debb760848ca95a(this), args));
    };
}
function $2862506a89f542be$var$transformCachableValue(value) {
    if (typeof value === 'function') return $2862506a89f542be$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $2862506a89f542be$var$cacheDonePromiseForTransaction(value);
    if ($2862506a89f542be$var$instanceOfAny(value, $2862506a89f542be$var$getIdbProxyableTypes())) return new Proxy(value, $2862506a89f542be$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $2862506a89f542be$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $2862506a89f542be$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($2862506a89f542be$var$transformCache.has(value)) return $2862506a89f542be$var$transformCache.get(value);
    const newValue = $2862506a89f542be$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $2862506a89f542be$var$transformCache.set(value, newValue);
        $2862506a89f542be$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $2862506a89f542be$export$debb760848ca95a = (value)=>$2862506a89f542be$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $2862506a89f542be$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $2862506a89f542be$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($2862506a89f542be$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $2862506a89f542be$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $2862506a89f542be$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $2862506a89f542be$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $2862506a89f542be$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $2862506a89f542be$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $2862506a89f542be$var$cachedMethods = new Map();
function $2862506a89f542be$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($2862506a89f542be$var$cachedMethods.get(prop)) return $2862506a89f542be$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $2862506a89f542be$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $2862506a89f542be$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $2862506a89f542be$var$cachedMethods.set(prop, method);
    return method;
}
$2862506a89f542be$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$2862506a89f542be$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$2862506a89f542be$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $2862506a89f542be$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $2862506a89f542be$var$methodMap = {};
const $2862506a89f542be$var$advanceResults = new WeakMap();
const $2862506a89f542be$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $2862506a89f542be$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$2862506a89f542be$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $2862506a89f542be$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $2862506a89f542be$var$methodMap[prop] = function(...args) {
            $2862506a89f542be$var$advanceResults.set(this, $2862506a89f542be$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $2862506a89f542be$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $2862506a89f542be$var$cursorIteratorTraps);
    $2862506a89f542be$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $2862506a89f542be$var$reverseTransformCache.set(proxiedCursor, $2862506a89f542be$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($2862506a89f542be$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $2862506a89f542be$var$advanceResults.delete(proxiedCursor);
    }
}
function $2862506a89f542be$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $2862506a89f542be$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $2862506a89f542be$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$2862506a89f542be$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($2862506a89f542be$var$isIteratorProp(target, prop)) return $2862506a89f542be$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $2862506a89f542be$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));


// Создание тестовой доски для инициализации
const $fec5f87c8f441fc1$export$416551eec0702b29 = {
    title: "New",
    description: "",
    createdAt: new Date(),
    updatedAt: new Date(),
    deletedAt: null,
    isSynced: false,
    syncVersion: 1,
    comments: [],
    attachments: [],
    meta: {},
    order: 0,
    id: "",
    localId: "",
    serverId: null,
    columnId: "",
    boardId: ""
};
function $fec5f87c8f441fc1$export$33506068753312cf() {
    const boardId = 'board_1';
    let counter = 0;
    const getId = ()=>{
        return 'local_' + Date.now() + ++counter;
    };
    const now = new Date;
    const createIdentity = (id)=>{
        if (!id) id = getId();
        return {
            id: id,
            localId: id,
            serverId: null,
            isSynced: false,
            syncVersion: 0,
            createdAt: now,
            updatedAt: now,
            deletedAt: null
        };
    };
    const tasks = [
        {
            ...$fec5f87c8f441fc1$export$416551eec0702b29,
            ...createIdentity(getId()),
            localId: getId(),
            serverId: null,
            title: "\u0421\u0438\u0442\u0430\u0441\u043A - \u0432\u0430\u0448 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0440\u0433\u0430\u043D\u0430\u0439\u0437\u0435\u0440 \u0438 \u0434\u043E\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u0447, \u0445\u0440\u0430\u043D\u0438\u0442\u0441\u044F \u0443 \u0432\u0430\u0441 \u0432 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435 \u0438\u043B\u0438 \u041F\u041A. \u0420\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043E\u0444\u0444\u043B\u0430\u0439\u043D \u0431\u0435\u0437 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u0421\u041C\u0421. \u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043F\u0435\u0440\u0432\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443 \u043F\u043E \u043A\u043D\u043E\u043F\u043A\u0435 \u0432\u043D\u0438\u0437\u0443 \u0441\u043F\u0438\u0441\u043A\u0430.",
            columnId: 'col_1'
        },
        {
            ...$fec5f87c8f441fc1$export$416551eec0702b29,
            ...createIdentity(getId()),
            localId: getId(),
            serverId: null,
            title: "\u0415\u0441\u0442\u044C \u0440\u0435\u0436\u0438\u043C\u044B \u0441\u043F\u0438\u0441\u043A\u0430 \u0438 \u0434\u043E\u0441\u043A\u0438 \u0437\u0430\u0434\u0430\u0447. \u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044C \u0440\u0435\u0436\u0438\u043C\u043E\u0432 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0441\u0432\u0435\u0440\u0445\u0443. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0440\u0435\u0436\u0438\u043C\u044B.",
            description: '',
            columnId: 'col_1',
            order: 1
        },
        {
            ...$fec5f87c8f441fc1$export$416551eec0702b29,
            ...createIdentity(getId()),
            localId: getId(),
            serverId: null,
            title: "\u0421\u0438\u0442\u0430\u0441\u043A \u0443\u043C\u0435\u0435\u0442 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 \u0441\u0435\u0440\u0432\u0435\u0440\u043E\u043C. \u0422\u043E\u0447\u043D\u0435\u0435 \u0441\u043A\u043E\u0440\u043E \u0431\u0443\u0434\u0435\u0442 \u0443\u043C\u0435\u0442\u044C.",
            description: "\u0422\u043E\u0433\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0430\u043C \u0432\u0441\u0435\u0445 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u0445.",
            columnId: 'col_2',
            order: 2
        },
        {
            ...$fec5f87c8f441fc1$export$416551eec0702b29,
            ...createIdentity(getId()),
            localId: getId(),
            serverId: null,
            title: '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u043F\u0438\u0441\u043A\u043E\u0432 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442\u0441\u044F \u043F\u043E \u043A\u043D\u043E\u043F\u043A\u0435 "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0434\u043E\u0441\u043A\u0443" \u0441\u0432\u0435\u0440\u0445\u0443 \u0434\u043E\u0441\u043A\u0438.',
            columnId: 'col_3',
            order: 2
        },
        {
            ...$fec5f87c8f441fc1$export$416551eec0702b29,
            ...createIdentity(getId()),
            serverId: null,
            title: "\u041C\u043E\u0436\u043D\u043E \u0430\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438, \u043A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u043D\u0443\u0436\u043D\u044B",
            columnId: 'col_3',
            order: 2
        },
        {
            ...$fec5f87c8f441fc1$export$416551eec0702b29,
            ...createIdentity(getId()),
            id: 'task_6',
            localId: getId(),
            serverId: null,
            title: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432 \u0431\u0440\u043E\u0443\u0437\u0435\u0440\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043F\u0443\u043D\u043A\u0442 "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D" \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F.',
            columnId: 'col_3',
            order: 2
        }
    ].map((task)=>{
        task.id = task.localId;
        task.boardId = boardId;
        return task;
    });
    const defaultColumn = {
        boardId: boardId,
        updatedAt: new Date()
    };
    const columns = [
        {
            ...defaultColumn,
            ...createIdentity('col_1'),
            title: "\u041F\u043B\u0430\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F",
            order: 0
        },
        {
            ...defaultColumn,
            ...createIdentity('col_2'),
            title: "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F",
            order: 1
        },
        {
            ...defaultColumn,
            ...createIdentity('col_3'),
            title: "\u0413\u043E\u0442\u043E\u0432\u043E",
            order: 2
        }
    ];
    return {
        ...createIdentity('board_1'),
        title: "\u0421\u0438\u0442\u0430\u0441\u043A \u0437\u0430\u0434\u0430\u0447\u0438",
        columns: columns,
        tasks: tasks
    };
}


var $0688375772546079$export$79234e00edec7f22 = /*#__PURE__*/ function(StoreName) {
    StoreName["Boards"] = "boards";
    StoreName["Columns"] = "columns";
    StoreName["Tasks"] = "tasks";
    StoreName["SyncQueue"] = "syncQueue";
    StoreName["Metadata"] = "metadata";
    return StoreName;
}({});


// Конфигурация базы данных
const $4ab65bb78fd818d7$var$DB_CONFIG = {
    name: 'sitask-db',
    version: 1,
    stores: {
        boards: 'id, title, updatedAt',
        columns: 'id, boardId, order',
        tasks: 'id, localId, serverId, columnId, boardId, isSynced, updatedAt',
        syncQueue: 'id, entityType, entityId, priority, createdAt',
        metadata: 'key'
    },
    indexes: {
        boards: [
            {
                name: 'by-title',
                keyPath: 'title'
            },
            {
                name: 'by-updated',
                keyPath: 'updatedAt'
            }
        ],
        columns: [
            {
                name: 'by-board',
                keyPath: 'boardId'
            },
            {
                name: 'by-order',
                keyPath: 'order'
            }
        ],
        tasks: [
            {
                name: 'by-localId',
                keyPath: 'localId',
                unique: true
            },
            {
                name: 'by-column',
                keyPath: 'columnId'
            },
            {
                name: 'by-board',
                keyPath: 'boardId'
            },
            {
                name: 'by-sync',
                keyPath: [
                    'isSynced',
                    'updatedAt'
                ]
            },
            {
                name: 'by-updated',
                keyPath: 'updatedAt'
            }
        ],
        syncQueue: [
            {
                name: 'by-priority',
                keyPath: [
                    'priority',
                    'createdAt'
                ]
            },
            {
                name: 'by-entity',
                keyPath: [
                    'entityType',
                    'entityId'
                ]
            }
        ]
    }
};
// Инициализация базы данных
class $4ab65bb78fd818d7$var$Database {
    constructor(){
        this.db = null;
    }
    static getInstance() {
        if (!$4ab65bb78fd818d7$var$Database.instance) $4ab65bb78fd818d7$var$Database.instance = new $4ab65bb78fd818d7$var$Database();
        return $4ab65bb78fd818d7$var$Database.instance;
    }
    deleteDatabase() {
        indexedDB.deleteDatabase($4ab65bb78fd818d7$var$DB_CONFIG.name);
    }
    /** set instance in tests*/ setDb(db) {
        this.db = db;
    }
    createDatabase() {
        this.deleteDatabase();
        this.db = null;
        this.init(false);
    }
    async init(isFillDefault = true) {
        if (this.db) return this.db;
        const self = this;
        function createIndex(boardStore1, indexName, arg1, arg2) {
            //@ts-ignore
            boardStore1.createIndex(indexName, arg1, arg2);
        }
        const blockedUpgradeBlockingTerminated = {
            upgrade (db, oldVersion, newVersion, transaction) {
                // Создание хранилищ при первой инициализации
                if (oldVersion >= 1) return;
                const boardStore = db.createObjectStore((0, $0688375772546079$export$79234e00edec7f22).Boards, {
                    keyPath: 'id'
                });
                createIndex(boardStore, 'by-title', 'title');
                createIndex(boardStore, 'by-updated', 'updatedAt');
                const columnStore = db.createObjectStore((0, $0688375772546079$export$79234e00edec7f22).Columns, {
                    keyPath: 'id'
                });
                createIndex(columnStore, 'by-board', 'boardId');
                createIndex(columnStore, 'by-order', 'order');
                const taskStore = db.createObjectStore((0, $0688375772546079$export$79234e00edec7f22).Tasks, {
                    keyPath: 'id'
                });
                createIndex(taskStore, 'by-column', 'columnId');
                createIndex(taskStore, 'by-board', 'boardId');
                createIndex(taskStore, 'by-localId', 'localId', {
                    unique: true
                });
                createIndex(taskStore, 'by-sync', [
                    'isSynced',
                    'updatedAt'
                ]);
                createIndex(taskStore, 'by-updated', 'updatedAt');
                const syncStore = db.createObjectStore((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, {
                    keyPath: 'id'
                });
                createIndex(syncStore, 'by-priority', [
                    'priority',
                    'createdAt'
                ]);
                createIndex(syncStore, 'by-entity', [
                    'entityType',
                    'entityId'
                ]);
                db.createObjectStore((0, $0688375772546079$export$79234e00edec7f22).Metadata, {
                    keyPath: 'key'
                });
                if (isFillDefault) {
                    console.log("Initialized default database");
                    $4ab65bb78fd818d7$export$583aa5ff25a0a729(boardStore, columnStore, taskStore);
                }
            }
        };
        this.db = await (0, $2862506a89f542be$export$ca0ed41b1a2af7e)($4ab65bb78fd818d7$var$DB_CONFIG.name, $4ab65bb78fd818d7$var$DB_CONFIG.version, blockedUpgradeBlockingTerminated);
        return this.db;
    }
    getDB() {
        if (!this.db) throw new Error('Database not initialized. Call init() first.');
        return this.db;
    }
    async close() {
        if (this.db) {
            this.db.close();
            this.db = null;
        }
    }
}
function $4ab65bb78fd818d7$export$583aa5ff25a0a729(boardStore, columnStore, taskStore, testBoard) {
    if (!testBoard) testBoard = (0, $fec5f87c8f441fc1$export$33506068753312cf)();
    boardStore.put(testBoard);
    testBoard.columns.forEach((col)=>columnStore.put(col));
    testBoard.tasks.forEach((task)=>taskStore.put(task));
}
var $4ab65bb78fd818d7$export$2e2bcd8739ae039 = $4ab65bb78fd818d7$var$Database;



function $40de3e02e5c0712c$export$f2db7d5238e1d23f(arg) {
    return arg;
}


class $ffca8a34189c2d37$var$BoardStorage {
    constructor(){
        this.db = (0, $4ab65bb78fd818d7$export$2e2bcd8739ae039).getInstance();
    }
    // Получение доски с колонками и задачами
    async getBoard(boardId) {
        const db = await this.db.init();
        try {
            // Получаем доску
            const board = await db.get((0, $0688375772546079$export$79234e00edec7f22).Boards, boardId);
            if (!board) return null;
            // Получаем колонки этой доски
            const columns = await db.getAllFromIndex((0, $0688375772546079$export$79234e00edec7f22).Columns, 'by-board', boardId);
            // Получаем задачи для каждой колонки
            const tasks = [];
            for (const column of columns){
                let columnTasks = (0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(await db.getAllFromIndex((0, $0688375772546079$export$79234e00edec7f22).Tasks, 'by-column', column.id));
                columnTasks = columnTasks.filter((t)=>!t.deletedAt);
                columnTasks.forEach((task)=>{
                    task.boardId = board.id;
                });
                tasks.push(...columnTasks);
            }
            // Сортируем колонки по order
            columns.sort((a, b)=>a.order - b.order);
            return (0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)({
                ...board,
                columns: columns,
                tasks: tasks
            });
        } catch (error) {
            console.error('Error getting board:', error);
            return null;
        }
    }
    // Получение всех досок (для списка)
    async getAllBoards() {
        const db = await this.db.init();
        try {
            const boards = await db.getAll((0, $0688375772546079$export$79234e00edec7f22).Boards);
            return (0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(boards);
        } catch (error) {
            console.error('Error getting all boards:', error);
            return [];
        }
    }
    // Сохранение доски
    async saveBoard(board) {
        const db = await this.db.init();
        const transaction = db.transaction([
            (0, $0688375772546079$export$79234e00edec7f22).Boards,
            (0, $0688375772546079$export$79234e00edec7f22).Columns,
            (0, $0688375772546079$export$79234e00edec7f22).Tasks
        ], 'readwrite');
        board.isEditing = false;
        try {
            const now = new Date();
            const boardToSave = {
                ...board,
                updatedAt: now,
                columns: undefined,
                tasks: undefined
            };
            // Сохраняем доску
            await transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Boards).put((0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(boardToSave));
            // Сохраняем колонки
            for (const column of board.columns){
                const columnToSave = {
                    ...column,
                    boardId: board.id,
                    updatedAt: now
                };
                await transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Columns).put(columnToSave);
            }
            // Сохраняем задачи
            for (const task of board.tasks){
                const taskToSave = {
                    ...task,
                    updatedAt: now
                };
                await transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Tasks).put(taskToSave);
            }
            await transaction.done;
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('board', board.id, 'update', boardToSave);
            return (0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(boardToSave);
        } catch (error) {
            console.error('Error saving board:', error);
            throw error;
        }
    }
    // Создание новой доски
    async createBoard(boardData) {
        const db = await this.db.init();
        const now = new Date();
        const newBoard = {
            ...boardData,
            id: `board_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            createdAt: now,
            updatedAt: now
        };
        try {
            await db.add((0, $0688375772546079$export$79234e00edec7f22).Boards, newBoard);
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('board', newBoard.id, 'create', newBoard);
            return newBoard;
        } catch (error) {
            console.error('Error creating board:', error);
            throw error;
        }
    }
    // Удаление доски
    async deleteBoard(boardId) {
        const db = await this.db.init();
        const transaction = db.transaction([
            (0, $0688375772546079$export$79234e00edec7f22).Boards,
            (0, $0688375772546079$export$79234e00edec7f22).Columns,
            (0, $0688375772546079$export$79234e00edec7f22).Tasks
        ], 'readwrite');
        try {
            // Получаем колонки доски
            const columns = await db.getAllFromIndex((0, $0688375772546079$export$79234e00edec7f22).Columns, 'by-board', boardId);
            const columnIds = columns.map((col)=>col.id);
            // Удаляем задачи этих колонок
            for (const columnId of columnIds){
                const tasks = await db.getAllFromIndex((0, $0688375772546079$export$79234e00edec7f22).Tasks, 'by-column', columnId);
                for (const task of tasks){
                    await transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Tasks).delete(task.id);
                    // Добавляем в очередь синхронизации
                    await this.addToSyncQueue('task', task.id, 'delete', task);
                }
            }
            // Удаляем колонки
            for (const column of columns){
                await transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Columns).delete(column.id);
                // Добавляем в очередь синхронизации
                await this.addToSyncQueue('column', column.id, 'delete', column);
            }
            // Удаляем доску
            await transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Boards).delete(boardId);
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('board', boardId, 'delete', {
                id: boardId
            });
            await transaction.done;
        } catch (error) {
            console.error('Error deleting board:', error);
            throw error;
        }
    }
    // Вспомогательный метод для добавления в очередь синхронизации
    async addToSyncQueue(entityType, entityId, operation, data) {
        const db = await this.db.init();
        const syncOp = {
            id: `sync_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            entityType: entityType,
            entityId: entityId,
            operation: operation,
            data: data,
            priority: operation === 'delete' ? 1 : 2,
            attempts: 0,
            maxAttempts: 3,
            createdAt: new Date(),
            updatedAt: new Date()
        };
        await db.add((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, syncOp);
    }
    // Получение непросинхронизированных операций
    async getUnsyncedOperations(count) {
        const db = await this.db.init();
        try {
            const index = db.transaction((0, $0688375772546079$export$79234e00edec7f22).SyncQueue).store.index('by-priority');
            let cursor = await index.openCursor(null, 'next');
            const operations = [];
            while(cursor && (!count || operations.length < count)){
                operations.push(cursor.value);
                cursor = await cursor.continue();
            }
            return operations;
        } catch (error) {
            console.error('Error getting unsynced operations:', error);
            return [];
        }
    }
    // Пометить операцию как успешно синхронизированную
    async markAsSynced(operationId) {
        const db = await this.db.init();
        try {
            await db.delete((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, operationId);
        } catch (error) {
            console.error('Error marking operation as synced:', error);
            throw error;
        }
    }
    // Обновление операции после неудачной попытки синхронизации
    async updateSyncOperation(operationId, errorMessage) {
        const db = await this.db.init();
        const transaction = db.transaction((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, 'readwrite');
        try {
            const operation = await transaction.store.get(operationId);
            if (!operation) return;
            const updatedOperation = {
                ...operation,
                attempts: operation.attempts + 1,
                error: errorMessage,
                updatedAt: new Date()
            };
            await transaction.store.put(updatedOperation);
            await transaction.done;
        } catch (error) {
            console.error('Error updating sync operation:', error);
            throw error;
        }
    }
    // Получение метаданных
    async getMetadata(key) {
        const db = await this.db.init();
        try {
            const metadata = await db.get((0, $0688375772546079$export$79234e00edec7f22).Metadata, key);
            return metadata?.value;
        } catch (error) {
            console.error('Error getting metadata:', error);
            return null;
        }
    }
    // Сохранение метаданных
    async setMetadata(key, value) {
        const db = await this.db.init();
        const now = new Date();
        const metadata = {
            key: key,
            value: value,
            updatedAt: now
        };
        try {
            await db.put((0, $0688375772546079$export$79234e00edec7f22).Metadata, metadata);
        } catch (error) {
            console.error('Error setting metadata:', error);
            throw error;
        }
    }
    // Получение колонки
    async getColumn(columnId) {
        const db = await this.db.init();
        try {
            const column = await db.get((0, $0688375772546079$export$79234e00edec7f22).Columns, columnId);
            return (0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(column || null);
        } catch (error) {
            console.error('Error getting column:', error);
            return null;
        }
    }
    // Сохранение колонки
    async saveColumn(column) {
        const db = await this.db.init();
        const now = new Date();
        const columnToSave = {
            ...column,
            updatedAt: now
        };
        try {
            await db.put((0, $0688375772546079$export$79234e00edec7f22).Columns, columnToSave);
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('column', column.id, 'update', columnToSave);
            return columnToSave;
        } catch (error) {
            console.error('Error saving column:', error);
            throw error;
        }
    }
    // Обновление колонки
    async updateColumn(columnId, updates) {
        const db = await this.db.init();
        const transaction = db.transaction([
            (0, $0688375772546079$export$79234e00edec7f22).Columns
        ], 'readwrite');
        const store = transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Columns);
        try {
            const column = await store.get(columnId);
            if (!column) return null;
            const updatedColumn = {
                ...column,
                ...updates,
                updatedAt: new Date()
            };
            await store.put(updatedColumn);
            await transaction.done;
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('column', columnId, 'update', updatedColumn);
            return updatedColumn;
        } catch (error) {
            console.error('Error updating column:', error);
            throw error;
        }
    }
    // Удаление колонки
    async deleteColumn(columnId) {
        const db = await this.db.init();
        try {
            const column = await this.getColumn(columnId);
            if (!column) return false;
            // Удаляем задачи этой колонки
            const tasks = await db.getAllFromIndex((0, $0688375772546079$export$79234e00edec7f22).Tasks, 'by-column', columnId);
            for (const task of tasks){
                await db.delete((0, $0688375772546079$export$79234e00edec7f22).Tasks, task.id);
                await this.addToSyncQueue('task', task.id, 'delete', task);
            }
            // Удаляем колонку
            await db.delete((0, $0688375772546079$export$79234e00edec7f22).Columns, columnId);
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('column', columnId, 'delete', column);
            return true;
        } catch (error) {
            console.error('Error deleting column:', error);
            throw error;
        }
    }
}
var $ffca8a34189c2d37$export$2e2bcd8739ae039 = $ffca8a34189c2d37$var$BoardStorage;






//@ts-ignore TS18048
class $689c16ee6fdcea17$var$TaskStorage {
    constructor(){
        this.db = (0, $4ab65bb78fd818d7$export$2e2bcd8739ae039).getInstance();
    }
    // Получение задачи
    async getTask(taskId) {
        const db = await this.db.init();
        try {
            const task = await db.get((0, $0688375772546079$export$79234e00edec7f22).Tasks, taskId);
            return (0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(task || null);
        } catch (error) {
            console.error('Error getting task:', error);
            return null;
        }
    }
    // Получение задач колонки
    async getTasksByColumn(columnId) {
        const db = await this.db.init();
        try {
            const tasks = await db.getAllFromIndex((0, $0688375772546079$export$79234e00edec7f22).Tasks, 'by-column', columnId);
            return tasks.sort((a, b)=>new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
        } catch (error) {
            console.error('Error getting tasks by column:', error);
            return [];
        }
    }
    // Создание задачи
    async createTask(taskData) {
        const db = await this.db.init();
        const now = new Date();
        const newTask = {
            ...taskData,
            id: `task_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            localId: taskData.localId || `local_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            order: taskData.order || 0,
            createdAt: now,
            updatedAt: now,
            isSynced: false,
            syncVersion: 1
        };
        try {
            await db.add((0, $0688375772546079$export$79234e00edec7f22).Tasks, newTask);
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('task', newTask.id, 'create', newTask);
            return newTask;
        } catch (error) {
            console.error('Error creating task:', error);
            throw error;
        }
    }
    // Получение удаленных задач (с deletedAt)
    async getDeletedTasks() {
        const db = await this.db.init();
        try {
            const allTasks = await db.getAll((0, $0688375772546079$export$79234e00edec7f22).Tasks);
            return allTasks.filter((task)=>task.deletedAt !== null);
        } catch (error) {
            console.error('Error getting deleted tasks:', error);
            return [];
        }
    }
    // Полное удаление задачи
    async permanentlyDeleteTask(taskId) {
        const db = await this.db.init();
        await db.delete((0, $0688375772546079$export$79234e00edec7f22).Tasks, taskId);
    }
    async updateTask(taskId, updates) {
        const db = await this.db.init();
        const transaction = db.transaction([
            (0, $0688375772546079$export$79234e00edec7f22).Tasks
        ], 'readwrite');
        const store = transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Tasks);
        try {
            const task = await store.get(taskId);
            if (!task) return null;
            const updatedTask = {
                ...task,
                ...updates,
                deletedAt: updates.deletedAt !== undefined ? updates.deletedAt : task.deletedAt,
                updatedAt: new Date(),
                syncVersion: (task.syncVersion || 1) + 1,
                isSynced: false
            };
            await store.put(updatedTask);
            await transaction.done;
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('task', taskId, 'update', updatedTask);
            return updatedTask;
        } catch (error) {
            console.error('Error updating task:', error);
            throw error;
        }
    }
    // Обновление задачи (оптимистичное)
    async updateTaskOptimistic(taskId, updates) {
        const db = await this.db.init();
        const transaction = db.transaction([
            (0, $0688375772546079$export$79234e00edec7f22).Tasks
        ], 'readwrite');
        const store = transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Tasks);
        try {
            const task = await store.get(taskId);
            if (!task) return {
                task: null,
                rollbackData: null
            };
            // Сохраняем данные для отката
            const rollbackData = {
                ...task
            };
            const updatedTask = {
                ...task,
                ...updates,
                deletedAt: updates.deletedAt !== undefined ? updates.deletedAt : task.deletedAt,
                order: updates.order !== undefined ? updates.order : task.order,
                updatedAt: new Date(),
                syncVersion: (task.syncVersion || 1) + 1,
                isSynced: false
            };
            await store.put(updatedTask);
            await transaction.done;
            // Отложенное добавление в очередь синхронизации
            setTimeout(()=>{
                this.addToSyncQueue('task', taskId, 'update', updatedTask).catch(console.error);
            }, 100);
            return {
                task: updatedTask,
                rollbackData: rollbackData
            };
        } catch (error) {
            console.error('Error updating task optimistically:', error);
            throw error;
        }
    }
    // Удаление задачи
    async deleteTask(taskId) {
        const db = await this.db.init();
        try {
            const task = await this.getTask(taskId);
            if (!task) return false;
            await db.delete((0, $0688375772546079$export$79234e00edec7f22).Tasks, taskId);
            // Добавляем в очередь синхронизации
            await this.addToSyncQueue('task', taskId, 'delete', task);
            return true;
        } catch (error) {
            console.error('Error deleting task:', error);
            throw error;
        }
    }
    // Получение непросинхронизированных задач
    async getUnsyncedTasks() {
        const db = await this.db.init();
        try {
            const index = db.transaction((0, $0688375772546079$export$79234e00edec7f22).Tasks).store.index('by-sync');
            const range = IDBKeyRange.bound([
                false
            ], [
                false,
                new Date()
            ]);
            let cursor = await index.openCursor(range, 'next');
            const tasks = [];
            while(cursor){
                tasks.push(cursor.value);
                cursor = await cursor.continue();
            }
            return tasks;
        } catch (error) {
            console.error('Error getting unsynced tasks:', error);
            return [];
        }
    }
    // Пометить задачу как синхронизированную
    async markTaskAsSynced(taskId, serverId) {
        const db = await this.db.init();
        const transaction = db.transaction([
            (0, $0688375772546079$export$79234e00edec7f22).Tasks
        ], 'readwrite');
        const store = transaction.objectStore((0, $0688375772546079$export$79234e00edec7f22).Tasks);
        try {
            const task = await store.get(taskId);
            if (!task) return;
            const updatedTask = {
                ...task,
                serverId: serverId,
                isSynced: true,
                updatedAt: new Date()
            };
            await store.put(updatedTask);
            await transaction.done;
        } catch (error) {
            console.error('Error marking task as synced:', error);
            throw error;
        }
    }
    // Вспомогательный метод для добавления в очередь синхронизации
    async addToSyncQueue(entityType, entityId, operation, data) {
        const db = await this.db.init();
        const syncOp = {
            id: `sync_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            entityType: entityType,
            entityId: entityId,
            operation: operation,
            data: data,
            priority: operation === 'delete' ? 1 : 2,
            attempts: 0,
            maxAttempts: 3,
            createdAt: new Date(),
            updatedAt: new Date()
        };
        await db.add((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, syncOp);
    }
}
var $689c16ee6fdcea17$export$2e2bcd8739ae039 = $689c16ee6fdcea17$var$TaskStorage;



class $78cb44dee5dc0ea7$var$SyncService {
    constructor(){
        this.isSyncing = false;
        this.retryDelay = 5000 // 5 секунд
        ;
        this.maxRetryDelay = 60000 // 1 минута
        ;
        this.db = (0, $4ab65bb78fd818d7$export$2e2bcd8739ae039).getInstance();
    }
    // Начать фоновую синхронизацию
    startBackgroundSync() {
        return;
    }
    // Принудительная синхронизация
    async forceSync() {
        if (this.isSyncing) throw new Error('Sync already in progress');
        this.isSyncing = true;
        try {
            await this.sync();
        } finally{
            this.isSyncing = false;
        }
    }
    // Основной метод синхронизации
    async sync() {
        const db = await this.db.init();
        try {
            // Получаем операции для синхронизации (максимум 10 за раз)
            const operations = await this.getSyncOperations(10);
            if (operations.length === 0) {
                console.log('No operations to sync');
                return;
            }
            console.log(`Syncing ${operations.length} operations...`);
            // Синхронизируем каждую операцию
            for (const operation of operations)await this.syncOperation(operation);
            // Обновляем метаданные о последней синхронизации
            await this.updateLastSyncTime();
        } catch (error) {
            console.error('Sync error:', error);
            throw error;
        }
    }
    // Получение операций для синхронизации
    async getSyncOperations(limit) {
        const db = await this.db.init();
        try {
            const index = db.transaction((0, $0688375772546079$export$79234e00edec7f22).SyncQueue).store.index('by-priority');
            let cursor = await index.openCursor(null, 'next');
            const operations = [];
            while(cursor && operations.length < limit){
                // Пропускаем операции, которые уже были попробованы слишком много раз
                if (cursor.value.attempts < cursor.value.maxAttempts) operations.push(cursor.value);
                cursor = await cursor.continue();
            }
            return operations;
        } catch (error) {
            console.error('Error getting sync operations:', error);
            return [];
        }
    }
    // Синхронизация одной операции
    async syncOperation(operation) {
        try {
            // Здесь будет реальный вызов API
            // Для этапа 4 просто имитируем успешную синхронизацию
            await this.mockApiCall(operation);
            // Удаляем операцию из очереди после успешной синхронизации
            await this.markOperationAsSynced(operation.id);
            console.log(`Operation ${operation.id} synced successfully`);
        } catch (error) {
            console.error(`Failed to sync operation ${operation.id}:`, error);
            // Увеличиваем счетчик попыток
            await this.incrementOperationAttempts(operation.id, error.message);
            // Если это последняя попытка, отмечаем операцию как неудачную
            if (operation.attempts + 1 >= operation.maxAttempts) await this.markOperationAsFailed(operation.id, error.message);
        }
    }
    // Имитация вызова API
    async mockApiCall(operation) {
        // Имитируем задержку сети
        await new Promise((resolve)=>setTimeout(resolve, Math.random() * 1000 + 500));
        // Имитируем случайные ошибки (10% вероятность)
        if (Math.random() < 0.1) throw new Error('Mock API error: Network timeout');
        // Для задач, которые создаются, генерируем serverId
        if (operation.entityType === 'task' && operation.operation === 'create') {
            const task = operation.data;
            if (task) task.serverId = Math.floor(Math.random() * 10000) + 1000;
        }
    }
    // Пометить операцию как синхронизированную
    async markOperationAsSynced(operationId) {
        const db = await this.db.init();
        try {
            await db.delete((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, operationId);
            // Если это была операция создания задачи, обновляем serverId
            const operation = await db.get((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, operationId);
            if (!operation) return;
            if (operation.entityType === 'task' && operation.operation === 'create') {
                const taskStorage = new (0, $689c16ee6fdcea17$export$2e2bcd8739ae039)();
                await taskStorage.markTaskAsSynced(operation.entityId, operation.data.serverId);
            }
        } catch (error) {
            console.error('Error marking operation as synced:', error);
            throw error;
        }
    }
    // Увеличить счетчик попыток
    async incrementOperationAttempts(operationId, errorMessage) {
        const db = await this.db.init();
        const transaction = db.transaction((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, 'readwrite');
        try {
            const operation = await transaction.store.get(operationId);
            if (!operation) return;
            const updatedOperation = {
                ...operation,
                attempts: operation.attempts + 1,
                error: errorMessage,
                updatedAt: new Date()
            };
            await transaction.store.put(updatedOperation);
            await transaction.done;
        } catch (error) {
            console.error('Error incrementing operation attempts:', error);
            throw error;
        }
    }
    // Пометить операцию как неудачную
    async markOperationAsFailed(operationId, errorMessage) {
        const db = await this.db.init();
        try {
            // Здесь можно добавить логику для обработки окончательно неудачных операций
            // Например, отправить уведомление пользователю
            console.warn(`Operation ${operationId} failed after maximum attempts: ${errorMessage}`);
            // Пока просто удаляем из очереди
            await db.delete((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, operationId);
        } catch (error) {
            console.error('Error marking operation as failed:', error);
            throw error;
        }
    }
    // Обновление времени последней синхронизации
    async updateLastSyncTime() {
        const db = await this.db.init();
        try {
            const metadata = {
                key: 'lastSyncTime',
                value: new Date().toISOString(),
                updatedAt: new Date()
            };
            await db.put((0, $0688375772546079$export$79234e00edec7f22).Metadata, metadata);
        } catch (error) {
            console.error('Error updating last sync time:', error);
            throw error;
        }
    }
    // Получение времени последней синхронизации
    async getLastSyncTime() {
        const db = await this.db.init();
        try {
            const metadata = await db.get((0, $0688375772546079$export$79234e00edec7f22).Metadata, 'lastSyncTime');
            return metadata ? new Date(metadata.value) : null;
        } catch (error) {
            console.error('Error getting last sync time:', error);
            return null;
        }
    }
    // Получение статуса синхронизации
    async getSyncStatus() {
        const db = await this.db.init();
        try {
            const operations = await db.getAll((0, $0688375772546079$export$79234e00edec7f22).SyncQueue);
            const pending = operations.length;
            const failed = operations.filter((op)=>op.attempts >= op.maxAttempts).length;
            const lastSync = await this.getLastSyncTime();
            return {
                pending: pending,
                failed: failed,
                lastSync: lastSync,
                isOnline: navigator.onLine
            };
        } catch (error) {
            console.error('Error getting sync status:', error);
            return {
                pending: 0,
                failed: 0,
                lastSync: null,
                isOnline: navigator.onLine
            };
        }
    }
    // Очистка очереди синхронизации
    async clearSyncQueue() {
        const db = await this.db.init();
        try {
            const operations = await db.getAll((0, $0688375772546079$export$79234e00edec7f22).SyncQueue);
            for (const operation of operations)await db.delete((0, $0688375772546079$export$79234e00edec7f22).SyncQueue, operation.id);
            console.log('Sync queue cleared');
        } catch (error) {
            console.error('Error clearing sync queue:', error);
            throw error;
        }
    }
}
var $78cb44dee5dc0ea7$export$2e2bcd8739ae039 = $78cb44dee5dc0ea7$var$SyncService;



class $7fe9597f067fa1a3$export$4f8e2d3a3828478e {
    // 1. Для новой задачи в колонке: последний order + 10
    static getOrderForNewTask(columnTasks) {
        if (columnTasks.length === 0) return 0;
        const lastTask = this.sortTasksByOrder(columnTasks)[columnTasks.length - 1];
        return lastTask.order + 10;
    }
    // 2. Для вставки между задачами: среднее значение
    static getOrderBetweenTasks(prevTask, nextTask) {
        if (!prevTask && !nextTask) return 0;
        if (!prevTask) return nextTask.order - 10; // В начало
        if (!nextTask) return prevTask.order + 10; // В конец
        // Если разница = 1 или меньше, нужна перевыдача
        if (nextTask.order - prevTask.order <= 1) return -1; // Флаг для перевыдачи
        return Math.floor((prevTask.order + nextTask.order) / 2);
    }
    // 3. Проверка необходимости перевыдачи
    static needsReorder(tasks) {
        const sorted = this.sortTasksByOrder(tasks);
        for(let i = 1; i < sorted.length; i++){
            if (sorted[i].order - sorted[i - 1].order <= 1) return true;
        }
        return false;
    }
    // 4. Перевыдача order с шагом 10
    static redistributeOrders(tasks) {
        const sorted = this.sortTasksByOrder(tasks);
        return sorted.map((task, index)=>({
                ...task,
                order: index * 10
            }));
    }
    // 5. Сортировка задач по order
    static sortTasksByOrder(tasks) {
        return [
            ...tasks
        ].sort((a, b)=>a.order - b.order);
    }
    // 6. Получение задач для позиционирования
    static getAdjacentTasks(tasks, targetIndex) {
        const sorted = this.sortTasksByOrder(tasks);
        if (targetIndex === 0) return {
            prevTask: null,
            nextTask: sorted[0] || null
        };
        if (targetIndex >= sorted.length || targetIndex < 0) return {
            prevTask: sorted[sorted.length - 1] || null,
            nextTask: null
        };
        return {
            prevTask: sorted[targetIndex - 1] || null,
            nextTask: sorted[targetIndex] || null
        };
    }
}


class $e452282908266737$export$71ab42719e74e591 {
    // 1. Для новой колонки: последний order + 10
    static getOrderForNewColumn(columns) {
        if (columns.length === 0) return 0;
        const lastColumn = this.sortColumnsByOrder(columns)[columns.length - 1];
        return lastColumn.order + 10;
    }
    // 2. Для вставки между колонками: среднее значение
    static getOrderBetweenColumns(prevColumn, nextColumn) {
        if (!prevColumn && !nextColumn) return 0;
        if (!prevColumn) return nextColumn.order - 10; // В начало
        if (!nextColumn) return prevColumn.order + 10; // В конец
        // Если разница = 1 или меньше, нужна перевыдача
        if (nextColumn.order - prevColumn.order <= 1) return -1; // Флаг для перевыдачи
        return Math.floor((prevColumn.order + nextColumn.order) / 2);
    }
    // 3. Проверка необходимости перевыдачи
    static needsReorder(columns) {
        const sorted = this.sortColumnsByOrder(columns);
        for(let i = 1; i < sorted.length; i++){
            if (sorted[i].order - sorted[i - 1].order <= 1) return true;
        }
        return false;
    }
    // 4. Перевыдача order с шагом 10
    static redistributeOrders(columns) {
        const sorted = this.sortColumnsByOrder(columns);
        return sorted.map((column, index)=>({
                ...column,
                order: index * 10
            }));
    }
    // 5. Сортировка колонок по order
    static sortColumnsByOrder(columns) {
        return [
            ...columns
        ].sort((a, b)=>a.order - b.order);
    }
    // 6. Получение колонок для позиционирования
    static getAdjacentColumns(columns, targetIndex) {
        const sorted = this.sortColumnsByOrder(columns);
        if (targetIndex === 0) return {
            prevColumn: null,
            nextColumn: sorted[0] || null
        };
        if (targetIndex >= sorted.length) return {
            prevColumn: sorted[sorted.length - 1] || null,
            nextColumn: null
        };
        return {
            prevColumn: sorted[targetIndex - 1] || null,
            nextColumn: sorted[targetIndex] || null
        };
    }
}



//define system wide storage.
let $d1146091929fdc0c$var$started = {};
let $d1146091929fdc0c$var$lastDrop = {};
window.__DEBUG_runAsyncTask = false;
function $d1146091929fdc0c$export$94a40668381dd679(taskKey, run, timeout = 100, passDropTimeout = 0) {
    if ($d1146091929fdc0c$var$started[taskKey]) {
        if (window.__DEBUG_runAsyncTask) console.log("cancel task:" + taskKey);
        const now = Date.now();
        if ($d1146091929fdc0c$var$lastDrop[taskKey] !== undefined && passDropTimeout > 0) {
            if (now - $d1146091929fdc0c$var$lastDrop[taskKey] < passDropTimeout) clearTimeout($d1146091929fdc0c$var$started[taskKey]);
        } else clearTimeout($d1146091929fdc0c$var$started[taskKey]);
        $d1146091929fdc0c$var$lastDrop[taskKey] = now;
    }
    $d1146091929fdc0c$var$started[taskKey] = setTimeout(()=>{
        run();
        delete $d1146091929fdc0c$var$started[taskKey];
    }, timeout);
}




// utils/TaskOrderProcessor.ts

class $e9fce746c8105712$export$109143baced8e56f {
    constructor(){
        this.cache = new Map() // columnId -> sortedTaskIds
        ;
        this.versionMap = new Map() // columnId -> version
        ;
        this.taskMapCache = new Map() // cacheKey -> taskId -> Task
        ;
    }
    static reset() {
        $e9fce746c8105712$export$109143baced8e56f.instance = undefined;
    }
    static getInstance() {
        if (!$e9fce746c8105712$export$109143baced8e56f.instance) $e9fce746c8105712$export$109143baced8e56f.instance = new $e9fce746c8105712$export$109143baced8e56f();
        return $e9fce746c8105712$export$109143baced8e56f.instance;
    }
    /**
	 * Получить отсортированные ID задач для конкретной колонки
	 */ getSortedTaskIds(columnId, allTasks) {
        const currentVersion = this.getVersion(columnId);
        const cacheKey = `${columnId}_v${currentVersion}`;
        // Проверяем кэш
        const cached = this.cache.get(cacheKey);
        if (cached) return cached;
        // Вычисляем порядок на основе Task.order
        const sortedTasks = allTasks.filter((task)=>task.columnId === columnId).sort((a, b)=>a.order - b.order);
        const sortedIds = sortedTasks.map((task)=>task.id);
        // Сохраняем в кэш
        this.cache.set(cacheKey, sortedIds);
        return sortedIds;
    }
    /**
	 * Получить мапу задач по ID для оптимизации поиска
	 */ getTaskMap(allTasks) {
        // Создаем уникальный ключ для кэша на основе длины массива и максимальной даты обновления
        const maxUpdateTime = allTasks.reduce((max, task)=>new Date(task.updatedAt).getTime() > max ? new Date(task.updatedAt).getTime() : max, 0);
        const cacheKey = `tasks_${allTasks.length}_${maxUpdateTime}`;
        const cached = this.taskMapCache.get(cacheKey);
        if (cached) return cached;
        // Создаем мапу задач
        const taskMap = new Map();
        for (const task of allTasks)taskMap.set(task.id, task);
        // Сохраняем в кэш
        this.taskMapCache.set(cacheKey, taskMap);
        return taskMap;
    }
    /**
	 * Обновить порядок задач в колонке
	 */ async updateColumnOrder(columnId, allTasks, taskStorage// TaskStorage instance
    ) {
        const columnTasks = allTasks.filter((task)=>task.columnId === columnId);
        const needsReorder = (0, $7fe9597f067fa1a3$export$4f8e2d3a3828478e).needsReorder(columnTasks);
        if (!needsReorder) return columnTasks;
        // Вариант А: Сначала вычисляем новые order для всех задач в колонке
        const redistributed = (0, $7fe9597f067fa1a3$export$4f8e2d3a3828478e).redistributeOrders(columnTasks);
        // Потом обновляем в памяти
        for (const redistTask of redistributed){
            const existingTask = allTasks.find((t)=>t.id === redistTask.id);
            if (existingTask) {
                existingTask.order = redistTask.order;
                existingTask.updatedAt = new Date();
                existingTask.isSynced = false;
            }
        }
        // Потом сохраняем в БД
        for (const redistTask of redistributed)await taskStorage.updateTaskOptimistic(redistTask.id, {
            order: redistTask.order,
            updatedAt: new Date(),
            isSynced: false
        });
        // Инвалидируем кэш для колонки
        this.invalidateColumn(columnId);
        return redistributed;
    }
    /**
	 * Обновить позицию задачи в колонке
	 */ async updateTaskPosition(taskId, targetColumnId, targetIndex, allTasks, taskStorage// TaskStorage instance
    ) {
        const task = allTasks.find((t)=>t.id === taskId);
        if (!task) throw new Error(`Task ${taskId} not found`);
        const oldColumnId = task.columnId;
        const isNewColumn = oldColumnId !== targetColumnId;
        // Регистрация (обновление меток времени и т.д.)
        task.updatedAt = new Date();
        task.isSynced = false;
        // Если колонка меняется, обновляем поле columnId
        if (isNewColumn) task.columnId = targetColumnId;
        // Получить задачи целевой колонки (без текущей задачи, если она меняет колонку)
        const targetColumnTasks = allTasks.filter((t)=>t.columnId === targetColumnId && t.id !== taskId);
        // Вычислить новый order (реальная позиция задачи)
        const adjacent = (0, $7fe9597f067fa1a3$export$4f8e2d3a3828478e).getAdjacentTasks(targetColumnTasks, targetIndex);
        let newOrder = (0, $7fe9597f067fa1a3$export$4f8e2d3a3828478e).getOrderBetweenTasks(adjacent.prevTask, adjacent.nextTask);
        // Если нужна перевыдача order
        if (newOrder === -1) {
            // Добавить задачу в правильную позицию для перевыдачи
            const tasksForRedistribution = [
                ...targetColumnTasks,
                task
            ];
            const sorted = (0, $7fe9597f067fa1a3$export$4f8e2d3a3828478e).sortTasksByOrder(tasksForRedistribution);
            // Вставить задачу в нужную позицию
            const finalSorted = [
                ...sorted.slice(0, targetIndex),
                task,
                ...sorted.slice(targetIndex)
            ];
            const redistributed = (0, $7fe9597f067fa1a3$export$4f8e2d3a3828478e).redistributeOrders(finalSorted);
            newOrder = redistributed.find((t)=>t.id === task.id)?.order || 0;
            // Обновить order для всех задач целевой колонки (кроме текущей)
            for (const redistTask of redistributed){
                if (redistTask.id === task.id) continue;
                const existingTask = allTasks.find((t)=>t.id === redistTask.id);
                if (existingTask) {
                    existingTask.order = redistTask.order;
                    existingTask.updatedAt = new Date();
                    existingTask.isSynced = false;
                }
            }
        }
        // Установить новый order для текущей задачи
        task.order = newOrder;
        // Обновить order для целевой колонки (если нужно)
        await this.updateColumnOrder(targetColumnId, allTasks, taskStorage);
    // Обновить order для старой колонки (если задача меняет колонку)
    // if (isNewColumn) {
    // 	await this.updateColumnOrder(oldColumnId, allTasks, taskStorage);
    // }
    }
    /**
	 * Инвалидация кэша для конкретной колонки
	 */ invalidateColumn(columnId) {
        const newVersion = (this.versionMap.get(columnId) || 0) + 1;
        this.versionMap.set(columnId, newVersion);
        // Удаляем устаревшие записи из кэша
        for (const key of this.cache.keys())if (key.startsWith(`${columnId}_`)) this.cache.delete(key);
    }
    /**
	 * Инвалидация кэша для нескольких колонок
	 */ invalidateColumns(columnIds) {
        for (const columnId of columnIds)this.invalidateColumn(columnId);
    }
    /**
	 * Получить версию кэша для колонки
	 */ getVersion(columnId) {
        return this.versionMap.get(columnId) || 0;
    }
    /**
	 * Полная инвалидация кэша
	 */ invalidateAll() {
        this.cache.clear();
        this.versionMap.clear();
        this.taskMapCache.clear();
    }
}



class $b923651d7cbf96a1$export$86fbec116b87613f {
    constructor(){
        this.currentBoardSnapshot = null // Для отката оптимистичных обновлений
        ;
        // Фильтры для режима списка
        this.listFilters = {
            column: null,
            status: 'all'
        };
        this.taskOrderProcessor = (0, $e9fce746c8105712$export$109143baced8e56f).getInstance();
        this.taskUi = new Map();
        this.editState = {
            originalBoard: null,
            hasChanges: false,
            isSaving: false,
            lastSaved: null
        };
        //</editor-fold>
        //<editor-fold desc="Responsive mode and view mode">
        this.responsiveState = {
            currentViewMode: (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns,
            availableModes: [
                (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns,
                (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List
            ],
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            isPortrait: window.innerHeight > window.innerWidth,
            touchSupported: 'ontouchstart' in window,
            gesturesEnabled: true
        };
        this.boardStorage = new (0, $ffca8a34189c2d37$export$2e2bcd8739ae039)();
        this.taskStorage = new (0, $689c16ee6fdcea17$export$2e2bcd8739ae039)();
        this.syncService = new (0, $78cb44dee5dc0ea7$export$2e2bcd8739ae039)();
        // Состояние сначала пустое
        this.state = {
            currentBoards: [
                {
                    ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)(''),
                    title: "",
                    tasks: [],
                    columns: []
                }
            ],
            activeBoardIndex: 0,
            viewMode: "columns",
            lastSyncTime: null,
            isLoading: true,
            showFilters: false
        };
        // Инициализация контроллера редактирования задач
        this.taskEditController = new (0, $19d6ae3d23827c9e$export$10417d07c8a86bc0)((id)=>this.getTaskById(id), (id, updates)=>this.taskUpdateOptimistic(id, updates), (id)=>this.taskDeletePermanently(id));
        // Инициализация асинхронная
        this.init();
    }
    //<editor-fold desc="Вспомогательные методы для оптимистичных обновлений">
    async withOptimisticUpdate(operation, optimisticUpdate, onSuccess, onError) {
        // Сохраняем снимок для отката
        const board = this.getCurrentBoard();
        this.currentBoardSnapshot = JSON.parse(JSON.stringify(board));
        // Выполняем оптимистичное обновление
        optimisticUpdate();
        // Уведомляем об изменении
        (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
        try {
            // Выполняем асинхронную операцию
            const result = await operation();
            // Успешно - сбрасываем снимок
            this.currentBoardSnapshot = null;
            // Вызываем коллбэк успеха
            if (onSuccess) onSuccess(result);
            return result;
        } catch (error) {
            console.error('Error in optimistic update:', error);
            // Откатываем изменения
            if (this.currentBoardSnapshot) {
                board.columns = this.currentBoardSnapshot.columns;
                board.tasks = this.currentBoardSnapshot.tasks;
                this.currentBoardSnapshot = null;
                (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
            }
            // Вызываем коллбэк ошибки
            if (onError) onError(error);
            throw error;
        }
    }
    emitBoardUpdate() {
        (0, $d1146091929fdc0c$export$94a40668381dd679)((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.name, ()=>{
            (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit($b923651d7cbf96a1$export$86fbec116b87613f.getInstance().getCurrentBoard());
        });
    }
    saveBoardAfterOperation() {
        const board = {
            ...this.getCurrentBoard(),
            isEditing: undefined
        };
        this.boardStorage.saveBoard(board).catch((error)=>{
            console.error('Error saving board after operation:', error);
        });
    }
    //</editor-fold>
    async init() {
        // Загружаем состояние из IndexedDB
        this.state = await this.loadInitialState();
        // Инициализация адаптивности
        this.responsiveInit();
        // Слушаем сеть
        this.setupNetworkListeners();
        // Запускаем фоновую синхронизацию
        this.syncService.startBackgroundSync();
        // Уведомляем, что доска загружена
        (0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated.emit();
        (0, $883133d1f570db27$export$bfc40ca370b68e03).responsiveStateChanged.emit(this.getResponsiveState());
    }
    static getInstance() {
        if (!$b923651d7cbf96a1$export$86fbec116b87613f.instance) {
            $b923651d7cbf96a1$export$86fbec116b87613f.instance = new $b923651d7cbf96a1$export$86fbec116b87613f();
            window.app = $b923651d7cbf96a1$export$86fbec116b87613f.instance;
        }
        return $b923651d7cbf96a1$export$86fbec116b87613f.instance;
    }
    async initDatabase() {
        try {
            // Инициализация происходит автоматически при первом обращении
            // Просто проверяем доступность
            await this.boardStorage.getBoard('board_1');
            console.log('Database initialized successfully');
        } catch (error) {
            console.error('Failed to initialize database:', error);
        // Можно показать уведомление пользователю
        }
    }
    setupNetworkListeners() {
        window.addEventListener('online', ()=>{
            console.log('App is online, starting sync...');
            this.syncService.forceSync().catch(console.error);
            (0, $883133d1f570db27$export$bfc40ca370b68e03).networkStatus.emit(true);
        });
        window.addEventListener('offline', ()=>{
            console.log('App is offline');
            (0, $883133d1f570db27$export$bfc40ca370b68e03).networkStatus.emit(false);
        });
    }
    //<editor-fold desc="Методы для работы с фильтрами">
    getFilters() {
        return {
            ...this.listFilters
        };
    }
    setFilterColumn(columnId) {
        this.listFilters.column = columnId;
        (0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated.emit();
    }
    setFilterStatus(status) {
        this.listFilters.status = status;
        (0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated.emit();
    }
    clearFilters() {
        this.listFilters = {
            column: null,
            status: 'all'
        };
        (0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated.emit();
    }
    //</editor-fold>
    //<editor-fold desc="Публичные методы для работы с задачами ">
    async getTaskById(taskId) {
        const board = this.getCurrentBoard();
        return board.tasks.find((t)=>t?.id === taskId) || null;
    }
    // noinspection JSMethodCanBeStatic
    taskDeletePermanently(id) {
        new (0, $689c16ee6fdcea17$export$2e2bcd8739ae039)().deleteTask(id);
        return Promise.resolve();
    }
    async taskUpdateOptimistic(taskId, updates) {
        const board = this.getCurrentBoard();
        const taskIndex = board.tasks.findIndex((t)=>t?.id === taskId);
        if (taskIndex === -1) throw new Error(`Task ${taskId} not found`);
        const original = board.tasks[taskIndex];
        const updatedTask = {
            ...original,
            ...updates,
            boardId: board.id,
            updatedAt: new Date(),
            isSynced: false
        };
        const targetColumnId = updates.columnId || updatedTask.columnId;
        const oldColumnId = original.columnId;
        const newIndex = updates.order || updatedTask.order;
        const isNewColumn = updates.columnId !== original.columnId;
        return this.withOptimisticUpdate(// Асинхронная операция
        async ()=>{
            const savedTask = await this.taskStorage.updateTaskOptimistic(taskId, updates);
            if (!savedTask || !savedTask.task) // noinspection ExceptionCaughtLocallyJS
            throw new Error("Error updating task");
            //	console.log("saved", savedTask.task);
            if (!savedTask.task?.deletedAt) //updated
            board.tasks[taskIndex] = {
                ...savedTask.task,
                boardId: board.id
            };
            return savedTask.task;
        }, // Оптимистичное обновление
        ()=>{
            //console.log("save", original.columnId, updatedTask.columnId, updates);
            board.tasks[taskIndex] = updatedTask;
            if (updatedTask.deletedAt) //task deleted
            delete board.tasks[taskIndex];
            else board.tasks[taskIndex] = updatedTask;
        //console.log("board", board.tasks.map(t => t.title));
        }, // Успешное завершение
        (result)=>{
            this.currentBoardSnapshot = null;
            if (!(updates.columnId !== undefined || updates.order !== undefined)) {
                this.emitBoardUpdate();
                return;
            }
            //need to move task.
            this.taskOrderProcessor.updateTaskPosition(taskId, targetColumnId, newIndex, board.tasks, this.taskStorage).then(()=>{
                // Обновление оперативных кешей
                if (isNewColumn) // Если колонка меняется, обновляем кеши обеих колонок
                this.taskOrderProcessor.invalidateColumns([
                    oldColumnId,
                    targetColumnId
                ]);
                else // Если колонка не меняется, обновляем только один кеш
                this.taskOrderProcessor.invalidateColumn(targetColumnId);
                this.emitBoardUpdate();
                this.setTaskHighlight(updatedTask, true);
            });
        });
    }
    /** Task action can be only on the current board.
	 *
	 * @param columnId
	 * @param title
	 */ async taskCreate(columnId, title) {
        const board = this.getCurrentBoard();
        // Регистрация (новый ID, метки времени и тд)
        const columnTasks = board.tasks.filter((t)=>t.columnId === columnId);
        const order = (0, $7fe9597f067fa1a3$export$4f8e2d3a3828478e).getOrderForNewTask(columnTasks);
        let localId = `local_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const tempTask = {
            ...(0, $fec5f87c8f441fc1$export$416551eec0702b29),
            id: localId,
            localId: localId,
            title: title,
            description: '',
            columnId: columnId,
            boardId: board.id,
            order: order
        };
        // Обновление оперативных данных
        board.tasks.push(tempTask);
        (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
        // Обновление БД (и отправка на синхронизацию)
        try {
            const savedTask = await this.taskStorage.createTask(tempTask);
            //
            // Обновить ID задачи
            const taskIndex = board.tasks.findIndex((t)=>t && t.id === tempTask.id);
            if (taskIndex !== -1) {
                board.tasks[taskIndex] = savedTask;
                let taskId = savedTask.id;
                this.setTaskHighlight(savedTask, true);
            }
            // Отправить сигнал для подсветки и скролла к созданной задаче
            setTimeout(()=>{
                (0, $883133d1f570db27$export$bfc40ca370b68e03).highlightAndScrollToTask.emit({
                    taskId: savedTask.id,
                    columnId: savedTask.columnId,
                    tempId: tempTask.id
                });
            }, 0);
            // Обновление оперативных кешей
            this.taskOrderProcessor.invalidateColumn(columnId);
            (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
            return savedTask;
        } catch (error) {
            // Откат при ошибке
            board.tasks = board.tasks.filter((t)=>t.id !== tempTask.id);
            (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
            throw error;
        }
    }
    setTaskHighlight(task, value) {
        this.taskUi.set(task.id, {
            isHighlighted: value
        });
        if (!value) this.taskUi.delete(task.id);
        (0, $883133d1f570db27$export$bfc40ca370b68e03).taskUpdated.emit(task);
    }
    getTaskHighlight(task) {
        return this.taskUi.get(task.id)?.isHighlighted || false;
    }
    // Алиас для совместимости с TaskAdd компонентом
    async taskAdd(columnId, title) {
        return this.taskCreate(columnId, title);
    }
    async taskMove(taskId, targetColumnId, newIndex) {
        const board = this.getCurrentBoard();
        const task = board.tasks.find((t)=>t.id === taskId);
        if (!task) return Promise.resolve((0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(task));
        const oldColumnId = task.columnId;
        return this.taskUpdateOptimistic(taskId, {
            columnId: targetColumnId,
            order: task.order,
            updatedAt: new Date(),
            isSynced: false
        });
    }
    async taskReorder(taskId, newIndex) {
        return this.taskUpdateOptimistic(taskId, {
            order: newIndex
        });
    //
    // const board = this.getCurrentBoard();
    // const task = board.tasks.find(t => t.id === taskId);
    //
    // if (!task) {
    // 	return;
    // }
    //
    // const columnId = task.columnId;
    //
    // return this.withOptimisticUpdate<void>(
    // 	// Асинхронная операция - обновление БД
    // 	async () => {
    // 		await this.taskStorage.updateTaskOptimistic(taskId, {
    // 			order: task.order,
    // 			updatedAt: new Date(),
    // 			isSynced: false,
    // 		});
    // 	},
    // 	// Оптимистичное обновление - обновление оперативных данных
    // 	async () => {
    // 		// Обновить позицию задачи
    // 		await this.taskOrderProcessor.updateTaskPosition(
    // 			taskId,
    // 			columnId,
    // 			newIndex,
    // 			board.tasks,
    // 			this.taskStorage
    // 		);
    //
    // 		// Обновление оперативных кешей
    // 		this.taskOrderProcessor.invalidateColumn(columnId);
    // 	}
    // );
    }
    //</editor-fold>
    //<editor-fold desc="Публичные методы для работы с колонками">
    async columnAdd(title) {
        const board = this.getCurrentBoard();
        return this.withOptimisticUpdate(// Асинхронная операция
        async ()=>{
            const savedColumn = await this.boardStorage.saveColumn({
                ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)(`col_temp_${Date.now()}`),
                title: title || "\u041D\u043E\u0432\u0430\u044F \u043A\u043E\u043B\u043E\u043D\u043A\u0430",
                order: 0,
                boardId: board.id
            });
            // Обновляем ID колонки в локальном состоянии
            const columnIndex = board.columns.findIndex((c)=>c.id === savedColumn.id);
            if (columnIndex !== -1) board.columns[columnIndex] = savedColumn;
            return savedColumn;
        }, // Оптимистичное обновление
        ()=>{
            // Вычисляем order для новой колонки
            const order = (0, $e452282908266737$export$71ab42719e74e591).getOrderForNewColumn(board.columns);
            // Проверяем, не нужна ли перевыдача
            const columnsWithNewOne = [
                ...board.columns,
                {
                    ...board.columns[0],
                    order: order
                }
            ];
            const needsReorder = (0, $e452282908266737$export$71ab42719e74e591).needsReorder(columnsWithNewOne);
            const finalOrder = needsReorder ? board.columns.length * 10 // Если нужна перевыдача, просто вычисляем по позиции
             : order;
            // Оптимистичное обновление
            const newColumn = {
                ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)(`col_temp_${Date.now()}`),
                title: title || "\u041D\u043E\u0432\u0430\u044F \u043A\u043E\u043B\u043E\u043D\u043A\u0430",
                order: finalOrder,
                boardId: board.id
            };
            board.columns.push(newColumn);
            // Если нужна была перевыдача, делаем её для всех колонок
            if (needsReorder) {
                const redistributed = (0, $e452282908266737$export$71ab42719e74e591).redistributeOrders(board.columns);
                board.columns = redistributed;
            }
            this.editState.hasChanges = true;
        }, // Успешное завершение
        (result)=>{
            this.emitBoardUpdate();
        });
    }
    async columnDelete(columnId) {
        const board = this.getCurrentBoard();
        // Нельзя удалить последнюю колонку
        if (board.columns.length <= 1) throw new Error('Cannot delete the last column');
        return this.withOptimisticUpdate(// Асинхронная операция
        async ()=>{
            // Удаляем колонку из базы
            await this.boardStorage.deleteColumn(columnId);
            // Сохраняем обновленные задачи
            for (const task of board.tasks.filter((t)=>t.columnId === columnId)){
                const targetColumn = board.columns.find((c)=>c.id === task.columnId);
                if (targetColumn) await this.taskStorage.updateTaskOptimistic(task.id, {
                    boardId: board.id,
                    columnId: targetColumn.id,
                    updatedAt: new Date(),
                    isSynced: false
                });
            }
            // Сохраняем обновленные колонки
            for (const col of board.columns)await this.boardStorage.updateColumn(col.id, {
                order: col.order
            });
        }, // Оптимистичное обновление
        ()=>{
            const columnIndex = board.columns.findIndex((c)=>c.id === columnId);
            if (columnIndex === -1) return;
            const column = board.columns[columnIndex];
            // Оптимистичное обновление: перемещаем задачи в предыдущую колонку
            const columnTasks = board.tasks.filter((t)=>t.columnId === column.id);
            if (columnTasks.length > 0) {
                const targetColumnIndex = Math.max(0, columnIndex - 1);
                const targetColumn = board.columns[targetColumnIndex];
                // Обновляем задачи
                columnTasks.forEach((task)=>{
                    task.columnId = targetColumn.id;
                    task.isSynced = false;
                });
            }
            // Удаляем колонку
            board.columns.splice(columnIndex, 1);
            // Перевыдаем порядок колонок с правильным order
            const redistributed = (0, $e452282908266737$export$71ab42719e74e591).redistributeOrders(board.columns);
            board.columns = redistributed;
            this.editState.hasChanges = true;
        });
    }
    //</editor-fold>
    //<editor-fold desc="Методы для синхронизации">
    async getSyncStatus() {
        return this.syncService.getSyncStatus();
    }
    async forceSync() {
        return this.syncService.forceSync();
    }
    //</editor-fold>
    //<editor-fold desc="Геттеры">
    getCurrentBoard() {
        return this.state.currentBoards[this.state.activeBoardIndex];
    }
    getBoardById(boardId) {
        return this.state.currentBoards.find((board)=>board.id === boardId);
    }
    getBoardStorage() {
        return this.boardStorage;
    }
    getTaskStorage() {
        return this.taskStorage;
    }
    getSyncService() {
        return this.syncService;
    }
    getState() {
        return this.state;
    }
    getViewMode() {
        return this.state.viewMode;
    }
    //</editor-fold>
    //<editor-fold desc="Начальное состояние">
    async loadInitialState() {
        const defaultState = {
            viewMode: this.getPreferredViewMode() || (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List,
            activeBoardIndex: 0,
            isLoading: false,
            lastSyncTime: null,
            showFilters: false
        };
        try {
            // Попробуем загрузить реальную доску
            const boards = await this.boardStorage.getAllBoards();
            if (boards.length > 0) {
                const board = await this.boardStorage.getBoard(boards[0].id);
                if (board) //console.log('Loaded board from IndexedDB:', board);
                return {
                    ...defaultState,
                    currentBoards: [
                        board
                    ]
                };
            }
        } catch (error) {
            console.warn('No board found in IndexedDB, creating default board', error);
        }
        // Если нет данных — создаем мок
        const createdBoard = await this.boardStorage.createBoard(this.createMockBoard());
        const starterAppState = {
            ...defaultState,
            currentBoards: [
                createdBoard
            ]
        };
        return starterAppState;
    }
    // Создание тестовой доски
    createMockBoard() {
        let boardId = 'board1';
        const column1 = {
            ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)('col1'),
            title: 'To Do',
            order: 0,
            boardId: boardId
        };
        const column2 = {
            ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)('col2'),
            title: 'In Progress',
            order: 1,
            boardId: boardId
        };
        const tasks = [
            {
                ...(0, $fec5f87c8f441fc1$export$416551eec0702b29),
                ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)(''),
                id: 'task1',
                localId: 'local_1',
                serverId: null,
                title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0431\u0430\u0437\u043E\u0432\u044B\u0439 \u043A\u0430\u0440\u043A\u0430\u0441",
                description: "\u0420\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438 App \u0441\u0438\u043D\u0433\u043B\u0442\u043E\u043D",
                columnId: 'col1'
            },
            {
                ...(0, $fec5f87c8f441fc1$export$416551eec0702b29),
                ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)(''),
                id: 'task2',
                localId: 'local_2',
                title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442",
                description: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ParcelJS \u0438 Tailwind",
                columnId: 'col1'
            },
            {
                ...(0, $fec5f87c8f441fc1$export$416551eec0702b29),
                ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)(''),
                id: 'task3',
                localId: 'local_3',
                title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B",
                description: 'Board, Column, TaskCard',
                columnId: 'col2'
            }
        ].map((task)=>{
            return {
                ...task,
                boardId: boardId
            };
        });
        return {
            ...(0, $9f05ce5269191f7e$export$2eca89e9ac669625)(boardId),
            title: "\u041F\u0440\u043E\u0435\u043A\u0442: \u0414\u043E\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u0447",
            columns: [
                column1,
                column2
            ],
            tasks: tasks,
            isEditing: false,
            updatedAt: new Date(),
            createdAt: new Date()
        };
    }
    //</editor-fold>
    // Публичные сеттеры
    boardSetTitle(title) {
        const board = this.getCurrentBoard();
        const trimmedTitle = title.trim();
        if (!trimmedTitle) throw new Error('Board title cannot be empty');
        if (board.title === trimmedTitle) return;
        // Оптимистичное обновление
        board.title = trimmedTitle;
        // Отмечаем изменения в режиме редактирования
        if (board.isEditing && this.editState.originalBoard) this.editState.hasChanges = true;
        // Эмитируем сигнал обновления доски
        this.emitBoardUpdate();
        // Сохраняем в IndexedDB
        this.saveBoardAfterOperation();
    }
    //<editor-fold desc="Edit mode">
    toggleEditMode() {
        const board = this.getCurrentBoard();
        board.isEditing = !board.isEditing;
    // TODO: Добавить систему сигналов на этапах 2-3
    }
    // Проверка наличия изменений
    hasUnsavedChanges() {
        return this.editState.hasChanges;
    }
    // Получение состояния редактирования
    getEditState() {
        return {
            ...this.editState
        };
    }
    // Вход/выход из режима редактирования
    editModeStart() {
        const board = this.getCurrentBoard();
        //		console.log('Starting edit mode, current board:', board);
        // Сохраняем глубокую копию оригинальной доски
        this.editState.originalBoard = JSON.parse(JSON.stringify(board));
        board.isEditing = true;
        this.editState.hasChanges = false;
        this.editState.isSaving = false;
        //		console.log('Edit state after start:', this.editState);
        (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
    }
    editModeCancel() {
        if (this.editState.isSaving) return;
        const board = this.getCurrentBoard();
        // Восстанавливаем оригинальное состояние
        if (this.editState.originalBoard) {
            const original = this.editState.originalBoard;
            board.columns = original.columns;
            board.tasks = original.tasks;
            board.title = original.title;
        }
        board.isEditing = false;
        this.editState.originalBoard = null;
        this.editState.hasChanges = false;
        (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
    }
    editModeSave() {
        return new Promise((resolve, reject)=>{
            if (this.editState.isSaving) {
                reject(new Error('Already saving'));
                return;
            }
            const board = this.getCurrentBoard();
            this.editState.isSaving = true;
            this.boardStorage.saveBoard(board);
            // Симуляция асинхронного сохранения
            setTimeout(()=>{
                board.isEditing = false;
                this.editState.originalBoard = null;
                this.editState.hasChanges = false;
                this.editState.isSaving = false;
                this.editState.lastSaved = new Date();
                (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit(board);
                resolve();
            }, 500); // Имитация задержки сети
        });
    }
    //</editor-fold>
    //<editor-fold desc="Columns actions">
    async columnMove(fromIndex, toIndex) {
        const board = this.getCurrentBoard();
        if (fromIndex < 0 || fromIndex >= board.columns.length || toIndex < 0 || toIndex >= board.columns.length || fromIndex === toIndex) return;
        return this.withOptimisticUpdate(// Асинхронная операция
        async ()=>{
            // Сохраняем все колонки
            for (const column of board.columns)await this.boardStorage.updateColumn(column.id, {
                order: column.order,
                boardId: board.id
            });
        }, // Оптимистичное обновление
        ()=>{
            // Получаем колонки для вычисления order (без перемещаемой колонки)
            const columnsWithoutMoved = board.columns.filter((_, index)=>index !== fromIndex);
            // Получаем соседние колонки для целевой позиции
            const adjacent = (0, $e452282908266737$export$71ab42719e74e591).getAdjacentColumns(columnsWithoutMoved, toIndex);
            let newOrder = (0, $e452282908266737$export$71ab42719e74e591).getOrderBetweenColumns(adjacent.prevColumn, adjacent.nextColumn);
            // Если нужна перевыдача order
            if (newOrder === -1) {
                // Добавляем колонку в правильную позицию для перевыдачи
                const movedColumn = board.columns[fromIndex];
                const columnsForRedistribution = [
                    ...columnsWithoutMoved
                ];
                columnsForRedistribution.splice(toIndex, 0, movedColumn);
                const redistributed = (0, $e452282908266737$export$71ab42719e74e591).redistributeOrders(columnsForRedistribution);
                newOrder = redistributed.find((c)=>c.id === movedColumn.id)?.order || 0;
                // Обновляем order для всех колонок
                board.columns = redistributed;
            } else {
                // Просто перемещаем колонку и обновляем order
                const [movedColumn] = board.columns.splice(fromIndex, 1);
                movedColumn.order = newOrder;
                board.columns.splice(toIndex, 0, movedColumn);
            }
            this.editState.hasChanges = true;
        });
    }
    /** Метод для переименования колонки
	 * @param columnId
	 * @param newTitle
	 */ async columnRename(columnId, newTitle) {
        const board = this.getCurrentBoard();
        const columnIndex = board.columns.findIndex((col)=>col.id === columnId);
        if (columnIndex === -1) throw new Error(`Column ${columnId} not found`);
        const trimmedTitle = newTitle.trim();
        if (!trimmedTitle) throw new Error('Column title cannot be empty');
        return this.withOptimisticUpdate(// Асинхронная операция
        async ()=>{
            const result = await this.boardStorage.updateColumn(columnId, {
                title: trimmedTitle
            });
            if (!result) throw new Error('Error updating column');
            return result;
        }, // Оптимистичное обновление
        ()=>{
            // Оптимистичное обновление
            const originalColumn = board.columns[columnIndex];
            const updatedColumn = {
                ...originalColumn,
                title: trimmedTitle
            };
            board.columns[columnIndex] = updatedColumn;
        }, // Успешное завершение
        (result)=>{
            this.emitBoardUpdate();
        });
    }
    responsiveInit() {
        // Определяем начальный режим
        this.determineViewMode();
        // Слушаем изменения размера окна
        window.addEventListener('resize', this.handleResize.bind(this));
        // Слушаем изменения ориентации
        window.addEventListener('orientationchange', this.handleOrientationChange.bind(this));
        // Предотвращаем масштабирование на мобильных при двойном тапе
        if (this.responsiveState.touchSupported) document.addEventListener('touchmove', this.preventZoomOnDrag.bind(this), {
            passive: false
        });
    }
    determineViewMode() {
        const width = window.innerWidth;
        // Автоматическое определение режима по ширине экрана
        let newMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
        if (width < 768) newMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List; // По умолчанию список на очень узких экранах
        else newMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns;
        this.setViewMode(newMode, 'auto');
    }
    handleResize() {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        this.responsiveState.screenWidth = newWidth;
        this.responsiveState.screenHeight = newHeight;
        this.responsiveState.isPortrait = newHeight > newWidth;
        // Автоматически переключаем режим при изменении размера (только если в режиме auto)
        if (this.responsiveState.currentViewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns && newWidth < 1024) this.setViewMode((0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List, 'auto');
        else if (this.responsiveState.currentViewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && newWidth >= 1024) this.setViewMode((0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns, 'auto');
        (0, $883133d1f570db27$export$bfc40ca370b68e03).responsiveStateChanged.emit(this.getResponsiveState());
    }
    handleOrientationChange() {
        setTimeout(()=>{
            this.handleResize();
        }, 100);
    }
    preventZoomOnDrag(event) {
        if (event.touches.length > 1) event.preventDefault();
    }
    // Публичные методы для управления режимами
    setViewMode(mode, source = 'manual') {
        if (!this.responsiveState.availableModes.includes(mode)) {
            console.warn(`View mode ${mode} is not available`);
            return;
        }
        this.responsiveState.currentViewMode = mode;
        this.state.viewMode = mode;
        // Сохраняем выбор пользователя в localStorage
        if (source === 'manual') localStorage.setItem('preferredViewMode', mode);
        // Обновляем CSS классы на body для глобальных стилей
        this.updateBodyClasses();
        (0, $883133d1f570db27$export$bfc40ca370b68e03).viewModeChanged.emit(mode);
        (0, $883133d1f570db27$export$bfc40ca370b68e03).responsiveStateChanged.emit(this.getResponsiveState());
    }
    toggleViewMode() {
        const currentIndex = this.responsiveState.availableModes.indexOf(this.responsiveState.currentViewMode);
        const nextIndex = (currentIndex + 1) % this.responsiveState.availableModes.length;
        const nextMode = this.responsiveState.availableModes[nextIndex];
        this.setViewMode(nextMode, 'manual');
    }
    updateBodyClasses() {
        const { currentViewMode: currentViewMode, touchSupported: touchSupported } = this.responsiveState;
        const body = document.body;
        // Удаляем предыдущие классы режимов
        body.classList.remove('view-columns', 'view-list');
        // Добавляем текущий класс режима
        body.classList.add(`view-${currentViewMode}`);
        // Добавляем класс для тач-устройств
        if (touchSupported) body.classList.add('touch-device');
        else body.classList.remove('touch-device');
        // Добавляем класс для ориентации
        if (this.responsiveState.isPortrait) {
            body.classList.add('portrait');
            body.classList.remove('landscape');
        } else {
            body.classList.add('landscape');
            body.classList.remove('portrait');
        }
    }
    getCurrentViewMode() {
        return this.responsiveState.currentViewMode;
    }
    getViewConfig() {
        return (0, $33b90e3c48366ffe$export$fd4d112fcca8c71e)[this.responsiveState.currentViewMode];
    }
    getResponsiveState() {
        return {
            ...this.responsiveState
        };
    }
    isTouchDevice() {
        return this.responsiveState.touchSupported;
    }
    // Метод для получения предпочтительного режима из localStorage
    getPreferredViewMode() {
        const saved = localStorage.getItem('preferredViewMode');
        return saved && this.responsiveState.availableModes.includes(saved) ? saved : null;
    }
    //</editor-fold>
    //<editor-fold desc=" Контроллер редактирования задач">
    getTaskEditController() {
        return this.taskEditController;
    }
    //</editor-fold>
    //<editor-fold desc="Методы для работы с мобильным списком">
    getFilteredTasks(columnId) {
        const board = this.getCurrentBoard();
        const { column: column, status: status } = this.listFilters;
        let tasks = board.tasks;
        // Фильтр по колонке
        if (column) tasks = tasks.filter((task)=>task.columnId === column);
        else if (columnId) tasks = tasks.filter((task)=>task.columnId === columnId);
        // Фильтр по статусу
        if (status === 'unsynced') tasks = tasks.filter((task)=>!task.isSynced);
        else if (status === 'recent') {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            tasks = tasks.filter((task)=>new Date(task.updatedAt) > yesterday);
        }
        // Сортировка по order
        return tasks.sort((a, b)=>a.order - b.order);
    }
    getListStats() {
        const board = this.getCurrentBoard();
        const tasks = board.tasks;
        const total = tasks.length;
        const unsynced = tasks.filter((t)=>!t.isSynced).length;
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const recent = tasks.filter((t)=>new Date(t.updatedAt) > yesterday).length;
        return {
            total: total,
            unsynced: unsynced,
            recent: recent,
            columns: board.columns.length
        };
    }
    setShowFilters(showFilter) {
        this.state.showFilters = showFilter;
        (0, $883133d1f570db27$export$bfc40ca370b68e03).filtersToggled.emit(showFilter);
    }
    //</editor-fold>
    //<editor-fold desc="Методы для экспорта/импорта/очистки данных">
    /**
	 * Экспорт всех данных приложения
	 */ async exportData() {
        const boards = await this.boardStorage.getAllBoards();
        const fullBoards = [];
        for (const board of boards){
            console.log(`Exporting board ${board.id} `);
            fullBoards.push((0, $40de3e02e5c0712c$export$f2db7d5238e1d23f)(await this.boardStorage.getBoard(board.id)));
        }
        const container = {
            version: '1.0',
            timestamp: new Date().toISOString(),
            boards: fullBoards
        };
        return container;
    }
    /**
	 * Импорт данных в приложение
	 * @param importData - данные для импорта
	 */ async importData(importData) {
        if (!importData || !importData.version) throw new Error("\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u0438\u043C\u043F\u043E\u0440\u0442\u0430");
        // Проверяем версию данных
        if (importData.version !== '1.0') throw new Error(`\u{41D}\u{435}\u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{435}\u{43C}\u{430}\u{44F} \u{432}\u{435}\u{440}\u{441}\u{438}\u{44F} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{445}: ${importData.version}. \u{41F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{435}\u{43C}\u{430}\u{44F} \u{432}\u{435}\u{440}\u{441}\u{438}\u{44F}: 1.0`);
        try {
            (0, $4ab65bb78fd818d7$export$2e2bcd8739ae039).getInstance().deleteDatabase();
            (0, $4ab65bb78fd818d7$export$2e2bcd8739ae039).getInstance().createDatabase();
            // Сохраняем доски в хранилище
            for (const board of importData.boards)await this.boardStorage.saveBoard(board);
            window.location.reload();
            // Уведомляем об обновлении
            (0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated.emit();
            (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.emit($b923651d7cbf96a1$export$86fbec116b87613f.getInstance().getCurrentBoard());
        } catch (error) {
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0445:", error);
            throw error;
        }
    }
    /**
	 * Очистка всех данных приложения
	 */ async eraseAllData() {
        try {
            (0, $4ab65bb78fd818d7$export$2e2bcd8739ae039).getInstance().deleteDatabase();
            window.location.reload();
        } catch (error) {
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0447\u0438\u0441\u0442\u043A\u0435 \u0434\u0430\u043D\u043D\u044B\u0445:", error);
            throw error;
        }
    }
}


const $19eb34fed071fd5f$var$AppContext = /*#__PURE__*/ (0, $gIfym.createContext)(null);
const $19eb34fed071fd5f$export$fca13ab91e1a6240 = ()=>{
    const context = (0, $gIfym.useContext)($19eb34fed071fd5f$var$AppContext);
    if (!context) throw new Error('useApp must be used within AppProvider');
    return context;
};
const $19eb34fed071fd5f$export$c7dacf3845253dcf = ({ children: children })=>{
    const [appInstance] = (0, $gIfym.useState)(()=>(0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance());
    const contextValue = {
        app: appInstance
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($19eb34fed071fd5f$var$AppContext.Provider, {
        value: contextValue,
        children: children
    });
};




var $gIfym = parcelRequire("gIfym");



const $24374de5e71514a4$export$4f13f83fd8bb1dac = {
    Search: "\uD83D\uDD0D",
    Close: "\xd7",
    Add: '+',
    Sync: "\u21BB",
    Synced: "\u2713",
    Checked: "\u2713",
    Local: "\uD83D\uDCBE",
    Attachment: "\uD83D\uDCCE",
    Comment: "\uD83D\uDCAC",
    User: "\uD83D\uDC64",
    Menu: "\u22EE",
    Edit: "\u270E",
    EditDoc: "\uD83D\uDCDD",
    Delete: "\xd7",
    Save: "\uD83D\uDCBE",
    Back: "\u2190",
    Settings: "\u2699\uFE0F",
    Columns: "\uD83D\uDCF1",
    List: "\uD83D\uDCF2",
    Desktop: "\uD83D\uDDA5\uFE0F",
    Expand: "\u25BC",
    Collapse: "\u25B2",
    ChevronDown: "\u25BC",
    ChevronUp: "\u25B2",
    ChevronRight: "\u25B6",
    ChevronLeft: "\u25C0",
    ArrowLeft: "\u2190",
    ArrowRight: "\u2192"
};




var $gIfym = parcelRequire("gIfym");





var $gIfym = parcelRequire("gIfym");




var $gIfym = parcelRequire("gIfym");



// src/utils/BackButtonHandler.ts

class $1923c571a553c258$export$b9a4112f38f18035 {
    constructor(){
        this.handlers = [] // Возвращает true если нужно прервать навигацию
        ;
        this.isAndroid = /Android/i.test(navigator.userAgent);
        this.lastBackButtonPress = 0;
        // Сигнал для уведомлений
        this.toastSignal = new (0, $9b26b9646341d616$export$8210dfe1863c478)("/back-button/toast");
        this.handlePopState = (event)=>{
            //		console.log("pop state");
            let isHandled = false;
            // Проверяем все обработчики
            for (const handler of this.handlers){
                handler();
                isHandled = true;
            }
            setTimeout(()=>{
                // Добавляем новую запись в историю, чтобы избежать закрытия приложения
                history.pushState({
                    backButtonHandled: true,
                    initial: false
                }, '', window.location.href + "#back" + Date.now());
            }, 10);
            const lookit = window.history;
            const state = lookit.state;
            if (isHandled) return false;
            // Проверяем, был ли последний раз нажата кнопка "назад" менее 2 секунд назад
            const currentTime = new Date().getTime();
            const timeDifference = currentTime - (this.lastBackButtonPress || 0);
            if (timeDifference < 2000) ;
            else {
                // Первое нажатие - показываем сообщение пользователю
                this.showToast("\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 \u0434\u043B\u044F \u0432\u044B\u0445\u043E\u0434\u0430");
                this.lastBackButtonPress = currentTime;
            }
            // // ВАЖНО: Всегда добавляем новую запись в историю, чтобы гарантировать,
            // // что мы никогда не достигнем начальной точки и приложение не закроется
            // setTimeout(()=> {
            // 	history.pushState({backButtonHandled: true, initial: false}, '', window.location.href);
            // }, 10);
            return false;
        };
        if (this.isAndroid) this.init();
    }
    static getInstance() {
        if (!$1923c571a553c258$export$b9a4112f38f18035.instance) $1923c571a553c258$export$b9a4112f38f18035.instance = new $1923c571a553c258$export$b9a4112f38f18035();
        return $1923c571a553c258$export$b9a4112f38f18035.instance;
    }
    init() {
        //console.log("init");
        window.addEventListener('popstate', this.handlePopState);
        // Используем history.pushState для создания истории.
        // Добавляем начальную запись в историю, чтобы предотвратить закрытие приложения.
        if (history.state === null) history.replaceState({
            backButtonHandled: true,
            initial: true
        }, '', window.location.href);
        else // Проверяем, есть ли уже метка backButtonHandled в текущем состоянии
        if (!history.state?.backButtonHandled) // Если нет, добавляем её
        history.replaceState({
            ...history.state,
            backButtonHandled: true,
            initial: false
        }, '', window.location.href);
        else // Если уже есть, просто добавляем новую запись для дополнительной защиты
        history.pushState({
            backButtonHandled: true,
            initial: false
        }, '', window.location.href);
        // Добавляем обработчик для каждого изменения состояния истории,
        // чтобы гарантировать, что всегда есть хотя бы одна запись
        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;
        history.pushState = (...args)=>{
            originalPushState.apply(history, args);
            // Убедимся, что у нас всегда есть хотя бы одна запись с меткой
            if (!history.state?.backButtonHandled) history.replaceState({
                ...history.state,
                backButtonHandled: true,
                initial: false
            }, '', window.location.href);
        };
        history.replaceState = (...args)=>{
            originalReplaceState.apply(history, args);
            // Убедимся, что у нас всегда есть хотя бы одна запись с меткой
            if (!history.state?.backButtonHandled) history.replaceState({
                ...history.state,
                backButtonHandled: true,
                initial: false
            }, '', window.location.href);
        };
    }
    showToast(message) {
        // Показываем уведомление через сигнал
        this.toastSignal.emit({
            message: message,
            show: true
        });
        // Через 2 секунды скрываем уведомление
        setTimeout(()=>{
            this.toastSignal.emit({
                message: '',
                show: false
            });
        }, 2000);
    }
    /**
     * Регистрирует обработчик кнопки "Назад"
     * @param handler Функция, возвращающая true если нужно прервать навигацию
     * @returns Функция для отмены регистрации
     */ register(handler) {
        this.handlers.push(handler);
        return ()=>{
            const index = this.handlers.indexOf(handler);
            if (index > -1) this.handlers.splice(index, 1);
        };
    }
    /**
     * Для ситуаций, когда нужно имитировать нажатие кнопки "Назад"
     */ triggerBack() {
        window.dispatchEvent(new PopStateEvent('popstate', {
            state: null
        }));
    }
    dispose() {
        //console.log("dispose");
        window.removeEventListener('popstate', this.handlePopState);
        this.handlers = [];
    }
}


class $32e8693be7508bbb$export$8eed1b9046569dcd extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.classBlock = 'task-editor-core', this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef(), this.actionsRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef(), this.ref = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef(), this.backButtonUnregister = null, // ==================== ARROW METHODS (коллбэки) ====================
        this.handleInputChange = (e)=>{
            this.setState({
                title: e.target.value
            }, this.updateTextareaHeight);
        }, this.handleKeyDown = (e)=>{
            if (e.key === 'Escape' && this.props.onCancel) {
                e.preventDefault();
                this.props.onCancel();
            } else if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                this.handleSubmit();
            }
        }, this.handleCancelEdit = ()=>{
            this.close(false, ()=>{
                this.props.onCancel?.();
            });
        }, this.handleSubmit = async ()=>{
            const { title: title, isSaving: isSaving } = this.state;
            const { onSubmit: onSubmit } = this.props;
            if (!title.trim() || isSaving) return;
            this.setState({
                isSaving: true
            });
            try {
                await onSubmit(title.trim());
            } catch (error) {
                console.error('Error saving task:', error);
            } finally{
                this.setState({
                    isSaving: false
                });
                this.close(false);
            }
        }, this.handleDelete = async ()=>{
            const { isSaving: isSaving } = this.state;
            const { onDelete: onDelete } = this.props;
            if (!onDelete || isSaving) return;
            try {
                await onDelete();
            } catch (error) {
                console.error('Error deleting task:', error);
            } finally{
                this.close(true);
            }
        }, this.handleMoveTask = async (targetColumnId)=>{
            const { taskId: taskId, onCancel: onCancel } = this.props;
            const { title: title, isSaving: isSaving } = this.state;
            if (!taskId || isSaving || targetColumnId === this.props.columnId) return;
            this.setState({
                isSaving: true
            });
            const app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
            const runMoveTask = (result)=>{
                // Перемещаем задачу в начало целевой колонки (newIndex = 0)
                return app.taskMove(taskId, targetColumnId, 0);
            };
            const updates = {
                id: taskId,
                title: title.trim()
            };
            try {
                if (!app.getTaskEditController().isChanged(updates)) runMoveTask({});
                else await app.getTaskEditController().updateTask(updates).then(runMoveTask);
                // Закрываем редактор после успешного перемещения
                if (onCancel) {
                    onCancel();
                    this.close(false);
                }
            } catch (error) {
                console.error('Error moving task:', error);
            } finally{
                this.setState({
                    isSaving: false,
                    showActions: false,
                    showMoveMenu: false
                });
                this.close(false);
            }
        }, this.handleActionsToggle = ()=>{
            this.setState((prevState)=>({
                    showActions: !prevState.showActions,
                    showMoveMenu: false
                }));
        }, this.handleClickOutside = (event)=>{
            const actionsElement = this.actionsRef.current;
            const isClickInside = actionsElement && actionsElement.contains(event.target);
            if (!isClickInside) this.setState({
                showActions: false
            });
        };
        this.state = {
            title: props.initialTitle,
            isSaving: false,
            showActions: false,
            showMoveMenu: true
        };
    }
    // ==================== LIFECYCLE METHODS ====================
    componentDidMount() {
        const current = this.inputRef.current;
        if (this.props.autoFocus && current) current?.focus();
        this.checkCurrentColumn();
        document.addEventListener('mousedown', this.handleClickOutside);
        setTimeout(()=>this.updateTextareaHeight(), 0); // На следующий тик, после рендера
        this.backButtonUnregister = (0, $1923c571a553c258$export$b9a4112f38f18035).getInstance().register(()=>{
            // Всегда обрабатываем нажатие кнопки "назад", чтобы предотвратить закрытие приложения
            if (this.props.onCancel) this.handleCancelEdit();
            else // Если onCancel не определен, просто закрываем редактор
            this.close(false);
            return true; // Всегда возвращаем true, чтобы предотвратить стандартное поведение
        });
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        // Отписываемся от обработчика кнопки "назад"
        if (this.backButtonUnregister) {
            this.backButtonUnregister();
            this.backButtonUnregister = null;
        }
    }
    // ==================== REGULAR METHODS (вспомогательные) ====================
    updateTextareaHeight() {
        if (this.inputRef.current) {
            const input = this.inputRef.current;
            input.style.height = 'auto';
            input.style.height = `${input.scrollHeight}px`;
        }
    }
    checkCurrentColumn() {
        // Проверяем, есть ли текущая колонка задачи
        const { columnId: columnId, app: app } = this.props;
        if (!columnId) return;
        const board = this.getBoard();
        const columnExists = board.columns.some((col)=>col.id === columnId);
        if (!columnExists) console.warn(`Column ${columnId} not found in current board`);
    }
    getBoard() {
        const board = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getBoardById(this.props.boardId);
        if (!board) throw Error(`Board '${this.props.boardId}' not found`);
        return board;
    }
    getInputClassName() {
        const { inputClassName: inputClassName } = this.props;
        const classElement = `${this.classBlock}__input`;
        const customClass = inputClassName || '';
        return `${classElement} ${customClass}`.trim();
    }
    getSaveButtonClassName() {
        const { isSaving: isSaving } = this.state;
        const classElement = `${this.classBlock}__save-button`;
        const classSaving = isSaving ? `${classElement}--saving` : '';
        return `${classElement} ${classSaving}`.trim();
    }
    renderActions() {
        const { isSaving: isSaving, showMoveMenu: showMoveMenu } = this.state;
        const { mode: mode } = this.props;
        const classBlock = this.classBlock;
        const classActions = `${classBlock}__actions`;
        const classToggle = `${classBlock}__actions-toggle`;
        const classDropdown = `${classBlock}__actions-dropdown`;
        const classActionItem = `${classBlock}__action-item`;
        const classMoveItem = `${classActionItem}--move`;
        const classDelete = `${classActionItem}--delete`;
        const classDivider = `${classBlock}__divider`;
        //if (mode !== 'edit') return null;
        let divider = /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: classDivider
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classActions,
            ref: this.actionsRef,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                    className: classToggle,
                    onClick: this.handleActionsToggle,
                    "aria-label": "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
                    type: "button",
                    disabled: isSaving,
                    children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Menu
                }),
                this.state.showActions && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: classDropdown,
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
                        className: `${classActionItem} ${classDelete}`,
                        onClick: this.handleDelete,
                        disabled: isSaving,
                        type: "button",
                        children: [
                            (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Delete,
                            " \u0410\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C"
                        ]
                    })
                })
            ]
        });
    }
    renderFloatingActions() {
        const { isSaving: isSaving } = this.state;
        const { columnId: columnId } = this.props;
        const actionDelete = /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "task-editor-core__actions-row",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
                    className: "task-editor-core__delete-button",
                    onClick: this.handleDelete,
                    disabled: isSaving,
                    type: "button",
                    children: [
                        (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Delete,
                        " \u0410\u0440\u0445\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443"
                    ]
                })
            })
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "task-editor-core__floating-actions",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "task-editor-core__columns-row",
                children: this.renderButtonsMoveTo()
            })
        });
    }
    renderButtonsMoveTo() {
        const { isSaving: isSaving } = this.state;
        const { columnId: columnId } = this.props;
        const board = this.getBoard();
        const columns = board.columns || [];
        const classElement = `task-editor-core__column-button`;
        return columns.map((column)=>{
            const isCurrent = column.id === columnId;
            const classCurrent = isCurrent ? `${classElement}--current` : '';
            const handleClick = isCurrent ? undefined : ()=>this.handleMoveTask(column.id);
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
                type: "button",
                className: `${classElement} ${classCurrent}`,
                onClick: handleClick,
                disabled: isSaving || isCurrent,
                title: isCurrent ? "\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u043A\u043E\u043B\u043E\u043D\u043A\u0430" : `\u{421}\u{43E}\u{445}\u{440}\u{430}\u{43D}\u{438}\u{442}\u{44C} \u{438} \u{43F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432} "${column.title}"`,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        className: `${classElement}-text`,
                        children: column.title
                    }),
                    isCurrent && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        className: `${this.classBlock}__current-indicator`,
                        children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Checked
                    })
                ]
            }, column.id);
        });
    }
    renderMoveMenu() {
        const { isSaving: isSaving, showMoveMenu: showMoveMenu } = this.state;
        const { columnId: columnId, app: app } = this.props;
        const classBlock = this.classBlock;
        const classSubmenu = `${classBlock}__submenu`;
        const classMoveItem = `${classBlock}__move-item`;
        const classCurrent = `${classMoveItem}--current`;
        const classDivider = `${classBlock}__divider`;
        if (!columnId) return null;
        const board = this.getBoard();
        const columns = board.columns || [];
        // Фильтруем колонки, исключая текущую
        const otherColumns = columns.filter((column)=>column.id !== columnId);
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {
            children: [
                otherColumns.length > 0 ? otherColumns.map((column)=>{
                    const handleClick = ()=>this.handleMoveTask(column.id);
                    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        className: classMoveItem,
                        onClick: handleClick,
                        disabled: isSaving,
                        type: "button",
                        title: `\u{41F}\u{435}\u{440}\u{435}\u{43C}\u{435}\u{441}\u{442}\u{438}\u{442}\u{44C} \u{432} "${column.title}"`,
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                            children: column.title
                        })
                    }, column.id);
                }) : /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: classMoveItem,
                    style: {
                        opacity: 0.6,
                        cursor: 'default'
                    },
                    children: "\u041D\u0435\u0442 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043E\u043B\u043E\u043D\u043E\u043A"
                }),
                columns.length > 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: classDivider
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: `${classMoveItem} ${classCurrent}`,
                            style: {
                                opacity: 0.6
                            },
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
                                    children: [
                                        "\u0422\u0435\u043A\u0443\u0449\u0430\u044F: ",
                                        columns.find((c)=>c.id === columnId)?.title || "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                    children: "\u2713"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    renderHeader() {
        const { mode: mode, actionsPosition: actionsPosition } = this.props;
        if (actionsPosition !== 'header' || mode !== 'edit') return null;
        const classElement = `${this.classBlock}__header`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: classElement,
            children: this.renderActions()
        });
    }
    renderContent() {
        const { title: title, isSaving: isSaving } = this.state;
        const { placeholder: placeholder } = this.props;
        const classElement = `${this.classBlock}__content`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: classElement,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("textarea", {
                ref: this.inputRef,
                value: title,
                onChange: this.handleInputChange,
                onKeyDown: this.handleKeyDown,
                placeholder: placeholder,
                className: this.getInputClassName(),
                disabled: isSaving,
                rows: 1
            })
        });
    }
    renderControls() {
        const { title: title, isSaving: isSaving } = this.state;
        const { mode: mode, onCancel: onCancel, showCancelButton: showCancelButton, hintText: hintText, actionsPosition: actionsPosition } = this.props;
        const classBlock = this.classBlock;
        const classControls = `${classBlock}__controls`;
        const classButtons = `${classBlock}__buttons`;
        const classCancel = `${classBlock}__cancel-button`;
        const classHint = `${classBlock}__hint`;
        const classSavingIndicator = `${classBlock}__saving-indicator`;
        const classSpinner = `${classBlock}__spinner`;
        const classSavingText = `${classBlock}__saving-text`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classControls,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: classButtons,
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            onClick: this.handleSubmit,
                            disabled: isSaving || !title.trim(),
                            className: this.getSaveButtonClassName(),
                            "aria-label": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443",
                            type: "button",
                            children: isSaving ? /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                className: classSavingIndicator,
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: classSpinner
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                        className: classSavingText,
                                        children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..."
                                    })
                                ]
                            }) : "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"
                        }),
                        showCancelButton && onCancel && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            onClick: this.handleCancelEdit,
                            disabled: isSaving,
                            className: classCancel,
                            "aria-label": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
                            type: "button",
                            children: "\u041E\u0442\u043C\u0435\u043D\u0430"
                        }),
                        actionsPosition === 'footer' && mode === 'edit' && this.renderActions()
                    ]
                }),
                hintText && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: classHint,
                    children: hintText
                })
            ]
        });
    }
    // ==================== RENDER METHOD ====================
    render() {
        const { mode: mode, className: className } = this.props;
        const baseClass = this.classBlock;
        const customClass = className || '';
        const dataMode = `data-mode="${mode}"`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            ref: this.ref,
            className: `${baseClass} ${customClass}`.trim(),
            [dataMode.split('=')[0]]: mode,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "task-editor-core__main",
                    children: [
                        this.renderHeader(),
                        this.renderContent(),
                        this.renderControls()
                    ]
                }),
                mode === 'edit' && this.renderFloatingActions()
            ]
        });
    }
    // noinspection JSMethodCanBeStatic
    getAnimationSpeed(element) {
        if (!element) return 200;
        const speedValue = getComputedStyle(element).getPropertyValue('--editor-animation-speed').trim();
        // Проверяем единицы измерения
        if (speedValue.endsWith('ms')) return parseFloat(speedValue); // уже в миллисекундах
        else if (speedValue.endsWith('s')) return parseFloat(speedValue) * 1000; // конвертируем в мс
        else // Без единиц - предполагаем секунды
        return parseFloat(speedValue || '0.3') * 1000;
    }
    /** Run animation and wait , after that run close action.
	 *
	 * @private
	 */ close(isDeleted, afterAction = null) {
        this.ref.current?.classList.add("task-editor-core--exiting");
        setTimeout(()=>{
            this.props.onClose?.(isDeleted);
            afterAction?.();
        }, this.getAnimationSpeed(this.ref.current));
    }
}




const $f442743f362fb998$var$messages = {
    "title_placeholder": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438...",
    "hint": "Enter \u2014 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C, Esc \u2014 \u043E\u0442\u043C\u0435\u043D\u0430",
    "button_caption": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443"
};
class $f442743f362fb998$var$TaskAdd extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), // ✅ Стрелочные функции (коллбэки/обработчики)
        this.handleSubmit = async (title)=>{
            this.setState({
                isAdding: false
            });
            try {
                await (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().taskAdd(this.props.columnId, title.trim());
                (0, $883133d1f570db27$export$bfc40ca370b68e03).cancelTaskAdd.emit(this.props.columnId);
                if (this.props.onTaskAdded) this.props.onTaskAdded();
            } catch (error) {
                console.error('Error creating task:', error);
                throw error;
            }
        }, this.handleCancel = ()=>{
            this.setState({
                isAdding: false
            });
            (0, $883133d1f570db27$export$bfc40ca370b68e03).cancelTaskAdd.emit(this.props.columnId);
            if (this.props.onCancel) this.props.onCancel();
        }, this.startAdding = ()=>{
            this.setState({
                isAdding: true
            });
        };
        this.state = {
            isAdding: false
        };
    //		console.log("construct", props.columnId);
    }
    // ✅ Обычные методы (вызываются напрямую)
    renderAddButton() {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
            onClick: this.startAdding,
            className: "task-add__button",
            "aria-label": $f442743f362fb998$var$messages.button_caption,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("svg", {
                    className: "task-add__button-icon",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M12 4v16m8-8H4"
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: "task-add__button-text",
                    children: $f442743f362fb998$var$messages.button_caption
                })
            ]
        });
    }
    renderTaskEditor() {
        const { autoFocus: autoFocus = true, showCancel: showCancel = true } = this.props;
        const isModalMode = false; // this.props.onTaskAdded !== undefined;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $32e8693be7508bbb$export$8eed1b9046569dcd), {
            boardId: this.props.boardId,
            mode: "add",
            initialTitle: "",
            onSubmit: this.handleSubmit,
            onCancel: this.handleCancel,
            autoFocus: true,
            showCancelButton: showCancel,
            className: "task-editor-core--add",
            inputClassName: "task-editor-core__input--add",
            placeholder: $f442743f362fb998$var$messages.title_placeholder,
            hintText: $f442743f362fb998$var$messages.hint
        });
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        //console.log("update add", this.props.columnId, nextState.isAdding);
        return true;
    }
    // ✅ Lifecycle методы (обычные, как определено React)
    componentDidMount() {
        this.unsubscribe = (0, $883133d1f570db27$export$bfc40ca370b68e03).activateTaskAdd.subscribe((payloadColumnId)=>{
            if (payloadColumnId !== this.props.columnId) return;
            this.setState({
                isAdding: true
            });
        });
    //console.log("mount add", this.props.columnId, this.state.isAdding);
    }
    componentWillUnmount() {
        //		console.log("unmount", this.props.columnId);
        if (this.unsubscribe) this.unsubscribe();
    }
    // ✅ Обычный метод рендеринга (вызывается только React)
    render() {
        const { isAdding: isAdding } = this.state;
        const { onTaskAdded: onTaskAdded } = this.props;
        const isModalMode = false; // onTaskAdded !== undefined;
        const showAddButton = !isModalMode && !isAdding;
        //console.log("render add", this.props.columnId, isAdding);
        if (showAddButton) {
            //console.log("mode", App.getInstance().getViewMode());
            if ((0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getViewMode() === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) return null;
            return this.renderAddButton();
        }
        return this.renderTaskEditor();
    }
}
var $f442743f362fb998$export$2e2bcd8739ae039 = $f442743f362fb998$var$TaskAdd;




var $gIfym = parcelRequire("gIfym");






var $gIfym = parcelRequire("gIfym");




var $gIfym = parcelRequire("gIfym");

class $a5e408917c052157$export$ed2437e464510be2 extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.portalContainer = null, this.resizeObserver = null, this.componentMounted = false, this.updatePosition = ()=>{
            if (!this.props.enabled || !this.portalContainer) return;
            const targetElement = this.getTargetElement();
            if (!targetElement) return;
            const rect = targetElement.getBoundingClientRect();
            this.setState({
                portalStyle: {
                    position: 'fixed',
                    top: `${rect.top}px`,
                    left: `${rect.left}px`,
                    width: `${rect.width}px`,
                    minWidth: `${rect.width}px`,
                    pointerEvents: 'auto'
                }
            });
        };
        this.placeholderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef();
        this.state = {
            portalStyle: {}
        };
    }
    getTargetElement() {
        if (this.props.targetRef?.current) return this.props.targetRef.current;
        return this.placeholderRef.current;
    }
    setupObservers() {
        if (!this.props.enabled) return;
        const targetElement = this.getTargetElement();
        if (!targetElement) return;
        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.updatePosition);
            this.resizeObserver.observe(targetElement);
        }
        window.addEventListener('scroll', this.updatePosition);
        window.addEventListener('resize', this.updatePosition);
    }
    cleanupObservers() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        window.removeEventListener('scroll', this.updatePosition);
        window.removeEventListener('resize', this.updatePosition);
    }
    createPortalContainer() {
        if (this.portalContainer) return;
        const container = document.createElement('div');
        container.className = 'portal-wrapper-container';
        const style = container.style;
        style.position = 'fixed';
        style.top = '0';
        style.left = '0';
        style.width = '0';
        style.height = '0';
        style.zIndex = '1000';
        style.pointerEvents = 'none';
        document.body.appendChild(container);
        this.portalContainer = container;
    }
    removePortalContainer() {
        if (!this.portalContainer) return;
        this.cleanupObservers();
        if (this.portalContainer.parentNode) this.portalContainer.parentNode.removeChild(this.portalContainer);
        this.portalContainer = null;
    }
    componentDidMount() {
        this.componentMounted = true;
        if (this.props.enabled) {
            this.createPortalContainer();
            // Ждем следующего тика для вычисления позиции
            setTimeout(()=>{
                if (this.componentMounted) {
                    this.updatePosition();
                    this.setupObservers();
                }
            }, 0);
        }
    }
    componentDidUpdate(prevProps) {
        // Если enabled изменился
        if (prevProps.enabled !== this.props.enabled) {
            if (this.props.enabled) {
                this.createPortalContainer();
                setTimeout(()=>{
                    if (this.componentMounted) {
                        this.updatePosition();
                        this.setupObservers();
                    }
                }, 0);
            } else {
                this.removePortalContainer();
                this.setState({
                    portalStyle: {}
                });
            }
        } else if (prevProps.targetRef !== this.props.targetRef && this.props.enabled) {
            this.cleanupObservers();
            setTimeout(()=>{
                if (this.componentMounted) {
                    this.updatePosition();
                    this.setupObservers();
                }
            }, 0);
        }
    }
    componentWillUnmount() {
        this.componentMounted = false;
        this.removePortalContainer();
    }
    render() {
        const { children: children, className: className = '', style: style = {}, enabled: enabled = true, targetRef: targetRef } = this.props;
        const { portalStyle: portalStyle } = this.state;
        if (!enabled) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: className + " portal-body",
            style: style,
            children: children
        });
        // Рендерим placeholder только если НЕ передан targetRef
        const shouldRenderPlaceholder = !targetRef;
        // Рендерим контент в портал если есть контейнер
        const portalContent = this.portalContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c4a08725a78d51bf$exports))).createPortal(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: className + " portal-content",
            style: {
                ...style,
                ...portalStyle
            },
            children: children
        }), this.portalContainer) : null;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                shouldRenderPlaceholder && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    ref: this.placeholderRef,
                    className: className + " portal-placeholder",
                    style: {
                        ...style,
                        visibility: 'hidden',
                        pointerEvents: 'none',
                        position: 'relative'
                    },
                    "aria-hidden": "true"
                }),
                portalContent
            ]
        });
    }
}


const $3cc2bb8914708843$var$InlineTaskEditor = (props)=>{
    const handleDelete = (0, $gIfym.useCallback)(async ()=>{
        try {
            await (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getTaskEditController().deleteTask();
            props.onClose(true);
        } catch (error) {
            console.error('Error deleting task:', error);
        }
    }, [
        props.onClose
    ]);
    const handleSubmit = (0, $gIfym.useCallback)(async (title)=>{
        if (!title.trim()) return;
        await props.onSave(title.trim());
    }, [
        props.onSave
    ]);
    const handleClose = (0, $gIfym.useCallback)((isDeleted)=>{
        props.onClose(isDeleted);
    }, [
        props.onClose
    ]);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $a5e408917c052157$export$ed2437e464510be2), {
        enabled: true,
        className: "editor-portal",
        targetRef: props.cardRef,
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $32e8693be7508bbb$export$8eed1b9046569dcd), {
            mode: "edit",
            initialTitle: props.task.title,
            onSubmit: handleSubmit,
            onClose: handleClose,
            onCancel: ()=>props.onClose(false),
            onDelete: handleDelete,
            autoFocus: true,
            showCancelButton: true,
            className: "task-editor-core--inline",
            inputClassName: "task-editor-core__input--inline",
            actionsPosition: "footer",
            columnId: props.task.columnId,
            boardId: props.task.boardId,
            taskId: props.task.id
        })
    });
};
var $3cc2bb8914708843$export$2e2bcd8739ae039 = $3cc2bb8914708843$var$InlineTaskEditor;


class $fe28be021e8e0b0d$export$cc74486daaaef499 {
    static getInstance(compatibility) {
        if (!$fe28be021e8e0b0d$export$cc74486daaaef499.instance) $fe28be021e8e0b0d$export$cc74486daaaef499.instance = new $fe28be021e8e0b0d$export$cc74486daaaef499(compatibility);
        return $fe28be021e8e0b0d$export$cc74486daaaef499.instance;
    }
    constructor(compatibility){
        // Track dragging state to block pull-to-refresh
        this.isDraggingActive = false;
        this.draggableHandlers = new Map();
        this.globalHandlers = {};
        this.isGlobalListening = false;
        // ========== EVENT HANDLERS ==========
        // Pointer Events - стрелочные функции, получают элемент из e.currentTarget
        this.handlePointerDown = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            e.preventDefault();
            e.stopPropagation();
            handlers.onPointerDown?.(e);
            // Также вызываем mouse/touch обработчики для совместимости
            if (e.pointerType === 'mouse') this.handleMouseDown(e);
            else if (e.pointerType === 'touch') this.handleTouchStart(e);
        };
        this.handlePointerMove = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onPointerMove?.(e);
        };
        this.handlePointerUp = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onPointerUp?.(e);
        };
        this.handlePointerCancel = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onPointerCancel?.(e);
        };
        // Mouse Events
        this.handleMouseDown = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            if (e.button === 0) {
                e.preventDefault();
                e.stopPropagation();
            }
            handlers.onMouseDown?.(e);
        };
        this.handleMouseMove = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onMouseMove?.(e);
        };
        this.handleMouseUp = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onMouseUp?.(e);
        };
        this.handleMouseLeave = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onMouseLeave?.(e);
        };
        // Touch Events
        this.handleTouchStart = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            e.stopPropagation();
            handlers.onTouchStart?.(e);
        };
        this.handleTouchMove = (e)=>{
            // Block pull-to-refresh during DnD
            if (this.isDraggingActive && e.cancelable) e.preventDefault();
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onTouchMove?.(e);
        };
        this.handleTouchEnd = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onTouchEnd?.(e);
        };
        this.handleTouchCancel = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onTouchCancel?.(e);
        };
        // Дополнительные события
        this.handleClick = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            handlers.onClick?.(e);
        };
        this.handleContextMenu = (e)=>{
            const element = e.currentTarget;
            if (!this.draggableHandlers.has(element)) return;
            const handlers = this.draggableHandlers.get(element);
            e.preventDefault();
            e.stopPropagation();
            handlers.onContextMenu?.(e);
        };
        // Глобальные обработчики - они не привязаны к конкретному элементу
        this.handleGlobalPointerMove = (e)=>{
            this.globalHandlers.onPointerMove?.(e);
        };
        this.handleGlobalPointerUp = (e)=>{
            this.globalHandlers.onPointerUp?.(e);
        };
        this.handleGlobalPointerCancel = (e)=>{
            this.globalHandlers.onPointerCancel?.(e);
        };
        this.handleGlobalMouseMove = (e)=>{
            this.globalHandlers.onMouseMove?.(e);
        };
        this.handleGlobalMouseUp = (e)=>{
            this.globalHandlers.onMouseUp?.(e);
        };
        this.handleGlobalTouchMove = (e)=>{
            // Block pull-to-refresh during DnD
            if (this.isDraggingActive && e.cancelable) e.preventDefault();
            this.globalHandlers.onTouchMove?.(e);
        };
        this.handleGlobalTouchEnd = (e)=>{
            this.globalHandlers.onTouchEnd?.(e);
        };
        this.handleGlobalTouchCancel = (e)=>{
            this.globalHandlers.onTouchCancel?.(e);
        };
        this.compatibility = compatibility || {};
        this.hasPointerEvents = 'PointerEvent' in window;
        this.hasTouchEvents = 'ontouchstart' in window;
        if (this.compatibility.usePointerEvents !== undefined) this.hasPointerEvents = this.compatibility.usePointerEvents;
    }
    /**
	 * Update dragging state for pull-to-refresh blocking
	 * TODO: Make this configurable via compatibility settings
	 */ setDraggingState(isActive) {
        this.isDraggingActive = isActive;
        // Re-register touchmove with correct passive option
        // passive: false is required for preventDefault() to work
        if (this.hasTouchEvents) this.updateGlobalTouchMoveListener();
    }
    /**
	 * Регистрация обработчиков для draggable элемента
	 */ registerDraggable(element, handlers) {
        this.draggableHandlers.set(element, handlers);
        if (this.hasPointerEvents) {
            // Pointer Events (универсальные) - одна функция на все элементы
            element.addEventListener('pointerdown', this.handlePointerDown);
            element.addEventListener('pointermove', this.handlePointerMove);
            element.addEventListener('pointerup', this.handlePointerUp);
            element.addEventListener('pointercancel', this.handlePointerCancel);
        } else {
            // Fallback: раздельные mouse и touch события
            element.addEventListener('mousedown', this.handleMouseDown);
            element.addEventListener('mousemove', this.handleMouseMove);
            element.addEventListener('mouseup', this.handleMouseUp);
            element.addEventListener('mouseleave', this.handleMouseLeave);
            if (this.hasTouchEvents) {
                const passive = this.compatibility.passiveEvents !== false;
                element.addEventListener('touchstart', this.handleTouchStart, {
                    passive: passive
                });
                element.addEventListener('touchmove', this.handleTouchMove, {
                    passive: passive
                });
                element.addEventListener('touchend', this.handleTouchEnd);
                element.addEventListener('touchcancel', this.handleTouchCancel);
            }
        }
        // Дополнительные обработчики
        element.addEventListener('click', this.handleClick);
        element.addEventListener('contextmenu', this.handleContextMenu);
    }
    /**
	 * Удаление обработчиков для draggable элемента
	 */ unregisterDraggable(element) {
        if (!this.draggableHandlers.has(element)) return;
        if (this.hasPointerEvents) {
            element.removeEventListener('pointerdown', this.handlePointerDown);
            element.removeEventListener('pointermove', this.handlePointerMove);
            element.removeEventListener('pointerup', this.handlePointerUp);
            element.removeEventListener('pointercancel', this.handlePointerCancel);
        } else {
            element.removeEventListener('mousedown', this.handleMouseDown);
            element.removeEventListener('mousemove', this.handleMouseMove);
            element.removeEventListener('mouseup', this.handleMouseUp);
            element.removeEventListener('mouseleave', this.handleMouseLeave);
            if (this.hasTouchEvents) {
                element.removeEventListener('touchstart', this.handleTouchStart);
                element.removeEventListener('touchmove', this.handleTouchMove);
                element.removeEventListener('touchend', this.handleTouchEnd);
                element.removeEventListener('touchcancel', this.handleTouchCancel);
            }
        }
        // Дополнительные обработчики
        element.removeEventListener('click', this.handleClick);
        element.removeEventListener('contextmenu', this.handleContextMenu);
        this.draggableHandlers.delete(element);
    }
    /**
	 * Регистрация глобальных обработчиков (для отслеживания движения)
	 */ registerGlobal(handlers) {
        this.globalHandlers = handlers;
        if (!this.isGlobalListening) this.startGlobalListening();
    }
    /**
	 * Очистка глобальных обработчиков
	 */ clearGlobal() {
        this.globalHandlers = {};
        this.stopGlobalListening();
    }
    /**
	 * Получение текущей стратегии событий
	 */ getEventStrategy() {
        return this.hasPointerEvents ? 'pointer' : 'mouse-touch';
    }
    /**
	 * Проверка поддержки Pointer Events
	 */ supportsPointerEvents() {
        return this.hasPointerEvents;
    }
    /**
	 * Полная очистка всех обработчиков
	 */ destroy() {
        // Удаляем все обработчики с элементов
        for (const element of this.draggableHandlers.keys())this.unregisterDraggable(element);
        // Очищаем глобальные обработчики
        this.clearGlobal();
        // Очищаем Map
        this.draggableHandlers.clear();
    }
    // ========== PRIVATE METHODS ==========
    startGlobalListening() {
        if (this.isGlobalListening) return;
        if (this.hasPointerEvents) {
            document.addEventListener('pointermove', this.handleGlobalPointerMove);
            document.addEventListener('pointerup', this.handleGlobalPointerUp);
            document.addEventListener('pointercancel', this.handleGlobalPointerCancel);
        } else {
            document.addEventListener('mousemove', this.handleGlobalMouseMove);
            document.addEventListener('mouseup', this.handleGlobalMouseUp);
            if (this.hasTouchEvents) {
                // Use passive: false when dragging to allow preventDefault()
                const passive = !this.isDraggingActive && this.compatibility.passiveEvents !== false;
                document.addEventListener('touchmove', this.handleGlobalTouchMove, {
                    passive: passive
                });
                document.addEventListener('touchend', this.handleGlobalTouchEnd);
                document.addEventListener('touchcancel', this.handleGlobalTouchCancel);
            }
        }
        this.isGlobalListening = true;
    }
    stopGlobalListening() {
        if (!this.isGlobalListening) return;
        if (this.hasPointerEvents) {
            document.removeEventListener('pointermove', this.handleGlobalPointerMove);
            document.removeEventListener('pointerup', this.handleGlobalPointerUp);
            document.removeEventListener('pointercancel', this.handleGlobalPointerCancel);
        } else {
            document.removeEventListener('mousemove', this.handleGlobalMouseMove);
            document.removeEventListener('mouseup', this.handleGlobalMouseUp);
            if (this.hasTouchEvents) {
                document.removeEventListener('touchmove', this.handleGlobalTouchMove);
                document.removeEventListener('touchend', this.handleGlobalTouchEnd);
                document.removeEventListener('touchcancel', this.handleGlobalTouchCancel);
            }
        }
        this.isGlobalListening = false;
    }
    updateGlobalTouchMoveListener() {
        // Remove and re-add with correct passive option
        document.removeEventListener('touchmove', this.handleGlobalTouchMove);
        const passive = !this.isDraggingActive && this.compatibility.passiveEvents !== false;
        document.addEventListener('touchmove', this.handleGlobalTouchMove, {
            passive: passive
        });
    }
}


class $a9c73c2a0c486918$export$2c50d0fe92974702 {
    constructor(config){
        this.dragPreview = null;
        this.dropIndicator = null;
        this.activationIndicator = null;
        this.config = {
            previewOpacity: 0.8,
            previewScale: 1.05,
            previewZIndex: 9999,
            indicatorZIndex: 9998,
            useDomClone: true,
            ...config
        };
        // Создаем контейнеры для визуальных элементов
        this.previewContainer = this.createContainer('dnd-preview-container', this.config.previewZIndex);
        this.indicatorContainer = this.createContainer('dnd-indicator-container', this.config.indicatorZIndex);
        document.body.appendChild(this.previewContainer);
        document.body.appendChild(this.indicatorContainer);
    }
    /**
   * Показывает визуальную обратную связь при активации
   */ showActivationFeedback(element, cssClass) {
        if (!element) return;
        // Добавляем CSS класс элементу
        if (cssClass) element.classList.add(cssClass);
        // Создаем отдельный индикатор активации (опционально)
        this.activationIndicator = document.createElement('div');
        this.activationIndicator.className = 'dnd-activation-indicator';
        this.activationIndicator.style.position = 'absolute';
        this.activationIndicator.style.pointerEvents = 'none';
        this.activationIndicator.style.zIndex = `${this.config.indicatorZIndex - 1}`;
        // Позиционируем вокруг элемента
        const rect = element.getBoundingClientRect();
        this.activationIndicator.style.left = `${rect.left - 4}px`;
        this.activationIndicator.style.top = `${rect.top - 4}px`;
        this.activationIndicator.style.width = `${rect.width + 8}px`;
        this.activationIndicator.style.height = `${rect.height + 8}px`;
        this.activationIndicator.style.border = '2px solid rgba(59, 130, 246, 0.5)';
        this.activationIndicator.style.borderRadius = '8px';
        this.activationIndicator.style.animation = 'dnd-pulse 1s infinite';
        this.indicatorContainer.appendChild(this.activationIndicator);
    }
    /**
   * Создает превью для перетаскиваемого элемента
   */ createDragPreview(element, offset) {
        this.clearDragPreview();
        const options = {
            element: element,
            offset: offset,
            opacity: this.config.previewOpacity,
            scale: this.config.previewScale,
            useDomClone: this.config.useDomClone
        };
        this.dragPreview = this.config.useDomClone ? this.createDomClonePreview(options) : this.createCustomPreview(options);
        this.previewContainer.appendChild(this.dragPreview);
    }
    /**
   * Обновляет позицию превью
   */ updateDragPreview(x, y) {
        if (!this.dragPreview) return;
        // Применяем трансформацию с аппаратным ускорением
        this.dragPreview.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${this.config.previewScale})`;
        // Синхронизируем размеры если они изменились
        requestAnimationFrame(()=>{
            if (this.dragPreview && this.dragPreview.dataset.originalId) {
                const original = document.querySelector(`[data-dnd-id="${this.dragPreview.dataset.originalId}"]`);
                if (original && original instanceof HTMLElement) {
                    const rect = original.getBoundingClientRect();
                    this.dragPreview.style.width = `${rect.width}px`;
                    this.dragPreview.style.height = `${rect.height}px`;
                }
            }
        });
    }
    /**
   * Создает индикатор дроп-зоны
   */ createDropIndicator(position, indicatorClass) {
        this.clearDropIndicator();
        const options = {
            position: position,
            indicatorClass: indicatorClass,
            zIndex: this.config.indicatorZIndex
        };
        this.dropIndicator = this.createPositionedIndicator(options);
        if (this.dropIndicator) {
            this.indicatorContainer.appendChild(this.dropIndicator);
            // Анимация появления
            requestAnimationFrame(()=>{
                if (this.dropIndicator) {
                    this.dropIndicator.style.opacity = '1';
                    this.dropIndicator.style.transform = 'scaleY(1)';
                }
            });
        }
    }
    /**
   * Обновляет позицию индикатора дроп-зоны
   */ updateDropIndicator(position, indicatorClass) {
        if (!this.dropIndicator) {
            this.createDropIndicator(position, indicatorClass);
            return;
        }
        // Обновляем CSS классы
        if (indicatorClass) this.dropIndicator.className = `dnd-drop-indicator ${indicatorClass}`;
        // Обновляем позиционирование если нужно
        if (position.visual?.style) Object.assign(this.dropIndicator.style, position.visual.style);
        // Если есть элемент для привязки
        if (position.visual?.element) {
            const rect = position.visual.element.getBoundingClientRect();
            const containerRect = this.indicatorContainer.getBoundingClientRect();
            switch(position.type){
                case 'between-tasks':
                    this.dropIndicator.style.left = `${rect.left - containerRect.left}px`;
                    this.dropIndicator.style.top = `${rect.top - containerRect.top - 2}px`;
                    this.dropIndicator.style.width = `${rect.width}px`;
                    this.dropIndicator.style.height = '4px';
                    break;
                case 'empty-container':
                    this.dropIndicator.style.left = `${rect.left - containerRect.left}px`;
                    this.dropIndicator.style.top = `${rect.top - containerRect.top}px`;
                    this.dropIndicator.style.width = `${rect.width}px`;
                    this.dropIndicator.style.height = `${rect.height}px`;
                    break;
            }
        }
    }
    /**
   * Очищает превью перетаскивания
   */ clearDragPreview() {
        if (this.dragPreview) {
            // Анимация исчезновения
            this.dragPreview.style.opacity = '0';
            this.dragPreview.style.transform += ' scale(0.9)';
            setTimeout(()=>{
                if (this.dragPreview && this.dragPreview.parentNode) this.dragPreview.parentNode.removeChild(this.dragPreview);
                this.dragPreview = null;
            }, 200);
        }
    }
    /**
   * Очищает индикатор дроп-зоны
   */ clearDropIndicator() {
        if (this.dropIndicator) {
            // Анимация исчезновения
            this.dropIndicator.style.opacity = '0';
            this.dropIndicator.style.transform = 'scaleY(0.5)';
            setTimeout(()=>{
                if (this.dropIndicator && this.dropIndicator.parentNode) this.dropIndicator.parentNode.removeChild(this.dropIndicator);
                this.dropIndicator = null;
            }, 150);
        }
        if (this.activationIndicator) {
            this.activationIndicator.remove();
            this.activationIndicator = null;
        }
    }
    /**
   * Очищает все визуальные элементы
   */ clearAll() {
        this.clearDragPreview();
        this.clearDropIndicator();
    }
    /**
   * Уничтожение менеджера
   */ destroy() {
        this.clearAll();
        if (this.previewContainer.parentNode) this.previewContainer.parentNode.removeChild(this.previewContainer);
        if (this.indicatorContainer.parentNode) this.indicatorContainer.parentNode.removeChild(this.indicatorContainer);
    }
    // ========== PRIVATE METHODS ==========
    createContainer(className, zIndex) {
        const container = document.createElement('div');
        container.className = className;
        container.style.position = 'fixed';
        container.style.top = '0';
        container.style.left = '0';
        container.style.width = '0';
        container.style.height = '0';
        container.style.zIndex = `${zIndex}`;
        container.style.pointerEvents = 'none';
        container.style.overflow = 'visible';
        return container;
    }
    createDomClonePreview(options) {
        const { element: element, offset: offset, opacity: opacity, scale: scale } = options;
        // Клонируем элемент со всеми стилями
        const clone = element.cloneNode(true);
        // Устанавливаем уникальный ID для связи с оригиналом
        const originalId = element.getAttribute('data-dnd-id') || `dnd-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        if (!element.hasAttribute('data-dnd-id')) element.setAttribute('data-dnd-id', originalId);
        clone.setAttribute('data-dnd-clone-of', originalId);
        clone.setAttribute('data-dnd-preview', 'true');
        // Стилизация превью
        const rect = element.getBoundingClientRect();
        clone.style.position = 'absolute';
        clone.style.left = '0';
        clone.style.top = '0';
        clone.style.width = `${rect.width}px`;
        clone.style.height = `${rect.height}px`;
        clone.style.opacity = `${opacity}`;
        clone.style.transform = `translate3d(${rect.left}px, ${rect.top}px, 0) scale(${scale})`;
        clone.style.transformOrigin = 'top left';
        clone.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.2)';
        clone.style.borderRadius = 'inherit';
        clone.style.pointerEvents = 'none';
        clone.style.zIndex = `${this.config.previewZIndex}`;
        clone.style.transition = 'transform 0.1s, opacity 0.2s';
        // Сохраняем offset для точного позиционирования
        clone.dataset.offsetX = offset.x.toString();
        clone.dataset.offsetY = offset.y.toString();
        clone.dataset.originalId = originalId;
        // Убираем интерактивные элементы из клона
        this.disableInteractiveElements(clone);
        return clone;
    }
    createCustomPreview(options) {
        const { element: element, offset: offset, opacity: opacity, scale: scale } = options;
        const preview = document.createElement('div');
        preview.className = 'dnd-custom-preview';
        // Копируем основные стили
        const computedStyle = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        preview.style.position = 'absolute';
        preview.style.left = '0';
        preview.style.top = '0';
        preview.style.width = `${rect.width}px`;
        preview.style.height = `${rect.height}px`;
        preview.style.backgroundColor = computedStyle.backgroundColor;
        preview.style.border = computedStyle.border;
        preview.style.borderRadius = computedStyle.borderRadius;
        preview.style.opacity = `${opacity}`;
        preview.style.transform = `translate3d(${rect.left}px, ${rect.top}px, 0) scale(${scale})`;
        preview.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.2)';
        preview.style.pointerEvents = 'none';
        preview.style.zIndex = `${this.config.previewZIndex}`;
        // Копируем содержимое (упрощенно)
        preview.textContent = element.textContent?.substring(0, 50) || '';
        return preview;
    }
    createPositionedIndicator(options) {
        const { position: position, indicatorClass: indicatorClass, zIndex: zIndex } = options;
        if (!position.visual) {
            // Дефолтный индикатор
            const indicator = document.createElement('div');
            indicator.className = `dnd-drop-indicator ${indicatorClass || ''}`.trim();
            indicator.style.position = 'absolute';
            indicator.style.left = '0';
            indicator.style.top = '0';
            indicator.style.width = '100%';
            indicator.style.height = '4px';
            indicator.style.backgroundColor = '#4dabf7';
            indicator.style.borderRadius = '2px';
            indicator.style.opacity = '0';
            indicator.style.transform = 'scaleY(0.5)';
            indicator.style.transition = 'opacity 0.15s, transform 0.15s';
            indicator.style.zIndex = `${zIndex}`;
            indicator.style.pointerEvents = 'none';
            return indicator;
        }
        // Кастомный индикатор из конфигурации
        if (position.visual.element) {
            const indicator = document.createElement('div');
            indicator.className = `dnd-drop-indicator ${indicatorClass || ''} ${position.visual.className || ''}`.trim();
            // Базовые стили
            indicator.style.position = 'absolute';
            indicator.style.pointerEvents = 'none';
            indicator.style.zIndex = `${zIndex}`;
            indicator.style.opacity = '0';
            indicator.style.transition = 'opacity 0.15s, transform 0.15s';
            // Применяем кастомные стили
            if (position.visual.style) Object.assign(indicator.style, position.visual.style);
            return indicator;
        }
        return null;
    }
    disableInteractiveElements(element) {
        // Находим все интерактивные элементы внутри
        const interactive = element.querySelectorAll('button, input, textarea, select, a, [tabindex], [contenteditable]');
        interactive.forEach((el)=>{
            if (el instanceof HTMLElement) {
                el.setAttribute('disabled', 'true');
                el.setAttribute('aria-disabled', 'true');
                el.style.pointerEvents = 'none';
                el.style.opacity = '0.5';
            }
        });
    }
}


class $9ddb0709b0f30f3f$export$c4257058f6eb2273 {
    constructor(config){
        this.isActive = false;
        this.scrollContainer = null;
        this.animationFrameId = null;
        this.currentSpeedX = 0;
        this.currentSpeedY = 0;
        this.lastCursorX = 0;
        this.lastCursorY = 0;
        this.lastUpdateTime = 0;
        this.lastRealCursorX = 0;
        this.lastRealCursorY = 0;
        this.isManualSpeedUpdate = false;
        this.scrollTargets = [];
        this.scrollTargetElement = null;
        this.config = {
            edgeThreshold: 50,
            scrollSpeed: 1,
            maxSpeed: 20,
            enabled: true,
            scrollableSelectors: [],
            ...config
        };
    }
    /**
	 * Начинает отслеживание для автокролла
	 */ start(container) {
        if (!this.config.enabled) return;
        this.scrollContainer = container || document.documentElement;
        this.isActive = true;
        this.lastUpdateTime = performance.now();
    }
    /**
	 * Обновляет позицию курсора и активирует автокролл если нужно
	 */ update(cursorX, cursorY) {
        if (!this.isActive || !this.config.enabled) return;
        // Проверяем, действительно ли курсор двигался
        const cursorMoved = Math.abs(cursorX - this.lastRealCursorX) > 1 || Math.abs(cursorY - this.lastRealCursorY) > 1;
        if (cursorMoved) {
            // Запоминаем РЕАЛЬНЫЕ координаты курсора
            this.lastRealCursorX = cursorX;
            this.lastRealCursorY = cursorY;
            this.isManualSpeedUpdate = true;
            // Ищем новые контейнеры для скролла
            this.scrollTargets = this.findScrollContainers(cursorX, cursorY);
        }
        this.lastCursorX = cursorX;
        this.lastCursorY = cursorY;
        if (this.scrollTargets.length > 0) {
            // ОБНОВЛЯЕМ скорость ТОЛЬКО если курсор двигался
            if (cursorMoved) this.calculateScrollSpeeds(cursorX, cursorY);
            // Проверяем, есть ли хоть у одного контейнера ненулевая скорость
            const hasAnySpeed = this.scrollTargets.some((target)=>target.speedX !== 0 || target.speedY !== 0);
            if (hasAnySpeed) this.startScrollAnimation();
            else this.stopScrollAnimation();
        } else {
            this.stopScrollAnimation();
            this.scrollTargets = [];
        }
    }
    /**
	 * Останавливает автокролл
	 */ stop() {
        this.isActive = false;
        this.currentSpeedX = 0;
        this.currentSpeedY = 0;
        this.scrollTargets = [];
        this.scrollTargetElement = null;
        this.isManualSpeedUpdate = false;
        this.stopScrollAnimation();
    }
    /**
	 * Проверяет, активен ли автокролл
	 */ isScrolling() {
        return this.isActive && (this.currentSpeedX !== 0 || this.currentSpeedY !== 0);
    }
    /**
	 * Возвращает текущую скорость скролла
	 */ getCurrentSpeed() {
        return {
            x: this.currentSpeedX,
            y: this.currentSpeedY
        };
    }
    /**
	 * Возвращает текущий элемент, который скроллится
	 */ getScrollTarget() {
        return this.scrollTargetElement;
    }
    /**
	 * Возвращает все текущие скроллящиеся элементы
	 */ getScrollTargets() {
        return this.scrollTargets.map((target)=>target.element);
    }
    // ========== PRIVATE METHODS ==========
    /**
	 * Находит ВСЕ контейнеры для скролла по селекторам
	 * Возвращает массив всех контейнеров, которые содержат курсор
	 */ findScrollContainers(x, y) {
        const targets = [];
        // Всегда добавляем дефолтный контейнер если он есть
        if (this.scrollContainer) {
            const defaultContainer = this.scrollContainer;
            if (this.isCursorNearEdge(defaultContainer, x, y)) targets.push({
                element: defaultContainer,
                speedX: 0,
                speedY: 0,
                canScrollHorizontal: this.canScrollHorizontally(defaultContainer),
                canScrollVertical: this.canScrollVertically(defaultContainer)
            });
        }
        // Ищем по всем селекторам из конфига
        for (const selector of this.config.scrollableSelectors)try {
            const elements = document.querySelectorAll(selector);
            for (const element of elements){
                if (!(element instanceof HTMLElement)) continue;
                const rect = element.getBoundingClientRect();
                // Проверяем что курсор внутри элемента
                if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
                    // Проверяем что курсор близко к краю
                    if (this.isCursorNearEdge(element, x, y)) // Проверяем дубликаты
                    {
                        if (!targets.some((t)=>t.element === element)) targets.push({
                            element: element,
                            speedX: 0,
                            speedY: 0,
                            canScrollHorizontal: this.canScrollHorizontally(element),
                            canScrollVertical: this.canScrollVertically(element)
                        });
                    }
                }
            }
        } catch (error) {
            // Игнорируем ошибки селекторов
            console.warn(`Invalid selector or element: ${selector}`, error);
        }
        // Сортируем по вложенности: самые глубокие контейнеры первыми
        return targets.sort((a, b)=>{
            const aDepth = this.getElementDepth(a.element);
            const bDepth = this.getElementDepth(b.element);
            return bDepth - aDepth; // Большая глубина = выше приоритет
        });
    }
    getElementDepth(element) {
        let depth = 0;
        let current = element;
        while(current && current !== document.body){
            depth++;
            current = current.parentElement;
        }
        return depth;
    }
    /**
	 * Проверяет, находится ли курсор рядом с краями элемента
	 */ isCursorNearEdge(element, x, y) {
        const rect = element.getBoundingClientRect();
        const { edgeThreshold: edgeThreshold } = this.config;
        return x < rect.left + edgeThreshold || // близко к левому краю
        x > rect.right - edgeThreshold || // близко к правому краю
        y < rect.top + edgeThreshold || // близко к верхнему краю
        y > rect.bottom - edgeThreshold // близко к нижнему краю
        ;
    }
    canScrollHorizontally(element) {
        return element.scrollWidth > element.clientWidth;
    }
    canScrollVertically(element) {
        return element.scrollHeight > element.clientHeight;
    }
    calculateScrollSpeeds(x, y) {
        const { edgeThreshold: edgeThreshold, scrollSpeed: scrollSpeed, maxSpeed: maxSpeed } = this.config;
        for (const target of this.scrollTargets){
            const { element: container, canScrollHorizontal: canScrollHorizontal, canScrollVertical: canScrollVertical } = target;
            const rect = container.getBoundingClientRect();
            // Сбрасываем скорость для этого контейнера
            target.speedX = 0;
            target.speedY = 0;
            // Проверяем, находится ли курсор ВНУТРИ контейнера
            const isCursorInsideX = x >= rect.left && x <= rect.right;
            const isCursorInsideY = y >= rect.top && y <= rect.bottom;
            // Горизонтальный скролл (только если контейнер может скроллиться горизонтально)
            if (canScrollHorizontal && isCursorInsideX) {
                const distanceToLeft = x - rect.left;
                const distanceToRight = rect.right - x;
                if (distanceToLeft < edgeThreshold) {
                    const ratio = (edgeThreshold - distanceToLeft) / edgeThreshold;
                    target.speedX = -this.calculateSpeedForDistance(ratio, scrollSpeed, maxSpeed);
                } else if (distanceToRight < edgeThreshold) {
                    const ratio = (edgeThreshold - distanceToRight) / edgeThreshold;
                    target.speedX = this.calculateSpeedForDistance(ratio, scrollSpeed, maxSpeed);
                }
            }
            // Вертикальный скролл (только если контейнер может скроллиться вертикально)
            if (canScrollVertical && isCursorInsideY) {
                const distanceToTop = y - rect.top;
                const distanceToBottom = rect.bottom - y;
                if (distanceToTop < edgeThreshold) {
                    const ratio = (edgeThreshold - distanceToTop) / edgeThreshold;
                    target.speedY = -this.calculateSpeedForDistance(ratio, scrollSpeed, maxSpeed);
                } else if (distanceToBottom < edgeThreshold) {
                    const ratio = (edgeThreshold - distanceToBottom) / edgeThreshold;
                    target.speedY = this.calculateSpeedForDistance(ratio, scrollSpeed, maxSpeed);
                }
            }
            // Корректируем скорость если достигли границ скролла
            if (target.speedX < 0 && container.scrollLeft <= 0) target.speedX = 0;
            else if (target.speedX > 0 && container.scrollLeft >= container.scrollWidth - container.clientWidth) target.speedX = 0;
            if (target.speedY < 0 && container.scrollTop <= 0) target.speedY = 0;
            else if (target.speedY > 0 && container.scrollTop >= container.scrollHeight - container.clientHeight) target.speedY = 0;
        }
    }
    calculateSpeedForDistance(ratio, baseSpeed, maxSpeed) {
        // Экспоненциальное увеличение скорости при приближении к краю
        const speed = baseSpeed * Math.pow(ratio, 0.7) * 15;
        return Math.min(speed, maxSpeed);
    }
    startScrollAnimation() {
        // Если уже скроллим, НЕ ПЕРЕЗАПУСКАЕМ анимацию
        if (this.animationFrameId) return;
        const animate = ()=>{
            if (!this.isActive) {
                this.stopScrollAnimation();
                return;
            }
            // Проверяем, есть ли хоть у одного контейнера ненулевая скорость
            let hasAnyActiveTarget = false;
            for (const target of this.scrollTargets){
                const { element: container, speedX: speedX, speedY: speedY } = target;
                // Проверяем достигли ли границ скролла для этого контейнера
                if (speedX < 0 && container.scrollLeft <= 0) target.speedX = 0;
                else if (speedX > 0 && container.scrollLeft >= container.scrollWidth - container.clientWidth) target.speedX = 0;
                if (speedY < 0 && container.scrollTop <= 0) target.speedY = 0;
                else if (speedY > 0 && container.scrollTop >= container.scrollHeight - container.clientHeight) target.speedY = 0;
                // Применяем скролл с ПОСТОЯННОЙ скоростью для каждого контейнера
                if (speedX !== 0 || speedY !== 0) {
                    hasAnyActiveTarget = true;
                    container.scrollLeft += speedX;
                    container.scrollTop += speedY;
                }
            }
            // КРИТИЧНО: НЕ пересчитываем скорость здесь!
            // Скорость остается постоянной пока не придет новый update()
            if (!hasAnyActiveTarget) {
                this.stopScrollAnimation();
                return;
            }
            // Запускаем следующий кадр
            this.animationFrameId = requestAnimationFrame(animate);
        };
        this.animationFrameId = requestAnimationFrame(animate);
    }
    stopScrollAnimation() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    }
}


class $f63fc3479aafcb8a$export$9506d3c8a82c6d97 {
    constructor(){
        this.capabilities = this.detectCapabilities();
    }
    static getInstance() {
        if (!$f63fc3479aafcb8a$export$9506d3c8a82c6d97.instance) $f63fc3479aafcb8a$export$9506d3c8a82c6d97.instance = new $f63fc3479aafcb8a$export$9506d3c8a82c6d97();
        return $f63fc3479aafcb8a$export$9506d3c8a82c6d97.instance;
    }
    getCapabilities() {
        return this.capabilities;
    }
    /**
   * Проверяет, поддерживается ли Pointer Events API
   */ supportsPointerEvents() {
        return this.capabilities.pointerEvents;
    }
    /**
   * Проверяет, поддерживаются ли Touch Events
   */ supportsTouchEvents() {
        return this.capabilities.touchEvents;
    }
    /**
   * Определяет оптимальную стратегию событий
   */ getRecommendedEventStrategy() {
        return this.capabilities.pointerEvents ? 'pointer' : 'mouse-touch';
    }
    /**
   * Проверяет, нужно ли использовать passive event listeners
   */ shouldUsePassiveEvents() {
        return this.capabilities.passiveEvents;
    }
    detectCapabilities() {
        return {
            pointerEvents: 'PointerEvent' in window,
            touchEvents: 'ontouchstart' in window || navigator.maxTouchPoints !== undefined && navigator.maxTouchPoints > 0,
            passiveEvents: this.detectPassiveEventsSupport(),
            cssTransforms: this.detectCSSTransforms(),
            cssTransitions: this.detectCSSTransitions(),
            requestAnimationFrame: 'requestAnimationFrame' in window
        };
    }
    detectPassiveEventsSupport() {
        let supportsPassive = false;
        try {
            const opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassive = true;
                    return true;
                }
            });
            window.addEventListener('test', ()=>{}, opts);
            window.removeEventListener('test', ()=>{});
        } catch (e) {
        // Если произошла ошибка, passive events не поддерживаются
        }
        return supportsPassive;
    }
    detectCSSTransforms() {
        const style = document.createElement('div').style;
        return 'transform' in style || 'webkitTransform' in style || 'mozTransform' in style;
    }
    detectCSSTransitions() {
        const style = document.createElement('div').style;
        return 'transition' in style || 'webkitTransition' in style || 'mozTransition' in style;
    }
}


class $125e076244bea594$export$c706bde4a5fbd99b {
    constructor(){
        this.isPhone = this.checkIfPhone();
        this.bindEvents();
    }
    checkIfPhone() {
        const ua = navigator.userAgent;
        // User agent проверка
        const isMobileUA = /iPhone|iPod|Android.*Mobile|Windows.*Phone/i.test(ua);
        const isTabletUA = /iPad|Android(?!.*Mobile)|Tablet/i.test(ua);
        // Проверка по размеру экрана
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const minDimension = Math.min(screenWidth, screenHeight);
        const maxDimension = Math.max(screenWidth, screenHeight);
        // Эмпирические правила для определения телефона
        const isSmallScreen = minDimension < 768;
        const isPhoneAspectRatio = maxDimension / minDimension > 1.6;
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
        return isMobileUA || isSmallScreen || isPhoneAspectRatio || isStandalone;
    }
    bindEvents() {
        window.addEventListener('resize', ()=>{
            this.isPhone = this.checkIfPhone();
        });
        window.addEventListener('orientationchange', ()=>{
            setTimeout(()=>{
                this.isPhone = this.checkIfPhone();
            }, 300);
        });
    }
    shouldDisableDnD() {
        return this.isPhone;
    }
}
const $125e076244bea594$export$2b3327f70059e02e = new $125e076244bea594$export$c706bde4a5fbd99b();
const $125e076244bea594$export$abd12cac50e458a2 = $125e076244bea594$export$2b3327f70059e02e.shouldDisableDnD();


const $676334fc1be830c5$export$3972aae8a4604eb5 = {
    previewOpacity: 0.8,
    previewScale: 1.05,
    previewZIndex: 9999,
    indicatorZIndex: 9998,
    useDomClone: true
};
const $676334fc1be830c5$export$c82d80506540e07a = {
    edgeThreshold: 50,
    scrollSpeed: 1,
    maxSpeed: 20,
    enabled: true,
    scrollableSelectors: [
        'body',
        'html' // Скролл страницы
    ]
};
const $676334fc1be830c5$export$a933b7232259c6fb = {
    usePointerEvents: 'PointerEvent' in window,
    passiveEvents: true
};
const $676334fc1be830c5$export$1cb32b5de27018ac = {
    visual: $676334fc1be830c5$export$3972aae8a4604eb5,
    scroll: $676334fc1be830c5$export$c82d80506540e07a,
    compatibility: $676334fc1be830c5$export$a933b7232259c6fb
};
const $676334fc1be830c5$export$431ebf0ba424e5b6 = {
    MOVE_DETECTION_THRESHOLD_PX: 10,
    SWIPE_DETECTION_THRESHOLD_PX: 25,
    SCROLL_DETECTION_THRESHOLD: 10,
    SHORT_CLICK_TIMEOUT_MS: 150,
    POST_SCROLL_BLOCK_DURATION_MS: 200,
    TimeDesktopActivationMs: 151,
    TimeMobileActivationMs: 1000
};
const $676334fc1be830c5$export$d8f2ed617be73058 = {
    activationDelay: (0, $125e076244bea594$export$abd12cac50e458a2) ? $676334fc1be830c5$export$431ebf0ba424e5b6.TimeMobileActivationMs : $676334fc1be830c5$export$431ebf0ba424e5b6.TimeDesktopActivationMs,
    movementThreshold: 5,
    preventScroll: true,
    disabled: false
};



const $5c62c5d2b879ac35$var$DndDebug = {
    debug: 0
};
window.dndDebug = $5c62c5d2b879ac35$var$DndDebug;
class $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3 {
    constructor(config){
        this.MOVE_DETECTION_THRESHOLD_PX = 10 // Порог для детектирования любого движения
        ;
        this.SWIPE_DETECTION_THRESHOLD_PX = 25 // Минимальное расстояние для распознавания свайпа
        ;
        this.SCROLL_DETECTION_THRESHOLD = 10 // Порог для определения скролла
        ;
        this.SHORT_CLICK_TIMEOUT_MS = 150 // Максимальное время для короткого нажатия
        ;
        this.POST_SCROLL_BLOCK_DURATION_MS = 200 // Время блокировки драга после скролла
        ;
        this.originalEvent = null;
        this.draggables = new Map();
        this.dropZones = new Map();
        this.currentDrag = null;
        this.currentDropZone = null;
        this.activationTimer = null;
        this.isActivating = false;
        this.isShortClick = false;
        this.isDragStarted = false;
        this.isDragging = false;
        this.hasMoved = false;
        this.ShortClickTimout = this.SHORT_CLICK_TIMEOUT_MS;
        // Переменные для отслеживания скролла
        this.lastScrollEndTime = 0 // Время последнего скролла
        ;
        this.isScrolling = false // Флаг, указывающий, что сейчас происходит скролл
        ;
        this.config = {
            ...(0, $676334fc1be830c5$export$1cb32b5de27018ac),
            ...config
        };
        this.compatibilityDetector = (0, $f63fc3479aafcb8a$export$9506d3c8a82c6d97).getInstance();
        this.eventManager = (0, $fe28be021e8e0b0d$export$cc74486daaaef499).getInstance(this.config.compatibility);
        this.visualManager = new (0, $a9c73c2a0c486918$export$2c50d0fe92974702)(this.config.visual);
        this.scrollManager = new (0, $9ddb0709b0f30f3f$export$c4257058f6eb2273)(this.config.scroll);
        this.setupGlobalListeners();
    }
    /**
	 * Destroy DndSystem instance and clean up all listeners
	 */ destroy() {
        this.cleanupPageVisibilityListeners();
        this.cancelCurrentDrag();
        this.eventManager.destroy();
        $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3.instance = null;
    }
    static getInstance(config) {
        if (!$5c62c5d2b879ac35$export$7b3b75ad1a39a3f3.instance) $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3.instance = new $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3(config);
        return $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3.instance;
    }
    /**
	 * Регистрация draggable элемента
	 */ registerDraggable(options) {
        const { context: context, strategy: strategy, config: config } = options;
        const { element: element } = context;
        this.draggables.set(element, options);
        // Регистрируем обработчики событий
        this.eventManager.registerDraggable(element, {
            onMouseDown: (e)=>this.handleDragStart(e, element, false),
            onTouchStart: (e)=>this.handleDragStart(e, element, true),
            onPointerDown: (e)=>this.handleDragStart(e, element, e.pointerType === 'touch'),
            onMouseUp: (e)=>this.cancelClickTimer("mouseup"),
            onTouchCancel: (e)=>this.cancelClickTimer("touch_cancel"),
            onTouchEnd: (e)=>this.cancelClickTimer("touch_end"),
            onPointerUp: (e)=>this.cancelClickTimer("pointer_up"),
            onClick: (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
        });
        // Функция для отмены регистрации
        return ()=>{
            this.draggables.delete(element);
            this.eventManager.unregisterDraggable(element);
            if (this.currentDrag?.element === element) this.cancelCurrentDrag();
        };
    }
    cancelClickTimer(cause) {
        if (this.clickTimer) {
            if ($5c62c5d2b879ac35$var$DndDebug.debug) console.log(`${Date.now()} cancel click timer`, cause);
            clearTimeout(this.clickTimer);
            this.clickTimer = null;
        }
    }
    /**
	 * Регистрация drop zone
	 */ registerDropZone(config) {
        const { context: context } = config;
        const { element: element } = context;
        this.dropZones.set(element, config);
        // Функция для отмены регистрации
        return ()=>{
            this.dropZones.delete(element);
            if (this.currentDropZone?.config.context.element === element) this.clearDropZone();
        };
    }
    /**
	 * Принудительная отмена текущего перетаскивания
	 */ cancelCurrentDrag() {
        this.cancelClickTimer("cancel drag");
        if (this.activationTimer) {
            clearTimeout(this.activationTimer);
            this.activationTimer = null;
        }
        this.isActivating = false;
        this.isDragStarted = false; // ← ВАЖНО: сбросить этот флаг!
        this.isDragging = false;
        this.isShortClick = false;
        this.hasMoved = false;
        if (this.currentDrag) {
            const options = this.draggables.get(this.currentDrag.element);
            if (options) // Вызываем onDragCancel для завершения перетаскивания
            options.strategy.onDragCancel?.(options.context);
            this.visualManager.clearAll();
        }
        this.clearDropZone();
        this.scrollManager.stop();
        // Notify EventManager to restore normal touch behavior
        this.eventManager.setDraggingState(false);
        this.currentDrag = null;
        this.originalEvent = null; // Также сбрасываем оригинальное событие
        // Устанавливаем время последнего скролла при отмене драга
        this.lastScrollEndTime = performance.now();
    }
    /**
	 * Проверка, активно ли перетаскивание
	 */ isDragActive() {
        return this.isDragging || this.isActivating || this.isDragStarted;
    }
    /**
	 * Получение текущих данных перетаскивания
	 */ getCurrentDrag() {
        return this.currentDrag?.data || null;
    }
    /**
	 * Получение информации о браузерной совместимости
	 */ getCompatibilityInfo() {
        return this.compatibilityDetector.getCapabilities();
    }
    /**
	 * Получение стратегии по умолчанию
	 */ static defaultStrategy() {
        return {
            onActivate: (context)=>{
                console.log('Default activate:', context.id);
            },
            onDragStart: (context, dragData)=>{
                console.log('Default drag start:', context.id);
            },
            onDragEnd: (context, result)=>{
                console.log('Default drag end:', result.success);
            }
        };
    }
    // ========== PRIVATE METHODS ==========
    setupGlobalListeners() {
        // Глобальные обработчики для отслеживания движения
        this.eventManager.registerGlobal({
            onMouseMove: (e)=>this.handleDragMove(e.clientX, e.clientY, false),
            onTouchMove: (e)=>{
                if (e.touches.length === 1) {
                    const touch = e.touches[0];
                    this.handleDragMove(touch.clientX, touch.clientY, true);
                    // Предотвращаем скролл страницы только при активном DnD
                    if (this.isDragging) e.preventDefault();
                }
            },
            onPointerMove: (e)=>{
                this.handleDragMove(e.clientX, e.clientY, e.pointerType === 'touch');
            },
            onMouseUp: (e)=>this.handleDragEnd(e),
            onTouchEnd: (e)=>this.handleDragEnd(e),
            onPointerUp: (e)=>this.handleDragEnd(e)
        });
        // Add visibility/blur listeners for forced drag cancellation
        this.setupPageVisibilityListeners();
    }
    setupPageVisibilityListeners() {
        // Handle page visibility change (app minimized/background)
        const handleVisibilityChange = ()=>{
            if (document.hidden && this.isDragActive()) {
                console.log('Page became hidden during drag, cancelling...');
                this.cancelCurrentDrag();
            }
        };
        // Handle window blur (app lost focus)
        const handleWindowBlur = ()=>{
            if (this.isDragActive()) {
                console.log('Window lost focus during drag, cancelling...');
                this.cancelCurrentDrag();
            }
        };
        // Handle page hide (especially for mobile)
        const handlePageHide = ()=>{
            if (this.isDragActive()) {
                console.log('Page hiding, cancelling drag...');
                this.cancelCurrentDrag();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('blur', handleWindowBlur);
        window.addEventListener('pagehide', handlePageHide);
        // Store for cleanup
        this.pageVisibilityHandlers = {
            handleVisibilityChange: handleVisibilityChange,
            handleWindowBlur: handleWindowBlur,
            handlePageHide: handlePageHide
        };
    }
    /**
	 * Cleanup page visibility listeners
	 */ cleanupPageVisibilityListeners() {
        if (this.pageVisibilityHandlers) {
            document.removeEventListener('visibilitychange', this.pageVisibilityHandlers.handleVisibilityChange);
            window.removeEventListener('blur', this.pageVisibilityHandlers.handleWindowBlur);
            window.removeEventListener('pagehide', this.pageVisibilityHandlers.handlePageHide);
            this.pageVisibilityHandlers = undefined;
        }
    }
    handleDragStart(event, element, isTouch) {
        // Проверяем, не было ли недавно скролла
        const currentTime = performance.now();
        if (currentTime - this.lastScrollEndTime < this.POST_SCROLL_BLOCK_DURATION_MS) // Слишком рано после скролла, игнорируем попытку драга
        return;
        if (this.isDragActive()) return;
        const options = this.draggables.get(element);
        if (!options || options.config?.disabled) return;
        // Сохраняем оригинальное событие для обработки клика
        this.originalEvent = event;
        // Предотвращаем стандартное поведение для DnD
        this.originalEvent.preventDefault();
        this.originalEvent.stopPropagation();
        // Получаем координаты
        let clientX, clientY;
        if ('touches' in event) {
            // Touch event
            const touch = event.touches[0];
            if (!touch) return;
            clientX = touch.clientX;
            clientY = touch.clientY;
        } else {
            // Mouse or Pointer event
            clientX = event.clientX;
            clientY = event.clientY;
        }
        // Сохраняем начальные данные
        this.currentDrag = {
            element: element,
            startX: clientX,
            startY: clientY,
            startTime: performance.now(),
            data: {
                id: options.context.id,
                type: options.context.type,
                data: options.context.data,
                element: element,
                startRect: element.getBoundingClientRect(),
                offset: {
                    x: 0,
                    y: 0
                }
            }
        };
        // Вычисляем offset относительно элемента
        const rect = element.getBoundingClientRect();
        this.currentDrag.data.offset = {
            x: clientX - rect.left,
            y: clientY - rect.top
        };
        // Сбрасываем флаги
        this.isShortClick = false;
        this.hasMoved = false;
        if ($5c62c5d2b879ac35$var$DndDebug.debug) console.log(`${Date.now()} start click timer`, event);
        // Запускаем таймер активации сразу, без ожидания таймера клика
        // Это обеспечивает более надежную активацию драга
        this.cancelClickTimer("start new timer");
        this.clickTimer = setTimeout(()=>{
            this.startActivationTimer(options);
        }, this.ShortClickTimout);
    }
    startActivationTimer(options) {
        // Проверяем, было ли движение до запуска таймера активации
        if (this.hasMoved) // Если уже было движение, не запускаем таймер активации
        return;
        this.isActivating = true;
        this.hasMoved = false;
        this.isDragStarted = false;
        // Визуальная обратная связь
        options.strategy.onActivate?.(options.context);
        const element = this.currentDrag?.element;
        if (!element) {
            console.error("No drag element found");
            return;
        }
        this.visualManager.showActivationFeedback(element, options.strategy.cssClasses?.activating);
        const activationDelay = options.config?.activationDelay || ((0, $125e076244bea594$export$abd12cac50e458a2) ? 2000 : 200);
        this.activationTimer = window.setTimeout(()=>{
            if ($5c62c5d2b879ac35$var$DndDebug.debug) console.log(`${Date.now()} start activation timer expired`);
            if (this.isActivating && this.currentDrag && !this.hasMoved && !this.isShortClick) {
                // Устанавливаем флаг, что перетаскивание началось
                // Это нужно для правильного определения isDragActive()
                this.isDragStarted = true;
                this.activateDrag();
            } else if ($5c62c5d2b879ac35$var$DndDebug.debug) console.log(`${Date.now()}  no drag:${this.currentDrag}, moved:${this.hasMoved}, not activated:${this.isActivating}`);
        }, activationDelay);
        if ($5c62c5d2b879ac35$var$DndDebug.debug) console.log(`${Date.now()} start activation timer`, activationDelay);
    }
    activateDrag() {
        if (!this.currentDrag) {
            console.log("no drag");
            return;
        }
        const options = this.draggables.get(this.currentDrag.element);
        if (!options) {
            console.log("no options");
            return;
        }
        this.isActivating = false;
        this.isDragging = true;
        this.isDragStarted = true;
        this.activationTimer = null;
        // Notify EventManager to block pull-to-refresh
        this.eventManager.setDraggingState(true);
        // Уведомляем клиента
        options.strategy.onDragStart?.(options.context, this.currentDrag.data);
        // Создаем превью
        this.visualManager.createDragPreview(this.currentDrag.element, this.currentDrag.data.offset);
        // Запускаем автоскролл
        this.scrollManager.start();
    }
    handleDragMove(clientX, clientY, isTouch) {
        if (!this.currentDrag) return;
        const options = this.draggables.get(this.currentDrag.element);
        if (!options) return;
        // Отслеживаем движение с самого начала
        const distanceX = Math.abs(clientX - this.currentDrag.startX);
        const distanceY = Math.abs(clientY - this.currentDrag.startY);
        const movementThreshold = options.config?.movementThreshold || this.MOVE_DETECTION_THRESHOLD_PX; // Используем порог для детектирования движения
        // Обновляем флаг hasMoved при любом движении, превышающем порог
        if (!this.hasMoved && (distanceX > movementThreshold || distanceY > movementThreshold)) {
            this.hasMoved = true;
            // Если таймер активации еще не запущен, отменяем его
            // Если уже запущен, проверяем, нужно ли отменить
            if (this.activationTimer && this.isActivating) {
                // Отменяем таймер активации, если уже было движение
                clearTimeout(this.activationTimer);
                this.activationTimer = null;
                this.isActivating = false;
                // Отменяем текущий драг
                this.cancelCurrentDrag();
                return;
            }
        }
        //console.log(`${Date.now()} move`, distanceX, distanceY, this.hasMoved);
        // Проверяем движение во время активации
        if (this.isActivating && !this.isShortClick) {
            const movedX = Math.abs(clientX - this.currentDrag.startX);
            const movedY = Math.abs(clientY - this.currentDrag.startY);
            // Используем централизованный метод для определения типа движения
            const movementType = this.detectMovementType(movedX, movedY);
            switch(movementType){
                case 'vertical_swipe':
                    // Это вертикальный свайп (скролл), отменяем драг
                    options.strategy.onScrollActivation?.(options.context);
                    this.cancelCurrentDrag();
                    // Устанавливаем время последнего скролла
                    this.lastScrollEndTime = performance.now();
                    return;
                case 'horizontal_drag':
                    break;
                case 'movement_detected':
                    // Любое движение больше порога детекции, но не явный свайп
                    // Отменяем DnD в пользу скролла или обычного движения
                    options.strategy.onScrollActivation?.(options.context);
                    this.cancelCurrentDrag();
                    // Устанавливаем время последнего скролла
                    this.lastScrollEndTime = performance.now();
                    return;
                case 'no_movement':
                    break;
            }
        }
        // Обновляем позицию при активном перетаскивании
        if (this.isDragging) {
            // Обновляем превью с учетом offset
            const previewX = Math.floor(clientX - this.currentDrag.data.offset.x);
            const previewY = Math.floor(clientY - this.currentDrag.data.offset.y);
            // console.log(`${Date.now()} update preview`, previewX, previewY);
            this.visualManager.updateDragPreview(previewX, previewY);
            // Обновляем автоскролл
            this.scrollManager.update(clientX, clientY);
            // Ищем дроп-зону под курсором
            this.updateDropZoneUnderCursor(clientX, clientY);
        }
    }
    updateDropZoneUnderCursor(x, y) {
        if (!this.currentDrag) return;
        // Ищем все подходящие дроп-зоны
        for (const [element, config] of this.dropZones){
            const { context: context, strategy: strategy } = config;
            // Проверяем совместимость типов
            if (!context.acceptTypes.includes(this.currentDrag.data.type)) continue;
            const rect = element.getBoundingClientRect();
            // Проверяем попадание в bounding box
            if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
                // Вызываем стратегию для определения позиции
                const position = strategy.calculateDropPosition(x, y, context, this.currentDrag.data);
                if (position) {
                    // Проверяем, является ли это та же дроп-зона, что и текущая
                    const isSameDropZone = this.currentDropZone && this.currentDropZone.config.context.element === element;
                    // Если это новая дроп-зона или текущая дроп-зона изменила позицию
                    if (!this.currentDropZone || !isSameDropZone) {
                        // Уведомляем о выходе из предыдущей зоны
                        const dropZoneConfig = this.currentDropZone?.config;
                        //@ts-ignore
                        dropZoneConfig?.strategy.onDragLeave?.(dropZoneConfig.context, this.currentDrag.data);
                        // Уведомляем о входе в новую зону
                        strategy.onDragEnter?.(context, this.currentDrag.data, position);
                        this.currentDropZone = {
                            config: config,
                            position: position
                        };
                        // Создаем индикатор
                        this.visualManager.createDropIndicator(position, strategy.cssClasses?.active);
                        if ($5c62c5d2b879ac35$var$DndDebug.debug) console.log(`${Date.now()} dropzone changed`);
                    } else if (this.currentDropZone && isSameDropZone) {
                        // Проверяем, изменилась ли позиция достаточно, чтобы обновить
                        const currentPosition = this.currentDropZone.position;
                        const positionChanged = currentPosition.relativeX !== position.relativeX || currentPosition.relativeY !== position.relativeY || JSON.stringify(currentPosition.data) !== JSON.stringify(position.data);
                        if (positionChanged) {
                            this.currentDropZone.position = position;
                            this.visualManager.updateDropIndicator(position, strategy.cssClasses?.active);
                        }
                    }
                    return;
                }
            }
        }
        // Курсор вне всех дроп-зон
        if (this.currentDropZone) {
            if ($5c62c5d2b879ac35$var$DndDebug.debug) console.log(`${Date.now()} dropzone clear`);
            this.clearDropZone();
        }
    }
    clearDropZone() {
        if (this.currentDropZone && this.currentDrag) this.currentDropZone.config.strategy.onDragLeave?.(this.currentDropZone.config.context, this.currentDrag.data);
        this.currentDropZone = null;
        this.visualManager.clearDropIndicator();
    }
    handleDragEnd(e) {
        e?.stopPropagation?.();
        if (!this.currentDrag) {
            // Если была только активация - отменяем
            if (this.isActivating) this.cancelCurrentDrag();
            return;
        }
        const options = this.draggables.get(this.currentDrag.element);
        if (!options) {
            this.cancelCurrentDrag();
            return;
        }
        // Проверяем, был ли это короткий клик
        // Если таймер активации все еще работает, значит пользователь отпустил до окончания таймера - это короткий клик
        const dragDuration = performance.now() - this.currentDrag.startTime;
        const isShortClick = dragDuration < this.ShortClickTimout && !this.hasMoved && !this.isDragging;
        // Если это короткий клик - обрабатываем как клик
        if (isShortClick) {
            // Отменяем таймер активации если он есть
            if (this.activationTimer) {
                clearTimeout(this.activationTimer);
                this.activationTimer = null;
            }
            // Сбрасываем визуальные эффекты
            this.visualManager.clearAll();
            // Восстанавливаем нормальное поведение для кликов
            this.eventManager.setDraggingState(false);
            // Вызываем обработчик короткого клика если есть
            setTimeout(()=>{
                options.strategy.onShortClick?.(options.context, this.getOriginalEvent());
            }, 0);
            // Уведомляем о отмене драга
            options.strategy.onDragCancel?.(options.context);
            // Сбрасываем состояние
            this.resetDragState();
            return;
        }
        let dropResult = {
            success: false
        };
        // Обрабатываем дроп, если есть активная зона
        if (this.currentDropZone && this.isDragging) {
            const { config: config, position: position } = this.currentDropZone;
            dropResult = config.strategy.onDrop?.(config.context, this.currentDrag.data, position) || {
                success: true
            };
        }
        // Уведомляем клиента о завершении перетаскивания в любом случае
        if (this.isDragging || this.isDragStarted) // Вызываем onDragEnd для завершения перетаскивания
        options.strategy.onDragEnd?.(options.context, dropResult);
        else if (this.isActivating) // Если был только таймер активации - это клик/тап
        options.strategy.onDragCancel?.(options.context);
        else // В любом другом случае, если было начато перетаскивание, вызываем onDragCancel
        options.strategy.onDragCancel?.(options.context);
        // Очищаем состояние
        this.completeDrag();
    }
    // Новый метод для сброса состояния драга
    resetDragState() {
        this.isActivating = false;
        this.isDragging = false;
        this.isDragStarted = false; // ← ВАЖНО: сбросить этот флаг!
        this.hasMoved = false;
        this.activationTimer = null;
        this.currentDrag = null;
        this.currentDropZone = null;
        this.scrollManager.stop();
        this.eventManager.setDraggingState(false);
    }
    // Метод для получения оригинального события (нужно добавить сохранение события в handleDragStart)
    getOriginalEvent() {
        // В handleDragStart нужно сохранить оригинальное событие
        return this.originalEvent;
    }
    completeDrag() {
        this.scrollManager.stop();
        // Clear visual elements
        this.visualManager.clearAll();
        // Restore normal touch behavior (CRITICAL: was missing!)
        this.eventManager.setDraggingState(false);
        this.clearDropZone();
        this.isActivating = false;
        this.isDragging = false;
        this.hasMoved = false;
        this.isShortClick = false;
        this.isDragStarted = false;
        this.activationTimer = null;
        this.currentDrag = null;
        this.currentDropZone = null;
        this.originalEvent = null;
    }
    /**
	 * Централизованный метод для определения типа движения
	 * @param movedX - абсолютное движение по оси X от начальной точки
	 * @param movedY - абсолютное движение по оси Y от начальной точки
	 * @returns тип движения
	 */ detectMovementType(movedX, movedY) {
        // Проверяем, является ли движение в основном вертикальным (скролл)
        if (movedY > movedX && movedY > this.SWIPE_DETECTION_THRESHOLD_PX) return 'vertical_swipe'; // Это вертикальный свайп (скролл)
        else if (movedX > movedY && movedX > this.SWIPE_DETECTION_THRESHOLD_PX) return 'horizontal_drag'; // Это горизонтальный драг
        else if (movedX > this.MOVE_DETECTION_THRESHOLD_PX || movedY > this.MOVE_DETECTION_THRESHOLD_PX) return 'movement_detected'; // Любое движение больше порога детекции, но не явный свайп
        else return 'no_movement'; // Нет значительного движения
    }
}




var $gIfym = parcelRequire("gIfym");
class $6010f9a8d990c1ae$export$698223c589197ab7 extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    componentDidMount() {
        const element = document.createElement('div');
        element.className = this.props.className ? this.props.className : 'task-card__backdrop';
        element.onclick = this.props.onClick;
        element.role = "presentation";
        document.body.appendChild(this.element = element);
    }
    componentWillUnmount() {
        if (this.element) this.element.remove();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), this.element = null;
    }
}











class $81f9e04fc0b14fe4$var$TaskCard extends (0, $gIfym.Component) {
    constructor(props){
        super(props), this.dndSystem = (0, $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3).getInstance(), this.disposer = new (0, $9b26b9646341d616$export$6039fc6176d96e35)(), // Статус синхронизации
        this.getSyncStatus = (task)=>{
            if (task.isSynced && task.serverId) return {
                text: "\u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
                color: 'text-green-600',
                bgColor: 'bg-green-100',
                icon: "\u2713",
                className: 'task-card__sync-status--synced'
            };
            else if (!task.isSynced && task.serverId) return {
                text: "\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0435 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u044B",
                color: 'text-yellow-600',
                bgColor: 'bg-yellow-100',
                icon: "\u21BB",
                className: 'task-card__sync-status--pending'
            };
            else return {
                text: "\u0442\u043E\u043B\u044C\u043A\u043E \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E",
                color: 'text-gray-600',
                bgColor: 'bg-gray-100',
                icon: "\uD83D\uDCBE",
                className: 'task-card__sync-status--local'
            };
        }, // Методы для редактирования
        this.onEditInline = ()=>{
            // Блокируем редактирование если доска в режиме редактирования
            if (this.state.board.isEditing) {
                console.log("\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u043F\u0440\u0430\u0432\u043A\u0438 \u0434\u043E\u0441\u043A\u0438");
                return;
            }
            this.setState({
                isEditing: true
            });
            this.taskEditController.startInlineEdit(this.props.task.id, 'title').catch(console.error);
        }, this.onEditFull = ()=>{
            // Блокируем редактирование если доска в режиме редактирования
            if (this.state.board.isEditing) {
                console.log("\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u043F\u0440\u0430\u0432\u043A\u0438 \u0434\u043E\u0441\u043A\u0438");
                return;
            }
            console.log("\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0434\u043B\u044F \u0437\u0430\u0434\u0430\u0447\u0438:", this.props.task.id);
            this.taskEditController.startEdit(this.props.task.id).catch(console.error);
        }, this.handleDoubleClick = (e)=>{
            e.stopPropagation();
            this.onEditInline();
        }, this.handleTitleClick = (e)=>{
            e.stopPropagation();
            this.onEditInline();
        }, this.handleFullEditClick = (e)=>{
            e.stopPropagation();
            this.onEditFull();
        }, this.handleAttachmentClick = (e)=>{
            e.stopPropagation();
            console.log("\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0437\u0430\u0434\u0430\u0447\u0438:", this.props.task.id);
        }, this.handleSaveTask = async (newTitle)=>{
            try {
                await this.taskEditController.updateTask({
                    title: newTitle.trim()
                });
            } catch (error) {
                console.error('Error updating task:', error);
                throw error;
            }
        }, this.handleDeleteTask = async ()=>{
            try {
                await this.taskEditController.deleteTask();
            } catch (error) {
                console.error('Error deleting task:', error);
                throw error;
            }
        }, this.handleCloseEditor = ()=>{
            this.taskEditController.cancelEdit();
            this.setState({
                isEditing: false
            });
        }, this.toggleDescription = ()=>{
            this.setState((prevState)=>({
                    isExpanded: !prevState.isExpanded
                }));
        };
        this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
        this.taskEditController = this.app.getTaskEditController();
        this.cardRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef();
        this.state = {
            viewMode: this.app.getViewMode(),
            isExpanded: false,
            isEditing: false,
            isDragging: false,
            isActivating: false,
            isHighlighted: false,
            isNewTask: false,
            board: this.getBoard()
        };
    }
    getBoard() {
        let board = this.app.getBoardById(this.props.task.boardId);
        if (!board) {
            console.error(`"Board '${this.props.task.boardId}' not found`, this.props);
            throw new Error(`"Board '${this.props.task.boardId}' not found`);
        }
        return board;
    }
    componentDidMount() {
        // Подписываемся на изменение режима просмотра
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).viewModeChanged, (mode)=>{
            this.setState({
                viewMode: mode
            });
        });
        // Подписываемся на завершение редактирования
        this.disposer.register(this.taskEditController.onEditEnd, ()=>{
            // Сохраняем состояние подсветки при завершении редактирования
            this.setState((prevState)=>({
                    isEditing: false
                }));
        });
        // Подписываемся на обновление доски для отслеживания режима редактирования
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated, ()=>{
            this.forceUpdate();
            // Если доска перешла в режим редактирования, а мы редактируем задачу - отменяем
            if (this.getBoard().isEditing && this.state.isEditing) {
                this.taskEditController.cancelEdit();
                this.setState((prevState)=>({
                        isEditing: false
                    }));
            }
            // Перерегистрируем DnD с новым состоянием
            this.unregisterDnd();
            this.registerDnd();
        });
        // Подписываемся на сигнал подсветки и скролла к задаче
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).highlightAndScrollToTask, (data)=>{
            // Проверяем совпадение по актуальному ID или по временному ID
            if (data.taskId === this.props.task.id || data.tempId === this.props.task.id || data.tempId === this.props.task.localId) this.highlightAndScroll();
        });
        if (this.app.getTaskHighlight(this.props.task)) //global state changed, new task created.
        this.highlightAndScroll();
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).taskUpdated, (task)=>{
            if (task.id !== this.props.task.id) return;
            this.forceUpdate();
        });
        // Регистрируем DnD когда элемент доступен
        this.registerDnd();
    }
    componentDidUpdate(prevProps, prevState) {
        // Если изменился индекс, перерегистрируем DnD
        if (prevProps.index !== this.props.index && this.cardRef.current || prevState.isEditing !== this.state.isEditing) {
            this.unregisterDnd();
            this.registerDnd();
        }
    }
    componentWillUnmount() {
        // Отписываемся от всех подписок через Disposer
        this.disposer.dispose();
        // Отменяем регистрацию DnD
        this.unregisterDnd();
    }
    highlightAndScroll() {
        // Устанавливаем состояние подсветки
        //this.setState({ isHighlighted: true });
        // Прокручиваем к элементу с небольшой задержкой, чтобы убедиться, что DOM обновлен
        setTimeout(()=>{
            if (this.cardRef.current) // Прокручиваем к элементу
            this.cardRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }, 100); // Небольшая задержка для гарантии отрисовки
        // Убираем состояние подсветки через 3 секунды
        setTimeout(()=>{
            this.app.setTaskHighlight(this.props.task, false);
            (0, $883133d1f570db27$export$bfc40ca370b68e03).taskUpdated.emit(this.props.task);
        }, 1000);
    }
    registerDnd() {
        if (!this.cardRef.current) return;
        const { task: task } = this.props;
        const editState = this.taskEditController.state;
        // Не регистрируем DnD если редактируем задачу или доску находится в режиме редактирования
        const board = this.getBoard();
        if (editState.isEditing || board.isEditing) //console.log("dnd ignore - task editing or board editing");
        return;
        const element = this.cardRef.current;
        const context = {
            element: element,
            id: task.id,
            type: 'task',
            data: {
                taskId: task.id,
                columnId: task.columnId,
                index: this.props.index
            }
        };
        const strategy = {
            cssClasses: {
                activating: 'task-card--touch-active',
                dragging: 'task-card--dragging'
            },
            onActivate: (context)=>{
                this.setState({
                    isActivating: true
                });
                context.element.classList.add('task-card--touch-active');
            },
            onDragStart: (context, dragData)=>{
                this.setState({
                    isActivating: false,
                    isDragging: true
                });
                (0, $883133d1f570db27$export$bfc40ca370b68e03).taskDragStarted.emit(dragData);
                context.element.classList.remove('task-card--touch-active');
                context.element.classList.add('task-card--dragging');
            },
            onDragEnd: (context, result)=>{
                this.setState({
                    isDragging: false,
                    isActivating: false
                });
                (0, $883133d1f570db27$export$bfc40ca370b68e03).taskDragEnded.emit(result);
                context.element.classList.remove('task-card--touch-active', 'task-card--dragging');
            },
            onDragCancel: (context)=>{
                this.setState({
                    isActivating: false,
                    isDragging: false
                });
                context.element.classList.remove('task-card--touch-active', 'task-card--dragging');
            },
            onScrollActivation: (context)=>{
                this.setState({
                    isActivating: false
                });
                context.element.classList.remove('task-card--touch-active');
                console.log('Scroll activated instead of DnD');
            },
            onShortClick: (context, event)=>{
                event.stopPropagation();
                this.onEditInline();
            }
        };
        const config = {
            ...(0, $676334fc1be830c5$export$d8f2ed617be73058),
            preventScroll: true,
            disabled: editState.isEditing
        };
        this.dndUnregister = this.dndSystem.registerDraggable({
            context: context,
            strategy: strategy,
            config: config
        });
    }
    unregisterDnd() {
        if (this.dndUnregister) {
            this.dndUnregister();
            this.dndUnregister = undefined;
        }
    }
    render() {
        // Собираем модификаторы для корневого элемента по БЭМ
        const classBlock = `task-card`;
        const rootModifiers = [
            `${classBlock}--${this.state.viewMode}`,
            this.state.isEditing ? `${classBlock}--editing` : '',
            this.state.isExpanded ? `${classBlock}--expanded` : '',
            this.state.isDragging ? `${classBlock}--dragging` : '',
            this.state.isActivating ? `${classBlock}--touch-active` : '',
            this.state.board.isEditing ? `${classBlock}--board-editing` : '',
            this.app.getTaskHighlight(this.props.task) ? `${classBlock}--highlighted` : ''
        ].filter(Boolean).join(' ');
        // Определяем курсор
        const cursor = this.taskEditController.state.isEditing || this.state.board.isEditing ? 'default' : 'grab';
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                this.state.isEditing && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6010f9a8d990c1ae$export$698223c589197ab7), {
                    onClick: this.handleCloseEditor,
                    className: "task-card__backdrop"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    ref: this.cardRef,
                    className: `task-card ${rootModifiers}`,
                    //onDoubleClick={this.handleDoubleClick}
                    style: {
                        cursor: cursor
                    },
                    "data-task-id": this.props.task.id,
                    children: [
                        this.state.isEditing && this.renderEditor(),
                        this.renderCardContent()
                    ]
                })
            ]
        });
    }
    renderEditor() {
        const { task: task } = this.props;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3cc2bb8914708843$export$2e2bcd8739ae039), {
            cardRef: this.cardRef,
            task: task,
            onClose: this.handleCloseEditor,
            onSave: this.handleSaveTask,
            onDelete: this.handleDeleteTask
        });
    }
    renderCardContent() {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                this.renderHeader(),
                this.renderDescription(),
                this.renderMetaSection(),
                false
            ]
        });
    }
    renderHeader() {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "task-card__header",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h4", {
                className: `task-card__title task-card__title--${this.state.viewMode}`,
                onClick: this.handleTitleClick,
                style: {
                    cursor: !this.state.isEditing ? 'text' : 'default'
                },
                children: this.props.task.title
            })
        });
    }
    renderDescription() {
        return null;
    }
    renderMetaSection() {
        const hasAttachments = this.props.task.attachments.length > 0;
        const hasComments = this.props.task.comments.length > 0;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "task-card__meta",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "task-card__meta-left",
                    children: hasAttachments || hasComments ? this.renderIcons() : null
                }),
                this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && this.renderMobileActions()
            ]
        });
    }
    renderIcons() {
        const hasAttachments = this.props.task.attachments.length > 0;
        const hasComments = this.props.task.comments.length > 0;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "task-card__icons",
            children: [
                hasAttachments && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
                    className: "task-card__icon",
                    title: "\u0412\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
                    children: [
                        (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Attachment,
                        this.props.task.attachments.length
                    ]
                }),
                hasComments && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
                    className: "task-card__icon",
                    title: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438",
                    children: [
                        (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Comment,
                        this.props.task.comments.length
                    ]
                })
            ]
        });
    }
    renderMobileActions() {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "task-card__actions",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                className: "task-card__action-button",
                type: "button",
                "aria-label": "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
                children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Menu
            })
        });
    }
    renderDesktopFooter() {
        const syncStatus = this.getSyncStatus(this.props.task);
        const actions = [
            {
                id: 'attachment',
                icon: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Attachment,
                title: "\u0412\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
                onClick: this.handleAttachmentClick
            },
            {
                id: 'edit',
                icon: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).EditDoc,
                title: "\u041F\u043E\u043B\u043D\u043E\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
                onClick: this.handleFullEditClick
            },
            {
                id: 'comment',
                icon: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Comment,
                title: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438"
            },
            {
                id: 'user',
                icon: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).User,
                title: "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438"
            },
            {
                id: 'sync',
                title: syncStatus.text,
                icon: syncStatus.icon,
                className: `task-card__sync-icon ${syncStatus.className}`,
                ariaLabel: syncStatus.text
            }
        ];
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "task-card__footer",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "task-card__footer-content",
                    children: this.props.task.serverId && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
                        className: `task-card__id task-card__id--${this.state.viewMode}`,
                        children: [
                            "#",
                            this.props.task.serverId
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "task-card__footer-actions",
                    children: actions.map((config)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                            className: `task-card__footer-icon ${config.className || ''}`,
                            onClick: config.onClick,
                            title: config.title,
                            type: "button",
                            "aria-label": config.ariaLabel || config.title,
                            children: config.icon
                        }, config.id))
                })
            ]
        });
    }
}
var $81f9e04fc0b14fe4$export$2e2bcd8739ae039 = $81f9e04fc0b14fe4$var$TaskCard;




var $gIfym = parcelRequire("gIfym");


const $92760033e2138c20$var$InlineEditWidget = ({ value: value, onSave: onSave, onEditStart: onEditStart, onEditFinish: onEditFinish, onCancel: onCancel, placeholder: placeholder = "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435", className: className = '', maxLength: maxLength = 255, autoFocus: autoFocus = true, view: view })=>{
    const [isEditing, setIsEditing] = (0, $gIfym.useState)(false);
    const [inputValue, setInputValue] = (0, $gIfym.useState)(value);
    const [isSaving, setIsSaving] = (0, $gIfym.useState)(false);
    const inputRef = (0, $gIfym.useRef)(null);
    (0, $gIfym.useEffect)(()=>{
        setInputValue(value);
    }, [
        value
    ]);
    (0, $gIfym.useEffect)(()=>{
        if (isEditing && autoFocus && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [
        isEditing,
        autoFocus
    ]);
    const handleEditStart = ()=>{
        if (onEditStart) onEditStart();
        setIsEditing(true);
    };
    const handleSave = async ()=>{
        const trimmedValue = inputValue.trim();
        if (!trimmedValue) {
            // Не сохраняем пустые значения
            if (onCancel) onCancel();
            handleEditFinish();
            setIsEditing(false);
            return;
        }
        setIsSaving(true);
        try {
            await onSave(trimmedValue);
            handleEditFinish();
            setIsEditing(false);
        } catch (error) {
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438:", error);
        } finally{
            setIsSaving(false);
        }
    };
    const handleCancel = ()=>{
        if (onCancel) onCancel();
        handleEditFinish();
        setIsEditing(false);
    };
    const handleEditFinish = ()=>{
        if (onEditFinish) onEditFinish();
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            handleCancel();
        }
    };
    const handleBlur = (e)=>{
        // Не закрываем при клике на кнопки внутри виджета
        if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) handleSave();
    };
    if (!isEditing) {
        if (!view) return null;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: `inline-edit-widget ${className}`,
            onClick: ()=>setIsEditing(true),
            children: view({
                value: value,
                onEditStart: handleEditStart
            })
        });
    }
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: `inline-edit-widget ${className}`,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "inline-edit-widget__input-container",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                    ref: inputRef,
                    type: "text",
                    value: inputValue,
                    onChange: (e)=>setInputValue(e.target.value),
                    onKeyDown: handleKeyDown,
                    onBlur: handleBlur,
                    placeholder: placeholder,
                    maxLength: maxLength,
                    disabled: isSaving,
                    className: "inline-edit-widget__input",
                    "aria-label": "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435"
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "inline-edit-widget__buttons",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        type: "button",
                        onClick: handleSave,
                        disabled: isSaving || !inputValue.trim(),
                        className: "inline-edit-widget__button inline-edit-widget__button--save",
                        title: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
                        "aria-label": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F",
                        children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Checked
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        type: "button",
                        onClick: handleCancel,
                        disabled: isSaving,
                        className: "inline-edit-widget__button inline-edit-widget__button--cancel",
                        title: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
                        "aria-label": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F",
                        children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Close
                    })
                ]
            })
        ]
    });
};
var $92760033e2138c20$export$2e2bcd8739ae039 = $92760033e2138c20$var$InlineEditWidget;







// Константа для localStorage ключа
const $103ed583fee002d5$var$COLLAPSED_PREFIX = 'column-collapsed-';
function $103ed583fee002d5$var$SyncProgress({ tasks: tasks }) {
    //TODO: activate it.
    return null;
}
class $103ed583fee002d5$var$Column extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.dndSystem = (0, $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3).getInstance(), this.columnRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef(), this.disposer = new (0, $9b26b9646341d616$export$6039fc6176d96e35)(), this.tasksContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef(), this.editButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef(), this.taskOrderProcessor = (0, $e9fce746c8105712$export$109143baced8e56f).getInstance(), // Проверяет, есть ли переполнение в контейнере задач
        this.checkScrollOverflow = ()=>{
            requestAnimationFrame(()=>{
                const tasksContainer = this.tasksContainerRef.current;
                if (tasksContainer) {
                    const hasScroll = tasksContainer.scrollHeight > tasksContainer.clientHeight;
                    if (hasScroll !== this.state.hasScroll) this.setState({
                        hasScroll: hasScroll
                    });
                }
            });
        }, // Разворачивает колонку если она свернута
        this.expandIfCollapsed = ()=>{
            if (this.state.isCollapsed && this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) {
                const collapsedKey = `${$103ed583fee002d5$var$COLLAPSED_PREFIX}${this.props.column.id}`;
                this.setState({
                    isCollapsed: false
                });
                localStorage.setItem(collapsedKey, 'false');
                return true;
            }
            return false;
        }, // Начать редактирование названия колонки
        this.handleStartEditTitle = (e)=>{
            e.stopPropagation();
            e.preventDefault();
            this.setState({
                isEditingTitle: true
            }, ()=>{
                // Отключаем DnD при начале редактирования
                this.unregisterDropZone();
                (0, $883133d1f570db27$export$bfc40ca370b68e03).columnEditStart.emit(this.props.column.id);
            });
        }, // Сохранить новое название колонки
        this.handleSaveTitle = async (newTitle)=>{
            try {
                this.props.column.title = newTitle;
                await this.app.columnRename(this.props.column.id, newTitle);
                this.handleCancelEditTitle();
            } catch (error) {
                console.error('Error renaming column:', error);
            // Оставляем в режиме редактирования при ошибке
            }
        }, // Отменить редактирование названия
        this.handleCancelEditTitle = ()=>{
            this.setState({
                isEditingTitle: false
            }, ()=>{
                // Восстанавливаем DnD после отмены
                (0, $883133d1f570db27$export$bfc40ca370b68e03).columnEditFinish.emit(this.props.column.id);
                this.registerDropZone();
            });
        }, // Сохранить при потере фокуса
        this.handleBlurSaveTitle = async (newTitle)=>{
            if (newTitle.trim() && newTitle.trim() !== this.props.column.title) await this.handleSaveTitle(newTitle);
            else this.handleCancelEditTitle();
        }, // Обработчик клика по заголовку для сворачивания/разворачивания
        this.handleToggleExpand = (e)=>{
            e.stopPropagation();
            const newCollapsed = !this.state.isCollapsed;
            this.setState({
                isCollapsed: newCollapsed
            });
            // Сохраняем в localStorage
            const collapsedKey = `${$103ed583fee002d5$var$COLLAPSED_PREFIX}${this.props.column.id}`;
            localStorage.setItem(collapsedKey, newCollapsed.toString());
            // Если разворачиваем колонку, возможно нужно прокрутить к ней
            if (!newCollapsed && this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) setTimeout(()=>{
                this.columnRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }, // Обработчик удаления колонки
        this.handleDeleteColumn = (e)=>{
            e.stopPropagation(); // Важно: останавливаем всплытие
            this.app.columnDelete(this.props.column.id).catch(console.error);
        }, this.handleTaskAddedInMobileList = ()=>{
            // Уведомляем Board, что задача добавлена
            // Board закроет режим добавления
            if (this.props.onTaskAdded) this.props.onTaskAdded();
        }, this.handleCancelAddInMobileList = ()=>{
            // Уведомляем Board, что добавление отменено
            if (this.props.onCancel) this.props.onCancel();
        };
        this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
        const initialBoard = this.getBoard();
        const initialViewMode = this.app.getCurrentViewMode();
        const shouldForceCollapse = initialBoard.isEditing && initialViewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
        this.state = {
            viewMode: initialViewMode,
            isCollapsed: shouldForceCollapse ? true : false,
            originalCollapsedState: null,
            forceUpdate: 0,
            hasScroll: false,
            isDragOver: false,
            isEditingTitle: false
        };
    }
    componentDidMount() {
        const board = this.getBoard();
        // Загружаем состояние collapsed из localStorage
        const collapsedKey = `${$103ed583fee002d5$var$COLLAPSED_PREFIX}${this.props.column.id}`;
        const isCollapsed = localStorage.getItem(collapsedKey) === 'true';
        this.setState({
            isCollapsed: isCollapsed
        });
        // Подписка на сигнал принудительного раскрытия
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).expandColumn, (columnId)=>{
            if (columnId === this.props.column.id && this.state.isCollapsed) {
                this.setState({
                    isCollapsed: false
                });
                localStorage.setItem(collapsedKey, 'false');
            }
        });
        // Подписка на сигнал активации добавления задачи
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).activateTaskAdd, (columnId)=>{
            if (columnId !== this.props.column.id) return;
            if (this.expandIfCollapsed()) setTimeout(()=>{
                (0, $883133d1f570db27$export$bfc40ca370b68e03).activateTaskAdd.emit(columnId);
            }, 10);
        });
        // Подписка на изменение режима просмотра
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).viewModeChanged, (mode)=>{
            const shouldForceCollapse = board.isEditing && mode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
            if (shouldForceCollapse && !this.state.isCollapsed) {
                // Сохраняем текущее состояние как оригинальное
                const collapsedKey = `${$103ed583fee002d5$var$COLLAPSED_PREFIX}${this.props.column.id}`;
                const currentCollapsed = localStorage.getItem(collapsedKey) === 'true';
                this.setState({
                    viewMode: mode,
                    isCollapsed: true,
                    originalCollapsedState: currentCollapsed
                });
            } else if (!board.isEditing && this.state.originalCollapsedState !== null) // Восстанавливаем оригинальное состояние при выходе из редактирования
            this.setState({
                viewMode: mode,
                isCollapsed: this.state.originalCollapsedState,
                originalCollapsedState: null
            });
            else this.setState({
                viewMode: mode
            });
        });
        // Подписка на изменение режима редактирования доски
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated, ()=>{
            const shouldForceCollapse = board.isEditing && this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
            if (shouldForceCollapse && !this.state.isCollapsed) {
                // Сохраняем текущее состояние как оригинальное
                const collapsedKey = `${$103ed583fee002d5$var$COLLAPSED_PREFIX}${this.props.column.id}`;
                const currentCollapsed = localStorage.getItem(collapsedKey) === 'true';
                this.setState({
                    isCollapsed: true,
                    originalCollapsedState: currentCollapsed
                });
            } else if (!board.isEditing && this.state.originalCollapsedState !== null) // Восстанавливаем оригинальное состояние при выходе из редактирования
            this.setState({
                isCollapsed: this.state.originalCollapsedState,
                originalCollapsedState: null
            });
            // Обновляем forceUpdate для перерендера
            this.setState((prevState)=>({
                    forceUpdate: prevState.forceUpdate + 1
                }));
        });
        // Подписка на обновление доски
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated, ()=>{
            this.setState((prevState)=>({
                    forceUpdate: prevState.forceUpdate + 1
                }));
        });
        // Подписка на сигнал подсветки и скролла к задаче
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).highlightAndScrollToTask, (data)=>{
            if (data.columnId === this.props.column.id) {
                // Если колонка свернута, разворачиваем её для отображения задачи
                if (this.state.isCollapsed) this.expandIfCollapsed();
                // После обновления DOM и разворачивания колонки, ищем задачу и скроллим к ней
                setTimeout(()=>{
                    // Ищем элемент задачи по ID
                    const taskElement = document.querySelector(`[data-task-id="${data.taskId}"]`);
                    if (taskElement) // Скроллим к самой задаче
                    taskElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                    else // Если элемент задачи не найден, скроллим к колонке
                    if (this.columnRef.current) this.columnRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }, 150); // Даем время для обновления DOM
            }
        });
        // Регистрируем drop zone когда элемент доступен
        this.registerDropZone();
        this.columnRef.current.onDndClick = (e)=>{
            if (e.target !== this.editButtonRef.current) return;
            if (this.state.isEditingTitle) return;
            this.handleStartEditTitle(e);
        };
    }
    getBoard() {
        const board = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getBoardById(this.props.column.boardId);
        if (!board) throw Error(`Board '${this.props.column.boardId}' not found`);
        return board;
    }
    componentDidUpdate(prevProps, prevState) {
        // Проверяем переполнение контейнера задач после обновлений
        if (this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && !this.state.isCollapsed) this.checkScrollOverflow();
        // Если изменилась колонка или режим просмотра, перерегистрируем drop zone
        if ((prevProps.column.id !== this.props.column.id || prevState.viewMode !== this.state.viewMode) && this.columnRef.current) {
            this.unregisterDropZone();
            this.registerDropZone();
        }
    }
    componentWillUnmount() {
        this.disposer.dispose();
        this.unregisterDropZone();
    }
    registerDropZone() {
        const element = this.columnRef.current;
        if (!element) return;
        const context = {
            element: element,
            id: this.props.column.id,
            acceptTypes: [
                'task'
            ]
        };
        const strategy = {
            cssClasses: {
                active: 'column--drag-over'
            },
            calculateDropPosition: (x, y, context, dragData)=>{
                const board = this.getBoard();
                // В режиме редактирования доски не принимаем задачи
                if (board.isEditing) return null;
                const element = context.element;
                const rect = element.getBoundingClientRect();
                // Проверяем попадание в bounding box
                if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) return null;
                // Получаем все задачи в колонке
                const taskElements = Array.from(element.querySelectorAll('.task-card[data-task-id]'));
                // Если колонка пустая
                if (taskElements.length === 0) return {
                    type: 'empty-container',
                    relativeX: 0.5,
                    relativeY: 0.5,
                    data: {
                        columnId: context.id,
                        index: 0,
                        insertAt: 'start'
                    },
                    visual: {
                        className: 'drop-indicator--empty',
                        style: {
                            top: `${rect.top + 20}px`,
                            left: `${rect.left + 10}px`,
                            width: `${rect.width - 20}px`,
                            height: '100px',
                            border: '2px dashed #4dabf7',
                            borderRadius: '8px'
                        }
                    }
                };
                // Ищем позицию между задачами
                for(let i = 0; i < taskElements.length; i++){
                    const taskRect = taskElements[i].getBoundingClientRect();
                    const middleY = taskRect.top + taskRect.height / 2;
                    if (y < middleY) return {
                        type: 'between-tasks',
                        relativeX: 0.5,
                        relativeY: (y - rect.top) / rect.height,
                        data: {
                            columnId: context.id,
                            index: i,
                            insertAt: 'before',
                            beforeTaskId: taskElements[i].dataset.taskId
                        },
                        visual: {
                            element: taskElements[i],
                            className: "task-drop-indicator",
                            style: {
                                top: `${taskRect.top - 2}px`,
                                left: `${taskRect.left}px`,
                                width: `${taskRect.width}px`,
                                height: '4px',
                                backgroundColor: '#4dabf7',
                                borderRadius: '2px'
                            }
                        }
                    };
                }
                // Дроп в конце колонки
                const lastTask = taskElements[taskElements.length - 1];
                const lastRect = lastTask.getBoundingClientRect();
                return {
                    type: 'end-of-column',
                    relativeX: 0.5,
                    relativeY: 0.95,
                    data: {
                        columnId: context.id,
                        index: taskElements.length,
                        insertAt: 'end'
                    },
                    visual: {
                        element: lastTask,
                        style: {
                            top: `${lastRect.bottom}px`,
                            left: `${lastRect.left}px`,
                            width: `${lastRect.width}px`,
                            height: '4px',
                            backgroundColor: '#4dabf7',
                            borderRadius: '2px'
                        }
                    }
                };
            },
            onDragEnter: (context, dragData, position)=>{
                this.setState({
                    isDragOver: true
                });
                context.element.classList.add('column--drag-over');
            },
            onDragLeave: (context, dragData)=>{
                this.setState({
                    isDragOver: false
                });
                context.element.classList.remove('column--drag-over');
            },
            onDrop: (context, dragData, position)=>{
                this.setState({
                    isDragOver: false
                });
                context.element.classList.remove('column--drag-over');
                try {
                    // Вызов бизнес-логики перемещения задачи
                    // В реальном приложении здесь будет вызов AppSingleton.moveTask()
                    console.log('Drop task:', dragData.id, 'to column:', context.id, 'at position:', position.data.index);
                    // Вызываем метод App для перемещения задачи
                    if (this.app.taskMove) this.app.taskMove(dragData.id, context.id, position.data.index).catch(console.error);
                    return {
                        success: true,
                        data: position.data,
                        message: "\u0417\u0430\u0434\u0430\u0447\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0430"
                    };
                } catch (error) {
                    console.error('Drop failed:', error);
                    return {
                        success: false,
                        error: error instanceof Error ? error.message : 'Unknown error',
                        revert: true
                    };
                }
            }
        };
        const dropZoneConfig = {
            context: context,
            strategy: strategy
        };
        this.dropZoneUnregister = this.dndSystem.registerDropZone(dropZoneConfig);
    }
    unregisterDropZone() {
        if (this.dropZoneUnregister) {
            this.dropZoneUnregister();
            this.dropZoneUnregister = undefined;
        }
    }
    // Получение задач колонки
    getColumnTasks() {
        const { column: column } = this.props;
        const allTasks = this.getBoard().tasks;
        // Получаем отсортированные ID задач из кэша
        const sortedTaskIds = this.taskOrderProcessor.getSortedTaskIds(column.id, allTasks);
        // Получаем мапу задач для быстрого поиска
        const taskMap = this.taskOrderProcessor.getTaskMap(allTasks);
        // Возвращаем задачи в правильном порядке
        return sortedTaskIds.map((taskId)=>taskMap.get(taskId));
    }
    // Получение количества задач в колонке
    getColumnTasksCount() {
        const allTasks = this.getBoard().tasks;
        const sortedTaskIds = this.taskOrderProcessor.getSortedTaskIds(this.props.column.id, allTasks);
        return sortedTaskIds.length;
    }
    // Определение классов для контейнера колонки
    getColumnClasses() {
        const { viewMode: viewMode, isCollapsed: isCollapsed, isDragOver: isDragOver } = this.state;
        const { className: className = '' } = this.props;
        let classes = 'column';
        if (viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) classes += ' column--view_columns';
        else if (viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) {
            classes += ' column--view_list';
            if (isCollapsed) classes += ' column--collapsed';
        }
        if (isDragOver) classes += ' column--drag-over';
        if (className) classes += ' ' + className;
        return classes;
    }
    // Определение классов для заголовка
    getHeaderClasses() {
        let classes = 'column__header';
        if (this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) classes += ' column__header--view_columns';
        else if (this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) classes += ' column__header--view_mobile-list';
        return classes;
    }
    renderCollapsedView() {
        const { column: column } = this.props;
        const tasks = this.getColumnTasks();
        const taskCount = this.getColumnTasksCount();
        const unsyncedCount = tasks.filter((t)=>!t.isSynced).length;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "column__collapsed-view",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
                onClick: this.handleToggleExpand,
                className: "column__toggle-button",
                "aria-expanded": "false",
                "aria-label": `\u{420}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{443} ${column.title}`,
                "data-column-id": column.id,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "column__collapsed-content",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: "column__collapsed-count",
                                children: taskCount
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                className: "column__collapsed-info",
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: "column__collapsed-title",
                                        children: column.title
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                        className: "column__collapsed-status",
                                        children: unsyncedCount > 0 ? `${unsyncedCount} \u{43D}\u{435} \u{441}\u{438}\u{43D}\u{445}\u{440}.` : "\u0412\u0441\u0435 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043E"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        className: "column__collapsed-arrow",
                        children: "\u25BC"
                    })
                ]
            })
        });
    }
    renderColumnHeader() {
        const { viewMode: viewMode, isCollapsed: isCollapsed, isEditingTitle: isEditingTitle } = this.state;
        const { column: column } = this.props;
        const tasks = this.getColumnTasks();
        const board = this.getBoard();
        const headerSpec = {
            tooltip: board.isEditing ? "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0443" : ""
        };
        let classHasTasks = tasks.length > 0 ? 'column__task-count--has-tasks' : '';
        // Если редактируем название, показываем виджет редактирования
        if (isEditingTitle && board.isEditing && viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: this.getHeaderClasses(),
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "column__header-content",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "column__header-main column__title-edit-container",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $92760033e2138c20$export$2e2bcd8739ae039), {
                            value: column.title,
                            onSave: this.handleSaveTitle,
                            onEditStart: ()=>{
                                (0, $883133d1f570db27$export$bfc40ca370b68e03).columnEditStart.emit(this.props.column.id);
                            },
                            onEditFinish: ()=>{
                                (0, $883133d1f570db27$export$bfc40ca370b68e03).columnEditFinish.emit(this.props.column.id);
                            },
                            onCancel: this.handleCancelEditTitle,
                            onBlurSave: this.handleBlurSaveTitle,
                            placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0438",
                            className: "column__edit-widget",
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                            className: `column__task-count ${classHasTasks}`,
                            "aria-label": `\u{41A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{437}\u{430}\u{434}\u{430}\u{447}: ${tasks.length}`,
                            children: tasks.length
                        })
                    ]
                })
            })
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: this.getHeaderClasses(),
            onClick: viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List ? this.handleToggleExpand : undefined,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: "column__header-content",
                    children: [
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: "column__header-main",
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                    className: "column__title-container",
                                    children: [
                                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                                            className: "column__title",
                                            "aria-label": `\u{41A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{430}: ${column.title}`,
                                            title: headerSpec.tooltip,
                                            children: column.title
                                        }),
                                        board.isEditing && viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                            ref: this.editButtonRef,
                                            className: "column__edit-button",
                                            onClick: this.handleStartEditTitle,
                                            title: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
                                            "aria-label": `\u{420}\u{435}\u{434}\u{430}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{442}\u{44C} \u{43D}\u{430}\u{437}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438} ${column.title}`,
                                            onMouseDown: (e)=>e.stopPropagation(),
                                            draggable: false,
                                            "data-dnd-ignore": "true",
                                            children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Edit
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                    className: `column__task-count ${classHasTasks}`,
                                    "aria-label": `\u{41A}\u{43E}\u{43B}\u{438}\u{447}\u{435}\u{441}\u{442}\u{432}\u{43E} \u{437}\u{430}\u{434}\u{430}\u{447}: ${tasks.length}`,
                                    children: tasks.length
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                            className: "column__header-actions",
                            children: [
                                board.isEditing && board.columns.length > 1 && viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && !isEditingTitle && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                    className: "column__delete-button",
                                    onClick: this.handleDeleteColumn,
                                    title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043E\u043B\u043E\u043D\u043A\u0443",
                                    "aria-label": `\u{423}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{44C} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{443} ${column.title}`,
                                    onMouseDown: (e)=>e.stopPropagation(),
                                    draggable: false,
                                    children: " \xd7 "
                                }),
                                viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                    onClick: this.handleToggleExpand,
                                    className: "column__expand-button",
                                    title: isCollapsed ? "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C" : "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
                                    draggable: false,
                                    children: !isCollapsed ? "\u25B2" : "\u25BC"
                                })
                            ]
                        })
                    ]
                }),
                viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && tasks.length > 0 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($103ed583fee002d5$var$SyncProgress, {
                    tasks: tasks
                })
            ]
        });
    }
    renderTasksList() {
        const { viewMode: viewMode } = this.state;
        const tasks = this.getColumnTasks();
        const className = `column__tasks column__tasks--${viewMode} has-scrollbar`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            ref: this.tasksContainerRef,
            className: className,
            children: tasks.map((task, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $81f9e04fc0b14fe4$export$2e2bcd8739ae039), {
                    task: task,
                    index: index
                }, task.localId))
        });
    }
    render() {
        const { viewMode: viewMode, isCollapsed: isCollapsed } = this.state;
        const { column: column } = this.props;
        const { hasScroll: hasScroll } = this.state;
        // Если это мобильный список и колонка свернута
        let isColumnCollapsed = viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && isCollapsed;
        let classSticky = viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && hasScroll ? 'column__add-task-container--sticky' : '';
        let columnContent = /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                this.renderTasksList(),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: `column__add-task-container ${classSticky}`,
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $f442743f362fb998$export$2e2bcd8739ae039), {
                        columnId: column.id,
                        boardId: column.boardId,
                        onTaskAdded: this.handleTaskAddedInMobileList,
                        onCancel: this.handleCancelAddInMobileList,
                        autoFocus: true
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            id: column.id,
            ref: this.columnRef,
            className: this.getColumnClasses(),
            role: "list",
            "aria-label": `\u{41A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{430}: ${column.title}`,
            children: [
                this.renderColumnHeader(),
                isColumnCollapsed ? null : columnContent
            ]
        });
    }
}
var $103ed583fee002d5$export$2e2bcd8739ae039 = $103ed583fee002d5$var$Column;




var $gIfym = parcelRequire("gIfym");


const $2965d131bb960fd6$var$ColumnAdd = ()=>{
    const [isAdding, setIsAdding] = (0, $gIfym.useState)(false);
    const [title, setTitle] = (0, $gIfym.useState)('');
    const [error, setError] = (0, $gIfym.useState)('');
    const inputRef = (0, $gIfym.useRef)(null);
    const app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
    const handleAddClick = ()=>{
        setIsAdding(true);
        setTitle('');
        setError('');
    };
    const handleSave = ()=>{
        if (!title.trim()) {
            setError("\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0443\u0441\u0442\u044B\u043C");
            return;
        }
        try {
            app.columnAdd(title.trim());
            setIsAdding(false);
            setTitle('');
            setError('');
        } catch (err) {
            setError(err instanceof Error ? err.message : "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u043A\u043E\u043B\u043E\u043D\u043A\u0438");
        }
    };
    const handleCancel = ()=>{
        setIsAdding(false);
        setTitle('');
        setError('');
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') handleSave();
        else if (e.key === 'Escape') handleCancel();
    };
    // Автофокус при открытии
    (0, $gIfym.useEffect)(()=>{
        if (isAdding && inputRef.current) inputRef.current.focus();
    }, [
        isAdding
    ]);
    if (!isAdding) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
        onClick: handleAddClick,
        className: "column-add-button",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: "column-add-button__content",
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "column-add-button__icon",
                    children: "+"
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "column-add-button__text",
                    children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u043B\u043E\u043D\u043A\u0443"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "column-add-form",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "column-add-form__input-container",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        value: title,
                        onChange: (e)=>setTitle(e.target.value),
                        onKeyDown: handleKeyDown,
                        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0438",
                        className: "column-add-form__input",
                        maxLength: 50
                    }),
                    error && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "column-add-form__error",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "column-add-form__buttons",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        onClick: handleSave,
                        className: "column-add-form__button column-add-form__button--add",
                        children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        onClick: handleCancel,
                        className: "column-add-form__button column-add-form__button--cancel",
                        children: "\u041E\u0442\u043C\u0435\u043D\u0430"
                    })
                ]
            })
        ]
    });
};
var $2965d131bb960fd6$export$2e2bcd8739ae039 = $2965d131bb960fd6$var$ColumnAdd;




var $gIfym = parcelRequire("gIfym");





class $45b6034cf84bac67$var$ColumnDropzone extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.dndSystem = (0, $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3).getInstance(), this.unregisterFn = null, // Проверяем, находится ли доска в режиме редактирования
        this.isBoardEditing = ()=>{
            return this.getBoard().isEditing || false;
        }, this.getPositionClass = ()=>{
            const { isFirst: isFirst, isLast: isLast } = this.props;
            const viewMode = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getViewMode();
            const baseClass = `column-dropzone column-dropzone--view_${viewMode}`;
            if (isFirst) return `${baseClass} column-dropzone--position_first`;
            if (isLast) return `${baseClass} column-dropzone--position_middle`; // column-dropzone--position_last
            return `${baseClass} column-dropzone--position_middle`;
        }, this.setIsOver = (value)=>{
            this.setState({
                isOver: value
            });
            this.isOverRef.current = value;
        }, // Метод для вычисления позиции дропа
        this.calculateDropPosition = (x, y, context, dragData)=>{
            const { index: index, isFirst: isFirst = false, isLast: isLast = false, viewMode: viewMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List } = this.props;
            // Проверяем, что перетаскивается именно колонка
            if (dragData.type !== 'column') return null;
            const element = context.element;
            const rect = element.getBoundingClientRect();
            // Проверяем попадание в dropzone
            if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) return null;
            // Определяем тип дропзоны с учетом режима просмотра
            const positionType = isFirst ? 'first-column' : isLast ? 'last-column' : 'between-columns';
            // Настраиваем визуальные стили в зависимости от режима
            let visualStyle;
            if (viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) // Вертикальный индикатор для режима списка
            visualStyle = {
                top: `${rect.top}px`,
                left: `${rect.left}px`,
                width: `${rect.width}px`,
                height: `${rect.height}px`,
                backgroundColor: 'rgba(77, 171, 247, 0.1)',
                border: '2px dashed #4dabf7',
                borderRadius: '4px',
                pointerEvents: 'none'
            };
            else // Горизонтальный индикатор для режима колонок
            visualStyle = {
                top: `${rect.top}px`,
                left: `${rect.left}px`,
                width: `${rect.width}px`,
                height: `${rect.height}px`,
                backgroundColor: 'rgba(77, 171, 247, 0.1)',
                border: '2px dashed #4dabf7',
                borderRadius: '8px',
                pointerEvents: 'none'
            };
            return {
                type: positionType,
                relativeX: 0.5,
                relativeY: 0.5,
                data: {
                    dropzoneIndex: index,
                    position: isFirst ? 'before-first' : isLast ? 'after-last' : 'between',
                    sourceColumnId: dragData.data?.columnId,
                    viewMode: viewMode
                },
                visual: {
                    className: `column-dropzone-indicator--${positionType} column-dropzone-indicator--view_${viewMode}`,
                    style: visualStyle
                }
            };
        }, // Метод для обработки входа перетаскивания
        this.handleDragEnter = (context, dragData, position)=>{
            const { index: index } = this.props;
            this.setIsOver(true);
            context.element.classList.add('column-dropzone--drag-over');
            // Уведомляем о начале перетаскивания в дропзону
            (0, $883133d1f570db27$export$bfc40ca370b68e03).columnDragOver.emit({
                dropzoneIndex: index,
                sourceColumnId: dragData.data?.columnId,
                position: position.data?.position
            });
        }, // Метод для обработки выхода перетаскивания
        this.handleDragLeave = (context, dragData)=>{
            const { index: index } = this.props;
            this.setIsOver(false);
            context.element.classList.remove('column-dropzone--drag-over');
            // Уведомляем о выходе из дропзоны
            (0, $883133d1f570db27$export$bfc40ca370b68e03).columnDragLeave.emit({
                dropzoneIndex: index,
                sourceColumnId: dragData.data?.columnId
            });
        }, // Метод для обработки дропа
        this.handleDrop = (context, dragData, position)=>{
            const { index: index, isFirst: isFirst = false, isLast: isLast = false } = this.props;
            this.setIsOver(false);
            context.element.classList.remove('column-dropzone--drag-over');
            try {
                const app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
                const sourceColumnId = dragData.data?.columnId;
                if (!sourceColumnId) throw new Error("\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043A\u043E\u043B\u043E\u043D\u043A\u0430 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F");
                // Определяем новую позицию для колонки
                let targetIndex = index;
                if (isFirst) // Вставка перед первой колонкой
                targetIndex = 0;
                else if (isLast) // Вставка после последней колонки
                targetIndex = this.getBoard().columns.length;
                // Находим исходный индекс колонки
                const columns = this.getBoard().columns;
                const sourceColumn = columns.find((col)=>col.id === sourceColumnId);
                const sourceIndex = sourceColumn ? columns.indexOf(sourceColumn) : -1;
                if (sourceIndex === -1) throw new Error(`\u{41A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{430} \u{441} ID ${sourceColumnId} \u{43D}\u{435} \u{43D}\u{430}\u{439}\u{434}\u{435}\u{43D}\u{430}`);
                // Если дропзона находится между колонками, и мы перетаскиваем колонку из того же набора,
                // нужно скорректировать индекс
                if (sourceIndex >= 0 && targetIndex > sourceIndex) // Если перемещаем вправо, уменьшаем targetIndex на 1
                // потому что исходный элемент будет удален
                targetIndex--;
                // Вызываем метод App для перемещения колонки с индексами
                if (app.columnMove) app.columnMove(sourceIndex, targetIndex).then(()=>{
                    (0, $883133d1f570db27$export$bfc40ca370b68e03).columnMoved.emit({
                        columnId: sourceColumnId,
                        newIndex: targetIndex,
                        oldIndex: sourceIndex
                    });
                }).catch(console.error);
                else // Fallback для обратной совместимости
                console.warn("app.moveColumn \u043D\u0435 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u043D, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C \u043F\u0440\u044F\u043C\u043E\u0439 \u0432\u044B\u0437\u043E\u0432");
                return {
                    success: true,
                    data: {
                        columnId: sourceColumnId,
                        newIndex: targetIndex,
                        dropzoneIndex: index
                    },
                    message: "\u041A\u043E\u043B\u043E\u043D\u043A\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0430"
                };
            } catch (error) {
                console.error('Drop column failed:', error);
                return {
                    success: false,
                    error: error instanceof Error ? error.message : 'Unknown error',
                    revert: true
                };
            }
        };
        this.droppableId = `column-dropzone-${props.index}`;
        this.dropzoneRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef();
        this.isOverRef = {
            current: false
        };
        this.state = {
            isOver: false
        };
    }
    getBoard() {
        return this.props.board;
    }
    componentDidMount() {
        if (!this.dropzoneRef.current || !this.isBoardEditing()) return;
        const { index: index, isFirst: isFirst = false, isLast: isLast = false, viewMode: viewMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List } = this.props;
        const context = {
            element: this.dropzoneRef.current,
            id: this.droppableId,
            acceptTypes: [
                'column'
            ] // Только колонки можно перетаскивать в дропзону
        };
        const strategy = {
            cssClasses: {
                active: 'column-dropzone__line--active'
            },
            calculateDropPosition: this.calculateDropPosition,
            onDragEnter: this.handleDragEnter,
            onDragLeave: this.handleDragLeave,
            onDrop: this.handleDrop
        };
        const dropZoneConfig = {
            context: context,
            strategy: strategy
        };
        this.unregisterFn = this.dndSystem.registerDropZone(dropZoneConfig);
    }
    componentWillUnmount() {
        if (this.unregisterFn) this.unregisterFn();
        if (this.isOverRef.current) {
            // Если компонент размонтируется во время перетаскивания
            const { index: index } = this.props;
            (0, $883133d1f570db27$export$bfc40ca370b68e03).columnDragLeave.emit({
                dropzoneIndex: index,
                sourceColumnId: undefined
            });
        }
    }
    render() {
        const { index: index, isFirst: isFirst = false, isLast: isLast = false, viewMode: viewMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List } = this.props;
        // Не показываем дропзону, если доска не в режиме редактирования
        const isEditing = this.isBoardEditing();
        if (!isEditing) return null;
        const { isOver: isOver } = this.state;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            ref: this.dropzoneRef,
            className: `column-dropzone ${this.getPositionClass()} ${isOver ? 'column-dropzone--drag-over' : ''}`,
            "data-dropzone-index": index,
            "aria-label": `\u{41F}\u{43E}\u{437}\u{438}\u{446}\u{438}\u{44F} \u{434}\u{43B}\u{44F} \u{432}\u{441}\u{442}\u{430}\u{432}\u{43A}\u{438} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{438} ${isFirst ? "\u043F\u0435\u0440\u0435\u0434 \u043F\u0435\u0440\u0432\u043E\u0439" : isLast ? "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0439" : "\u043C\u0435\u0436\u0434\u0443 \u043A\u043E\u043B\u043E\u043D\u043A\u0430\u043C\u0438"}`,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: `column-dropzone__line ${isOver ? 'column-dropzone__line--active' : ''}`,
                    children: isOver && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "column-dropzone__indicator"
                    })
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: `column-dropzone__icon-container ${isOver ? 'column-dropzone__icon-container--active' : ''}`,
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "column-dropzone__icon",
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                            children: "+"
                        })
                    })
                })
            ]
        });
    }
}
var $45b6034cf84bac67$export$2e2bcd8739ae039 = $45b6034cf84bac67$var$ColumnDropzone;




var $gIfym = parcelRequire("gIfym");



const $c9e414a3b8cdc11d$var$BoardFilters = ()=>{
    const app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
    const [filters, setFilters] = (0, $gIfym.useState)(app.getFilters());
    const [showFilters, setShowFilters] = (0, $gIfym.useState)(app.getState().showFilters);
    const [stats, setStats] = (0, $gIfym.useState)(app.getListStats());
    (0, $gIfym.useEffect)(()=>{
        const unsubscribeBoard = (0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated.subscribe(()=>{
            setFilters(app.getFilters());
            setShowFilters(app.getState().showFilters);
            setStats(app.getListStats());
        });
        const unsubscribeFilters = (0, $883133d1f570db27$export$bfc40ca370b68e03).filtersToggled.subscribe((newShowFilters)=>{
            setShowFilters(newShowFilters);
        });
        return ()=>{
            unsubscribeBoard();
            unsubscribeFilters();
        };
    }, [
        app
    ]);
    const handleFilterChange = (status)=>{
        app.setFilterStatus(status);
    };
    const filterSpecs = [
        {
            id: 'all',
            label: "\u0412\u0441\u0435",
            count: stats.total
        },
        {
            id: 'unsynced',
            label: "\u041D\u0435 \u0441\u0438\u043D\u0445\u0440.",
            count: stats.unsynced
        },
        {
            id: 'recent',
            label: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
            count: stats.recent
        }
    ];
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "board-filters",
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: "board-filters__container",
            children: filterSpecs.map((spec)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
                    className: `board-filters__button ${filters.status === spec.id ? 'board-filters__button--active' : ''} ${spec.id}`,
                    onClick: ()=>handleFilterChange(spec.id),
                    children: [
                        spec.label,
                        " (",
                        spec.count,
                        ")"
                    ]
                }, spec.id))
        })
    });
};
var $c9e414a3b8cdc11d$export$2e2bcd8739ae039 = $c9e414a3b8cdc11d$var$BoardFilters;




var $gIfym = parcelRequire("gIfym");





class $728a421a274d0038$export$665f9a256fc60a70 extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance(), this.classBlock = 'board-nav', this.buttonsContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef(), this.scrollContainer = null, this.resizeObserver = null, this.disposer = new (0, $9b26b9646341d616$export$6039fc6176d96e35)(), this.scrollTimeout = null, this.isUpdatingScroll = false, // ========== Обработчики событий навигатора (стрелочные функции) ==========
        this.handleNavScroll = ()=>{
            this.updateActiveColumnFromScroll();
        }, // ========== Обработчики событий (стрелочные функции) ==========
        this.handleViewModeChanged = (mode)=>{
            this.setState({
                viewMode: mode
            }, ()=>{
                this.checkNavigationNeeded();
                this.updateEventListeners();
            });
        }, this.handleBoardUpdated = ()=>{
            this.setState({
                columns: this.getSortedColumns()
            }, this.checkNavigationNeeded);
        }, this.handleColumnClick = (index)=>{
            if (this.isUpdatingScroll) return;
            const columnId = this.state.columns[index]?.id;
            if (!columnId) return;
            this.setState({
                currentIndex: index,
                isManualSelection: true,
                manualColumnId: columnId
            }, ()=>{
                this.scrollToColumn(index);
                this.centerSelectedButton(index);
            });
        }, this.handleContainerScroll = ()=>{
            this.debounceUpdateActiveColumn();
        }, this.handleWindowScroll = ()=>{
            if (this.isList()) this.debounceUpdateActiveColumn();
        }, this.checkNavigationNeeded = ()=>{
            if (this.isList()) {
                this.setState({
                    showNavigation: true
                });
                return;
            }
            const container = document.querySelector('.board--columns .board__container');
            if (container) {
                const needsNavigation = container.scrollWidth > container.clientWidth;
                this.setState({
                    showNavigation: needsNavigation
                });
            }
        };
        this.state = {
            viewMode: this.app.getCurrentViewMode(),
            columns: this.getSortedColumns(),
            currentIndex: 0,
            showNavigation: false,
            isManualSelection: false,
            manualColumnId: null
        };
    }
    componentDidMount() {
        this.setupSubscriptions();
        this.setupEventListeners();
        this.checkNavigationNeeded();
    }
    componentWillUnmount() {
        this.cleanupSubscriptions();
        this.cleanupEventListeners();
    }
    isColumns() {
        return this.getCurrentViewMode() === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns;
    }
    isList() {
        return this.getCurrentViewMode() === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
    }
    // ========== Подписки ==========
    setupSubscriptions() {
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).viewModeChanged, this.handleViewModeChanged);
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated, this.handleBoardUpdated);
    }
    updateEventListeners() {
        // Удаляем старые слушатели
        this.cleanupEventListeners();
        // Сбрасываем scrollContainer
        this.scrollContainer = null;
        // Устанавливаем новые слушатели для текущего режима
        this.setupEventListeners();
    }
    cleanupSubscriptions() {
        this.disposer.dispose();
    }
    // ========== Вспомогательные методы (обычные методы) ==========
    getSortedColumns() {
        const board = this.props.board;
        return [
            ...board.columns
        ].sort((a, b)=>a.order - b.order);
    }
    setupEventListeners() {
        // Находим контейнер для скролла
        this.scrollContainer = this.getScrollContainer();
        if (this.scrollContainer) {
            this.scrollContainer.addEventListener('scroll', this.handleContainerScroll);
            this.disposer.registerDisposer(()=>{
                this.scrollContainer?.removeEventListener('scroll', this.handleContainerScroll);
            });
        }
        // Для режима списка также слушаем скролл window
        if (this.isList()) {
            window.addEventListener('scroll', this.handleWindowScroll);
            this.disposer.registerDisposer(()=>{
                window.removeEventListener('scroll', this.handleWindowScroll);
            });
        }
        this.resizeObserver = new ResizeObserver(this.checkNavigationNeeded);
        if (this.scrollContainer) this.resizeObserver.observe(this.scrollContainer);
    }
    getScrollContainer() {
        if (this.isColumns()) return document.querySelector('.board--columns .board__container') || document.querySelector('.board');
        else // Для режима списка используем window как контейнер скролла
        return document.querySelector('.board');
    }
    updateActiveColumn() {
        if (this.state.columns.length === 0) return;
        // Если включен ручной режим, проверяем видимость выбранной колонки
        if (this.state.isManualSelection && this.state.manualColumnId) {
            const isVisible = this.isColumnVisible(this.state.manualColumnId, 0.05); // 5% видимости
            if (!isVisible) // Колонка уехала из видимости → переключаемся на авторежим
            this.setState({
                isManualSelection: false,
                manualColumnId: null
            });
            else // Колонка еще видна → не меняем активную
            return;
        }
        // Автоматическое определение в зависимости от режима
        if (this.isColumns()) this.updateActiveColumnForColumns();
        else if (this.isList()) this.updateActiveColumnForList();
    }
    updateActiveColumnForColumns() {
        const container = this.scrollContainer || document.querySelector('.board--columns .board__container');
        if (!container) return;
        const scrollLeft = container.scrollLeft;
        // Получаем реальную ширину колонки с учетом gap
        const columnElements = container.querySelectorAll('.column');
        let columnWidth = container.clientWidth * 0.85; // fallback
        if (columnElements.length > 0 && columnElements[0]) {
            const firstColumn = columnElements[0];
            columnWidth = firstColumn.offsetWidth;
            // Добавляем gap между колонками
            const containerStyle = window.getComputedStyle(container);
            const gap = parseFloat(containerStyle.gap) || 0;
            columnWidth += gap;
        }
        const newIndex = Math.round(scrollLeft / columnWidth);
        // Проверяем границы
        if (newIndex >= 0 && newIndex < this.state.columns.length && newIndex !== this.state.currentIndex) {
            this.setState({
                currentIndex: newIndex
            });
            this.centerSelectedButton(newIndex);
        }
    }
    updateActiveColumnForList() {
        const boardContainer = document.querySelector('.board');
        if (!boardContainer) return;
        const boardRect = boardContainer.getBoundingClientRect();
        const boardTopThird = boardRect.height / 3; // Высота верхней трети контейнера
        const columnElements = document.querySelectorAll('.column');
        if (columnElements.length === 0) return;
        let bestCandidate = null;
        let bestScore = -1;
        columnElements.forEach((columnElement)=>{
            if (!(columnElement instanceof HTMLElement) || !columnElement.id) return;
            // Находим индекс колонки в массиве columns
            const columnIndex = this.state.columns.findIndex((col)=>col.id === columnElement.id);
            if (columnIndex === -1) return;
            // Получаем координаты колонки относительно viewport
            const columnRect = columnElement.getBoundingClientRect();
            // Преобразуем в координаты относительно контейнера .board
            const columnTopRelative = columnRect.top - boardRect.top;
            const columnBottomRelative = columnRect.bottom - boardRect.top;
            const columnHeight = columnRect.height;
            // Вычисляем видимость в верхней трети контейнера
            const visibilityInTopThird = this.calculateVisibilityInTopThird(columnTopRelative, columnBottomRelative, columnHeight, boardTopThird);
            // Проверяем видимость заголовка в контейнере
            const headerElement = columnElement.querySelector('.column__header');
            let isHeaderVisible = false;
            if (headerElement) {
                const headerRect = headerElement.getBoundingClientRect();
                const headerTopRelative = headerRect.top - boardRect.top;
                const headerBottomRelative = headerRect.bottom - boardRect.top;
                // Заголовок виден, если он находится в пределах контейнера
                isHeaderVisible = headerTopRelative >= 0 && headerBottomRelative <= boardRect.height && headerBottomRelative > 0;
            }
            // Вычисляем общий score по приоритетам:
            // 1. Видимость в верхней трети (0-100)
            // 2. Видимость заголовка (добавляем бонус)
            // 3. Близость к верху (чем меньше расстояние, тем лучше)
            let score = visibilityInTopThird;
            if (isHeaderVisible) score += 50; // Бонус за видимый заголовок
            // Бонус за близость к верху (максимум 30 баллов)
            const distanceFromTop = Math.max(0, columnTopRelative);
            const proximityBonus = Math.max(0, 30 - distanceFromTop / 50);
            score += proximityBonus;
            if (score > bestScore) {
                bestScore = score;
                bestCandidate = {
                    index: columnIndex,
                    visibility: visibilityInTopThird,
                    isHeaderVisible: isHeaderVisible,
                    distanceToTop: columnTopRelative
                };
            }
        });
        if (bestCandidate && bestCandidate.index !== this.state.currentIndex) {
            this.setState({
                currentIndex: bestCandidate.index
            });
            this.centerSelectedButton(bestCandidate.index);
        }
    }
    isColumnVisible(columnId, minVisibility = 0.1) {
        const columnElement = document.getElementById(columnId);
        if (!columnElement) return false;
        const rect = columnElement.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        if (this.isList()) {
            // Для списка: проверяем вертикальную видимость относительно .board контейнера
            const boardContainer = document.querySelector('.board');
            if (!boardContainer) return false;
            const boardRect = boardContainer.getBoundingClientRect();
            // Преобразуем в относительные координаты
            const columnTopRelative = rect.top - boardRect.top;
            const columnBottomRelative = rect.bottom - boardRect.top;
            const columnHeight = rect.height;
            // Находим пересечение с контейнером
            const intersectionTop = Math.max(columnTopRelative, 0);
            const intersectionBottom = Math.min(columnBottomRelative, boardRect.height);
            if (intersectionBottom <= intersectionTop) return false;
            const visibleHeight = intersectionBottom - intersectionTop;
            return visibleHeight >= columnHeight * minVisibility;
        } else {
            // Для колонок: проверяем горизонтальную видимость
            const visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
            return visibleWidth >= rect.width * minVisibility;
        }
    }
    calculateVisibilityInTopThird(columnTop, columnBottom, columnHeight, boardTopThird) {
        // Верхняя треть контейнера: от 0 до boardTopThird
        const topThirdStart = 0;
        const topThirdEnd = boardTopThird;
        // Находим пересечение колонки с верхней третью
        const intersectionTop = Math.max(columnTop, topThirdStart);
        const intersectionBottom = Math.min(columnBottom, topThirdEnd);
        // Если нет пересечения
        if (intersectionBottom <= intersectionTop) return 0;
        // Высота пересечения
        const intersectionHeight = intersectionBottom - intersectionTop;
        // Процент колонки, видимый в верхней трети контейнера
        return intersectionHeight / columnHeight * 100;
    }
    debounceUpdateActiveColumn() {
        // Дебаунсим обновление для оптимизации
        if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(()=>{
            this.updateActiveColumn();
        }, 150);
    }
    updateActiveColumnFromScroll() {
        const buttonsContainer = this.buttonsContainerRef.current;
        if (!buttonsContainer) return;
        this.debounceUpdateActiveColumn();
    }
    centerSelectedButton(index) {
        this.isUpdatingScroll = true;
        const container = this.buttonsContainerRef.current;
        if (!container) {
            this.isUpdatingScroll = false;
            return;
        }
        const button = container.children[index];
        if (!button) {
            this.isUpdatingScroll = false;
            return;
        }
        const containerWidth = container.clientWidth;
        const buttonWidth = button.offsetWidth;
        const buttonOffset = button.offsetLeft;
        const maxScroll = container.scrollWidth - containerWidth;
        let targetScroll;
        // Краевые случаи
        if (index === 0) targetScroll = 0; // Первая кнопка
        else if (index === this.state.columns.length - 1) targetScroll = maxScroll; // Последняя кнопка
        else {
            // Центрирование: позиция кнопки минус половина ширины контейнера плюс половина ширины кнопки
            targetScroll = buttonOffset - containerWidth / 2 + buttonWidth / 2;
            // Ограничиваем значения
            targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
        }
        container.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
        setTimeout(()=>{
            this.isUpdatingScroll = false;
        }, 300);
    }
    cleanupEventListeners() {
        if (this.scrollContainer) this.scrollContainer.removeEventListener('scroll', this.handleContainerScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }
    scrollToColumn(index) {
        if (index < 0 || index >= this.state.columns.length) return;
        if (this.isColumns()) {
            // В режиме колонок - горизонтальный скролл
            const container = document.querySelector('.board--columns') || document.querySelector('.board--columns .board__container');
            if (!container) return;
            // Получаем реальную ширину колонки с учетом gap
            const columnElements = container.querySelectorAll('.column');
            let columnWidth = container.clientWidth * 0.85; // fallback
            if (columnElements.length > 0 && columnElements[0]) {
                const firstColumn = columnElements[0];
                columnWidth = firstColumn.offsetWidth;
                // Добавляем gap между колонками
                const containerStyle = window.getComputedStyle(container);
                const gap = parseFloat(containerStyle.gap) || 0;
                columnWidth += gap;
            }
            // Позиционируем по левой границе колонки
            const targetScroll = index * columnWidth;
            container.scrollTo({
                left: targetScroll,
                behavior: 'smooth'
            });
        } else if (this.isList()) {
            // В режиме списка - вертикальный скролл к колонке
            const columnId = this.state.columns[index]?.id;
            if (!columnId) return;
            const columnElement = document.getElementById(columnId);
            if (columnElement) columnElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
    // noinspection JSMethodCanBeStatic
    getCurrentViewMode() {
        return (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getCurrentViewMode();
    }
    getButtonClasses(index) {
        const classElement = `${this.classBlock}__button`;
        const classActive = index === this.state.currentIndex ? `${classElement}--active` : `${classElement}--inactive`;
        return `${classElement} ${classActive}`.trim();
    }
    // ========== Методы рендеринга (обычные методы) ==========
    renderColumnButtons() {
        const classElement = `${this.classBlock}__buttons`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: classElement,
            ref: this.buttonsContainerRef,
            children: this.state.columns.map((column, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                    onClick: ()=>this.handleColumnClick(index),
                    className: this.getButtonClasses(index),
                    "aria-label": `\u{41F}\u{435}\u{440}\u{435}\u{439}\u{442}\u{438} \u{43A} \u{43A}\u{43E}\u{43B}\u{43E}\u{43D}\u{43A}\u{435} ${column.title}`,
                    "aria-current": index === this.state.currentIndex ? 'page' : undefined,
                    children: column.title
                }, column.id))
        });
    }
    renderContent() {
        const classElement = `${this.classBlock}__content`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: classElement,
            children: this.renderColumnButtons()
        });
    }
    render() {
        const { showNavigation: showNavigation, columns: columns, viewMode: viewMode } = this.state;
        if (!showNavigation || columns.length === 0) return null;
        const classModifier = `${this.classBlock}--${viewMode}`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: `${this.classBlock} ${classModifier}`.trim(),
            children: this.renderContent()
        });
    }
}








class $b261911ba84319db$var$BoardComponent extends (0, $gIfym.Component) {
    //<editor-fold desc="Init">
    constructor(props){
        super(props), this.dndSystem = (0, $5c62c5d2b879ac35$export$7b3b75ad1a39a3f3).getInstance({
            scroll: {
                ...(0, $676334fc1be830c5$export$c82d80506540e07a),
                scrollableSelectors: [
                    ".column__tasks",
                    ".board"
                ]
            }
        }), this.disposer = new (0, $9b26b9646341d616$export$6039fc6176d96e35)(), this.columnDraggables = new Map(), this.isProgrammaticScroll = false, //</editor-fold>
        //<editor-fold desc="Scroll Management">
        this.handleResize = ()=>{
            this.updateScrollIndicators();
        }, this.updateScrollIndicators = ()=>{
            if (!this.boardContainerRef.current || this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) return;
            const container = this.boardContainerRef.current;
            const scrollLeft = container.scrollLeft;
            const scrollWidth = container.scrollWidth;
            const clientWidth = container.clientWidth;
            this.setState({
                scrollIndicators: {
                    left: scrollLeft > 10,
                    right: scrollLeft < scrollWidth - clientWidth - 10
                }
            });
        }, this.handleColumnsScroll = ()=>{
            if (this.isProgrammaticScroll) {
                this.isProgrammaticScroll = false;
                return;
            }
            this.updateScrollIndicators();
            if (!this.boardContainerRef.current || this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) return;
            const container = this.boardContainerRef.current;
            const scrollLeft = container.scrollLeft;
            const columnWidth = container.clientWidth * 0.85;
            const newIndex = Math.round(scrollLeft / columnWidth);
            const sortedColumns = this.getSortedColumns();
            if (newIndex >= 0 && newIndex < sortedColumns.length && newIndex !== this.state.currentColumnIndex) this.setState({
                currentColumnIndex: newIndex
            });
        }, this.scrollToColumn = (index)=>{
            if (!this.boardContainerRef.current || index < 0 || index >= this.getSortedColumns().length) return;
            const container = this.boardContainerRef.current;
            const columnWidth = container.clientWidth * 0.85;
            // Всегда позиционируем по ЛЕВОЙ ГРАНИЦЕ колонки
            const targetScroll = index * columnWidth;
            this.isProgrammaticScroll = true;
            container.scrollTo({
                left: targetScroll,
                behavior: 'smooth'
            });
            this.setState({
                currentColumnIndex: index
            });
        }, //</editor-fold>
        //<editor-fold desc="Manual Scroll Handlers">
        this.handleColumnsWheel = (e)=>{
            if (this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) return;
            if (this.dndSystem.isDragActive()) return;
            const target = e.target;
            const isInteractiveElement = target.closest('.task-card') || target.closest('button') || target.closest('input') || target.closest('textarea') || target.closest('select') || target.closest('[role="button"]') || target.closest('.sortable-task');
            if (!isInteractiveElement && e.deltaY !== 0 && this.boardContainerRef.current) {
                e.preventDefault();
                const container = this.boardContainerRef.current;
                container.scrollLeft += e.deltaY * 0.5;
            }
        }, this.handleColumnsMouseDown = (e)=>{
            if (this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) return;
            if (this.dndSystem.isDragActive()) return;
            const target = e.target;
            const isInteractiveElement = target.closest('.task-card') || target.closest('button');
            if (e.button === 0 && !isInteractiveElement && this.boardContainerRef.current) {
                this.setState({
                    isGrabbing: true,
                    dragStartX: e.clientX,
                    dragStartScrollLeft: this.boardContainerRef.current.scrollLeft
                });
                this.boardContainerRef.current.style.cursor = 'grabbing';
            }
        }, this.handleColumnsMouseMove = (e)=>{
            if (this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns || !this.state.isGrabbing || !this.boardContainerRef.current) return;
            if (this.dndSystem.isDragActive()) return;
            const deltaX = e.clientX - this.state.dragStartX;
            this.boardContainerRef.current.scrollLeft = this.state.dragStartScrollLeft - deltaX;
        }, this.handleColumnsMouseUp = ()=>{
            if (this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) return;
            if (!this.state.isGrabbing) return;
            this.setState({
                isGrabbing: false
            });
            if (this.boardContainerRef.current) this.boardContainerRef.current.style.cursor = '';
        }, this.handleColumnsMouseLeave = ()=>{
            this.handleColumnsMouseUp();
        }, this.handleTouchStart = (e)=>{
            //if (this.state.viewMode !== ViewModeEnum.Columns) return;
            if (this.dndSystem.isDragActive()) return;
            if (e.touches.length !== 1) return;
            const touch = e.touches[0];
            this.setState({
                isSwiping: true,
                swipeStartX: touch.clientX,
                touchStartTime: Date.now(),
                swipeVelocity: 0,
                touchDeltaX: 0
            });
        }, this.handleTouchMove = (e)=>{
            if (!this.state.isSwiping || this.dndSystem.isDragActive() || e.touches.length !== 1 || !this.boardContainerRef.current) return;
            const touch = e.touches[0];
            const deltaX = this.state.swipeStartX - touch.clientX;
            const currentTime = Date.now();
            const timeDelta = currentTime - this.state.touchStartTime;
            // Вычисляем скорость (px/ms)
            const velocity = timeDelta > 0 ? Math.abs(deltaX) / timeDelta : 0;
            if (Math.abs(deltaX) > 5) {
                e.preventDefault();
                this.boardContainerRef.current.scrollLeft += deltaX;
                this.setState({
                    swipeStartX: touch.clientX,
                    swipeVelocity: velocity,
                    // Сохраняем общее смещение для определения направления свайпа
                    touchDeltaX: (this.state.touchDeltaX || 0) + deltaX
                });
            }
        }, this.handleTouchEnd = ()=>{
            const wasSwiping = this.state.isSwiping;
            this.setState({
                isSwiping: false
            });
            if (!this.boardContainerRef.current || !wasSwiping) return;
            const container = this.boardContainerRef.current;
            const columnsCount = this.getSortedColumns().length;
            // Определяем, был ли это быстрый свайп
            const touchEndTime = Date.now();
            const touchDuration = touchEndTime - this.state.touchStartTime;
            // Ужесточаем критерии свайпа
            const isFast = touchDuration < 250; // Быстрее 250ms
            const isFastEnough = true; // Скорость > 0.5px/ms
            const hasMinimumMovement = Math.abs(this.state.touchDeltaX || 0) > 30; // Минимальное смещение 30px
            const isSwipe = isFast && isFastEnough && hasMinimumMovement;
            console.log(touchDuration, this.state.swipeVelocity, isFast, isFastEnough, hasMinimumMovement, isSwipe);
            let targetIndex = this.state.currentColumnIndex;
            if (isSwipe) {
                // Определяем направление свайпа ПО НАПРАВЛЕНИЮ ДВИЖЕНИЯ ПАЛЬЦА
                const deltaX = this.state.touchDeltaX || 0;
                if (deltaX > 0) // Палец двигался ВПРАВО -> свайп ВЛЕВО (предыдущая колонка)
                // Палец двигался ВЛЕВО -> свайп ВПРАВО (следующая колонка)
                {
                    if (targetIndex < columnsCount - 1) targetIndex = targetIndex + 1;
                } else if (deltaX < 0) {
                    if (targetIndex > 0) targetIndex = targetIndex - 1;
                }
                // Для свайпа скроллим к целевой колонке по ЛЕВОЙ ГРАНИЦЕ
                // Учитываем gap между колонками (из CSS: var(--spacing-md))
                // Получаем реальную ширину колонки через первый элемент или вычисляем
                const columnElements = container.querySelectorAll('.column');
                let columnWidth = container.clientWidth * 0.85; // fallback
                if (columnElements.length > 0 && columnElements[0]) {
                    const firstColumn = columnElements[0];
                    // offsetWidth включает padding, border, но не margin
                    // gap реализован через margin или gap у flex-контейнера
                    columnWidth = firstColumn.offsetWidth;
                    // Если есть gap (обычно 8-16px), добавляем его
                    // Проверяем computed style контейнера
                    const containerStyle = window.getComputedStyle(container);
                    const gap = parseFloat(containerStyle.gap) || 0;
                    columnWidth += gap;
                }
                const targetScroll = targetIndex * columnWidth;
                container.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth'
                });
            }
            // Медленный тач-драг - ничего не делаем, остаемся на текущей позиции
            this.setState({
                currentColumnIndex: targetIndex,
                touchDeltaX: 0 // Сбрасываем смещение
            });
        }, //</editor-fold>
        //<editor-fold desc="List Mode Handlers">
        this.handleAddTask = ()=>{
            if (this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) return;
            const sortedColumns = this.getSortedColumns();
            if (sortedColumns.length === 0) {
                console.warn('No columns available to add task');
                return;
            }
            const firstColumn = sortedColumns[0];
            this.setState({
                isAddingTask: true,
                addingTaskColumnId: firstColumn.id
            });
            setTimeout(()=>{
                (0, $883133d1f570db27$export$bfc40ca370b68e03).activateTaskAdd.emit(firstColumn.id);
                const columnElement = document.getElementById(firstColumn.id);
                if (columnElement) columnElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }, this.handleTaskAdded = ()=>{
            this.setState({
                isAddingTask: false,
                addingTaskColumnId: null
            });
        }, this.handleCancelAddTask = ()=>{
            this.setState({
                isAddingTask: false,
                addingTaskColumnId: null
            });
        }, this.onDeleteColumn = (columnId)=>{
            this.app.columnDelete(columnId).catch(console.error);
        };
        this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
        this.boardContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef();
        const viewMode = this.app.getCurrentViewMode();
        this.state = {
            viewMode: viewMode,
            showFilters: this.app.getState().showFilters || false,
            isAddingTask: false,
            addingTaskColumnId: null,
            isGrabbing: false,
            dragStartX: 0,
            dragStartScrollLeft: 0,
            currentColumnIndex: 0,
            scrollIndicators: {
                left: false,
                right: false
            },
            isSwiping: false,
            swipeStartX: 0,
            touchStartTime: 0,
            swipeVelocity: 0,
            touchDeltaX: 0
        };
    }
    // ==================== Lifecycle Methods ====================
    componentDidMount() {
        // Подписка на обновление доски
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated, (targetBoard)=>{
            const newBoard = this.getBoard();
            this.forceUpdate();
            // Простая логика: если редактирование включено - регистрируем, если выключено - очищаем
            if (newBoard.isEditing) // Регистрируем draggable для колонок в ЛЮБОМ режиме просмотра
            this.setupColumnDraggables(newBoard);
            else // Очищаем draggable при выключении редактирования
            this.cleanupColumnDraggables();
        });
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).columnEditFinish, (columnId)=>{
            this.setupColumnDraggables(this.getBoard());
        });
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).columnEditStart, (columnId)=>{
            this.cleanupColumnDraggables();
        });
        // Подписка на изменения режима просмотра
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).viewModeChanged, (mode)=>{
            this.setState({
                viewMode: mode,
                // Сбрасываем состояние при смене режима
                isAddingTask: false,
                addingTaskColumnId: null,
                isGrabbing: false,
                isSwiping: false
            });
            // Разное поведение для board drop zone и scroll
            if (mode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) {
                this.registerBoardDropZone();
                this.updateScrollIndicators();
                window.addEventListener('resize', this.handleResize);
            } else {
                this.unregisterBoardDropZone();
                window.removeEventListener('resize', this.handleResize);
            }
            // Для column draggables: если редактирование активно - перерегистрируем
            const currentBoard = this.getBoard();
            if (currentBoard.isEditing) this.setupColumnDraggables(currentBoard);
        });
        // Подписка на сигнал подсветки и скролла к задаче
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).highlightAndScrollToTask, (data)=>{
            // В режиме колонок может потребоваться прокрутка к колонке
            if (this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List && this.boardContainerRef.current) {
                // Найдем элемент колонки, содержащей задачу
                const targetColumnElement = document.getElementById(data.columnId);
                if (targetColumnElement) // Прокрутим контейнер доски к колонке, но с небольшой задержкой,
                // чтобы дать возможность колонке обработать сигнал первее
                setTimeout(()=>{
                    targetColumnElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'center' // Центрируем колонку по горизонтали
                    });
                }, 200); // Задержка, чтобы дать колонке обработать сигнал первее
            }
        });
        // Подписка на изменения фильтров
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).filtersToggled, (showFilters)=>{
            this.setState({
                showFilters: showFilters
            });
        });
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).cancelTaskAdd, (column)=>{
            this.setState({
                isAddingTask: false
            });
        });
        // Инициализация для режима колонок
        if (this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) {
            this.registerBoardDropZone();
            this.updateScrollIndicators();
            window.addEventListener('resize', this.handleResize);
        }
    }
    componentWillUnmount() {
        this.disposer.dispose();
        this.unregisterBoardDropZone();
        this.cleanupColumnDraggables();
        window.removeEventListener('resize', this.handleResize);
    }
    //</editor-fold>
    //<editor-fold desc="DndSystem Integration">
    registerBoardDropZone() {
        if (!this.boardContainerRef.current) return;
        const context = {
            element: this.boardContainerRef.current,
            id: 'board-container',
            acceptTypes: [
                'task'
            ]
        };
        const strategy = {
            calculateDropPosition: (x, y, context, dragData)=>{
                const element = context.element;
                const rect = element.getBoundingClientRect();
                const edgeThreshold = 50;
                const nearLeft = x < rect.left + edgeThreshold;
                const nearRight = x > rect.right - edgeThreshold;
                if (nearLeft || nearRight) return {
                    type: 'auto-scroll',
                    relativeX: (x - rect.left) / rect.width,
                    relativeY: (y - rect.top) / rect.height,
                    data: {
                        direction: nearLeft ? 'left' : 'right',
                        intensity: Math.max(0, 1 - Math.min(nearLeft ? (x - rect.left) / edgeThreshold : (rect.right - x) / edgeThreshold, 1))
                    }
                };
                return null;
            },
            onDragEnter: (context, dragData, position)=>{
                this.updateScrollIndicators();
            },
            onDragLeave: (context, dragData)=>{
                this.setState({
                    scrollIndicators: {
                        left: false,
                        right: false
                    }
                });
            }
        };
        this.boardDropZoneUnregister = this.dndSystem.registerDropZone({
            context: context,
            strategy: strategy
        });
    }
    unregisterBoardDropZone() {
        if (this.boardDropZoneUnregister) {
            this.boardDropZoneUnregister();
            this.boardDropZoneUnregister = undefined;
        }
    }
    setupColumnDraggables(board) {
        // ВСЕГДА очищаем старые draggable
        this.cleanupColumnDraggables();
        // Регистрируем новые ТОЛЬКО если редактирование активно
        if (!board.isEditing) {
            console.log('[DnD] Board is not editing, skipping draggable registration');
            return;
        }
        // В режиме списка работаем со свернутыми колонками
        // В режиме колонок - с обычными
        const isListMode = this.state.viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
        if (!isListMode && this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) return;
        setTimeout(()=>{
            // В режиме списка используем заголовки свернутых колонок
            // В режиме колонок - стандартные drag-handle
            // В свернутом режиме колонка имеет структуру:
            // .column--view_list.column--collapsed > .column__collapsed-view > button
            // В режиме списка используем всю свернутую колонку для DnD
            // В режиме колонок - всю колонку для DnD
            // Требования: drag-handle убрать, вся колонка становится draggable
            const selector = isListMode ? '.column--view_list.column--collapsed' : '.column--view_columns';
            // console.log(`[DnD] Searching for draggable elements with selector: ${selector}`);
            const columnElements = document.querySelectorAll(selector);
            // console.log(`[DnD] Found ${columnElements.length} elements`);
            columnElements.forEach((element, index)=>{
                if (!(element instanceof HTMLElement)) return;
                const columnId = this.getColumnIdFromElement(element);
                // console.log(`[DnD] Element ${index}:`, element, 'Column ID:', columnId);
                if (!columnId) return;
                const column = board.columns.find((c)=>c.id === columnId);
                // ЗАМЕЩАЕМ ОБРАБОТЧИКИ - вся колонка становится draggable
                // Убираем обычные обработчики кликов, если они есть
                if (isListMode && board.isEditing) {
                    // Для режима списка: отключаем разворачивание
                    element.style.cursor = 'move';
                    // Заменяем onclick чтобы не мешал DnD
                    element.onclick = null;
                    element.onmousedown = null;
                    element.ontouchstart = null;
                } else if (!isListMode) // Для режима колонок: настраиваем всю колонку как draggable
                element.style.cursor = 'move';
                if (!column) {
                    console.warn(`[DnD] Column ${columnId} not found in board`);
                    return;
                }
                // console.log(`[DnD] Registering draggable for column: ${column.title}`);
                this.registerColumnDraggable(element, column);
            });
        }, 0);
    }
    getColumnIdFromElement(element) {
        // Ищем ближайшего родителя с классом column или data-column-id
        let current = element;
        while(current && current !== document.body){
            // Проверяем атрибут data-column-id на самом элементе (для кнопок в свернутом режиме)
            const columnIdAttr = current.getAttribute('data-column-id');
            if (columnIdAttr) return columnIdAttr;
            if (current.classList.contains('column')) return current.id;
            current = current.parentElement;
        }
        return null;
    }
    registerColumnDraggable(element, column) {
        const unregister = this.dndSystem.registerDraggable({
            context: {
                element: element,
                id: column.id,
                type: 'column',
                data: {
                    columnId: column.id,
                    order: column.order,
                    title: column.title
                }
            },
            strategy: {
                cssClasses: {
                    activating: 'column--drag-activating',
                    dragging: 'column--drag-dragging'
                },
                onActivate: (context)=>{
                    context.element.classList.add('column--drag-activating');
                },
                onDragStart: (context, dragData)=>{
                    context.element.classList.remove('column--drag-activating');
                    context.element.classList.add('column--drag-dragging');
                    (0, $883133d1f570db27$export$bfc40ca370b68e03).columnDragStarted.emit(dragData.data);
                },
                onDragEnd: (context, result)=>{
                    context.element.classList.remove('column--drag-activating', 'column--drag-dragging');
                    (0, $883133d1f570db27$export$bfc40ca370b68e03).columnDragEnded.emit(result);
                },
                onDragCancel: (context)=>{
                    context.element.classList.remove('column--drag-activating', 'column--drag-dragging');
                },
                onScrollActivation: (context)=>{
                    context.element.classList.remove('column--drag-activating');
                },
                onShortClick: (context, event)=>{
                    context.element.onDndClick(event);
                }
            },
            config: {
                movementThreshold: 10,
                preventScroll: false,
                disabled: false
            }
        });
        this.columnDraggables.set(column.id, unregister);
    }
    cleanupColumnDraggables() {
        this.columnDraggables.forEach((unregister)=>unregister());
        this.columnDraggables.clear();
    }
    //</editor-fold>
    //<editor-fold desc="Helper Methods">
    getSortedColumns() {
        return [
            ...this.getBoard().columns
        ].sort((a, b)=>a.order - b.order);
    }
    //</editor-fold>
    //<editor-fold desc="Rendering Methods">
    renderAddTaskFAB() {
        if (this.state.viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List) return null;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
            className: `board__add-task-fab ${this.state.isAddingTask ? 'board__add-task-fab--hidden' : ''}`,
            onClick: this.handleAddTask,
            "aria-label": "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443",
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                className: "board__add-task-fab-icon",
                children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Add
            })
        });
    }
    renderColumns() {
        const { viewMode: viewMode } = this.state;
        const sortedColumns = this.getSortedColumns();
        const board = this.getBoard();
        return sortedColumns.map((column, index)=>{
            const showDropzone = this.getBoard().isEditing;
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {
                children: [
                    showDropzone && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $45b6034cf84bac67$export$2e2bcd8739ae039), {
                        board: board,
                        index: index,
                        isFirst: index === 0,
                        isLast: index === sortedColumns.length - 1,
                        viewMode: viewMode
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $103ed583fee002d5$export$2e2bcd8739ae039), {
                        column: column,
                        index: index,
                        onDelete: this.onDeleteColumn,
                        onTaskAdded: this.handleTaskAdded,
                        onCancel: this.handleCancelAddTask
                    }),
                    showDropzone && index === sortedColumns.length - 1 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $45b6034cf84bac67$export$2e2bcd8739ae039), {
                        board: board,
                        index: index + 1,
                        isLast: true
                    })
                ]
            }, column.id);
        });
    }
    getBoard() {
        return this.props.board;
    }
    renderScrollIndicators() {
        const { viewMode: viewMode, scrollIndicators: scrollIndicators } = this.state;
        if (viewMode !== (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns) return null;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                scrollIndicators.left && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "board__scroll-indicator board__scroll-indicator--left",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "board__scroll-indicator-arrow",
                        children: "\u2039"
                    })
                }),
                scrollIndicators.right && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "board__scroll-indicator board__scroll-indicator--right",
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: "board__scroll-indicator-arrow",
                        children: "\u203A"
                    })
                })
            ]
        });
    }
    //</editor-fold>
    //<editor-fold desc="Main Render">
    render() {
        const { viewMode: viewMode, showFilters: showFilters, isGrabbing: isGrabbing } = this.state;
        const board = this.getBoard();
        const boardClass = `board board--${viewMode} ${viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns && isGrabbing ? 'board--grabbing' : ''} ${board.isEditing ? 'is-editing' : ''}`;
        // События для режима колонок
        const boardEvents = viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns ? {
            onWheel: this.handleColumnsWheel,
            onMouseDown: this.handleColumnsMouseDown,
            onMouseMove: this.handleColumnsMouseMove,
            onMouseUp: this.handleColumnsMouseUp,
            onMouseLeave: this.handleColumnsMouseLeave,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            onScroll: this.handleColumnsScroll
        } : {};
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                showFilters && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $c9e414a3b8cdc11d$export$2e2bcd8739ae039), {}),
                !board.isEditing && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $728a421a274d0038$export$665f9a256fc60a70), {
                    board: this.getBoard()
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                    className: boardClass,
                    ref: this.boardContainerRef,
                    ...boardEvents,
                    children: [
                        this.renderColumns(),
                        board.isEditing && viewMode === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                            className: "board__add-column-container",
                            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2965d131bb960fd6$export$2e2bcd8739ae039), {})
                        }),
                        this.renderScrollIndicators(),
                        this.renderAddTaskFAB()
                    ]
                })
            ]
        });
    }
}
var $b261911ba84319db$export$2e2bcd8739ae039 = $b261911ba84319db$var$BoardComponent;




var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");
var $753a6085594ee9f8$exports = {};

$753a6085594ee9f8$exports = (parcelRequire("525q9"));








var $gIfym = parcelRequire("gIfym");


class $8e6f5c335cee9f48$var$DropdownMenu extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.classBlock = 'dropdown', // Стрелочные функции для обработчиков
        this.handleToggle = ()=>{
            this.setState((prevState)=>({
                    isOpen: !prevState.isOpen
                }));
        }, this.handleClose = ()=>{
            this.setState({
                isOpen: false
            });
        };
        this.state = {
            isOpen: false
        };
    }
    // Методы рендеринга
    renderButton() {
        const { buttonProps: buttonProps } = this.props;
        const { isOpen: isOpen } = this.state;
        const classBlock = this.classBlock;
        const classElement = `${classBlock}__button`;
        const classArrow = `${classBlock}__arrow`;
        const classArrowOpen = isOpen ? `${classArrow}--open` : '';
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
            onClick: this.handleToggle,
            className: `${classElement} ${buttonProps.className || ''}`.trim(),
            title: buttonProps.title,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: `${classBlock}__icon`,
                    children: buttonProps.icon
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: `${classBlock}__label`,
                    children: buttonProps.label
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: `${classArrow} ${classArrowOpen}`.trim(),
                    children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).ChevronDown
                })
            ]
        });
    }
    renderMenuItems() {
        const { menuItems: menuItems } = this.props;
        const classBlock = this.classBlock;
        const classList = `${classBlock}__list`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("ol", {
            className: classList,
            children: menuItems.map((item)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("li", {
                    className: `${classBlock}__item ${classBlock}__item--${item.id}`,
                    onClick: ()=>{
                        // Закрываем меню, если элемент - кнопка
                        if (item.autoClose !== false) this.handleClose();
                    },
                    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(item.render, {
                        ...item
                    })
                }, item.id))
        });
    }
    renderDropdown() {
        const { isOpen: isOpen } = this.state;
        const classBlock = this.classBlock;
        const classOverlay = `${classBlock}__overlay`;
        const classDropdown = `${classBlock}__dropdown`;
        if (!isOpen) return null;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: classOverlay,
                    onClick: this.handleClose
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: classDropdown,
                    children: this.renderMenuItems()
                })
            ]
        });
    }
    render() {
        const classBlock = this.classBlock;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classBlock,
            children: [
                this.renderButton(),
                this.renderDropdown()
            ]
        });
    }
}
var $8e6f5c335cee9f48$export$2e2bcd8739ae039 = $8e6f5c335cee9f48$var$DropdownMenu;




parcelRequire("gIfym");
const $a0dd1aeb93ee8e9a$export$40cf18e2a4fda920 = (spec)=>{
    const classBlock = 'dropdown';
    const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
        title: spec.tooltip,
        onClick: (e)=>spec.onClick?.(spec),
        className: `${classBlock}__item-button`,
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: `${classBlock}__item-icon`,
                children: spec.icon
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: `${classBlock}__item-button-label`,
                children: label
            })
        ]
    });
};



parcelRequire("gIfym");

const $870cff314f7687b4$export$f7eae9ce1d90e907 = (spec)=>{
    const classBlock = 'dropdown';
    if (!spec.mode) return null;
    if (!spec.getCurrentMode) return null;
    const isActive = spec.getCurrentMode() === spec.mode;
    const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
        title: spec.tooltip,
        onClick: ()=>spec.onClick?.(spec),
        className: `${classBlock}__item-button ${isActive ? `${classBlock}__item-button--active` : ''}`.trim(),
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: `${classBlock}__item-icon`,
                children: spec.icon
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: `${classBlock}__item-button-label`,
                children: label
            }),
            isActive && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: `${classBlock}__item-check`,
                children: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Checked
            })
        ]
    });
};




var $gIfym = parcelRequire("gIfym");
const $4a393a72e52687f5$export$edd6986b1ced152b = (spec)=>{
    const { title: title, subtitle: subtitle } = spec;
    const classBlock = 'dropdown';
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                className: `${classBlock}__item-title`,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("p", {
                className: `${classBlock}__item-subtitle`,
                children: subtitle
            })
        ]
    });
};


class $f938181dc18f3ec9$var$ViewModeToggle extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.classBlock = 'view-mode-toggle', this.handleModeSelect = (mode)=>{
            (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().setViewMode(mode, 'manual');
            this.forceUpdate();
        }, this.handleSwitchChange = (id, checked)=>{
            if (id === 'auto-mode') {
                if (checked) {
                    localStorage.removeItem('preferredViewMode');
                    const width = window.innerWidth;
                    let autoMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
                    if (width < 768) autoMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List;
                    else autoMode = (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns;
                    this.app.setViewMode(autoMode, 'auto');
                } else localStorage.setItem('preferredViewMode', this.state.currentMode);
            } else if (id === 'filters') this.app.setShowFilters(checked);
            this.setState((prevState)=>({
                    switches: {
                        ...prevState.switches,
                        [id]: checked
                    }
                }));
        }, // Методы рендеринга элементов меню
        this.renderDivider = (spec)=>{
            const classBlock = 'dropdown';
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("hr", {
                className: `${classBlock}__item-divider`
            });
        }, this.renderSwitch = (spec)=>{
            const { id: id } = spec;
            const classBlock = 'dropdown';
            if (!id) return null;
            //@ts-ignore
            const checked = this.state.switches[id];
            const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($753a6085594ee9f8$exports))), {
                        id: `${id}-switch`,
                        checked: checked,
                        onChange: (checked)=>this.handleSwitchChange(id, checked),
                        onColor: "#10b981",
                        offColor: "#9ca3af",
                        onHandleColor: "#ffffff",
                        offHandleColor: "#ffffff",
                        checkedIcon: false,
                        uncheckedIcon: false,
                        height: 20,
                        width: 40,
                        handleDiameter: 16,
                        className: `${classBlock}__item-switch`
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("label", {
                        className: `${classBlock}__item-label`,
                        htmlFor: `${id}-switch`,
                        title: spec.tooltip,
                        children: label
                    })
                ]
            });
        }, this.renderStats = (spec)=>{
            const { id: id } = spec;
            const classBlock = 'dropdown';
            if (!id || !this.state.switches.filters) return null;
            const stats = this.getStats();
            const statsData = [
                {
                    label: "\u0412\u0441\u0435:",
                    value: stats.total
                },
                {
                    label: "\u041D\u0435 \u0441\u0438\u043D\u0445\u0440.:",
                    value: stats.unsynced
                }
            ];
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: `${classBlock}__item-stats`,
                children: statsData.map((stat, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: `${classBlock}__item-stat`,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: `${classBlock}__item-stat-label`,
                                children: stat.label
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: `${classBlock}__item-stat-value`,
                                children: stat.value
                            })
                        ]
                    }, index))
            });
        };
        this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
        this.state = {
            currentMode: this.app.getCurrentViewMode(),
            switches: {
                'auto-mode': !localStorage.getItem('preferredViewMode'),
                'filters': this.app.getState().showFilters || false
            }
        };
    }
    componentDidMount() {
        this.unsubscribe = (0, $883133d1f570db27$export$bfc40ca370b68e03).viewModeChanged.subscribe((mode)=>{
            this.setState({
                currentMode: mode,
                switches: {
                    ...this.state.switches,
                    'auto-mode': !localStorage.getItem('preferredViewMode')
                }
            });
        });
    }
    componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
    }
    // Вспомогательные методы
    getCurrentConfig() {
        const { currentMode: currentMode } = this.state;
        return (0, $33b90e3c48366ffe$export$fd4d112fcca8c71e)[currentMode] || (0, $33b90e3c48366ffe$export$fd4d112fcca8c71e)[(0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns];
    }
    getStats() {
        return this.app.getListStats();
    }
    // Создание спецификации меню
    getMenuSpecification() {
        return [
            // Заголовок
            {
                id: "header",
                render: (0, $4a393a72e52687f5$export$edd6986b1ced152b),
                title: "\u0420\u0435\u0436\u0438\u043C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                subtitle: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u0442\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447"
            },
            // Опция "Настроить доску"
            {
                id: 'edit-board',
                render: (0, $a0dd1aeb93ee8e9a$export$40cf18e2a4fda920),
                icon: "\u2699\uFE0F",
                label: (spec)=>this.app.getCurrentViewMode() === (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns ? "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0434\u043E\u0441\u043A\u0443" : "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A",
                tooltip: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043A\u043E\u043B\u043E\u043D\u043E\u043A \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0434\u043E\u0441\u043A\u0438",
                onClick: ()=>this.app.editModeStart(),
                autoClose: true
            },
            // Разделитель
            // {
            // 	id: "divider-1",
            // 	render: this.renderDivider
            // },
            //
            // Переключатель авто-режима
            // {
            // 	id: "auto-mode",
            // 	render: this.renderSwitch,
            // 	label: "Автоматический режим",
            // 	tooltip: "Автоматически выбирает режим в зависимости от размера экрана"
            // },
            // Переключатель фильтров
            // {
            // 	id: "filters",
            // 	render: this.renderSwitch,
            // 	label: "Показать фильтры",
            // 	tooltip: "Отображать панель фильтров в интерфейсе"
            // },
            //
            // // Статистика фильтров
            // {
            // 	id: "filter-stats",
            // 	render: this.renderStats
            // },
            // Разделитель
            {
                id: "divider-2",
                render: this.renderDivider
            },
            // Опция "Доска задач"
            {
                id: "view-mode-columns",
                render: (0, $870cff314f7687b4$export$f7eae9ce1d90e907),
                label: "\u0414\u043E\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u0447",
                tooltip: "\u0414\u043E\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u0447 \u0441 \u043A\u043E\u043B\u043E\u043D\u043A\u0430\u043C\u0438 \u0434\u043B\u044F CRM-\u0432\u043E\u0440\u043E\u043D\u043A\u0438 \u0438 Kanban, ",
                icon: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Desktop,
                autoClose: true,
                mode: (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).Columns,
                getCurrentMode: ()=>(0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getViewMode(),
                onClick: (spec)=>this.handleModeSelect(spec.mode)
            },
            // Опция "Список задач"
            {
                id: "view-mode-list",
                render: (0, $870cff314f7687b4$export$f7eae9ce1d90e907),
                label: "\u0421\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u0434\u0430\u0447",
                tooltip: "\u041A\u043E\u043C\u043F\u0430\u043A\u0442\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u0441\u0435\u0445 \u0437\u0430\u0434\u0430\u0447",
                icon: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Columns,
                autoClose: true,
                mode: (0, $33b90e3c48366ffe$export$65ea953c3c9014f8).List,
                getCurrentMode: ()=>(0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getViewMode(),
                onClick: (spec)=>this.handleModeSelect(spec.mode)
            }
        ];
    }
    render() {
        const currentConfig = this.getCurrentConfig();
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: this.classBlock,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8e6f5c335cee9f48$export$2e2bcd8739ae039), {
                buttonProps: {
                    icon: currentConfig.icon,
                    label: currentConfig.name,
                    title: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0440\u0435\u0436\u0438\u043C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                    className: this.classBlock + "--button"
                },
                menuItems: this.getMenuSpecification()
            })
        });
    }
}
var $f938181dc18f3ec9$export$2e2bcd8739ae039 = $f938181dc18f3ec9$var$ViewModeToggle;




var $gIfym = parcelRequire("gIfym");






function $6ff7504f00499ea3$var$BoardButton({ spec: spec, className: className }) {
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("button", {
        onClick: spec.onClick,
        disabled: spec.disabled(),
        "aria-disabled": spec.disabled(),
        className: className,
        children: [
            spec.icon && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                children: spec.icon
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                children: spec.label
            })
        ]
    }, spec.id);
}
class $6ff7504f00499ea3$var$BoardEditHeader extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.saveStatusTimeoutId = null, this.classBlock = 'board-edit-header', this.hintSpecs = [
            {
                id: 'drag',
                icon: "\u2630",
                text: "\u2014 \u043F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0443 \u0434\u043B\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u0440\u044F\u0434\u043A\u0430"
            },
            {
                id: 'delete',
                icon: "\xd7",
                text: "\u2014 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043E\u043B\u043E\u043D\u043A\u0443",
                iconModifier: 'delete'
            },
            {
                id: 'add',
                text: "\u2014 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u043A\u043E\u043B\u043E\u043D\u043A\u0443",
                customIcon: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: "w-32 h-8 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center text-sm text-gray-500",
                    children: "+"
                })
            }
        ], this.disposer = new (0, $9b26b9646341d616$export$6039fc6176d96e35)(), this.getModifierClass = (baseClass, condition, modifier)=>{
            return condition ? `${baseClass}--${modifier}` : '';
        }, this.handleSave = async ()=>{
            if (this.isSaveDisabled) return;
            this.setState({
                isSaving: true,
                saveStatus: 'idle'
            });
            try {
                await this.app.editModeSave();
                this.setState({
                    saveStatus: 'success'
                });
                this.saveStatusTimeoutId = setTimeout(()=>{
                    this.setState({
                        saveStatus: 'idle'
                    });
                }, 2000);
            } catch (error) {
                console.error('Save failed:', error);
                this.setState({
                    saveStatus: 'error'
                });
            } finally{
                this.setState({
                    isSaving: false
                });
            }
        }, this.handleCancel = ()=>{
            const { isSaving: isSaving } = this.state;
            if (isSaving) return;
            if (this.hasChanges && !window.confirm("\u0423 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F. \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C?")) return;
            this.app.editModeCancel();
        }, this.handleSaveBoardTitle = async (newTitle)=>{
            try {
                this.app.boardSetTitle(newTitle);
                this.setState({
                    isEditingTitle: false
                });
            } catch (error) {
                console.error('Error saving board title:', error);
            // Оставляем в режиме редактирования при ошибке
            }
        }, this.formatTime = (date)=>{
            if (!date) return '';
            return date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit'
            });
        }, this.renderHint = (hint)=>{
            const classElement = `${this.classBlock}__hint`;
            const classIcon = `${classElement}-icon`;
            const classText = `${classElement}-text`;
            const classIconModifier = hint.iconModifier ? `${classIcon}--${hint.iconModifier}` : '';
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: classElement,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: `${classIcon} ${classIconModifier}`.trim(),
                        children: hint.customIcon || hint.icon
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        className: classText,
                        children: hint.text
                    })
                ]
            }, hint.id);
        }, //<editor-fold desc="Specs">
        this.classButton = `${this.classBlock}__button`, this.buttonSpecs = [
            {
                id: 'cancel',
                label: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
                onClick: this.handleCancel,
                disabled: ()=>this.state.isSaving,
                classNameModifier: `${this.classButton}--cancel`
            },
            {
                id: 'save',
                label: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F",
                onClick: this.handleSave,
                disabled: ()=>this.isSaveDisabled ? true : undefined,
                classNameModifier: `${this.classButton}--save`,
                icon: (0, $24374de5e71514a4$export$4f13f83fd8bb1dac).Save
            }
        ];
        this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
        this.state = {
            isSaving: false,
            saveStatus: 'idle',
            update: 0,
            isEditingTitle: false
        };
    }
    componentDidMount() {
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated, ()=>{
            this.forceUpdate();
        });
    }
    componentWillUnmount() {
        if (this.saveStatusTimeoutId) clearTimeout(this.saveStatusTimeoutId);
        this.disposer.dispose();
    }
    get board() {
        return this.props.board;
    }
    get editState() {
        return this.app.getEditState();
    }
    get hasChanges() {
        return this.app.hasUnsavedChanges();
    }
    get isSaveDisabled() {
        return this.state.isSaving || !this.hasChanges;
    }
    renderHeader() {
        const classContent = `${this.classBlock}__content`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classContent,
            children: [
                this.renderLeftSection(),
                this.renderRightSection()
            ]
        });
    }
    renderLeftSection() {
        const classElement = `${this.classBlock}__left`;
        const classTitle = `${this.classBlock}__title`;
        const classTitleIcon = `${classTitle}-icon`;
        const classChangesIndicator = `${this.classBlock}__changes-indicator`;
        const classLastSaved = `${this.classBlock}__last-saved`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classElement,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $92760033e2138c20$export$2e2bcd8739ae039), {
                    value: this.board.title,
                    onSave: this.handleSaveBoardTitle,
                    placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u0441\u043A\u0438",
                    className: `${classTitle} ${classTitle}--editing`,
                    maxLength: 255,
                    autoFocus: true,
                    onEditStart: ()=>{},
                    onEditFinish: ()=>{},
                    view: ({ value: value, onEditStart: onEditStart })=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("h1", {
                            className: classTitle,
                            style: {
                                cursor: 'pointer'
                            },
                            title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
                            children: [
                                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                    className: classTitleIcon,
                                    children: "\u270E"
                                }),
                                this.board.title || "\u0414\u043E\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u0447",
                                this.hasChanges && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                    className: classChangesIndicator,
                                    children: "\u0435\u0441\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"
                                })
                            ]
                        })
                }),
                this.renderSaveStatus(),
                this.editState.lastSaved && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
                    className: classLastSaved,
                    children: [
                        "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435: ",
                        this.formatTime(this.editState.lastSaved)
                    ]
                })
            ]
        });
    }
    renderSaveStatus() {
        const { saveStatus: saveStatus } = this.state;
        const classElement = `${this.classBlock}__status`;
        const classDot = `${classElement}-dot`;
        const statusConfigs = {
            success: {
                text: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E",
                dotModifier: 'success',
                elementModifier: 'success'
            },
            error: {
                text: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F",
                dotModifier: 'error',
                elementModifier: 'error'
            }
        };
        if (saveStatus === 'idle') return null;
        const config = statusConfigs[saveStatus];
        const classElementModifier = `${classElement}--${config.elementModifier}`;
        const classDotModifier = `${classDot}--${config.dotModifier}`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
            className: `${classElement} ${classElementModifier}`.trim(),
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    className: `${classDot} ${classDotModifier}`.trim()
                }),
                config.text
            ]
        });
    }
    renderRightSection() {
        const classElement = `${this.classBlock}__right`;
        const { isSaving: isSaving } = this.state;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classElement,
            children: [
                isSaving && this.renderSavingIndicator(),
                this.buttonSpecs.map((spec, idx)=>{
                    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($6ff7504f00499ea3$var$BoardButton, {
                        spec: spec,
                        className: `${this.classButton} ${spec.classNameModifier}`
                    }, idx);
                })
            ]
        });
    }
    renderSavingIndicator() {
        const classElement = `${this.classBlock}__saving-indicator`;
        const classSpinner = `${this.classBlock}__spinner`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: classElement,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: classSpinner
                }),
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                    children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..."
                })
            ]
        });
    }
    renderHints() {
        const classElement = `${this.classBlock}__hints`;
        const classContent = `${classElement}-content`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: classElement,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: classContent,
                children: this.hintSpecs.map(this.renderHint)
            })
        });
    }
    render() {
        console.log("RENDERING BUTTON", {
            hasChanges: this.hasChanges,
            isSaving: this.state.isSaving,
            isSaveDisabled: this.isSaveDisabled,
            disabledAttr: this.isSaveDisabled
        });
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("header", {
            className: this.classBlock,
            children: [
                this.renderHeader(),
                this.renderHints()
            ]
        });
    }
}
var $6ff7504f00499ea3$export$2e2bcd8739ae039 = $6ff7504f00499ea3$var$BoardEditHeader;







var $gIfym = parcelRequire("gIfym");





var $gIfym = parcelRequire("gIfym");



class $f445cc9dba620a95$export$2d0ed9d3f995e2da extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance(), this.classBlock = 'data-management-dialog', this.handleExport = async ()=>{
            this.setState({
                isExporting: true
            });
            // Используем метод экспорта из AppSingleton
            this.app.exportData().then((exportData)=>{
                // Создаем Blob и ссылку для скачивания
                const blob = new Blob([
                    JSON.stringify(exportData, null, 2)
                ], {
                    type: 'application/json'
                });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `sitask-export-${new Date().toISOString().slice(0, 19)}.json`;
                document.body.appendChild(a);
                a.click();
                // Убираем временную ссылку
                setTimeout(()=>{
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }, 100);
            }).catch((error)=>{
                console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u044D\u043A\u0441\u043F\u043E\u0440\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0445:", error);
            }).finally(()=>{
                this.setState({
                    isExporting: false
                });
            });
        }, this.handleImport = async (event)=>{
            const file = event.target.files?.[0];
            if (!file) return;
            if (!window.confirm("\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u0442\u0435\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438 \u0437\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u043C\u0438? \u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C.")) return;
            this.setState({
                isImporting: true,
                importError: null
            });
            try {
                const text = await file.text();
                const importData = JSON.parse(text);
                // Проверяем формат импортируемых данных
                if (!importData.version) throw new Error("\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0444\u0430\u0439\u043B\u0430 \u0438\u043C\u043F\u043E\u0440\u0442\u0430");
                // Вызываем метод импорта из AppSingleton
                await this.app.importData(importData);
                alert("\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u044B!");
                this.props.onClose();
            } catch (error) {
                console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0445:", error);
                this.setState({
                    importError: error instanceof Error ? error.message : "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0435"
                });
            } finally{
                this.setState({
                    isImporting: false
                });
                // Сбрасываем значение инпута, чтобы можно было повторно загрузить тот же файл
                event.target.value = '';
            }
        }, this.handleErase = async ()=>{
            if (!window.confirm("\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u0442\u0435\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435? \u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C.")) return;
            this.setState({
                isErasing: true
            });
            try {
                // Вызываем метод очистки данных из AppSingleton
                await this.app.eraseAllData();
                alert("\u0412\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0431\u044B\u043B\u0438 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u0442\u0435\u0440\u0442\u044B!");
                this.props.onClose();
            } catch (error) {
                console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0447\u0438\u0441\u0442\u043A\u0435 \u0434\u0430\u043D\u043D\u044B\u0445:", error);
            } finally{
                this.setState({
                    isErasing: false
                });
            }
        }, this.actionButtonsSpec = [
            {
                id: 'export',
                label: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
                labelInProgress: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442...",
                variant: 'export',
                handler: this.handleExport
            },
            {
                id: 'import',
                label: "\u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
                labelInProgress: "\u0418\u043C\u043F\u043E\u0440\u0442...",
                variant: 'import',
                handler: ()=>{},
                inputType: 'file',
                accept: '.json',
                onChange: this.handleImport
            },
            {
                id: 'erase',
                label: "\u0421\u0442\u0435\u0440\u0435\u0442\u044C \u0432\u0441\u0451",
                labelInProgress: "\u041E\u0447\u0438\u0441\u0442\u043A\u0430...",
                variant: 'erase',
                handler: this.handleErase
            }
        ], this.getActionButtonsSpec = ()=>{
            return this.actionButtonsSpec;
        }, this.renderActionButtons = ()=>{
            const classElement = this.classBlock;
            const classActionButton = `${classElement}__action-button`;
            const classExportButton = `${classActionButton} ${classElement}__export-button`;
            const classImportButton = `${classActionButton} ${classElement}__import-button`;
            const classEraseButton = `${classActionButton} ${classElement}__erase-button`;
            return this.getActionButtonsSpec().map((spec)=>{
                const buttonClassMap = {
                    export: classExportButton,
                    import: classImportButton,
                    erase: classEraseButton
                };
                const buttonClass = buttonClassMap[spec.variant];
                // Получаем состояния по id из this.state
                const stateKey = `is${spec.id.charAt(0).toUpperCase() + spec.id.slice(1)}`;
                const isLoading = this.state[stateKey];
                const disabled = isLoading;
                // Определяем текст кнопки в зависимости от состояния
                const labelText = isLoading ? spec.labelInProgress : spec.label;
                if (spec.inputType === 'file') // Для кнопки импорта используем label с input
                return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("label", {
                    className: buttonClass,
                    children: [
                        labelText,
                        /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("input", {
                            type: spec.inputType,
                            accept: spec.accept,
                            onChange: spec.onChange,
                            disabled: disabled
                        })
                    ]
                }, spec.id);
                else // Для остальных кнопок используем обычную кнопку
                return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                    className: buttonClass,
                    onClick: spec.handler,
                    disabled: disabled,
                    children: labelText
                }, spec.id);
            });
        }, this.dialogRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).createRef();
        this.state = {
            isExporting: false,
            isImporting: false,
            isErasing: false,
            importError: null
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            if (this.props.isOpen) {
                document.body.style.overflow = 'hidden';
                // Открываем диалог как модальное окно
                if (this.dialogRef.current && !this.dialogRef.current.open) this.dialogRef.current.showModal();
            } else {
                document.body.style.overflow = 'unset';
                this.setState({
                    importError: null
                });
                // Закрываем диалог
                if (this.dialogRef.current && this.dialogRef.current.open) this.dialogRef.current.close();
            }
        }
    }
    render() {
        const { onClose: onClose } = this.props;
        const { importError: importError } = this.state;
        const classElement = this.classBlock;
        const classContent = `${classElement}__content`;
        const classHeader = `${classElement}__header`;
        const classTitle = `${classElement}__title`;
        const classCloseButton = `${classElement}__close-button`;
        const classBody = `${classElement}__body`;
        const classActions = `${classElement}__actions`;
        const classError = `${classElement}__error`;
        const classInfo = `${classElement}__info`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("dialog", {
            ref: this.dialogRef,
            className: classElement,
            onCancel: onClose,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: classContent,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: classHeader,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h2", {
                                className: classTitle,
                                children: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u043C\u0438"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                                className: classCloseButton,
                                onClick: onClose,
                                "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
                                children: "\u2715"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: classBody,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                                className: classActions,
                                children: this.renderActionButtons()
                            }),
                            importError && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                className: classError,
                                children: [
                                    "\u041E\u0448\u0438\u0431\u043A\u0430 \u0438\u043C\u043F\u043E\u0440\u0442\u0430: ",
                                    importError
                                ]
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                                className: classInfo,
                                children: [
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("strong", {
                                                children: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442:"
                                            }),
                                            " \u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0435\u0442 \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u0437\u0430\u0434\u0430\u0447\u0438, \u043A\u043E\u043B\u043E\u043D\u043A\u0438 \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432 JSON \u0444\u0430\u0439\u043B."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("strong", {
                                                children: "\u0418\u043C\u043F\u043E\u0440\u0442:"
                                            }),
                                            " \u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438\u0437 \u0440\u0430\u043D\u0435\u0435 \u044D\u043A\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E JSON \u0444\u0430\u0439\u043B\u0430."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("strong", {
                                                children: "\u0421\u0442\u0435\u0440\u0435\u0442\u044C \u0432\u0441\u0451:"
                                            }),
                                            " \u0423\u0434\u0430\u043B\u044F\u0435\u0442 \u0432\u0441\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F. \u042D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043B\u044C\u0437\u044F \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C!"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    // Статический метод для отображения диалога
    static show() {
        // Создаем контейнер для портала
        const container = document.createElement('div');
        container.setAttribute('id', 'data-management-dialog-portal');
        document.body.appendChild(container);
        // Создаем root
        const root = (0, $49079038e9e61aa0$export$882461b6382ed46c)(container);
        // Функция для закрытия диалога
        const closeDialog = ()=>{
            root.unmount();
            document.body.removeChild(container);
        };
        // Рендерим компонент
        root.render(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($f445cc9dba620a95$export$2d0ed9d3f995e2da, {
            isOpen: true,
            onClose: closeDialog
        }));
        // Ждем, пока компонент смонтируется, и вызываем showModal()
        setTimeout(()=>{
            const dialogElement = container.querySelector('.data-management-dialog');
            if (dialogElement && typeof dialogElement.showModal === 'function') dialogElement.showModal();
        }, 0);
    }
}


class $ac85d646be18506d$var$SettingsMenu extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.classBlock = 'settings-menu', this.handleEditBoardClick = ()=>{
            this.app.editModeStart();
        }, // Методы рендеринга элементов меню
        this.renderItem = (spec)=>{
            const { tooltip: tooltip, onClick: onClick } = spec;
            const classBlock = 'dropdown';
            const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                title: tooltip,
                onClick: (e)=>spec.onClick?.(spec),
                className: `${classBlock}__item-button`,
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: `${classBlock}__item-button-label`,
                    children: label
                })
            });
        }, this.renderEditBoardItem = (spec)=>{
            return this.renderItem({
                ...spec,
                onClick: this.handleEditBoardClick
            });
        }, this.renderManageDataItem = (spec)=>{
            return this.renderItem({
                ...spec,
                onClick: (spec)=>{
                    // Открытие модального окна управления данными через статический метод
                    (0, $f445cc9dba620a95$export$2d0ed9d3f995e2da).show();
                }
            });
        };
        this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
        this.state = {};
    }
    // Создание спецификации меню
    getMenuSpecification() {
        return [
            // Опция "Управление данными"
            {
                id: 'manage-data',
                render: this.renderManageDataItem,
                label: "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u043C\u0438",
                tooltip: "\u042D\u043A\u0441\u043F\u043E\u0440\u0442, \u0438\u043C\u043F\u043E\u0440\u0442 \u0438 \u043E\u0447\u0438\u0441\u0442\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
                autoClose: true
            }
        ];
    }
    render() {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: this.classBlock,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8e6f5c335cee9f48$export$2e2bcd8739ae039), {
                buttonProps: {
                    icon: "\u2699\uFE0F",
                    label: "\u0415\u0449\u0435",
                    title: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
                    className: this.classBlock + '--button'
                },
                menuItems: this.getMenuSpecification()
            })
        });
    }
}
var $ac85d646be18506d$export$2e2bcd8739ae039 = $ac85d646be18506d$var$SettingsMenu;


class $2c1cbcf9cebc0d88$var$BoardHeader extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    constructor(props){
        super(props), this.classBlock = 'board-header', this.disposer = new (0, $9b26b9646341d616$export$6039fc6176d96e35)();
        this.app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
        this.state = {
            updated: false
        };
    }
    componentDidMount() {
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).boardUpdated, ()=>{
            this.forceUpdate();
        });
        this.disposer.register((0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated, ()=>{
            this.forceUpdate();
        });
    }
    componentWillUnmount() {
        this.disposer.dispose();
    }
    get board() {
        return this.props.board;
    }
    renderStandardHeader() {
        const classElement = `${this.classBlock}__content`;
        const classLeft = `${this.classBlock}__left`;
        const classRight = `${this.classBlock}__right`;
        const classTitle = `${this.classBlock}__title`;
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("header", {
            className: `${this.classBlock}`,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: classElement,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: classLeft,
                        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h1", {
                            className: classTitle,
                            children: this.board.title || "\u0414\u043E\u0441\u043A\u0430 \u0437\u0430\u0434\u0430\u0447"
                        })
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: classRight,
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $ac85d646be18506d$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $f938181dc18f3ec9$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        });
    }
    render() {
        // Если режим редактирования активен, показываем специальный заголовок
        if (this.board.isEditing) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6ff7504f00499ea3$export$2e2bcd8739ae039), {
            board: this.props.board
        });
        // Обычный заголовок с переключателем режимов
        return this.renderStandardHeader();
    }
}
var $2c1cbcf9cebc0d88$export$2e2bcd8739ae039 = $2c1cbcf9cebc0d88$var$BoardHeader;






parcelRequire("gIfym");


var $gIfym = parcelRequire("gIfym");

function $f22f93870602e0d9$var$getCounterSpec() {
    return [
        {
            type: "columns",
            count: (board)=>board.columns.length,
            label: "\u043A\u043E\u043B\u043E\u043D\u043E\u043A"
        },
        {
            type: "tasks",
            count: (board)=>board.tasks.length,
            label: "\u0437\u0430\u0434\u0430\u0447"
        },
        {
            type: "unsynced",
            count: (board)=>{
                return board.tasks.filter((t)=>!t.isSynced).length;
            },
            label: "\u043D\u0435 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043E"
        }
    ];
}
class $f22f93870602e0d9$export$1bf15374ff0ee1cf extends (0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Component {
    renderUpdatedInfo() {
        const classElement = `${this.classBlock}__updated`;
        const classContainer = `${classElement}-container`;
        const updatedTime = new Date(this.props.board.updatedAt).toLocaleTimeString();
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
            className: classContainer,
            children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: classElement,
                children: [
                    "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E: ",
                    updatedTime
                ]
            })
        });
    }
    render() {
        return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
            className: this.classBlock,
            children: [
                /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                    className: `${this.classBlock}__items`,
                    children: this.renderSpec.map((info)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)(this.Counter, {
                            ...info
                        }, info.type))
                }),
                this.renderUpdatedInfo()
            ]
        });
    }
    constructor(...args){
        super(...args), this.classBlock = "board-header-info", this.renderSpec = $f22f93870602e0d9$var$getCounterSpec(), this.Counter = ({ type: type, count: count, label: label })=>{
            const classElement = `${this.classBlock}__item`;
            const classIndicator = `${this.classBlock}__indicator`;
            const classModifier = `${classIndicator}--${type}`;
            return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: classElement,
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        className: `${classIndicator} ${classModifier}`
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("span", {
                        children: [
                            count(this.props.board),
                            " ",
                            label
                        ]
                    })
                ]
            });
        };
    }
}


function $af020be6ab0242ed$export$66c2190a6d69d44({ children: children }) {
    const context = (0, $19eb34fed071fd5f$export$fca13ab91e1a6240)();
    const app = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance();
    /* Информация о доске */ return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("footer", {
        children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $f22f93870602e0d9$export$1bf15374ff0ee1cf), {
            board: app.getCurrentBoard()
        })
    });
}



var $gIfym = parcelRequire("gIfym");
function $ebda103c06e70ceb$export$65d8bf213f6a4478(signal, handler, deps = []) {
    (0, $gIfym.useEffect)(()=>{
        return signal.subscribe(handler);
    }, deps);
}



//create your forceUpdate hook

var $gIfym = parcelRequire("gIfym");
function $b68596153a1a07d7$export$91db9bc4f8ac944a() {
    const [value, setValue] = (0, $gIfym.useState)(0); // integer state
    return (0, $gIfym.useCallback)(()=>setValue((value)=>++value), [
        true
    ]); // update the state to force render
}


/**
 * Регистрация Service Worker для PWA
 */ const $e673c5d4d76beed5$var$APP_PATH = '/app/';
const $e673c5d4d76beed5$var$SW_URL = `${$e673c5d4d76beed5$var$APP_PATH}sw.js`;
const $e673c5d4d76beed5$export$c6245babf0c60892 = ()=>{
    if (!('serviceWorker' in navigator && typeof window !== 'undefined')) return;
    if (window.location.href.indexOf("127.0.0.1") > -1 || window.location.href.indexOf("localhost:") > -1) return;
    window.addEventListener('load', ()=>{
        navigator.serviceWorker.register($e673c5d4d76beed5$var$SW_URL, {
            scope: $e673c5d4d76beed5$var$APP_PATH
        }).then((registration)=>{
            console.log("Service Worker \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0434\u043B\u044F:", $e673c5d4d76beed5$var$APP_PATH, registration);
            // Проверяем обновления каждые 1 час
            setInterval(()=>{
                registration.update();
            }, 3600000);
            // Отслеживаем обновления Service Worker
            registration.addEventListener('updatefound', ()=>{
                const newWorker = registration.installing;
                if (newWorker) newWorker.addEventListener('statechange', ()=>{
                    if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                        console.log("\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u043D\u043E\u0432\u043E\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F!");
                        // Можно показать уведомление пользователю
                        if ('Notification' in window && Notification.permission === 'granted') new Notification("\u0421\u0438\u0442\u0430\u0441\u043A \u0437\u0430\u0434\u0430\u0447\u0438", {
                            body: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F. \u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F.",
                            icon: `${$e673c5d4d76beed5$var$APP_PATH}icons/icon-192x192.png`
                        });
                    }
                });
            });
        }).catch((error)=>{
            console.warn("\u041E\u0448\u0438\u0431\u043A\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 Service Worker \u0434\u043B\u044F", $e673c5d4d76beed5$var$APP_PATH, ':', error);
        });
    });
};
const $e673c5d4d76beed5$export$16e7a388eb6d6d1 = async ()=>{
    if (typeof window === 'undefined' || !('Notification' in window)) {
        console.log("\u0411\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F");
        return false;
    }
    if (Notification.permission === 'granted') return true;
    if (Notification.permission !== 'denied') {
        const permission = await Notification.requestPermission();
        return permission === 'granted';
    }
    return false;
};
const $e673c5d4d76beed5$export$7ed1cba4b3835c66 = ()=>{
    let deferredPrompt = null;
    if (typeof window !== 'undefined') window.addEventListener('beforeinstallprompt', (e)=>{
        e.preventDefault();
        deferredPrompt = e;
    });
    return {
        show: async ()=>{
            if (!deferredPrompt) return false;
            try {
                await deferredPrompt.prompt();
                const choiceResult = await deferredPrompt.userChoice;
                deferredPrompt = null;
                return choiceResult.outcome === 'accepted';
            } catch (error) {
                console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u043A\u0430\u0437\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438:", error);
                return false;
            }
        }
    };
};
const $e673c5d4d76beed5$export$8a687766c18f2ea0 = ()=>{
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true || document.referrer.includes('android-app://');
};
const $e673c5d4d76beed5$export$e8d652910b2722ff = ()=>{
    if (typeof window === 'undefined') return {
        isInstalled: false,
        isOnline: false,
        supportsPWA: false,
        isIOS: false,
        appPath: $e673c5d4d76beed5$var$APP_PATH,
        supportsServiceWorker: false
    };
    const isInstalled = $e673c5d4d76beed5$export$8a687766c18f2ea0();
    const isOnline = navigator.onLine;
    const supportsServiceWorker = 'serviceWorker' in navigator;
    const supportsPWA = supportsServiceWorker && 'BeforeInstallPromptEvent' in window;
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return {
        isInstalled: isInstalled,
        isOnline: isOnline,
        supportsPWA: supportsPWA,
        isIOS: isIOS,
        appPath: $e673c5d4d76beed5$var$APP_PATH,
        supportsServiceWorker: supportsServiceWorker
    };
};
const $e673c5d4d76beed5$export$f7ade408b15a8de5 = ()=>{
    return typeof window !== 'undefined' && 'serviceWorker' in navigator;
};
const $e673c5d4d76beed5$export$a720ec463046c03d = async ()=>{
    if (!$e673c5d4d76beed5$export$f7ade408b15a8de5()) return null;
    try {
        return await navigator.serviceWorker.getRegistration($e673c5d4d76beed5$var$APP_PATH);
    } catch (error) {
        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 Service Worker:", error);
        return null;
    }
};
const $e673c5d4d76beed5$export$336ddb5f25de1126 = async (message)=>{
    if (!$e673c5d4d76beed5$export$f7ade408b15a8de5()) return;
    try {
        const registration = await navigator.serviceWorker.ready;
        if (registration.active) registration.active.postMessage(message);
    } catch (error) {
        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0432 Service Worker:", error);
    }
};
const $e673c5d4d76beed5$export$ac60f0346f7b361d = async ()=>{
    if (!$e673c5d4d76beed5$export$f7ade408b15a8de5()) return false;
    try {
        const registration = await navigator.serviceWorker.ready;
        return !!registration.active;
    } catch (error) {
        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 Service Worker:", error);
        return false;
    }
};




var $gIfym = parcelRequire("gIfym");


const $08139ffe7e080b1f$export$777bb01bd361b8ec = ({ showDetails: showDetails = false, onStatusChange: onStatusChange })=>{
    const [status, setStatus] = (0, $gIfym.useState)(null);
    const [isActive, setIsActive] = (0, $gIfym.useState)(false);
    const [cacheInfo, setCacheInfo] = (0, $gIfym.useState)(null);
    (0, $gIfym.useEffect)(()=>{
        const updateStatus = ()=>{
            const info = (0, $e673c5d4d76beed5$export$e8d652910b2722ff)();
            setStatus(info);
            onStatusChange?.(info);
            // Проверяем активность Service Worker
            (0, $e673c5d4d76beed5$export$ac60f0346f7b361d)().then((active)=>{
                setIsActive(active);
            });
        };
        updateStatus();
        // Обновляем статус при изменении сети
        window.addEventListener('online', updateStatus);
        window.addEventListener('offline', updateStatus);
        // Периодически обновляем статус
        const interval = setInterval(updateStatus, 30000);
        return ()=>{
            window.removeEventListener('online', updateStatus);
            window.removeEventListener('offline', updateStatus);
            clearInterval(interval);
        };
    }, [
        onStatusChange
    ]);
    const getCacheInfo = async ()=>{
        try {
            await (0, $e673c5d4d76beed5$export$336ddb5f25de1126)({
                type: 'GET_CACHE_INFO'
            });
        } catch (error) {
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043A\u044D\u0448\u0435:", error);
        }
    };
    const clearCache = async ()=>{
        try {
            await (0, $e673c5d4d76beed5$export$336ddb5f25de1126)({
                type: 'CLEAR_CACHE'
            });
            alert("\u041A\u044D\u0448 \u043E\u0447\u0438\u0449\u0435\u043D");
        } catch (error) {
            console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0447\u0438\u0441\u0442\u043A\u0438 \u043A\u044D\u0448\u0430:", error);
        }
    };
    if (!status) return null;
    if (!showDetails) return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "pwa-status pwa-status--compact",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "pwa-status__indicator",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                        className: `pwa-status__dot ${status.isOnline ? 'pwa-status__dot--online' : 'pwa-status__dot--offline'}`
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                        className: "pwa-status__text",
                        children: status.isOnline ? "\u041E\u043D\u043B\u0430\u0439\u043D" : "\u041E\u0444\u0444\u043B\u0430\u0439\u043D"
                    })
                ]
            }),
            status.isInstalled && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "pwa-status__badge",
                title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u043A\u0430\u043A PWA",
                children: "\uD83D\uDCF1"
            })
        ]
    });
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
        className: "pwa-status pwa-status--detailed",
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "pwa-status__header",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h3", {
                    className: "pwa-status__title",
                    children: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F"
                })
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "pwa-status__grid",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "pwa-status__item",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "pwa-status__label",
                                children: "\u0420\u0435\u0436\u0438\u043C:"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "pwa-status__value",
                                children: status.isInstalled ? "\uD83D\uDCF1 PWA" : "\uD83C\uDF10 \u0411\u0440\u0430\u0443\u0437\u0435\u0440"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "pwa-status__item",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "pwa-status__label",
                                children: "\u0421\u0435\u0442\u044C:"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: `pwa-status__value ${status.isOnline ? 'pwa-status__value--online' : 'pwa-status__value--offline'}`,
                                children: status.isOnline ? "\u2705 \u041E\u043D\u043B\u0430\u0439\u043D" : "\u274C \u041E\u0444\u0444\u043B\u0430\u0439\u043D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "pwa-status__item",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "pwa-status__label",
                                children: "Service Worker:"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: `pwa-status__value ${isActive ? 'pwa-status__value--active' : 'pwa-status__value--inactive'}`,
                                children: isActive ? "\u2705 \u0410\u043A\u0442\u0438\u0432\u0435\u043D" : "\u274C \u041D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "pwa-status__item",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "pwa-status__label",
                                children: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430:"
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("span", {
                                className: "pwa-status__value",
                                children: status.supportsPWA ? "\u2705 \u041F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F" : "\u274C \u041D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F"
                            })
                        ]
                    })
                ]
            }),
            status.supportsServiceWorker && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "pwa-status__actions",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        className: "pwa-status__button",
                        onClick: getCacheInfo,
                        title: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u043A\u044D\u0448\u0435",
                        children: "\u0418\u043D\u0444\u043E \u043E \u043A\u044D\u0448\u0435"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        className: "pwa-status__button pwa-status__button--danger",
                        onClick: clearCache,
                        title: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043A\u044D\u0448",
                        children: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043A\u044D\u0448"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("button", {
                        className: "pwa-status__button",
                        onClick: ()=>window.location.reload(),
                        title: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
                        children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"
                    })
                ]
            }),
            cacheInfo && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "pwa-status__cache-info",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("h4", {
                        children: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043A\u044D\u0448\u0435:"
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("p", {
                        children: [
                            "\u0417\u0430\u043F\u0438\u0441\u0435\u0439: ",
                            cacheInfo.count
                        ]
                    }),
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("ul", {
                        children: [
                            cacheInfo.urls.slice(0, 5).map((url, index)=>/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("li", {
                                    title: url,
                                    children: url.substring(url.lastIndexOf('/') + 1)
                                }, index)),
                            cacheInfo.count > 5 && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("li", {
                                children: [
                                    "... \u0438 \u0435\u0449\u0451 ",
                                    cacheInfo.count - 5
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $08139ffe7e080b1f$export$2e2bcd8739ae039 = $08139ffe7e080b1f$export$777bb01bd361b8ec;




var $gIfym = parcelRequire("gIfym");
// 640px - большинство смартфонов
const $003cce7f1f6af273$var$MOBILE_BREAKPOINT = 640;
const $003cce7f1f6af273$export$3a7f7cb44242f4e2 = ()=>{
    (0, $gIfym.useEffect)(()=>{
        const updateDeviceClass = ()=>{
            const isMobile = window.innerWidth <= $003cce7f1f6af273$var$MOBILE_BREAKPOINT;
            const isPortrait = window.matchMedia('(orientation: portrait)').matches;
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
            const body = document.body;
            // Более детальные классы
            if (window.innerWidth <= 480) body.classList.add('is-smartphone');
            else body.classList.remove('is-smartphone');
            if (window.innerWidth <= 768) body.classList.add('is-tablet');
            else body.classList.remove('is-tablet');
            if (isMobile) {
                body.classList.add('is-mobile');
                body.classList.remove('is-desktop');
            } else {
                body.classList.add('is-desktop');
                body.classList.remove('is-mobile');
            }
            body.classList.toggle('is-portrait', isPortrait);
            body.classList.toggle('is-landscape', !isPortrait);
            body.classList.toggle('is-standalone', isStandalone);
        };
        let debounceTimeout;
        const debounce = (handler, delayMs)=>{
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(handler, delayMs);
        };
        const handleUpdateClasses = ()=>{
            debounce(()=>{
                requestAnimationFrame(updateDeviceClass); //for animation
            }, 100);
        };
        handleUpdateClasses();
        window.addEventListener('resize', handleUpdateClasses);
        const mediaQuery = window.matchMedia('(orientation: portrait)');
        mediaQuery.addEventListener('change', handleUpdateClasses);
        return ()=>{
            window.removeEventListener('resize', handleUpdateClasses);
            mediaQuery.removeEventListener('change', handleUpdateClasses);
        };
    }, []);
};
function $003cce7f1f6af273$export$fe7334f0ffb449f9() {
    $003cce7f1f6af273$export$3a7f7cb44242f4e2();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).Fragment, {});
}



var $gIfym = parcelRequire("gIfym");


const $f467d26a0b4be46b$var$BackButtonManager = (props)=>{
    const { app: app } = (0, $19eb34fed071fd5f$export$fca13ab91e1a6240)();
    const isMobile = document.body.classList.contains('is-mobile');
    (0, $gIfym.useEffect)(()=>{
        if (!isMobile) // Не запускаем на десктопе
        return;
        // Регистрируем глобальный обработчик кнопки "назад"
        // Обратите внимание, что этот обработчик будет вызван только если
        // ни один из других обработчиков не вернул true
        const unregisterBackButton = (0, $1923c571a553c258$export$b9a4112f38f18035).getInstance().register(()=>{
            // Проверяем, находимся ли мы на главном экране
            // В нашем случае - если нет активного редактирования и пользователь на главной доске
            const currentBoard = props.board;
            const editState = app.getEditState();
            const taskEditController = app.getTaskEditController();
            // Если доска в режиме редактирования или есть активный редактор задач,
            // то обработчик в других компонентах уже сработает
            if (currentBoard.isEditing || taskEditController.state.isEditing) return false; // Позволяем другим обработчикам сработать
            // Мы на главном экране - возвращаем false, чтобы позволить
            // глобальному обработчику в BackButtonHandler выполнить логику двойного нажатия
            return false;
        });
        // При размонтировании компонента отписываемся
        return ()=>{
            unregisterBackButton();
        };
    }, [
        isMobile,
        app
    ]);
    return null; // Этот компонент не рендерит ничего
};
var $f467d26a0b4be46b$export$2e2bcd8739ae039 = $f467d26a0b4be46b$var$BackButtonManager;




var $gIfym = parcelRequire("gIfym");



var $gIfym = parcelRequire("gIfym");

const $8e1c60ce85694572$var$Toast = ({ message: message, isVisible: isVisible, onHide: onHide })=>{
    (0, $gIfym.useEffect)(()=>{
        if (isVisible) {
            const timer = setTimeout(()=>{
                onHide();
            }, 2000);
            return ()=>clearTimeout(timer);
        }
    }, [
        isVisible,
        onHide
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
        className: "back-button-toast",
        children: message
    });
};
var $8e1c60ce85694572$export$2e2bcd8739ae039 = $8e1c60ce85694572$var$Toast;


const $3dfd73bc295037bd$var$ToastManager = ()=>{
    const [toastVisible, setToastVisible] = (0, $gIfym.useState)(false);
    const [toastMessage, setToastMessage] = (0, $gIfym.useState)('');
    (0, $gIfym.useEffect)(()=>{
        const backButtonHandler = (0, $1923c571a553c258$export$b9a4112f38f18035).getInstance();
        const handleToast = (data)=>{
            if (data.show) {
                setToastMessage(data.message);
                setToastVisible(true);
            } else setToastVisible(false);
        };
        // Подписываемся на сигнал уведомлений
        const unsubscribe = backButtonHandler.toastSignal.subscribe(handleToast);
        return ()=>{
            // Отписываемся при размонтировании
            unsubscribe();
        };
    }, []);
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $8e1c60ce85694572$export$2e2bcd8739ae039), {
        message: toastMessage,
        isVisible: toastVisible,
        onHide: ()=>setToastVisible(false)
    });
};
var $3dfd73bc295037bd$export$2e2bcd8739ae039 = $3dfd73bc295037bd$var$ToastManager;




function $6112eed55e6a3838$var$PWAInstallPrompt(props) {
    return null;
}
function $6112eed55e6a3838$var$startPWA() {
    const [showInstallPrompt, setShowInstallPrompt] = (0, $gIfym.useState)(false);
    const [pwaInfo, setPwaInfo] = (0, $gIfym.useState)(null);
    (0, $gIfym.useEffect)(()=>{
        // Регистрируем Service Worker
        (0, $e673c5d4d76beed5$export$c6245babf0c60892)();
        // Получаем информацию о PWA
        const info = (0, $e673c5d4d76beed5$export$e8d652910b2722ff)();
        setPwaInfo(info);
        // Проверяем, нужно ли показывать промпт установки
        if (info.supportsPWA && !info.isInstalled) {
            // Проверяем, был ли уже отклонен промпт
            const promptDismissed = localStorage.getItem('pwaPromptDismissed');
            const promptShownCount = parseInt(localStorage.getItem('pwaPromptShownCount') || '0');
            if (!promptDismissed && promptShownCount < 3) {
                // Показываем промпт через 30 секунд после загрузки
                const timer = setTimeout(()=>{
                    setShowInstallPrompt(true);
                    localStorage.setItem('pwaPromptShownCount', (promptShownCount + 1).toString());
                }, 30000);
                return ()=>clearTimeout(timer);
            }
        }
    }, []);
    const handleInstallPromptDismiss = ()=>{
        setShowInstallPrompt(false);
        // Сохраняем в localStorage, что пользователь отклонил промпт
        localStorage.setItem('pwaPromptDismissed', 'true');
    };
    const handleInstall = ()=>{
        console.log("PWA \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E");
        localStorage.setItem('pwaInstalled', 'true');
        localStorage.removeItem('pwaPromptDismissed');
        localStorage.removeItem('pwaPromptShownCount');
    };
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $14fc2f3a09df08ae$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)("div", {
                className: "app__pwa-status",
                children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $08139ffe7e080b1f$export$2e2bcd8739ae039), {
                    showDetails: false
                })
            }),
            showInstallPrompt && /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)($6112eed55e6a3838$var$PWAInstallPrompt, {
                onDismiss: handleInstallPromptDismiss,
                onInstall: handleInstall
            })
        ]
    });
}
const $6112eed55e6a3838$var$AppComponent = ()=>{
    let syncStatus = null; // <SyncStatus/>;
    const forceUpdate = (0, $b68596153a1a07d7$export$91db9bc4f8ac944a)();
    // Подписка на инвалидацию приложения
    (0, $ebda103c06e70ceb$export$65d8bf213f6a4478)((0, $883133d1f570db27$export$bfc40ca370b68e03).appInvalidated, forceUpdate);
    let pwa = null;
    try {
        pwa = $6112eed55e6a3838$var$startPWA();
    } catch (e) {
        console.warn(e);
    }
    let board = (0, $b923651d7cbf96a1$export$86fbec116b87613f).getInstance().getCurrentBoard();
    return /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)((0, $19eb34fed071fd5f$export$c7dacf3845253dcf), {
        children: [
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $003cce7f1f6af273$export$fe7334f0ffb449f9), {}),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $f467d26a0b4be46b$export$2e2bcd8739ae039), {
                board: board
            }),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $3dfd73bc295037bd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsxs)("div", {
                        className: "app__content",
                        children: [
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $2c1cbcf9cebc0d88$export$2e2bcd8739ae039), {
                                board: board
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $b261911ba84319db$export$2e2bcd8739ae039), {
                                board: board
                            }),
                            /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $af020be6ab0242ed$export$66c2190a6d69d44), {
                                children: pwa
                            })
                        ]
                    }),
                    syncStatus
                ]
            })
        ]
    });
};
var $6112eed55e6a3838$export$2e2bcd8739ae039 = $6112eed55e6a3838$var$AppComponent;



if (window.location.href.indexOf("127.0.0.1") === -1) {
    (function(m, e, t, r, i) {
        m[i] = m[i] || function() {
            (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        for(var j = 0; j < document.scripts.length; j++){
            if (document.scripts[j].src === r) return;
        }
        var k = e.createElement(t), a = e.getElementsByTagName(t)[0], k_async = 1, k_src = r;
        k.async = Boolean(k_async);
        k.src = k_src;
        a.parentNode?.insertBefore(k, a);
    })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=106096124', 'ym');
    window.ym(106096124, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: "dataLayer",
        accurateTrackBounce: true,
        trackLinks: true
    });
}


// Удаляем скрипт регистрации из HTML и делаем его здесь
window.addEventListener('load', ()=>{
    (0, $e673c5d4d76beed5$export$c6245babf0c60892)();
});
const $76569041ca315844$var$container = document.getElementById('root');
if (!$76569041ca315844$var$container) throw new Error('Root element not found');
const $76569041ca315844$var$root = (0, $49079038e9e61aa0$export$882461b6382ed46c)($76569041ca315844$var$container);
$76569041ca315844$var$root.render(/*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gIfym))).StrictMode, {
    children: /*#__PURE__*/ (0, $14fc2f3a09df08ae$exports.jsx)((0, $6112eed55e6a3838$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=sitask.4d99843f.js.map
